/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Vendor.pages', [
        'ui.router',
        'ui.router.tabs',

        'Vendor.pages.dashboard',
        'Vendor.pages.dialogs',
        'Vendor.pages.info',
        'Vendor.pages.qualifications',
        'Vendor.pages.csmbs',
        'Vendor.pages.auth'
    ])
        .config(routeConfig)
        .run(runTime);

    /** @ngInject */
    function routeConfig($stateProvider, $urlRouterProvider, $httpProvider) {
        $urlRouterProvider.otherwise('/main/dashboard');
        $stateProvider
            .state('main', {
                url: '/main',
                templateUrl: 'app/pages/main/main.html',
                controller: "MainCtrl",
                controllerAs: "vm",
                abstract: true,
                data: {
                    requireLogin: true
                }
            })
            .state('login', {
                url: '/auth/login',
                templateUrl: 'app/pages/auth/auth.html',
                controller: "AuthCtrl",
                controllerAs: "vm",
                data: {
                    requireLogin: false
                }
            })
            .state('wx_login', {
                url: '/auth/wx_login?entry',
                controller: "WxAuthCtrl",
                data: {
                    requireLogin: false
                }
            })
            .state('get_cj_wechat_token', {
                url: "/get_cj_wechat_token?code",
                controller: "WechatAuthCtrl",
                data: {requireLogin: false}
            })
            .state('sso', {
                url: '/sso?token&backUrl',
                controller: "SSOCtrl",
                data: {
                    requireLogin: false
                }
            });

        var pendingRequests = [];
        $httpProvider.interceptors.push(['$timeout', '$q', '$injector', 'Auth',
            function ($timeout, $q, $injector, Auth) {
                var $state;
                var dialogs;
                var $http;
                var Auth;
                $timeout(function () {
                    $state = $injector.get('$state');
                    dialogs = $injector.get('dialogs');
                    $http = $injector.get('$http');
                    Auth = $injector.get('Auth');
                });

                return {
                    'request': function (config) {
                        config.headers = config.headers || {};
                        if (Auth.hasToken()) {
                            config.headers.Authorization = 'Bearer ' + Auth.getToken();
                        }
                        return config;
                    },
                    'responseError': function (response) {
                        if (response.status === 401) {
                            var code = getCode(response.data);
                            if (code === 1 || code === 3) {
                                logout(dialogs, Auth, $state);
                            }

                            if (code !== 2) return $q.reject(response);

                            if (pendingRequests.length === 0) {
                                $timeout(function () {
                                    Auth.refreshToken().then(function (resp) {
                                        var token = resp.data;
                                        Auth.setToken(token);
                                        var newAuth = 'Bearer ' + Auth.getToken();
                                        angular.forEach(pendingRequests, function (req) {
                                            req.config.headers.Authorization = newAuth;
                                            req.resolve($http(req.config));
                                        });
                                    }).catch(function () {
                                        angular.forEach(pendingRequests, function (req) {
                                            req.reject();
                                        });
                                        logout(dialogs, Auth, $state);
                                    }).finally(function () {
                                        pendingRequests = [];
                                    });
                                }, 1000);
                            }

                            return $q(function (resolve, reject) {
                                pendingRequests.push({config: response.config, resolve: resolve, reject: reject})
                            });

                        }
                        return $q.reject(response);
                    }
                };
            }]);
    }

    function logout(dialogs, Auth, $state) {
        if (Auth.hasToken()) {
            dialogs.notify('信标已过期', '用于通信的信标已过期，您需要重新登录！')
                .result.then(function () {
                $state.go('login');
            });
        }
        Auth.deleteToken();
    }

    function getCode(body) {
        // 针对文件上传时，响应数据类型为ArrayBuffer的情况
        if (body instanceof ArrayBuffer) {
            var str = String.fromCharCode.apply(null, new Uint8Array(body));
            body = JSON.parse(str)
        }
        return body.code
    }

    /** @ngInject */
    function runTime($rootScope, $state, Auth, $uibModalStack, Misc, $window) {
        $rootScope.$on('$stateChangeStart', function (event, toState) {
            //"ngInject";
            var requireLogin = toState.data.requireLogin;
            if (requireLogin && (!Auth.hasToken() || !Auth.hasUser())) {
                event.preventDefault();
                // if (Misc.isWxBrowser()) { //微信浏览器
                //     $window.location.href = Auth.getWxAuthorizeUrl();
                // } else {
                    $state.go('login');
                // }
            }
        });
        $rootScope.$on('$stateChangeSuccess', function (newVal, oldVal) {
            if (oldVal !== newVal) {
                $uibModalStack.dismissAll();
            }
        });
    }

})();

/**
 * @author richard.fan
 * created on 15.12.2015
 */
(function () {
  'use strict';

  angular.module('Vendor.theme', [
      'toaster',
      //'chart.js',
      //'angular-chartist',
      //'angular.morris-chart',
      'validation',

      'Vendor.theme.components'
  ]);

})();

/**
 * @author richard.fan
 * created on 15.12.2015
 */
(function () {
    'use strict';

    angular.module('Vendor.utils', []);

})();

/**
 * @author richard.fan
 * created on 15.12.2015
 */
(function () {
    'use strict';

    angular.module('Vendor.values', []);

})();

/**
 * @author richard
 */
(function () {
    'use strict';

    angular.module('Vendor.pages.auth', ['validation']);
})();

/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Vendor.pages.csmbs', [
        'Vendor.pages.csmbs.batches',
        'Vendor.pages.csmbs.inventories',
        'Vendor.pages.csmbs.purchase',
        'Vendor.pages.csmbs.return',
        'Vendor.pages.csmbs.categories',
        'Vendor.pages.csmbs.prices',
        'Vendor.pages.csmbs.qualifications',
        'Vendor.pages.csmbs.direct'

    ]).config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider) {
        $stateProvider
            .state('main.csmbs', {
                url: '/csmbs',
                template: '<ui-view></ui-view>',
                abstract: true,
                ncyBreadcrumb: {
                    label: '耗材管理',
                    parent: 'main.dashboard'
                },
                sidebarMeta: {
                    icon: 'fa fa-medkit',
                    order: 700
                }
            });
    }

})();

/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Vendor.pages.dashboard', [])
        .config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider) {
        $stateProvider
            .state('main.dashboard', {
                url: '/dashboard',
                templateUrl: 'app/pages/dashboard/dashboard.html',
                controller: 'DashboardPieChartCtrl',
                ncyBreadcrumb: {
                    label: '控制台'
                },
                sidebarMeta: {
                    icon: 'fa fa-home',
                    order: 0
                }
            });
    }

})();

/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Vendor.pages.dialogs', []);
})();

/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Vendor.pages.info', [
        'Vendor.pages.info.profile',
        'Vendor.pages.info.password'
    ]).config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider, $urlRouterProvider) {
        $stateProvider
            .state('main.info', {
                url: '/info',
                template: '<tabs data="vm.tabData" type="tabs"></tabs>',
                controller: 'infoTabCtrl',
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '基本信息',
                    parent: 'main.dashboard'
                },
                sidebarMeta: {
                    icon: 'fa fa-id-card',
                    order: 500
                }
            });
        $urlRouterProvider.when('/main/info', '/main/info/profile');
    }

})();

(function () {
    'use strict';

    angular.module('Vendor.pages.qualifications', [
        'Vendor.pages.qualifications.query',
        'Vendor.pages.qualifications.draft',
        'Vendor.pages.qualifications.remind',
        'Vendor.pages.qualifications.new',
        'Vendor.pages.qualifications.dialogs'

    ]).config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider, $urlRouterProvider) {
        $stateProvider
            .state('main.qualifications', {
                url: '/qualifications',
                template: '<tabs data="vm.tabData" type="tabs"></tabs>',
                controller: 'qualificationsTabCtrl',
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '厂商资质',
                    parent: 'main.dashboard'
                },
                sidebarMeta: {
                    icon: 'fa fa-list',
                    order: 600
                }
            });
        $urlRouterProvider.when('/main/qualifications', '/main/qualifications/query');
    }

})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('Vendor.theme.components', []);

})();

/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Vendor.pages.csmbs.batches', [
        'Vendor.pages.csmbs.batches.batch',
        'Vendor.pages.csmbs.batches.dialogs'
    ]).config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider, $urlRouterProvider) {
        $stateProvider
            .state('main.csmbs.batches', {
                url: '/batches',
                template: '<tabs data="vm.tabData" type="tabs"></tabs>',
                controller: 'batchesTabCtrl',
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '批次管理',
                    parent: 'main.csmbs'
                },
                sidebarMeta: {
                    order: 1
                }
            });
        $urlRouterProvider.when('/main/csmbs/batches', '/main/csmbs/batches/batch');
    }

})();

/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Vendor.pages.csmbs.categories', [
        'Vendor.pages.csmbs.categories.variety',
        'Vendor.pages.csmbs.categories.category',
        'Vendor.pages.csmbs.categories.update',
        'Vendor.pages.csmbs.categories.vStop',
        'Vendor.pages.csmbs.categories.cStop'
    ]).config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider, $urlRouterProvider) {
        $stateProvider
            .state('main.csmbs.categories', {
                url: '/categories',
                template: '<tabs data="vm.tabData" type="tabs"></tabs>',
                controller: 'categoriesTabCtrl',
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '品种管理',
                    parent: 'main.csmbs'
                },
                sidebarMeta: {
                    order: 5
                }
            });
        $urlRouterProvider.when('/main/csmbs/categories', '/main/csmbs/categories/variety');
    }

})();

/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Vendor.pages.csmbs.inventories', [
        'Vendor.pages.csmbs.inventories.storeroom',
        'Vendor.pages.csmbs.inventories.temporary'
    ]).config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider, $urlRouterProvider) {
        $stateProvider
            .state('main.csmbs.inventories', {
                url: '/inventories',
                template: '<tabs data="vm.tabData" type="tabs"></tabs>',
                controller: 'inventoriesTabCtrl',
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '库存查询',
                    parent: 'main.csmbs'
                },
                sidebarMeta: {
                    order: 0
                }
            });
        $urlRouterProvider.when('/main/csmbs/inventories', '/main/csmbs/inventories/storeroom');
    }

})();

/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Vendor.pages.csmbs.prices', [
        'Vendor.pages.csmbs.prices.query',
        'Vendor.pages.csmbs.prices.new'
    ]).config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider, $urlRouterProvider) {
        $stateProvider
            .state('main.csmbs.prices', {
                url: '/prices',
                template: '<tabs data="vm.tabData" type="tabs"></tabs>',
                controller: 'pricesTabCtrl',
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '耗材变价',
                    parent: 'main.csmbs'
                },
                sidebarMeta: {
                    order: 6
                }
            });
        $urlRouterProvider.when('/main/csmbs/prices', '/main/csmbs/prices/query');
    }

})();

/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Vendor.pages.csmbs.direct', [
        'Vendor.pages.csmbs.direct.approval',
        'Vendor.pages.csmbs.direct.approved',
        'Vendor.pages.csmbs.direct.return',
        'Vendor.pages.csmbs.direct.returned',
        'Vendor.pages.csmbs.direct.temporary',
        'Vendor.pages.csmbs.direct.dialogs'
    ]).config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider, $urlRouterProvider) {
        $stateProvider
            .state('main.csmbs.direct', {
                url: '/direct',
                template: '<tabs data="vm.tabData" type="tabs"></tabs>',
                controller: 'directTabCtrl',
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '科室直购',
                    parent: 'main.csmbs'
                },
                sidebarMeta: {
                    order: 10
                }
            });
        $urlRouterProvider.when('/main/csmbs/direct', '/main/csmbs/direct/approval');
    }

})();

/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Vendor.pages.csmbs.qualifications', [
        'Vendor.pages.csmbs.qualifications.query',
        'Vendor.pages.csmbs.qualifications.new'
    ]).config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider, $urlRouterProvider) {
        $stateProvider
            .state('main.csmbs.qualifications', {
                url: '/qualifications',
                template: '<tabs data="vm.tabData" type="tabs"></tabs>',
                controller: 'csmbQualificationsTabCtrl',
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '资质变更',
                    parent: 'main.csmbs'
                },
                sidebarMeta: {
                    order: 8
                }
            });
        $urlRouterProvider.when('/main/csmbs/qualifications', '/main/csmbs/qualifications/query');
    }

})();

/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Vendor.pages.csmbs.purchase', [
        'Vendor.pages.csmbs.purchase.approval',
        'Vendor.pages.csmbs.purchase.approved',
        'Vendor.pages.csmbs.purchase.dialogs'
    ]).config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider, $urlRouterProvider) {
        $stateProvider
            .state('main.csmbs.purchase', {
                url: '/purchase',
                template: '<tabs data="vm.tabData" type="tabs"></tabs>',
                controller: 'purchaseTabCtrl',
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '供货申请',
                    parent: 'main.csmbs'
                },
                sidebarMeta: {
                    order: 4
                }
            });
        $urlRouterProvider.when('/main/csmbs/purchase', '/main/csmbs/purchase/approval');
    }

})();

/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Vendor.pages.csmbs.return', [
        'Vendor.pages.csmbs.return.approval',
        'Vendor.pages.csmbs.return.approved'
    ]).config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider, $urlRouterProvider) {
        $stateProvider
            .state('main.csmbs.return', {
                url: '/return',
                template: '<tabs data="vm.tabData" type="tabs"></tabs>',
                controller: 'returnTabCtrl',
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '退货申请',
                    parent: 'main.csmbs'
                },
                sidebarMeta: {
                    order: 3
                }
            });
        $urlRouterProvider.when('/main/csmbs/return', '/main/csmbs/return/approval');
    }

})();

/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Vendor.pages.info.password', []).config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider) {
        $stateProvider
            .state('main.info.password', {
                url: '/password',
                templateUrl: 'app/pages/info/password/reset.html',
                controller: "passwordResetCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '重置密码',
                    parent: 'main.info'
                }
            });
    }

})();

/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Vendor.pages.info.profile', []).config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider) {
        $stateProvider
            .state('main.info.profile', {
                url: '/profile',
                templateUrl: 'app/pages/info/profile/show.html',
                controller: "profileCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '基本信息管理',
                    parent: 'main.info'
                }
            });
    }

})();

/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Vendor.pages.qualifications.dialogs', []);
})();

/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Vendor.pages.qualifications.draft', []).config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider, $urlRouterProvider) {
        $stateProvider
            .state('main.qualifications.draft', {
                url: '/draft',
                template: '<ui-view></ui-view>'
            }).state('main.qualifications.draft.list', {
                url: '/list',
                templateUrl: 'app/pages/qualifications/draft/list/list.html',
                controller: "qualificationDraftCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '资质草稿',
                    parent: 'main.qualifications'
                }
            }).state('main.qualifications.draft.edit', {
                url: '/edit/:id',
                templateUrl: 'app/pages/qualifications/query/edit/edit.html',
                controller: "qualificationEditCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '编辑资质',
                    parent: 'main.qualifications.draft.list'
                }
            });
        $urlRouterProvider.when('/main/qualifications/draft', '/main/qualifications/draft/list');
    }

})();

/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Vendor.pages.qualifications.new', []).config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider, $urlRouterProvider) {
        $stateProvider
            .state('main.qualifications.new', {
                url: '/new',
                templateUrl: 'app/pages/qualifications/new/apply.html',
                controller: "applyQualificationCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '上传资质',
                    parent: 'main.qualifications'
                }
            });
    }

})();

/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Vendor.pages.qualifications.query', []).config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider, $urlRouterProvider) {
        $stateProvider
            .state('main.qualifications.query', {
                url: '/query',
                template: '<ui-view></ui-view>'
            }).state('main.qualifications.query.list', {
                url: '/list',
                templateUrl: 'app/pages/qualifications/query/list/list.html',
                controller: "qualificationCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '我的资质',
                    parent: 'main.qualifications'
                }
            }).state('main.qualifications.query.edit', {
                url: '/edit/:id',
                templateUrl: 'app/pages/qualifications/query/edit/edit.html',
                controller: "qualificationEditCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '编辑资质',
                    parent: 'main.qualifications.query.list'
                }
            });
        $urlRouterProvider.when('/main/qualifications/query', '/main/qualifications/query/list');
    }

})();

/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Vendor.pages.qualifications.remind', []).config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider, $urlRouterProvider) {
        $stateProvider
            .state('main.qualifications.remind', {
                url: '/remind',
                template: '<ui-view></ui-view>'
            }).state('main.qualifications.remind.list', {
            url: '/list',
            templateUrl: 'app/pages/qualifications/remind/list/list.html',
            controller: "qualificationRemindCtrl",
            controllerAs: "vm",
            ncyBreadcrumb: {
                label: '资质到期提醒',
                parent: 'main.qualifications'
            }
        }).state('main.qualifications.remind.set', {
            url: '/set/:id',
            templateUrl: 'app/pages/qualifications/remind/set/set.html',
            controller: "qualificationSetCtrl",
            controllerAs: "vm",
            ncyBreadcrumb: {
                label: '设置提醒时间',
                parent: 'main.qualifications.query.list'
            }
        });
        $urlRouterProvider.when('/main/qualifications/remind', '/main/qualifications/remind/list');
    }

})();

/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Vendor.pages.csmbs.batches.batch', []).config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider, $urlRouterProvider) {
        $stateProvider
            .state('main.csmbs.batches.batch', {
                url: '/batch',
                template: '<ui-view></ui-view>'
            }).state('main.csmbs.batches.batch.list', {
                url: '/list',
                templateUrl: 'app/pages/csmbs/batches/batch/list/list.html',
                controller: "CBCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '我的批次',
                    parent: 'main.csmbs.batches'
                }
            }).state('main.csmbs.batches.batch.add', {
            url: '/add',
            templateUrl: 'app/pages/csmbs/batches/batch/edit/edit.html',
            controller: "CBEditCtrl",
            controllerAs: "vm",
            ncyBreadcrumb: {
                label: '添加批次',
                parent: 'main.csmbs.batches.batch.list'
            }
        }).state('main.csmbs.batches.batch.edit', {
            url: '/edit/:id',
            templateUrl: 'app/pages/csmbs/batches/batch/edit/edit.html',
            controller: "CBEditCtrl",
            controllerAs: "vm",
            ncyBreadcrumb: {
                label: '编辑批次',
                parent: 'main.csmbs.batches.batch.list'
            }
        });

        $urlRouterProvider.when('/main/csmbs/batches/batch', '/main/csmbs/batches/batch/list');
    }

})();

/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Vendor.pages.csmbs.batches.dialogs', []);
})();

/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Vendor.pages.csmbs.categories.cStop', []).config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider, $urlRouterProvider) {
        $stateProvider
            .state('main.csmbs.categories.cStop', {
                url: '/cStop',
                template: '<ui-view></ui-view>'
            }).state('main.csmbs.categories.cStop.list', {
            url: '/list',
            templateUrl: 'app/pages/csmbs/categories/cStop/list/list.html',
            controller: "ConsumableCStopListCtrl",
            controllerAs: "vm",
            ncyBreadcrumb: {
                label: '申请列表',
                parent: 'main.csmbs.categories'
            }
        }).state('main.csmbs.categories.cStop.add', {
            url: '/add',
            templateUrl: 'app/pages/csmbs/categories/cStop/add/add.html',
            controller: "ConsumableCStopCtrl",
            controllerAs: "vm",
            ncyBreadcrumb: {
                label: '新的申请',
                parent: 'main.csmbs.categories.cStop.list'
            }
        }).state('main.csmbs.categories.cStop.edit', {
            url: '/edit/:id',
            templateUrl: 'app/pages/csmbs/categories/cStop/add/add.html',
            controller: "ConsumableCStopCtrl",
            controllerAs: "vm",
            ncyBreadcrumb: {
                label: '编辑申请',
                parent: 'main.csmbs.categories.cStop.list'
            }
        });

        $urlRouterProvider.when('/main/csmbs/categories/cStop', '/main/csmbs/categories/cStop/list');
    }

})();

/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Vendor.pages.csmbs.categories.category', []).config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider, $urlRouterProvider) {
        $stateProvider
            .state('main.csmbs.categories.category', {
                url: '/category',
                template: '<ui-view></ui-view>'
            }).state('main.csmbs.categories.category.list', {
            url: '/list',
            templateUrl: 'app/pages/csmbs/categories/category/list/list.html',
            controller: "consumableCategoryCtrl",
            controllerAs: "vm",
            ncyBreadcrumb: {
                label: '型号列表',
                parent: 'main.csmbs.categories'
            }
        }).state('main.csmbs.categories.category.add', {
            url: '/add',
            templateUrl: 'app/pages/csmbs/categories/category/add/add.html',
            controller: "ConsumableAddDlgCtrl",
            controllerAs: "vm",
            ncyBreadcrumb: {
                label: '添加型号',
                parent: 'main.csmbs.categories.category.list'
            }
        }).state('main.csmbs.categories.category.edit', {
            url: '/edit/:id',
            templateUrl: 'app/pages/csmbs/categories/category/add/add.html',
            controller: "ConsumableAddDlgCtrl",
            controllerAs: "vm",
            ncyBreadcrumb: {
                label: '编辑型号',
                parent: 'main.csmbs.categories.category.list'
            }
        }).state('main.csmbs.categories.category.price', {
            url: '/price/:id',
            templateUrl: 'app/pages/csmbs/categories/category/price/list.html',
            controller: "ConsumablePriceDlgCtrl",
            controllerAs: "vm",
            ncyBreadcrumb: {
                label: '耗材价格',
                parent: 'main.csmbs.categories.category.list'
            }
        });

        $urlRouterProvider.when('/main/csmbs/categories/category', '/main/csmbs/categories/category/list');
    }

})();

/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Vendor.pages.csmbs.categories.update', []).config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider, $urlRouterProvider) {
        $stateProvider
            .state('main.csmbs.categories.update', {
                url: '/update',
                template: '<ui-view></ui-view>'
            }).state('main.csmbs.categories.update.list', {
            url: '/list',
            templateUrl: 'app/pages/csmbs/categories/update/list/list.html',
            controller: "ConsumableUpdateListCtrl",
            controllerAs: "vm",
            ncyBreadcrumb: {
                label: '申请列表',
                parent: 'main.csmbs.categories'
            }
        }).state('main.csmbs.categories.update.add', {
            url: '/add',
            templateUrl: 'app/pages/csmbs/categories/update/add/add.html',
            controller: "ConsumableUpdateCtrl",
            controllerAs: "vm",
            ncyBreadcrumb: {
                label: '新的申请',
                parent: 'main.csmbs.categories.update.list'
            }
        }).state('main.csmbs.categories.update.edit', {
            url: '/edit/:id',
            templateUrl: 'app/pages/csmbs/categories/update/add/add.html',
            controller: "ConsumableUpdateCtrl",
            controllerAs: "vm",
            ncyBreadcrumb: {
                label: '编辑申请',
                parent: 'main.csmbs.categories.update.list'
            }
        });

        $urlRouterProvider.when('/main/csmbs/categories/update', '/main/csmbs/categories/update/list');
    }

})();

/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Vendor.pages.csmbs.categories.vStop', []).config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider, $urlRouterProvider) {
        $stateProvider
            .state('main.csmbs.categories.vStop', {
                url: '/vStop',
                template: '<ui-view></ui-view>'
            }).state('main.csmbs.categories.vStop.list', {
            url: '/list',
            templateUrl: 'app/pages/csmbs/categories/vStop/list/list.html',
            controller: "ConsumableVStopListCtrl",
            controllerAs: "vm",
            ncyBreadcrumb: {
                label: '申请列表',
                parent: 'main.csmbs.categories'
            }
        }).state('main.csmbs.categories.vStop.add', {
            url: '/add',
            templateUrl: 'app/pages/csmbs/categories/vStop/add/add.html',
            controller: "ConsumableVStopCtrl",
            controllerAs: "vm",
            ncyBreadcrumb: {
                label: '新的申请',
                parent: 'main.csmbs.categories.vStop.list'
            }
        }).state('main.csmbs.categories.vStop.edit', {
            url: '/edit/:id',
            templateUrl: 'app/pages/csmbs/categories/vStop/add/add.html',
            controller: "ConsumableVStopCtrl",
            controllerAs: "vm",
            ncyBreadcrumb: {
                label: '编辑申请',
                parent: 'main.csmbs.categories.vStop.list'
            }
        });

        $urlRouterProvider.when('/main/csmbs/categories/vStop', '/main/csmbs/categories/vStop/list');
    }

})();

/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Vendor.pages.csmbs.categories.variety', []).config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider, $urlRouterProvider) {
        $stateProvider
            .state('main.csmbs.categories.variety', {
                url: '/variety',
                template: '<ui-view></ui-view>'
            }).state('main.csmbs.categories.variety.list', {
            url: '/list',
            templateUrl: 'app/pages/csmbs/categories/variety/list/list.html',
            controller: "consumableVarietyCtrl",
            controllerAs: "vm",
            ncyBreadcrumb: {
                label: '品种列表',
                parent: 'main.csmbs.categories'
            }
        }).state('main.csmbs.categories.variety.add', {
            url: '/add',
            templateUrl: 'app/pages/csmbs/categories/variety/add/add.html',
            controller: "consumableVarietyEditCtrl",
            controllerAs: "vm",
            ncyBreadcrumb: {
                label: '添加品种',
                parent: 'main.csmbs.categories.variety.list'
            }
        }).state('main.csmbs.categories.variety.edit', {
            url: '/edit/:id',
            templateUrl: 'app/pages/csmbs/categories/variety/add/add.html',
            controller: "consumableVarietyEditCtrl",
            controllerAs: "vm",
            ncyBreadcrumb: {
                label: '编辑品种',
                parent: 'main.csmbs.categories.variety.list'
            }
        });

        $urlRouterProvider.when('/main/csmbs/categories/variety', '/main/csmbs/categories/variety/list');
    }

})();

/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Vendor.pages.csmbs.inventories.storeroom', []).config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider, $urlRouterProvider) {
        $stateProvider
            .state('main.csmbs.inventories.storeroom', {
                url: '/storeroom',
                templateUrl: 'app/pages/csmbs/inventories/storeroom/storeroom.html',
                controller: "csmbStoreroomQueryCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '库房库存',
                    parent: 'main.csmbs.inventories'
                }
            });
    }

})();

/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Vendor.pages.csmbs.inventories.temporary', []).config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider, $urlRouterProvider) {
        $stateProvider
            .state('main.csmbs.inventories.temporary', {
                url: '/temporary',
                templateUrl: 'app/pages/csmbs/inventories/temporary/temporary.html',
                controller: "csmbStoreroomTemporaryCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '库房寄销库存',
                    parent: 'main.csmbs.inventories'
                }
            });
    }

})();

/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Vendor.pages.csmbs.prices.new', []).config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider, $urlRouterProvider) {
        $stateProvider
            .state('main.csmbs.prices.new', {
                url: '/new',
                templateUrl: 'app/pages/csmbs/prices/new/apply.html',
                controller: "csmbPriceNewCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '新的申请',
                    parent: 'main.csmbs.prices'
                },
                onExit: function (Misc) {
                    Misc.destroyEditor();
                }
            });
    }

})();

/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Vendor.pages.csmbs.prices.query', []).config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider, $urlRouterProvider) {
        $stateProvider
            .state('main.csmbs.prices.query', {
                url: '/query',
                template: '<ui-view></ui-view>'
            }).state('main.csmbs.prices.query.list', {
            url: '/list',
            templateUrl: 'app/pages/csmbs/prices/query/list/list.html',
            controller: "csmbPriceQueryCtrl",
            controllerAs: "vm",
            ncyBreadcrumb: {
                label: '我的申请',
                parent: 'main.csmbs.prices'
            }
        }).state('main.csmbs.prices.query.edit', {
            url: '/edit/:id',
            templateUrl: 'app/pages/csmbs/prices/query/edit/edit.html',
            controller: "csmbPriceEditCtrl",
            controllerAs: "vm",
            ncyBreadcrumb: {
                label: '编辑申请',
                parent: 'main.csmbs.prices.query.list'
            },
            onExit: function (Misc) {
                Misc.destroyEditor();
            }
        });
        $urlRouterProvider.when('/main/csmbs/prices/query', '/main/csmbs/prices/query/list');
    }

})();

/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Vendor.pages.csmbs.direct.approval', []).config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider, $urlRouterProvider) {
        $stateProvider
            .state('main.csmbs.direct.approval', {
                url: '/approval',
                templateUrl: 'app/pages/csmbs/direct/approval/approval.html',
                controller: "CsmbDirectApprovalCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '待处理申请',
                    parent: 'main.csmbs.direct'
                }
            });
    }

})();

/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Vendor.pages.csmbs.direct.approved', []).config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider, $urlRouterProvider) {
        $stateProvider
            .state('main.csmbs.direct.approved', {
                url: '/approved',
                templateUrl: 'app/pages/csmbs/direct/approved/approved.html',
                controller: "CsmbDirectApprovedCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '已处理申请',
                    parent: 'main.csmbs.direct'
                }
            });
    }

})();

/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Vendor.pages.csmbs.direct.dialogs', []);
})();

/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Vendor.pages.csmbs.direct.return', []).config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider, $urlRouterProvider) {
        $stateProvider
            .state('main.csmbs.direct.return', {
                url: '/return',
                template: '<ui-view></ui-view>'
            }).state('main.csmbs.direct.return.list', {
            url: '/list',
            templateUrl: 'app/pages/csmbs/direct/return/list/list.html',
            controller: "CsmbDirectReturnApprovalCtrl",
            controllerAs: "vm",
            ncyBreadcrumb: {
                label: '待处理',
                parent: 'main.csmbs.direct'
            }
        }).state('main.csmbs.direct.return.handle', {
            url: '/handle/:id',
            templateUrl: 'app/pages/csmbs/direct/return/handle/handle.html',
            controller: "CsmbDirectReturnHandleCtrl",
            controllerAs: "vm",
            ncyBreadcrumb: {
                label: '审批处理',
                parent: 'main.csmbs.direct.return.list'
            }
        });
        $urlRouterProvider.when('/main/csmbs/direct/return', '/main/csmbs/direct/return/list');
    }

})();

/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Vendor.pages.csmbs.direct.returned', []).config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider, $urlRouterProvider) {
        $stateProvider
            .state('main.csmbs.direct.returned', {
                url: '/returned',
                templateUrl: 'app/pages/csmbs/direct/returned/approved.html',
                controller: "CsmbDirectReturnApprovedCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '已处理',
                    parent: 'main.csmbs.direct'
                }
            });
    }

})();

/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Vendor.pages.csmbs.direct.temporary', []).config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider, $urlRouterProvider) {
        $stateProvider
            .state('main.csmbs.direct.temporary', {
                url: '/temporary',
                templateUrl: 'app/pages/csmbs/direct/temporary/temporary.html',
                controller: "csmbDeptTemporaryCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '科室寄销库存',
                    parent: 'main.csmbs.direct'
                }
            });
    }

})();

/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Vendor.pages.csmbs.qualifications.new', []).config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider) {
        $stateProvider
            .state('main.csmbs.qualifications.new', {
                url: '/new',
                templateUrl: 'app/pages/csmbs/qualifications/new/apply.html',
                controller: "csmbQANewCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '新的申请',
                    parent: 'main.csmbs.qualifications'
                }
            });
    }

})();

/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Vendor.pages.csmbs.qualifications.query', []).config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider, $urlRouterProvider) {
        $stateProvider
            .state('main.csmbs.qualifications.query', {
                url: '/query',
                template: '<ui-view></ui-view>'
            }).state('main.csmbs.qualifications.query.list', {
            url: '/list',
            templateUrl: 'app/pages/csmbs/qualifications/query/list/list.html',
            controller: "csmbQAQueryCtrl",
            controllerAs: "vm",
            ncyBreadcrumb: {
                label: '申请列表',
                parent: 'main.csmbs.qualifications'
            }
        }).state('main.csmbs.qualifications.query.edit', {
            url: '/edit/:id',
            templateUrl: 'app/pages/csmbs/qualifications/query/edit/edit.html',
            controller: "csmbQAEditCtrl",
            controllerAs: "vm",
            ncyBreadcrumb: {
                label: '编辑申请',
                parent: 'main.csmbs.qualifications.query.list'
            }
        });
        $urlRouterProvider.when('/main/csmbs/qualifications/query', '/main/csmbs/qualifications/query/list');
    }

})();

/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Vendor.pages.csmbs.purchase.approval', []).config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider, $urlRouterProvider) {
        $stateProvider
            .state('main.csmbs.purchase.approval', {
                url: '/approval',
                templateUrl: 'app/pages/csmbs/purchase/approval/approval.html',
                controller: "SPAApprovalCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '待处理',
                    parent: 'main.csmbs.purchase'
                }
            });
    }

})();

/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Vendor.pages.csmbs.purchase.approved', []).config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider, $urlRouterProvider) {
        $stateProvider
            .state('main.csmbs.purchase.approved', {
                url: '/approved',
                templateUrl: 'app/pages/csmbs/purchase/approved/approved.html',
                controller: "SPAApprovedCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '已处理',
                    parent: 'main.csmbs.purchase'
                }
            });
    }

})();

/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Vendor.pages.csmbs.purchase.dialogs', []);
})();

/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Vendor.pages.csmbs.return.approval', []).config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider, $urlRouterProvider) {
        $stateProvider
            .state('main.csmbs.return.approval', {
                url: '/approval',
                template: '<ui-view></ui-view>'
            }).state('main.csmbs.return.approval.list', {
            url: '/list',
            templateUrl: 'app/pages/csmbs/return/approval/list/list.html',
            controller: "SRAApprovalCtrl",
            controllerAs: "vm",
            ncyBreadcrumb: {
                label: '待处理',
                parent: 'main.csmbs.return'
            }
        }).state('main.csmbs.return.approval.handle', {
            url: '/handle/:id',
            templateUrl: 'app/pages/csmbs/return/approval/handle/handle.html',
            controller: "SRAHandleCtrl",
            controllerAs: "vm",
            ncyBreadcrumb: {
                label: '审批处理',
                parent: 'main.csmbs.return.approval.list'
            }
        });
        $urlRouterProvider.when('/main/csmbs/return/approval', '/main/csmbs/return/approval/list');
    }

})();

/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Vendor.pages.csmbs.return.approved', []).config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider, $urlRouterProvider) {
        $stateProvider
            .state('main.csmbs.return.approved', {
                url: '/approved',
                templateUrl: 'app/pages/csmbs/return/approved/approved.html',
                controller: "SRAApprovedCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '已处理',
                    parent: 'main.csmbs.return'
                }
            });
    }

})();

'use strict';

angular.module('Vendor', [
    'ui.bootstrap',
    'ui.sortable',
    'ui.router',
    'ui.slimscroll',


    'ncy-angular-breadcrumb',
    'mwl.calendar',

    'angular-img-cropper',
    'angular-clipboard',

    'uiSwitch',
    'ui.select',
    'ui.checkbox',

    'ngTouch',
    'ngTable',
    'ngAnimate',
    'ngSanitize',
    'ngResource',
    'ng.deviceDetector',
    'ngFileUpload',
    'ngStorage',
    'ngFileSaver',
    'uiCropper',

    'toaster',

    'oc.lazyLoad',

    'dialogs.main',
    'pascalprecht.translate',
    'dialogs.default-translations',

    'monospaced.elastic',
    'monospaced.qrcode',
    'ckeditor',
    'FBAngular',

    'Vendor.utils',
    'Vendor.values',
    'Vendor.theme',
    'Vendor.pages'
]).run(function ($anchorScroll) {
    $anchorScroll.yOffset = 86;
}).config(function ($translateProvider, $ocLazyLoadProvider) {
    $translateProvider.useSanitizeValueStrategy('escape');
    $ocLazyLoadProvider.config({
        modules: [
            {
                name: 'video',
                files: [
                    '/ocLazyLoad/video/vg-overlay-play.min.js',
                    '/ocLazyLoad/video/vg-controls.min.js',
                    '/ocLazyLoad/video/vg-buffering.min.js',
                    '/ocLazyLoad/video/vg-poster.min.js',
                    '/ocLazyLoad/video/videogular.min.js',
                ],
                serie: true
            }
        ]
    });
});
angular.module("ngLocale", [], ["$provide", function ($provide) {
    var PLURAL_CATEGORY = {ZERO: "zero", ONE: "one", TWO: "two", FEW: "few", MANY: "many", OTHER: "other"};
    $provide.value("$locale", {
        "DATETIME_FORMATS": {
            "AMPMS": [
                "\u4e0a\u5348",
                "\u4e0b\u5348"
            ],
            "DAY": [
                "\u661f\u671f\u65e5",
                "\u661f\u671f\u4e00",
                "\u661f\u671f\u4e8c",
                "\u661f\u671f\u4e09",
                "\u661f\u671f\u56db",
                "\u661f\u671f\u4e94",
                "\u661f\u671f\u516d"
            ],
            "ERANAMES": [
                "\u516c\u5143\u524d",
                "\u516c\u5143"
            ],
            "ERAS": [
                "\u516c\u5143\u524d",
                "\u516c\u5143"
            ],
            "FIRSTDAYOFWEEK": 6,
            "MONTH": [
                "\u4e00\u6708",
                "\u4e8c\u6708",
                "\u4e09\u6708",
                "\u56db\u6708",
                "\u4e94\u6708",
                "\u516d\u6708",
                "\u4e03\u6708",
                "\u516b\u6708",
                "\u4e5d\u6708",
                "\u5341\u6708",
                "\u5341\u4e00\u6708",
                "\u5341\u4e8c\u6708"
            ],
            "SHORTDAY": [
                "\u5468\u65e5",
                "\u5468\u4e00",
                "\u5468\u4e8c",
                "\u5468\u4e09",
                "\u5468\u56db",
                "\u5468\u4e94",
                "\u5468\u516d"
            ],
            "SHORTMONTH": [
                "1\u6708",
                "2\u6708",
                "3\u6708",
                "4\u6708",
                "5\u6708",
                "6\u6708",
                "7\u6708",
                "8\u6708",
                "9\u6708",
                "10\u6708",
                "11\u6708",
                "12\u6708"
            ],
            "WEEKENDRANGE": [
                5,
                6
            ],
            "fullDate": "y\u5e74M\u6708d\u65e5EEEE",
            "longDate": "y\u5e74M\u6708d\u65e5",
            "medium": "y\u5e74M\u6708d\u65e5 ah:mm:ss",
            "mediumDate": "y\u5e74M\u6708d\u65e5",
            "mediumTime": "ah:mm:ss",
            "short": "yy/M/d ah:mm",
            "shortDate": "yy/M/d",
            "shortTime": "ah:mm"
        },
        "NUMBER_FORMATS": {
            "CURRENCY_SYM": "\u00a5",
            "DECIMAL_SEP": ".",
            "GROUP_SEP": ",",
            "PATTERNS": [
                {
                    "gSize": 3,
                    "lgSize": 3,
                    "maxFrac": 3,
                    "minFrac": 0,
                    "minInt": 1,
                    "negPre": "-",
                    "negSuf": "",
                    "posPre": "",
                    "posSuf": ""
                },
                {
                    "gSize": 3,
                    "lgSize": 3,
                    "maxFrac": 2,
                    "minFrac": 2,
                    "minInt": 1,
                    "negPre": "\u00a4\u00a0-",
                    "negSuf": "",
                    "posPre": "\u00a4\u00a0",
                    "posSuf": ""
                }
            ]
        },
        "id": "zh-cn",
        "pluralCat": function (n, opt_precision) {
            return PLURAL_CATEGORY.OTHER;
        }
    });
}]);
(function () {
    'use strict';

    angular.module('Vendor.theme').config(calendarConfig);

    /** @ngInject */
    function calendarConfig(calendarConfig) {
        moment.locale('zh-cn', {
            week : {
                dow : 1
            }
        });
        calendarConfig.i18nStrings.weekNumber = '{week}周';
    }

})();
(function () {
    'use strict';

    angular.module('Vendor.theme').config(dialogConfig);

    /** @ngInject */
    function dialogConfig(dialogsProvider, $translateProvider) {
        dialogsProvider.useBackdrop('static');
        dialogsProvider.useEscClose(true);
        dialogsProvider.useCopy(false);
        dialogsProvider.setSize('sm');

        $translateProvider.preferredLanguage('zh-CN');
    }

})();

/**
 * Created by k.danovsky on 13.05.2016.
 */

(function () {
  'use strict';

  angular.module('Vendor.theme')
    .config(config);

  /** @ngInject */
  function config(baConfigProvider, colorHelper) {
    //baConfigProvider.changeTheme({blur: true});
    //
    //baConfigProvider.changeColors({
    //  default: 'rgba(#000000, 0.2)',
    //  defaultText: '#ffffff',
    //  dashboard: {
    //    white: '#ffffff',
    //  },
    //});
  }
})();

/**
 * Created by k.danovsky on 13.05.2016.
 */

(function () {
  'use strict';

  var basic = {
    default: '#ffffff',
    defaultText: '#666666',
    border: '#dddddd',
    borderDark: '#aaaaaa',
  };

  // main functional color scheme
  var colorScheme = {
    primary: '#209e91',
    info: '#2dacd1',
    success: '#90b900',
    warning: '#dfb81c',
    danger: '#e85656',
  };

  // dashboard colors for charts
  var dashboardColors = {
    blueStone: '#005562',
    surfieGreen: '#0e8174',
    silverTree: '#6eba8c',
    gossip: '#b9f2a1',
    white: '#10c4b5',
  };

  angular.module('Vendor.theme')
    .provider('baConfig', configProvider);

  /** @ngInject */
  function configProvider(colorHelper) {
    var conf = {
      theme: {
        blur: false,
      },
      colors: {
        default: basic.default,
        defaultText: basic.defaultText,
        border: basic.border,
        borderDark: basic.borderDark,

        primary: colorScheme.primary,
        info: colorScheme.info,
        success: colorScheme.success,
        warning: colorScheme.warning,
        danger: colorScheme.danger,

        primaryLight: colorHelper.tint(colorScheme.primary, 30),
        infoLight: colorHelper.tint(colorScheme.info, 30),
        successLight: colorHelper.tint(colorScheme.success, 30),
        warningLight: colorHelper.tint(colorScheme.warning, 30),
        dangerLight: colorHelper.tint(colorScheme.danger, 30),

        primaryDark: colorHelper.shade(colorScheme.primary, 15),
        infoDark: colorHelper.shade(colorScheme.info, 15),
        successDark: colorHelper.shade(colorScheme.success, 15),
        warningDark: colorHelper.shade(colorScheme.warning, 15),
        dangerDark: colorHelper.shade(colorScheme.danger, 15),

        dashboard: {
          blueStone: dashboardColors.blueStone,
          surfieGreen: dashboardColors.surfieGreen,
          silverTree: dashboardColors.silverTree,
          gossip: dashboardColors.gossip,
          white: dashboardColors.white,
        },
      }
    };

    conf.changeTheme = function(theme) {
      angular.merge(conf.theme, theme)
    };

    conf.changeColors = function(colors) {
      angular.merge(conf.colors, colors)
    };

    conf.$get = function () {
      delete conf.$get;
      return conf;
    };
    return conf;
  }
})();

/**
 * @author richard.fan
 * created on 15.12.2015
 */
(function () {
    'use strict';

    var injectVar = {imageRoot: "assets/img/"};

    angular.module('Vendor.theme')
        .constant('layoutSizes', {
            resWidthCollapseSidebar: 1200,
            resWidthHideSidebar: 500
        })
        .constant('layoutPaths', {
            images: {
                root: injectVar.imageRoot,
                profile: injectVar.imageRoot + 'profile/',
            }
        })
        .constant('colorHelper', {
            tint: function (color, weight) {
                return mix('#ffffff', color, weight);
            },
            shade: function (color, weight) {
                return mix('#000000', color, weight);
            },
        });

    function shade(color, weight) {
        return mix('#000000', color, weight);
    }

    function tint(color, weight) {
        return mix('#ffffff', color, weight);
    }

    //SASS mix function
    function mix(color1, color2, weight) {
        // convert a decimal value to hex
        function d2h(d) {
            return d.toString(16);
        }

        // convert a hex value to decimal
        function h2d(h) {
            return parseInt(h, 16);
        }

        var result = "#";
        for (var i = 1; i < 7; i += 2) {
            var color1Part = h2d(color1.substr(i, 2));
            var color2Part = h2d(color2.substr(i, 2));
            var resultPart = d2h(Math.floor(color2Part + (color1Part - color2Part) * (weight / 100.0)));
            result += ('0' + resultPart).slice(-2);
        }
        return result;
    }
})();

/**
 * @author v.lugovksy
 * created on 15.12.2015
 */
(function () {
    'use strict';

    angular.module('Vendor.theme')
        .run(themeRun);

    /** @ngInject */
    function themeRun($timeout, $rootScope, baSidebarService) {
        //var whatToWait = [
        //    preloader.loadAmCharts(),
        //    $timeout(3000)
        //];
        //
        //var theme = themeLayoutSettings;
        //if (theme.blur) {
        //    if (theme.mobile) {
        //        whatToWait.unshift(preloader.loadImg(layoutPaths.images.root + 'blur-bg-mobile.jpg'));
        //    } else {
        //        whatToWait.unshift(preloader.loadImg(layoutPaths.images.root + 'blur-bg.jpg'));
        //        whatToWait.unshift(preloader.loadImg(layoutPaths.images.root + 'blur-bg-blurred.jpg'));
        //    }
        //}
        //
        //$q.all(whatToWait).then(function () {
        //    $rootScope.$pageFinishedLoading = true;
        //});

        $timeout(function () {
            if (!$rootScope.$pageFinishedLoading) {
                $rootScope.$pageFinishedLoading = true;
            }
        }, 1000);

        $rootScope.$baSidebarService = baSidebarService;
    }

})();
/**
 * Created by k.danovsky on 12.05.2016.
 */

(function () {
  'use strict';

  angular.module('Vendor.theme')
    .service('themeLayoutSettings', themeLayoutSettings);

  /** @ngInject */
  function themeLayoutSettings(baConfig) {
    var isMobile = (/android|webos|iphone|ipad|ipod|blackberry|windows phone/).test(navigator.userAgent.toLowerCase());
    var mobileClass = isMobile ? 'mobile' : '';
    var blurClass = baConfig.theme.blur ? 'blur-theme' : '';
    angular.element(document.body).addClass(mobileClass).addClass(blurClass);

    return {
      blur: baConfig.theme.blur,
      mobile: isMobile,
    }
  }

})();
(function () {
    'use strict';

    angular.module('Vendor.theme').config(uibConfig);

    /** @ngInject */
    function uibConfig(uibDatepickerConfig, uibDatepickerPopupConfig) {
        uibDatepickerConfig.startingDay = 1;

        uibDatepickerPopupConfig.currentText = "今天";
        uibDatepickerPopupConfig.clearText = "清除";
        uibDatepickerPopupConfig.closeText = "关闭";
    }

})();
(function () {
    'use strict';

    angular.module('Vendor.theme').config(validationConfig);

    /** @ngInject */
    function validationConfig($validationProvider) {
        var expression = {
            required: function (value, scope, element, attrs, param) {
                if (param && !scope.Form[param].$modelValue) {
                    return true;
                }
                return !!value;
            },
            username: /^[a-zA-Z0-9_@\.]{3,}$/,
            password: function (value) {
                if (!!value) {
                    return !!value.match(/^[a-zA-Z0-9_\.]{6,}$/);
                }
                return true;
            },
            password2: function (value, scope, element, attrs, param) {
                var password = scope.vm.user.password;
                return password == value;
            },
            email: /^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/,
            phone: function (value) {
                if (!!value) {
                    return !!value.match(/^(13[0-9]|14[579]|15[0-3,5-9]|16[5-7]|17[0-3,5-8]|18[0-9]|19[12389])\d{8}$/);
                }
                return true;
            },
            tel: function (value) {
                if (!!value) {
                    return !!value.match(/(^(\d{3,4}-)?\d{7,8})$|(13[0-9]{9})/);
                }
                return true;
            },
            number: /^\d+$/,
            minlen: function (value, scope, element, attrs, param) {
                if (!!value) {
                    return value.length >= param;
                }
                return true;
            },
            maxlen: function (value, scope, element, attrs, param) {
                if (!!value) {
                    return value.length <= param;
                }
                return true;
            },
            minnum: function (value, scope, element, attrs, param) {
                if (!!value) {
                    return value >= +param;
                }
                return true;
            },
            maxnum: function (value, scope, element, attrs, param) {
                if (!!value) {
                    return value <= +param;
                }
                return true;
            },
        };

        var defaultMsg = {
            required: {
                error: '必填项!!'
            },
            username: {
                error: '用户名只能由下划线、数字、符号@、.和字母构成!'
            },
            password: {
                error: '密码只能由下划线、数字、符号.和字母构成!'
            },
            password2: {
                error: '密码两次密码必须一致!'
            },
            email: {
                error: '邮箱地址不正确'
            },
            phone: {
                error: '请填写地球上的手机号'
            },
            tel: {
                error: '请填写地球上的电话号码'
            },
            number: {
                error: '必须填写数字'
            },
            minlen: {
                error: '内容太短'
            },
            maxlen: {
                error: '内容太长'
            },
            minnum: {
                error: '数字太小'
            },
            maxnum: {
                error: '数字太大'
            }
        };
        $validationProvider.setExpression(expression).setDefaultMsg(defaultMsg);
        $validationProvider.showSuccessMessage = false;
    }

})();
/**
 * by richard
 */
(function () {
    'use strict';

    angular.module('Vendor.utils').factory('Api', apiService);

    /** @ngInject */
    function apiService(dialogs, toaster, Table) {
        var service = {
            /**
             * 删除表格中的数据项
             * @param s 服务
             * @param id 数据项id
             * @param vm 关联vm
             * @param itemType 数据项类型名称
             * @param itemName 数据项名称
             */
            delTableItem: delTableItem,
            setStop: setStop,
            /**
             *
             */
            w: w,
            e: e,
            s: s,
            EDIT: {
                SAVE: 1,
                STOP: 2
            }
        };

        return service;
        /**
         * 停用/启用某数据项，
         * @param s 服务
         * @param m 数据项
         */
        function setStop(s, m) {
            s.update({id: m.id}, {opt: service.EDIT.STOP, is_stop: !(m.is_stop == '1')})
                .$promise.then(function (resp) {
                m.is_stop = resp.is_stop;
            });
        }

        /**
         * 删除表格中的数据项
         * @param s 服务
         * @param id 数据项id
         * @param vm 关联vm
         * @param itemType 数据项类型名称
         * @param itemName 数据项名称
         */
        function delTableItem(s, id, vm, itemType, itemName) {
            dialogs.confirm('删除' + itemType, '确定要删除<strong>' + itemName + '</strong>'
                    + itemType + '吗？')
                .result.then(function () {
                Table.delItem(vm, s, id);
            });
        }

        ////////////////////////////////////////////////////////
        function w(msg) {
            toaster.warning(msg);
        }

        function e(msg) {
            toaster.error(msg);
        }

        function s(msg) {
            toaster.success(msg);
        }
    }
})();

/**
 * by richard
 */
(function () {
    'use strict';

    angular.module('Vendor.utils').factory('Array', arrayService);

    /** @ngInject */
    function arrayService() {
        var service = {
            inArray: inArray,
            indexOf: inArray,
            bitwise2array: bitwise2array,
            array2bitwise: array2bitwise,
            getItem: getItem,
            getItems: getItems,
            indexOfKey: indexOfKey,
            listKey: listKey,
            shuffle: shuffle,
            map: map,
            getParent: getParent
        };

        return service;


        function listKey(items, key) {
            if (typeof(key) === 'undefined') {
                key = 'id';
            }
            var i = -1;
            var result = [];
            while (++i < items.length) {
                result.push(items[i][key]);
            }
            return result;
        }

        function getItems(value, items, key) {
            if (typeof(key) === 'undefined') {
                key = 'id';
            }
            var i = -1;
            var result = [];
            while (++i < items.length) {
                if (items[i][key] == value) {
                    result.push(items[i]);
                }
            }
            return result;
        }

        function indexOfKey(value, items, key) {
            if (typeof(key) === 'undefined') {
                key = 'id';
            }
            var i = -1;
            while (++i < items.length) {
                if (items[i][key] == value)
                    return i;
            }
            return -1;
        }

        function getItem(value, items, key) {
            if (typeof(key) === 'undefined') {
                key = 'id';
            }
            var i = -1;
            while (++i < items.length) {
                if (items[i][key] == value)
                    return items[i];
            }
            return null;
        }

        /**
         * 打乱数组顺序
         * @param a
         */
        function shuffle(a) {
            var j, x, i;
            for (i = a.length; i; i--) {
                j = Math.floor(Math.random() * i);
                x = a[i - 1];
                a[i - 1] = a[j];
                a[j] = x;
            }
        }

        /**
         * 上传图片
         * @param image->json, 其中需要填写的属性包括toUrl:上传地址，croppedDataUrl：裁剪后生成的url
         * @returns {*}
         */
        function bitwise2array(b, n) {
            var a = [];
            for (var i = 0; i < n; i++) {
                a[i] = (b & 1) == 1;
                b >>= 1;
            }
            return a;
        }

        function array2bitwise(a) {
            var b = 0;
            for (var i = 0; i < a.length; i++) {
                if (a[i]) {
                    b |= (1 << i);
                }
            }
            return b;
        }

        function inArray(val, arr) {
            var i = arr.length;
            while (i--) {
                if (angular.equals(val, arr[i])) return i;
            }
            return -1
        }

        function map(arr, mapFn) {
            var mapArr = [];
            angular.forEach(arr, function (item) {
                mapArr.push(mapFn(item));
            });
            return mapArr;
        }

        function getParent(type) {
            if (type.parent && type.parent_id != 1) {
                return getParent(type.parent);
            }
            return type
        }
    }
})();

/**
 * by richard
 */
(function () {
    'use strict';

    angular.module('Vendor.utils').factory('File', fileService);

    /** @ngInject */
    function fileService($q, $http, toaster, FileSaver, Blob, Array, Upload) {
        var service = {
            uploadCroppedImage: uploadCroppedImage,
            upload: upload,
            upload1: upload1,
            download: download,
            isAttachmentsUploaded: isAttachmentsUploaded,
            dnExcel: dnExcel,
            uploadAttachment: uploadAttachment,
        };

        return service;

        /**
         * 上传裁剪后的图片
         * @param image->json, 其中需要填写的属性包括toUrl:上传地址，croppedDataUrl：裁剪后生成的url
         * @returns {*}
         */
        function uploadCroppedImage(image) {
            var defer = $q.defer();
            if (Upload.isUploadInProgress()) {
                defer.reject("正在上传，请稍后再试");
            } else {
                var file = Upload.dataUrltoBlob(image.croppedDataUrl);
                if (file.$error) {
                    defer.reject("图片不能大于20M");
                } else {
                    image.inProgress = true;
                    Upload.upload({
                        url: image.toUrl, data: {file: file}
                    }).then(function (resp) {
                        defer.resolve(resp.data.url);
                    }, function () {
                        defer.reject("服务器错误");
                    }, function (evt) {
                        image.progress = parseInt(100.0 * evt.loaded / evt.total);
                    }).finally(function () {
                        image.inProgress = false;
                    });
                }
            }
            return defer.promise;
        }

        /**
         * 对多附件上传的封装
         * @param url
         * @param file
         * @param pkg
         * @param e
         * @returns {*}
         */
        function upload(url, file, pkg, e) {
            var defer = $q.defer();
            if (Upload.isUploadInProgress()) {
                defer.reject("正在上传，请稍后再试");
            } else if (e && e[0] && e[0].$error == 'maxSize') {
                defer.reject('<strong>单个文件不能超过' + e[0].$errorParam + '</strong>' + '\n' + e[0].name);
            } else if (!file) {
            } else {
                var attachment = {name: file.name, progress: 0, inProgress: false};
                pkg.attachments.push(attachment);
                Upload.upload({
                    url: url, file: file
                }).then(function (resp) {
                    var data = resp.data;
                    attachment.name = data.name;
                    attachment.mime = data.mime;
                    attachment.filename = data.filename;
                    attachment.size = data.size;
                    defer.resolve(attachment);
                }, function () {
                    var i = Array.indexOf(attachment, pkg.attachments);
                    if (i != -1) {
                        pkg.attachments.splice(i, 1);
                    }
                    defer.reject("服务器错误");
                }, function (evt) {
                    attachment.progress = parseInt(100.0 * evt.loaded / evt.total);
                }).finally(function () {
                    attachment.inProgress = false;
                });
            }
            return defer.promise;
        }

        /**
         * 对单个附件上传的封装
         */
        function upload1(url, file, item, e) {
            var defer = $q.defer();
            if (Upload.isUploadInProgress()) {
                defer.reject("正在上传，请稍后再试");
            } else if (e && e[0] && e[0].$error == 'maxSize') {
                defer.reject('<strong>单个文件不能超过' + e[0].$errorParam + '</strong>' + '\n' + e[0].name);
            } else if (!file) {
            } else {
                item.inProgress = true;
                Upload.upload({
                    url: url, file: file
                }).then(function (resp) {
                    var data = resp.data;
                    item.name = data.name;
                    item.mime = data.mime;
                    item.filename = data.filename;
                    item.size = data.size;
                    defer.resolve(item);
                }, function () {
                    defer.reject("服务器错误");
                }, function (evt) {
                    item.progress = parseInt(100.0 * evt.loaded / evt.total);
                }).finally(function () {
                    item.inProgress = false;
                });
            }
            return defer.promise;
        }

        /**
         * 检查多附件上传中，所有附件是否都已上传并返回服务器文件路径
         * @param pkg
         * @returns {boolean}
         */
        function isAttachmentsUploaded(pkg) {
            for (var i = 0; i < pkg.attachments.length; i++) {
                if (!pkg.attachments[i].filename) {
                    return false;
                }
            }
            return true;
        }

        /**
         * 下载文件
         * @param url 文件资源地址
         * @param item 文件信息数据
         * @param rename 重命名文件信息数据中的字段
         */
        function download(url, item, rename) {
            if (angular.isUndefined(rename)) {
                rename = {};
            }
            if (!rename.name) rename.name = 'name';
            if (!rename.mime) rename.mime = 'mime';
            if (!rename.filename) rename.filename = 'filename';
            if (!rename.size) rename.size = 'size';
            var params = {name: item[rename.name], filename: item[rename.filename], mime: item[rename.mime]};
            item.downloading = true;
            $http({
                url: url,
                method: "POST",
                data: params,
                headers: {
                    'Content-type': 'application/json'
                },
                responseType: 'arraybuffer'
            }).success(function (resp) {
                item.downloading = false;
                var data = new Blob([resp], {type: item[rename.mime]});
                FileSaver.saveAs(data, item[rename.name]);
            }).error(function (error) {
                item.downloading = false;
                toaster.error('服务端文件丢失，请联系管理员！');
            });
        }

        function dnExcel(url, params, filename, cb) {
            return $http({
                url: url,
                method: "POST",
                data: params,
                headers: {
                    'Content-type': 'application/json'
                },
                responseType: 'arraybuffer'
            }).success(function (resp) {
                var data = new Blob([resp], {type: 'vnd.ms-excel'});
                FileSaver.saveAs(data, filename);
                if (cb) cb();
            });
        }

        function uploadAttachment(file, data, e) {
            service.upload('/api/v1/file/attachments/upload_single', file, data, e);
        }
    }
})();

/**
 * by richard
 */
(function () {
    'use strict';

    angular.module('Vendor.utils').factory('Misc', miscService);

    /** @ngInject */
    function miscService(deviceDetector, OS, Upload, dialogs, uibDateParser, Array, $filter, $sce, $templateRequest, $timeout) {
        var service = {
            destroyEditor: destroyEditor,
            initEditor: initEditor,
            getIconFromMime: getIconFromMime,
            datetime2Str: datetime2Str,
            date2Str: date2Str,
            str2Date: str2Date,
            print: print,
            toFixed: toFixed,
            isWxBrowser: isWxBrowser
        };

        return service;


        function destroyEditor() {
            for (var i in CKEDITOR.instances) {
                var editor = CKEDITOR.instances[i];
                if (editor) editor.destroy();
            }
        }

        function onCKReady(editor) {
            var editor = CKEDITOR.instances[editor];
            if (!editor) return;
            //目前只支持桌面
            if (deviceDetector.isDesktop()) {
                editor.on('afterInsertHtml', function (evt) {
                    //解决从word拷贝图片的问题...
                    var editable = editor.editable();
                    var imgList = editable.find('img').$;
                    var localImgList = {};
                    angular.forEach(imgList, function (img) {
                        if (img.src.match(/^file:\/\//)) {
                            if (Array.indexOfKey(img.src, localImgList, 'src') == -1) {
                                var filename = img.src.replace(/^.*(\\|\/|\:)/, '');
                                localImgList[filename] = img;
                            }
                        }
                    });
                    if (Object.keys(localImgList).length > 0) {
                        if (editor.commands.maximize.state == '1') {
                            editor.execCommand('maximize');
                        }

                        var files = [], startIndex = 7, changeSeparator = false;
                        if (deviceDetector.os == OS.WINDOWS) {
                            startIndex = 8;
                            changeSeparator = true;
                        }
                        var names = Object.keys(localImgList);
                        angular.forEach(names, function (name) {
                            var img = localImgList[name];
                            var path = img.src.substr(startIndex);
                            if (changeSeparator) {
                                path = path.replace(/\//g, "\\");
                            }
                            files.push({name: name, path: path});
                        });
                        dialogs.create('app/pages/dialogs/editor/upload.html', 'editorImageUploadCtrl', {
                            files: files
                        }, {
                            animation: true, size: 'md'
                        }, 'vm').result.then(function (result) {
                            var widgets = editor.widgets.instances,
                                curWidget,
                                i;
                            for (i in widgets) {
                                curWidget = widgets[i];
                                if (curWidget.definition.name == 'image') {
                                    var name = curWidget.parts.image.getAttribute('src').replace(/^.*(\\|\/|\:)/, '');
                                    var url = result[name];
                                    if (url) {
                                        curWidget.setData('src', url);
                                    }
                                }
                            }
                        });
                    }
                });
            }

            editor.on('fileUploadRequest', function (evt) {
                var loader = evt.data.fileLoader;
                var file = Upload.dataUrltoBlob(loader.data);
                Upload.upload({
                    url: loader.uploadUrl, data: {file: file}
                }).progress(function (evt) {
                    if (!loader.uploadTotal) {
                        loader.uploadTotal = evt.total;
                    }
                    loader.uploaded = evt.loaded;
                    loader.update();
                }).success(function (resp) {
                    if (resp.error && resp.error.message) {
                        loader['message'] = resp.error.message;
                    }
                    if (resp.result == '1') {
                        evt.cancel();
                        loader.changeStatus('error');
                    } else {
                        loader['url'] = resp.url;
                        loader['filename'] = resp.fileName;
                        loader.changeStatus('uploaded');
                    }
                }).error(function () {
                    loader.changeStatus('error');
                });
                evt.stop();
            });
        }

        function initEditor(vm) {
            vm.onCKReady = onCKReady;
        }

        function getIconFromMime(mime) {
            var app2Ico = {
                "zip": "file-archive-o",
                "x-7z-compressed": "file-archive-o",
                "x-gtar-compressed": "file-archive-o",
                "x-gtar": "file-archive-o",
                "x-tar": "file-archive-o",
                "rar": "file-archive-o",
                "x-rar": "file-archive-o",
                "pdf": "file-pdf-o",
                "vnd.ms-powerpoint": "file-powerpoint-o",
                "vnd.openxmlformats-officedocument.presentationml.presentation": "file-powerpoint-o",
                "msword": "file-word-o",
                "vnd.openxmlformats-officedocument.wordprocessingml.document": "file-word-o",
                "vnd.ms-excel": "file-excel-o",
                "vnd.openxmlformats-officedocument.spreadsheetml.sheet": "file-excel-o"
            };
            var mime2Ico = {
                "video": "file-video-o",
                "audio": "file-audio-o",
                "image": "file-image-o",
                "text": "file-text-o"
            };

            var len = mime.indexOf('/');
            var type = mime.substr(0, len);

            var ico = mime2Ico[type];
            if (ico == null) {
                var app = mime.substr(len + 1, mime.length);
                ico = app2Ico[app];
                if (ico == null) {
                    ico = 'file-o'
                }
            }
            return ico;
        }

        function datetime2Str(datetime) {
            return $filter('date')(datetime, "yyyy-MM-dd HH:mm");
        }

        function date2Str(datetime) {
            return $filter('date')(datetime, "yyyy-MM-dd");
        }

        function str2Date(str) {
            return uibDateParser.parse(str, "yyyy-MM-dd");
        }

        /**
         * @param w, 已打开窗口
         * @param styleFile:string, style文件
         * @param createBody:function, 创建<body>元素内的html并返回
         */
        function print(w, styleFile, createBody) {

            var templateUrl = $sce.getTrustedResourceUrl(styleFile, '');
            $templateRequest(templateUrl).then(function (resp) {
                var printStyle = resp;

                var html = '<html><body>';

                html += createBody();

                html += '</body></html>';

                w.document.write(html + printStyle);

                w.document.close();
                w.focus();
                $timeout(function () {
                    w.print();
                    w.close();
                }, 24);
            });
        }

        function toFixed(floatNum, decimal) {
            return parseFloat(floatNum.toFixed(decimal));
        }

        function isWxBrowser() {
            var microMessenger = navigator.userAgent.toLowerCase().match(/MicroMessenger/i);
            return microMessenger && microMessenger.toString() === 'micromessenger'
        }

    }
})();

/**
 * @author richard.fan
 * created on 15.12.2015
 */
(function () {
    'use strict';

    angular.module('Vendor.values')
        .constant('urls', {
            IMG_CROPPED_UPLOAD: '/api/v1/file/images/upload_cropped',
            IMG_UPLOAD: '/api/v1/file/images/upload',
        });
})();

/**
 * @author richard
 */
(function () {
    'use strict';

    angular.module('Vendor.pages.auth')
        .controller('AuthCtrl', AuthCtrl)
        .controller('WxAuthCtrl', WxAuthCtrl)
        .controller('WechatAuthCtrl', WechatAuthCtrl)
    ;


    /** @ngInject */
    function AuthCtrl($rootScope, $state, $http, $interval, toaster, Auth) {
        var vm = this;
        vm.user = {};
        vm.login = login;
        vm.getSmsPassword = getSmsPassword;
        vm.getSmsBtnText = getSmsBtnText;
        vm.remain = -1;


        $rootScope.$isAuth = true;

        function login(user) {
            user.sms_login = vm.smsLogin;
            Auth.login(user, function (resp) {
                $rootScope.$isAuth = false;
                Auth.setPromptLogin(false);
                if (vm.smsLogin) {
                    $state.go('main.info.password');
                } else {
                    $state.go('main.dashboard');
                }
            }, function (resp) {
                toaster.error(resp.msg);
            });
        }

        function getSmsPassword() {
            if (!vm.user.username
                || !vm.user.username.match(/^(0|86|17951)?1(3[0-9]|4[57]|5[0-35-9]|7[0-35-8]|8[0-9]|9[0-9])\d{8}$/)) {
                toaster.error('手机号格式不正确');
                return
            }
            $http.post("/auth/sms/password", {
                phone: vm.user.username
            }).then(
                function () {
                    vm.remain = 60;
                    var intervalId = $interval(function () {
                        vm.remain--;
                        if (vm.remain === 0) {
                            $interval.cancel(intervalId)
                        }
                    }, 1000)
                }
            ).catch(function (error) {
                    toaster.error(error.data.message);
                }
            )
        }

        function getSmsBtnText() {
            return vm.remain > 0 ? '重新获取(' + vm.remain + ')'
                : vm.remain === 0 ? '重新获取' : '获取短信动态密码'
        }
    }

    /** @ngInject */
    function WxAuthCtrl(Auth, $window, $stateParams) {
        $window.localStorage['entry'] = $stateParams.entry || 0;
        $window.location.href = Auth.getWxAuthorizeUrl();
    }

    /** @ngInject */
    function WechatAuthCtrl($state, $location, toaster, Auth, $window) {
        // 获取返回参数 code 和 state
        var code = $location.search().code;
        var state = $location.search().state;
        //出入口
        var entry = $window.localStorage['entry'] || 0;
        $window.localStorage['entry'] = null;

        Auth.wxLogin(code, state, entry).then(function (data) {
            switch (data.result) {
                case 0:
                    Auth.setToken(data.token, false);
                    Auth.setUser(data.account);
                    $state.go(data.entry);
                    break;
                case 1:
                    toaster.error(data.msg);
                    break;
                case 2:  //用户未绑定微信
                    //toaster.warning(data.msg);
                    var openid = data.openid;
                    window.location.href = Auth.WX_BIND + '?openid=' + openid;
                    break;
            }
        });
    }
})();

/**
 * @author richard
 */
(function () {
    'use strict';
    angular.module('Vendor.pages.auth').factory('Auth', Auth);

    function Auth($timeout, $injector, $localStorage, $q) {
        var service = {
            setToken: setToken,
            getToken: getToken,
            hasToken: hasToken,
            deleteToken: deleteToken,
            getUser: getUser,
            setUser: setUser,
            hasUser: hasUser,
            setPromptLogin: setPromptLogin,
            isPromptLogin: isPromptLogin,
            refreshToken: refreshToken,
            login: login,
            logout: logout,
            reset: reset,

            wxLogin: wxLogin,
            getWxAuthorizeUrl: getWxAuthorizeUrl,
            API_AUTH_LOGIN: '/api/wx/get_cj_wechat_token',
            WX_API_ID: 'wx8d575c5c02c4add7',
            WX_AUTH_REDIRECT_URL: 'http://jxs.tcd120.cn/get_cj_wechat_token',
            WX_BIND: '/api/wx/se_bind',
            VENDOR_ID: 128
        };
        var $http;
        var promptLogin = false;

        init();

        return service;

        function init() {
            $timeout(function () {
                $http = $injector.get('$http');
            }, 0);
        }

        function setToken(token) {
            $localStorage.dealerToken = token;
        }

        function getToken() {
            return $localStorage.dealerToken;
        }

        function setUser(user) {
            $localStorage.dealerUser = user;
        }

        function getUser() {
            return $localStorage.dealerUser == null ? {} : $localStorage.dealerUser;
        }

        function deleteToken() {
            delete $localStorage.dealerToken;
            delete $localStorage.dealerUser;
        }

        function hasUser() {
            return $localStorage.dealerUser != null;
        }

        function hasToken() {
            return $localStorage.dealerToken != null;
        }

        function setPromptLogin(isPrompt) {
            promptLogin = isPrompt;
        }

        function isPromptLogin() {
            return promptLogin;
        }

        function login(data, successFn, errorFn) {
            $http.post('/auth/token/issue', data).success(function (resp) {
                setToken(resp.token);
                setUser(resp.account);
                if (successFn) {
                    successFn(resp);
                }
            }).error(function (resp) {
                if (errorFn) {
                    errorFn(resp);
                }
            });
        }

        function logout(success) {
            $http.post('/auth/token/revoke').finally(function () {
                deleteToken();
                success();
            });
        }

        function refreshToken() {
            return $http.post('/auth/token/refresh')
        }

        function reset(data, successFn, errorFn) {
            $http.post('/api/v1/user/password/reset', data).success(successFn).error(errorFn)
        }

        function getWxAuthorizeUrl() {
            var appId = service.WX_API_ID,
                rUrl = window.encodeURIComponent(service.WX_AUTH_REDIRECT_URL);
            var url = 'https://www.tcd120.cn/get-weixin-code.html?appid=' + appId + '&scope=snsapi_base&state=123&redirect_uri='
                + rUrl;
            return url;
        }

        function wxLogin(code, state, entry) {
            var deferred = $q.defer();
            // 构造 url
            var url = service.API_AUTH_LOGIN + "?code=" + code + "&state=" + state + "&entry=" + entry;
            // 发送 get
            if (angular.isUndefined($http)) $http = $injector.get('$http');
            $http.get(url).then(function (data) {
                deferred.resolve(data.data);
            }, function (data) {
                deferred.reject(data);
            });
            return deferred.promise;
        }
    }
})();
(function () {
    'use strict';
    angular.module('Vendor.pages.csmbs')
        .factory('ConsumableVariety', ConsumableVarietyServiceFn)
        .factory('Consumable', ConsumableServiceFn)
        .factory('ConsumableType', ConsumableTypeServiceFn)
        .factory('ConsumableImg', ConsumableImgServiceFn)
        .factory('ConsumableQualification', ConsumableQualificationServiceFn)
        .factory('Province', ProvinceServiceFn)
        .factory('Country', CountryServiceFn)
        .factory('Producer', ProducerServiceFn)
        .factory('CsmbPrice', CsmbPriceServiceFn)
        .factory('CsmbGroup', CsmbGroupServiceFn)
        .factory('CsmbQA', CsmbQAServiceFn)
        .factory('CsmbInvoice', CsmbInvoiceServiceFn)
        .factory('CsmbDirectApplication', CsmbDirectApplicationServiceFn)
        .factory('CsmbDirectReissues', CsmbDirectReissuesServiceFn)
        .factory('CsmbDirectReturn', CsmbDirectReturnServiceFn)
        .factory('CsmbUpdate', CsmbUpdateServiceFn)
        .factory('DirectBatchItem', DirectBatchItemServiceFn)
        .factory('CsmbBatchItem', CsmbBatchItemServiceFn)
        .factory('StoreroomIn', StoreroomInServiceFn)
        .factory('CsmbSdPrice', CsmbSdPriceServiceFn)
        .factory('SecondaryDealer', SecondaryDealerServiceFn)
        .factory('CVStop', CVStopServiceFn)
        .factory('CsmbStop', CsmbStopServiceFn)
    ;

    /** @ngInject */
    function ConsumableVarietyServiceFn($resource) {
        var service = {
            getUnits: getUnits,
            getStates: getStates,
            getGroups: getGroups,
            getManageTypes: getManageTypes,
        };

        return angular.extend(service, $resource('/api/v1/consumable/consumable_varieties/:id', {}, {
            query: {
                method: 'GET'
            },
            update: {
                method: 'PUT'
            }
        }));

        function getUnits() {
            return [
                {id: 1, name: "箱"},
                {id: 2, name: "件"},
                {id: 3, name: "盒"},
                {id: 4, name: "包"},
                {id: 5, name: "袋"},
                {id: 6, name: "套"},
                {id: 7, name: "支"},
                {id: 8, name: "瓶"},
                {id: 9, name: "只"},
                {id: 10, name: "个"},
                {id: 11, name: "把"},
                {id: 12, name: "颗"},
                {id: 13, name: "张"},
                {id: 14, name: "片"},
                {id: 15, name: "条"},
                {id: 16, name: "枚"},
                {id: 17, name: "块"},
                {id: 18, name: "粒"},
                {id: 19, name: "根"},
                {id: 20, name: "具"},
                {id: 21, name: "双"},
                {id: 22, name: "台"},
                {id: 23, name: "卷"},
                {id: 24, name: "副"},
                {id: 25, name: "克"},
                {id: 26, name: "份"},
                {id: 27, name: "半盒"},
                {id: 28, name: "安瓿"},
                {id: 29, name: "提"},
                {id: 30, name: "本"},
                {id: 31, name: "罐"},
                {id: 32, name: "次"},
                {id: 33, name: "米"},
                {id: 34, name: "平方"},
                {id: 35, name: "板"},
                {id: 36, name: "厘米"},
                {id: 37, name: "平方厘米"},
                {id: 38, name: "桶"},
                {id: 39, name: "组"},
                {id: 40, name: "节"},
                {id: 41, name: "位"},
                {id: 42, name: "排"},
                {id: 43, name: "斤"},
                {id: 44, name: "付"},
                {id: 45, name: "公斤"},
                {id: 46, name: "升"},
                {id: 47, name: "分米"},
                {id: 48, name: "吨"},
                {id: 49, name: "批"},
                {id: 50, name: "平方分米"},
                {id: 51, name: "床"},
                {id: 52, name: "人/份"}
            ];
        }

        function getStates() {
            return [
                {id: 1, name: "待审批"},
                {id: 2, name: "退回"},
                {id: 3, name: "待定报销类型"},
                {id: 4, name: "使用中"},
                {id: 5, name: "草稿"}
            ];
        }

        function getGroups() {
            return [
                {id: 1, name: "生化"},
                {id: 2, name: "临检"},
                {id: 3, name: "免疫"},
                {id: 4, name: "微生物"},
                {id: 5, name: "输血科"},
                {id: 6, name: "分子组"}
            ];
        }

        function getManageTypes() {
            return [
                {id: 1, name: "一类"},
                {id: 2, name: "二类"},
                {id: 3, name: "三类"},
                {id: 4, name: "试剂类"},
                {id: 5, name: "器械类"}
            ];
        }
    }

    /** @ngInject */
    function ConsumableServiceFn($resource) {
        var service = {
            getStates: getStates,
            getHisFeeTypes: getHisFeeTypes
        };

        return angular.extend(service, $resource('/api/v1/consumable/consumables/:id', {}, {
            query: {
                method: 'GET'
            },
            update: {
                method: 'PUT'
            }
        }));

        function getStates() {
            return [
                {id: 1, name: "待审批"},
                {id: 2, name: "退回"},
                {id: 3, name: "待核价"},
                {id: 4, name: "使用中"},
                {id: 5, name: "草稿"}
            ];
        }

        function getHisFeeTypes() {
            return [
                {id: 11, name: "检查用一次性医用材料费"},
                {id: 29, name: "治疗用一次性医用耗材费"},
                {id: 30, name: "手术用一次性医用耗材费"},
                {id: 255, name: "无法计费"}
            ];
        }
    }

    /** @ngInject */
    function ConsumableTypeServiceFn($resource) {
        var service = {};

        return angular.extend(service, $resource('/api/v1/consumable/types/:id', {}, {
            query: {
                method: 'GET'
            },
            update: {
                method: 'PUT'
            }
        }));
    }

    /** @ngInject */
    function ConsumableImgServiceFn($resource) {
        var service = {};

        return angular.extend(service, $resource('/api/v1/consumable/consumable_images/:id', {}, {
            query: {
                method: 'GET'
            },
            update: {
                method: 'PUT'
            }
        }));
    }

    /** @ngInject */
    function ConsumableQualificationServiceFn($resource) {
        var service = {};

        return angular.extend(service, $resource('/api/v1/consumable/consumable_qualifications/:id', {}, {
            query: {
                method: 'GET'
            },
            update: {
                method: 'PUT'
            }
        }));
    }

    /** @ngInject */
    function ProvinceServiceFn($resource) {
        var service = {};

        return angular.extend(service, $resource('/api/v1/area/provinces/:id', {}, {
            query: {
                method: 'GET'
            },
            update: {
                method: 'PUT'
            }
        }));
    }


    /** @ngInject */
    function CountryServiceFn($resource) {
        var service = {};

        return angular.extend(service, $resource('/api/v1/area/countries/:id', {}, {
            query: {
                method: 'GET'
            },
            update: {
                method: 'PUT'
            }
        }));
    }

    /** @ngInject */
    function ProducerServiceFn($resource) {
        var service = {};

        return angular.extend(service, $resource('/api/v1/vendor/producers/:id', {}, {
            query: {
                method: 'GET'
            },
            update: {
                method: 'PUT'
            }
        }));
    }

    /** @ngInject */
    function CsmbPriceServiceFn($resource) {
        var service = {
            getStates: getStates
        };

        return angular.extend(service, $resource('/api/v1/consumable/csmb_price_applications/:id', {}, {
            query: {
                method: 'GET'
            },
            update: {
                method: 'PUT'
            }
        }));

        function getStates() {
            return [
                {id: 1, name: "采购审批"},
                {id: 2, name: "设备科审批"},
                {id: 3, name: "医保办审批"},
                {id: 4, name: "完成"},
                {id: 5, name: "退回"}
            ];
        }
    }

    /** @ngInject */
    function CsmbGroupServiceFn($resource) {
        var service = {};

        return angular.extend(service, $resource('/api/v1/consumable/csmb_groups/:action/:id', {
            id: '@id',
            action: '@action'
        }, {
            query: {
                method: 'GET'
            },
            update: {
                method: 'PUT'
            },
            attach_csmbs: {
                method: 'POST',
                params: {
                    action: 'attach_csmbs'
                }
            },
            detach_csmbs: {
                method: 'POST',
                params: {
                    action: 'detach_csmbs'
                }
            },
            set_csmb_stop: {
                method: 'POST',
                params: {
                    action: 'set_csmb_stop'
                }
            },
            batch: {
                method: 'POST',
                params: {
                    action: 'batch'
                }
            }
        }));
    }

    /** @ngInject */
    function CsmbQAServiceFn($resource) {
        var service = {
            getStates: getStates,
            getTypes: getTypes
        };

        return angular.extend(service, $resource('/api/v1/consumable/csmb_qualification_applications/:id', {}, {
            query: {
                method: 'GET'
            },
            update: {
                method: 'PUT'
            }
        }));

        function getStates() {
            return [
                {id: 1, name: "待审批"},
                {id: 2, name: "退回"},
                {id: 3, name: "完成"}
            ];
        }

        function getTypes() {
            return [
                {id: 1, name: "新增"},
                {id: 2, name: "解绑"},
                {id: 3, name: "新增并更改注册证号"}
            ];
        }
    }

    /** @ngInject */
    function CsmbInvoiceServiceFn($resource) {
        var service = {
            getStates: getStates,
            getTypes: getTypes,
            convertFee: convertFee
        };

        return angular.extend(service, $resource('/api/v1/consumable/csmb_invoices/:id', {}, {
            query: {
                method: 'GET'
            },
            update: {
                method: 'PUT'
            }
        }));

        function getStates() {
            return [
                {id: 1, name: "开票待审"},
                {id: 2, name: "设备科已审"},
                {id: 3, name: "财务科已审"},
                {id: 4, name: "退回"}
            ];
        }

        function getTypes() {
            return [
                {id: 1, name: "邮寄"},
                {id: 2, name: "送达"}
            ];
        }

        /** 数字金额大写转换(可以处理整数,小数,负数) */
        function convertFee(n) {
            var fraction = ['角', '分'];
            var digit = ['零', '壹', '贰', '叁', '肆', '伍', '陆', '柒', '捌', '玖'];
            var unit = [['元', '万', '亿'], ['', '拾', '佰', '仟']];
            var head = n < 0 ? '欠' : '';
            n = Math.abs(n);

            var s = '';

            for (var i = 0; i < fraction.length; i++) {
                s += (digit[Math.floor(n * 10 * Math.pow(10, i)) % 10] + fraction[i]).replace(/零./, '');
            }
            s = s || '整';
            n = Math.floor(n);

            for (var i = 0; i < unit[0].length && n > 0; i++) {
                var p = '';
                for (var j = 0; j < unit[1].length && n > 0; j++) {
                    p = digit[n % 10] + unit[1][j] + p;
                    n = Math.floor(n / 10);
                }
                s = p.replace(/(零.)*零$/, '').replace(/^$/, '零') + unit[0][i] + s;
            }
            return head + s.replace(/(零.)*零元/, '元').replace(/(零.)+/g, '零').replace(/^整$/, '零元整');
        }
    }

    /** @ngInject */
    function CsmbDirectApplicationServiceFn($resource) {
        var service = {
            getStates: getStates,
            getVendorStates: getVendorStates,
            getVendorApprovalStates: getVendorApprovalStates,
            getLevels: getLevels
        };

        return angular.extend(service, $resource('/api/v1/consumable/csmb_direct_applications/:action/:id', {
            id: '@id',
            action: '@action'
        }, {
            query: {
                method: 'GET'
            },
            update: {
                method: 'PUT'
            }
        }));

        function getStates() {
            return [
                {id: 1, name: "科室审核"},
                {id: 2, name: "科室拒绝"},
                {id: 3, name: "分管院审核"},
                {id: 4, name: "分管院拒绝"},
                {id: 5, name: "主管院审核"},
                {id: 6, name: "主管院拒绝"},
                {id: 7, name: "库房未确认"},
                {id: 8, name: "库房拒绝"},
                {id: 9, name: "经销商未确认"},
                {id: 10, name: "经销商发货中"},
                {id: 11, name: "库房已收货"},
                //{id: 12, name: "科室已收货"},
                {id: 13, name: "经销商待补货"},
                {id: 14, name: "经销商补货中"},
                {id: 15, name: "申请终止"},
                {id: 12, name: "申请完成"}
            ];
        }

        function getVendorApprovalStates() {
            return [
                {id: 9, name: "经销商未确认"},
                {id: 13, name: "经销商待补货"}
            ];
        }

        function getVendorStates() {
            return [
                {id: 10, name: "经销商发货中"},
                {id: 11, name: "库房已收货"},
                //{id: 12, name: "科室已收货"},
                {id: 13, name: "经销商待补货"},
                {id: 14, name: "经销商补货中"},
                {id: 12, name: "申请完成"}
            ];
        }

        function getLevels() {
            return [
                {id: 1, name: '无需审核'},
                {id: 2, name: '科室审核'},
                {id: 3, name: '分管院审核'},
                {id: 4, name: '主管院审核'}
            ];
        }
    }


    /** @ngInject */
    function CsmbDirectReissuesServiceFn($resource) {
        var service = {};

        return angular.extend(service, $resource('/api/v1/consumable/dept_csmb_direct_reissues/:action/:id', {
            id: '@id',
            action: '@action'
        }, {
            update: {
                method: 'PUT'
            },
            query: {
                method: 'GET'
            },
            batch: {
                method: 'POST',
                params: {
                    action: 'batch'
                }
            },
            confirm: {
                method: 'POST',
                params: {
                    action: 'confirm'
                }
            }
        }));
    }

    /** @ngInject */
    function CsmbDirectReturnServiceFn($resource) {
        var service = {
            getStates: getStates
        };

        return angular.extend(service, $resource('/api/v1/consumable/csmb_direct_return_applications/:action/:id', {
            id: '@id',
            action: '@action'
        }, {
            update: {
                method: 'PUT'
            },
            query: {
                method: 'GET'
            }
        }));


        function getStates() {
            return [
                {id: 4, name: "经销商确认"},
                {id: 5, name: "经销商拒绝"}
            ];
        }
    }

    /** @ngInject */
    function CsmbUpdateServiceFn($resource) {
        var service = {
            getStates: getStates
        };

        return angular.extend(service, $resource('/api/v1/consumable/csmb_update_applications/:action/:id', {
            id: '@id',
            action: '@action'
        }, {
            update: {
                method: 'PUT'
            },
            query: {
                method: 'GET'
            }
        }));


        function getStates() {
            return [
                {id: 1, name: "待审批"},
                {id: 2, name: "已审批"},
                {id: 3, name: "退回"}
            ];
        }
    }

    /** @ngInject */
    function DirectBatchItemServiceFn($resource) {
        var service = {
            getStates: getStates
        };

        return angular.extend(service, $resource('/api/v1/consumable/direct_batch_items/:action/:id', {
            id: '@id',
            action: '@action'
        }, {
            update: {
                method: 'PUT'
            },
            query: {
                method: 'GET'
            }
        }));


        function getStates() {
            return [
                {id: 1, name: "收货"},
                {id: 2, name: "拒收"}
            ];
        }
    }

    /** @ngInject */
    function CsmbBatchItemServiceFn($resource) {
        var service = {
            getStates: getStates
        };

        return angular.extend(service, $resource('/api/v1/consumable/csmb_batch_items/:action/:id', {
            id: '@id',
            action: '@action'
        }, {
            update: {
                method: 'PUT'
            },
            query: {
                method: 'GET'
            }
        }));


        function getStates() {
            return [
                {id: 1, name: "收货"},
                {id: 2, name: "拒收"}
            ];
        }
    }

    /** @ngInject */
    function StoreroomInServiceFn($resource) {
        var service = {
            getStates: getStates
        };

        return angular.extend(service, $resource('/api/v1/consumable/storeroom_in/:id', {}, {
            query: {
                method: 'GET'
            },
            update: {
                method: 'PUT'
            }
        }));

        function getStates() {
            return [
                {id: 1, name: "未开票"},
                {id: 2, name: "已开票"}
            ];
        }
    }

    /** @ngInject */
    function CsmbSdPriceServiceFn($resource) {
        var service = {};

        return angular.extend(service, $resource('/api/v1/consumable/csmb_sd_price/:id', {}, {
            query: {
                method: 'GET'
            },
            update: {
                method: 'PUT'
            }
        }));
    }

    /** @ngInject */
    function SecondaryDealerServiceFn($resource) {
        var service = {};

        return angular.extend(service, $resource('/api/v1/vendor/secondary_dealers/:id', {}, {
            query: {
                method: 'GET'
            },
            update: {
                method: 'PUT'
            }
        }));
    }

    /** @ngInject */
    function CVStopServiceFn($resource) {
        var service = {
            getStates: getStates
        };

        return angular.extend(service, $resource('/api/v1/consumable/cv_stop_applications/:id', {}, {
            query: {
                method: 'GET'
            },
            update: {
                method: 'PUT'
            }
        }));

        function getStates() {
            return [
                {id: 1, name: "待审批"},
                {id: 2, name: "已审批"},
                {id: 3, name: "退回"}
            ];
        }
    }

    /** @ngInject */
    function CsmbStopServiceFn($resource) {
        var service = {
            getStates: getStates
        };

        return angular.extend(service, $resource('/api/v1/consumable/csmb_stop_applications/:id', {}, {
            query: {
                method: 'GET'
            },
            update: {
                method: 'PUT'
            }
        }));

        function getStates() {
            return [
                {id: 1, name: "待审批"},
                {id: 2, name: "已审批"},
                {id: 3, name: "退回"}
            ];
        }
    }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Vendor.pages.dashboard')
        .controller('DashboardPieChartCtrl', DashboardPieChartCtrl);

    /** @ngInject */
    function DashboardPieChartCtrl($scope, $http, $state, SPApplication, SRApplication, Auth, dialogs, Array,
                                   ConsumableVariety, CsmbDirectApplication, CsmbDirectReturn) {
        var vm = $scope;

        init();


        function init() {
            vm.units = ConsumableVariety.getUnits();
            vm.charts = [
                {
                    description: '待库房确认',
                    count: 0,
                    icon: 'fa-cart-arrow-down',
                    bg: 'bg-teal-active',
                    route: 'main.csmbs.batches.batch.list',
                    subtext: '批次管理'
                },
                {
                    description: '即将到期',
                    count: 0,
                    icon: 'fa-file-text-o',
                    bg: 'bg-fuchsia-active',
                    route: 'main.qualifications.query.list',
                    subtext: '我的资质'
                },
                {
                    description: '库存不足',
                    count: 0,
                    icon: 'fa-stack-overflow',
                    bg: 'bg-orange-active',
                    route: 'main.csmbs.inventories.storeroom',
                    subtext: '库存查询'
                }
            ];

            $http.get('api/v1/vendor/dashboard').then(function (resp) {

                var countList = resp.data;
                for (var i = 0; i < countList.length - 1; i++) {
                    var count = countList[i];
                    vm.charts[i].count = count;
                }

                if (countList[countList.length - 1] == 1) {
                    dialogs.confirm('首次登录', '为了账号安全，请修改密码').result.then(function () {
                        $state.go('main.info.password');
                    });
                }
            });

            SPApplication.query({
                op: 'approval'
            }, function (resp) {
                angular.forEach(resp.items, function (item) {
                    angular.forEach(item.application_items, function (item) {
                        item.diff_num = item.r_num != null ? (parseInt(item.num) > parseInt(item.r_num) ? (parseInt(item.num) - parseInt(item.r_num)) : 0) : item.num;
                        item.consumable.storage_unit = Array.getItem(item.consumable.storage_unit, vm.units).name;
                        item.consumable.purchase_unit = Array.getItem(item.consumable.purchase_unit, vm.units).name;
                    });
                });
                vm.purchaseList = resp.items;
            });

            SRApplication.query({
                op: 'approval'
            }, function (resp) {
                angular.forEach(resp.items, function (row) {
                    var items = [];
                    angular.forEach(row.application_items, function (item) {
                        item.consumable.storage_unit = Array.getItem(item.consumable.storage_unit, vm.units).name;
                        item.consumable.purchase_unit = Array.getItem(item.consumable.purchase_unit, vm.units).name;
                        item.consumable.use_unit = Array.getItem(item.consumable.use_unit, vm.units).name;
                        var m = Array.getItem(item.consumable_id, items, 'consumable_id');
                        if (m == null) {
                            items.push(angular.copy(item));
                        } else {
                            m.num = parseInt(m.num) + parseInt(item.num);
                        }
                    });
                    row.itemDesc = items;
                });
                vm.returnList = resp.items;
            });

            CsmbDirectApplication.query({
                op:'approval'
            }, function (resp) {
                angular.forEach(resp.items, function (item) {
                    angular.forEach(item.application_items, function (item) {
                        item.diff_num = item.r_num != null ? (parseInt(item.num) > parseInt(item.r_num) ? (parseInt(item.num) - parseInt(item.r_num)) : 0) : item.num;
                        item.consumable.storage_unit = Array.getItem(item.consumable.storage_unit, vm.units).name;
                        item.consumable.purchase_unit = Array.getItem(item.consumable.purchase_unit, vm.units).name;
                    });
                });
                vm.directList = resp.items;
            });

            CsmbDirectReturn.query({
                op:'approval'
            }, function (resp) {
                angular.forEach(resp.items, function (row) {
                    var items = [];
                    angular.forEach(row.application_items, function (item) {
                        item.consumable.storage_unit = Array.getItem(item.consumable.storage_unit, vm.units).name;
                        item.consumable.purchase_unit = Array.getItem(item.consumable.purchase_unit, vm.units).name;
                        item.consumable.use_unit = Array.getItem(item.consumable.use_unit, vm.units).name;
                        var m = Array.getItem(item.consumable_id, items, 'consumable_id');
                        if (m == null) {
                            items.push(angular.copy(item));
                        } else {
                            m.num = parseInt(m.num) + parseInt(item.num);
                        }
                    });
                    row.itemDesc = items;
                });
                vm.directReturnList = resp.items;
            });
        }
    }
})();
/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Vendor.pages.info').controller('infoTabCtrl', infoTabCtrl);

    /** @ngInject */
    function infoTabCtrl() {
        this.tabData = [
            {
                heading: '基本信息',
                route: 'main.info.profile'
            },
            {
                heading: '重置登录密码',
                route: 'main.info.password'
            },
        ];
    }

})();

/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Vendor.pages').controller('MainCtrl', mainCtrl);

    /** @ngInject */
    function mainCtrl(Auth, $state) {
        if (!Auth.getUser().id) { //过期
            $state.go('login');
        }
    }

})();

(function () {
    'use strict';
    angular.module('Vendor.pages.qualifications')
        .factory('VendorQ', ServiceFn);

    /** @ngInject */
    function ServiceFn($resource) {
        var service = {
            getStates: getStates,
            urls: {
                UPLOAD: "/api/v1/vendor/vendor_qualifications/upload",
                DOWNLOAD: "/api/v1/vendor/vendor_qualifications/download"
            }
        };

        return angular.extend(service, $resource('/api/v1/vendor/vendor_qualifications/:id', {}, {
            query: {
                method: 'GET'
            },
            update: {
                method: 'PUT'
            }
        }));

        function getStates() {
            return [
                {id: 1, name: '申请使用'},
                {id: 2, name: '使用中'},
                {id: 3, name: '申请停用'},
                {id: 4, name: '已停用'}
            ];
        }
    }
})();
/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Vendor.pages.qualifications').controller('qualificationsTabCtrl', qualificationsTabCtrl);

    /** @ngInject */
    function qualificationsTabCtrl() {
        this.tabData = [
            {
                heading: '我的资质',
                route: 'main.qualifications.query'
            },
            {
                heading: '资质草稿',
                route: 'main.qualifications.draft'
            },
            {
                heading: '资质到期提醒',
                route: 'main.qualifications.remind'
            },
            {
                heading: '上传资质',
                route: 'main.qualifications.new'
            }
        ];
    }

})();

/**
 * Change top "Daily Downloads", "Active Users" values with animation effect
 */
(function () {
  'use strict';

  angular.module('Vendor.theme')
      .directive('animatedChange', animatedChange);

  /** @ngInject */
  function animatedChange($timeout) {
    return {
      link: function (scope, element) {
        $timeout(function () {
          var newValue = element.attr('new-value');
          var oldvalue = parseInt(element.html());

          function changeValue(val) {
            $timeout(function () {
              element.html(val);
            }, 30);
          }

          if (newValue > oldvalue) {
            for (var i = oldvalue; i <= newValue; i++) {
              changeValue(i);
            }
          } else {
            for (var j = oldvalue; j >= newValue; j--) {
              changeValue(j);
            }
          }
          $timeout(function () {
            element.next().find('i').addClass('show-arr');
          }, 500);
        }, 3500);
      }
    };
  }

})();
/**
 * Auto expand textarea field
 */
(function () {
  'use strict';

  angular.module('Vendor.theme')
      .directive('autoExpand', autoExpand);

  /** @ngInject */
  function autoExpand() {
    return {
      restrict: 'A',
      link: function ($scope, elem) {
        elem.bind('keydown', function ($event) {
          var element = $event.target;
          $(element).height(0);
          var height = $(element)[0].scrollHeight;
          height = (height < 16) ? 16 : height;
          $(element).height(height);
        });

        // Expand the textarea as soon as it is added to the DOM
        setTimeout(function () {
          var element = elem;
          $(element).height(0);
          var height = $(element)[0].scrollHeight;
          height = (height < 16) ? 16 : height;
          $(element).height(height);
        }, 0)
      }
    };
  }

})();
(function () {
  'use strict';

  angular.module('Vendor.theme')
      .directive('autoFocus', autoFocus);

  /** @ngInject */
  function autoFocus($timeout, $parse) {
    return {
      link: function (scope, element, attrs) {
        var model = $parse(attrs.autoFocus);
        scope.$watch(model, function (value) {
          if (value === true) {
            $timeout(function () {
              element[0].focus();
              element[0].select();
            });
          }
        });
        element.bind('blur', function () {
          scope.$apply(model.assign(scope, false));
        });
      }
    };
  }

})();
/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('Vendor.theme')
      .directive('includeWithScope', includeWithScope);

  /** @ngInject */
  function includeWithScope() {
    return {
      restrict: 'AE',
      templateUrl: function(ele, attrs) {
        return attrs.includeWithScope;
      }
    };
  }

})();

/**
 * Change top "Daily Downloads", "Active Users" values with animation effect
 */
(function () {
    'use strict';

    angular.module('Vendor.theme')
        .directive('inputFloat', inputFloat);

    /** @ngInject */
    function inputFloat($filter) {
        var FLOAT_REGEXP_1 = /^\$?\d+.(\d{3})*(\,\d*)$/; //Numbers like: 1.123,56
        var FLOAT_REGEXP_2 = /^\$?\d+,(\d{3})*(\.\d*)$/; //Numbers like: 1,123.56
        var FLOAT_REGEXP_3 = /^\$?\d+(\.\d*)?$/; //Numbers like: 1123.56
        var FLOAT_REGEXP_4 = /^\$?\d+(\,\d*)?$/; //Numbers like: 1123,56

        return {
            require: 'ngModel',
            link: function (scope, element, attrs, ngModelCtrl) {
                if (!ngModelCtrl) {
                    return;
                }
                var decimal_digit = scope.$eval(attrs.inputFloat);

                ngModelCtrl.$parsers.push(function (val) {
                    if (angular.isUndefined(val)) {
                        var val = '';
                    }
                    var minus = val[0] == '-';
                    var clean = val.replace(/[^0-9\.]/g, '');
                    var decimalCheck = clean.split('.');

                    if (!angular.isUndefined(decimalCheck[1])) {
                        decimalCheck[1] = decimalCheck[1].slice(0, decimal_digit);
                        clean = decimalCheck[0] + '.' + decimalCheck[1];
                    }

                    if (minus)
                        clean = '-' + clean;

                    if (val !== clean) {
                        ngModelCtrl.$setViewValue(clean);
                        ngModelCtrl.$render();
                    }
                    return clean;
                });

                element.bind('keypress', function (event) {
                    if (event.keyCode === 32) {
                        event.preventDefault();
                    }
                });
            }
        }
    }

})();
/**
 * Change top "Daily Downloads", "Active Users" values with animation effect
 */
(function () {
    'use strict';

    angular.module('Vendor.theme')
        .directive('inputNumber', inputNumber);

    /** @ngInject */
    function inputNumber() {
        return {
            require: 'ngModel',
            link: function (scope, element, attr, ngModelCtrl) {
                function fromUser(text) {
                    var minus = text[0] == '-';
                    var allow_minus = scope.$eval(attr.inputNumber);
                    var transformedInput = text.replace(/[^0-9]/g, '');
                    if (minus && allow_minus)
                        transformedInput = '-' + transformedInput;
                    if (transformedInput !== text) {
                        ngModelCtrl.$setViewValue(transformedInput);
                        ngModelCtrl.$render();
                    }
                    return transformedInput;  // or return Number(transformedInput)
                }

                ngModelCtrl.$parsers.push(fromUser);
            }
        };
    }

})();
/**
 * @author a.demeshko
 * created on 22.12.2015
 */
(function () {
  'use strict';

  angular.module('Vendor.theme')
    .directive('ionSlider', ionSlider);

  /** @ngInject */
  function ionSlider($timeout) {
    return {
      restrict: 'EA',
      template: '<div></div>',
      replace: true,
      scope: {
        min: '=',
        max: '=',
        type: '@',
        prefix: '@',
        maxPostfix: '@',
        prettify: '=',
        prettifySeparator: '@',
        grid: '=',
        gridMargin: '@',
        postfix: '@',
        step: '@',
        hideMinMax: '@',
        hideFromTo: '@',
        from: '=',
        to: '=',
        disable: '=',
        onChange: '=',
        onFinish: '=',
        values: '=',
        timeout: '@'
      },
      link: function ($scope, $element) {
            $element.ionRangeSlider({
              min: $scope.min,
              max: $scope.max,
              type: $scope.type,
              prefix: $scope.prefix,
              maxPostfix: $scope.maxPostfix,
              prettify_enabled: $scope.prettify,
              prettify_separator: $scope.prettifySeparator,
              grid: $scope.grid,
              gridMargin: $scope.gridMargin,
              postfix: $scope.postfix,
              step: $scope.step,
              hideMinMax: $scope.hideMinMax,
              hideFromTo: $scope.hideFromTo,
              from: $scope.from,
              to: $scope.to,
              disable: $scope.disable,
              onChange: $scope.onChange,
              onFinish: $scope.onFinish,
              values: $scope.values
            });

            $scope.$watch('min', function (value) {
              $timeout(function () {
                $element.data("ionRangeSlider").update({min: value});
              });
            }, true);
            $scope.$watch('max', function (value) {
              $timeout(function () {
                $element.data("ionRangeSlider").update({max: value});
              });
            });
            $scope.$watch('from', function (value) {
              $timeout(function () {
                $element.data("ionRangeSlider").update({from: value});
              });
            });
            $scope.$watch('to', function (value) {
              $timeout(function () {
                $element.data("ionRangeSlider").update({to: value});
              });
            });
            $scope.$watch('disable', function (value) {
              $timeout(function () {
                $element.data("ionRangeSlider").update({disable: value});
              });
            });
      }
    };
  }

})();
(function () {
    'use strict';

    angular.module('Vendor.theme')
        .directive('loadingContainer', loadingContainer);

    /** @ngInject */
    function loadingContainer() {
        return {
            restrict: 'A',
            scope: false,
            link: function (scope, element, attrs) {
                var loadingLayer = angular.element('<div class="loading"><i class="fa fa-spinner fa-pulse fa-4x loading-icon text-muted"></i></div>');
                element.append(loadingLayer);
                element.addClass('loading-container');
                scope.$watch(attrs.loadingContainer, function (value) {
                    loadingLayer.toggleClass('ng-hide', !value);
                });
            }
        };
    }
})();
(function () {
  'use strict';

  angular.module('Vendor.theme')
      .directive('ngFileSelect', ngFileSelect);

  /** @ngInject */
  function ngFileSelect() {
    return {
      link: function ($scope, el) {
        el.bind('change', function (e) {
          $scope.file = (e.srcElement || e.target).files[0];
          $scope.getFile();
        })
      }
    }
  }

})();
(function () {
    'use strict';

    angular.module('Vendor.theme')
        .directive('scrollForm', scrollForm);

    /** @ngInject */
    function scrollForm($anchorScroll, $location) {
        return {
            restrict: 'A',
            link: function (scope, elem) {

                elem.on('submit', function () {

                    var firstInvalid = elem[0].querySelector('.ng-invalid');

                    if (firstInvalid) {
                        if ($location.hash() !== firstInvalid.id) {
                            $location.hash(firstInvalid.id);
                        } else {
                            $anchorScroll();
                        }
                        firstInvalid.focus();
                    }
                });
            }
        };
    }

})();
(function () {
  'use strict';

  angular.module('Vendor.theme')
      .directive('scrollPosition', scrollPosition);

  /** @ngInject */
  function scrollPosition() {
    return {
      scope: {
        scrollPosition: '=',
        maxHeight: '='
      },
      link: function (scope) {
        $(window).on('scroll', function() {
          var scrollTop = $(window).scrollTop() > scope.maxHeight;
          if (scrollTop !== scope.prevScrollTop) {
            scope.$apply(function() {
              scope.scrollPosition = scrollTop;
            });
          }
          scope.prevScrollTop = scrollTop;
        });
      }
    };
  }

})();
/**
 * Change top "Daily Downloads", "Active Users" values with animation effect
 */
(function () {
    'use strict';

    angular.module('Vendor.theme')
        .directive('submitButton', submitButton);

    /** @ngInject */
    function submitButton() {

        var directive = {
            restrict: 'EA',
            //transclude: true,
            //template: '<button ng-disabled="submitting" type="submit" class="btn {{btnClass}}" ng-click="click()" ng-transclude></button>',
            link: link

        };

        return directive;

        function link(scope, element, attrs) {
            var cls = element.attr('btn-class');
            var fn = element.attr('btn-click');
            var txt = element.html();

            element.html("<button type=\"submit\" class=\"btn " + cls
                + "\">" + txt + "</button>");
            var loadingLayer = angular.element('<div class="loading"><i class="fa fa-spinner fa-pulse loading-icon text-muted"></i></div>');
            element.append(loadingLayer);
            element.addClass('btn-submitting');
            element.on('click', click);

            scope.$watch('submitting', function (value) {
                loadingLayer.toggleClass('ng-hide', !value);
            });

            function click() {
                if (!scope.submitting) {
                    scope.submitting = true;
                    scope.$eval(fn).finally(function() {
                        scope.submitting = false;

                    });
                }
            }
        }


    }

})();
(function () {
  'use strict';

  angular.module('Vendor.theme')
      .directive('trackWidth', trackWidth);

  /** @ngInject */
  function trackWidth() {
    return {
      scope: {
        trackWidth: '=',
        minWidth: '=',
      },
      link: function (scope, element) {
        scope.trackWidth = $(element).width() < scope.minWidth;
        scope.prevTrackWidth = scope.trackWidth;

        $(window).resize(function() {
          var trackWidth = $(element).width() < scope.minWidth;
          if (trackWidth !== scope.prevTrackWidth) {
            scope.$apply(function() {
              scope.trackWidth = trackWidth;
            });
          }
          scope.prevTrackWidth = trackWidth;
        });
      }
    };
  }

})();
/**
 * Animated load block
 */
(function () {
  'use strict';

  angular.module('Vendor.theme')
      .directive('zoomIn', zoomIn);

  /** @ngInject */
  function zoomIn($timeout, $rootScope) {
    return {
      restrict: 'A',
      link: function ($scope, elem) {
        var delay = 1000;

        if ($rootScope.$pageFinishedLoading) {
          delay = 100;
        }

        $timeout(function () {
          elem.removeClass('full-invisible');
          elem.addClass('animated zoomIn');
        }, delay);
      }
    };
  }

})();
/**
 * @author richard.fan
 * created on 03.05.2016
 */
(function () {
  'use strict';

  angular.module('Vendor.theme')
      .service('baUtil', baUtil);

  /** @ngInject */
  function baUtil() {

    this.isDescendant = function(parent, child) {
      var node = child.parentNode;
      while (node != null) {
        if (node == parent) {
          return true;
        }
        node = node.parentNode;
      }
      return false;
    };

    this.hexToRGB = function(hex, alpha) {
      var r = parseInt( hex.slice(1,3), 16 );
      var g = parseInt( hex.slice(3,5), 16 );
      var b = parseInt( hex.slice(5,7), 16 );
      return 'rgba(' + r + ', ' + g + ', ' + b + ', ' + alpha + ')';
    }
  }
})();

/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('Vendor.theme')
      .service('fileReader', fileReader);

  /** @ngInject */
  function fileReader($q) {
    var onLoad = function(reader, deferred, scope) {
      return function () {
        scope.$apply(function () {
          deferred.resolve(reader.result);
        });
      };
    };

    var onError = function (reader, deferred, scope) {
      return function () {
        scope.$apply(function () {
          deferred.reject(reader.result);
        });
      };
    };

    var onProgress = function(reader, scope) {
      return function (event) {
        scope.$broadcast('fileProgress',
            {
              total: event.total,
              loaded: event.loaded
            });
      };
    };

    var getReader = function(deferred, scope) {
      var reader = new FileReader();
      reader.onload = onLoad(reader, deferred, scope);
      reader.onerror = onError(reader, deferred, scope);
      reader.onprogress = onProgress(reader, scope);
      return reader;
    };

    var readAsDataURL = function (file, scope) {
      var deferred = $q.defer();

      var reader = getReader(deferred, scope);
      reader.readAsDataURL(file);

      return deferred.promise;
    };

    return {
      readAsDataUrl: readAsDataURL
    };
  }
})();
/**
 * @author a.demeshko
 * created on 3/1/16
 */
(function () {
  'use strict';

  angular.module('Vendor.theme')
    .service('preloader', preloader);

  /** @ngInject */
  function preloader($q) {
    return {
      loadImg: function (src) {
        var d = $q.defer();
        var img = new Image();
        img.src = src;
        img.onload = function(){
          d.resolve();
        };
        return d.promise;
      },
      loadAmCharts : function(){
        var d = $q.defer();
        AmCharts.ready(function(){
          d.resolve();
        });
        return d.promise;
      }
    }
  }

})();
/**
 * @author a.demeshko
 * created on 12/21/15
 */
(function () {
  'use strict';

  angular.module('Vendor.theme')
    .service('stopableInterval', stopableInterval);

  /** @ngInject */
  function stopableInterval($window) {
    return {
      start: function (interval, calback, time) {
        function startInterval() {
          return interval(calback, time);
        }

        var i = startInterval();

        angular.element($window).bind('focus', function () {
          if (i) interval.cancel(i);
          i = startInterval();
        });

        angular.element($window).bind('blur', function () {
          if (i) interval.cancel(i);
        });
      }
    }
  }

})();
/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Vendor.pages.csmbs.batches').controller('batchesTabCtrl', batchesTabCtrl);

    /** @ngInject */
    function batchesTabCtrl() {
        this.tabData = [
            {
                heading: '批次管理',
                route: 'main.csmbs.batches.batch'
            }
        ];
    }

})();

/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Vendor.pages.csmbs.categories').controller('categoriesTabCtrl', categoriesTabCtrl);

    /** @ngInject */
    function categoriesTabCtrl() {
        this.tabData = [
            {
                heading: '品种列表',
                route: 'main.csmbs.categories.variety'
            },
            {
                heading: '型号列表',
                route: 'main.csmbs.categories.category'
            },
            {
                heading: '型号更新',
                route: 'main.csmbs.categories.update'
            },
            {
                heading: '品种停用',
                route: 'main.csmbs.categories.vStop'
            },
            {
                heading: '型号停用',
                route: 'main.csmbs.categories.cStop'
            }
        ];
    }

})();

/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Vendor.pages.csmbs.inventories').controller('inventoriesTabCtrl', inventoriesTabCtrl);

    /** @ngInject */
    function inventoriesTabCtrl() {
        this.tabData = [
            {
                heading: '库房库存',
                route: 'main.csmbs.inventories.storeroom'
            },
            {
                heading: '库房寄销库存',
                route: 'main.csmbs.inventories.temporary'
            }
        ];
    }
})();

/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Vendor.pages.csmbs.prices').controller('pricesTabCtrl', pricesTabCtrl);

    /** @ngInject */
    function pricesTabCtrl() {
        this.tabData = [
            {
                heading: '我的申请',
                route: 'main.csmbs.prices.query'
            },
            {
                heading: '新的申请',
                route: 'main.csmbs.prices.new'
            }
        ];
    }
})();

/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Vendor.pages.csmbs.direct').controller('directTabCtrl', directTabCtrl);

    /** @ngInject */
    function directTabCtrl() {
        this.tabData = [
            {
                heading: '待处理申请',
                route: 'main.csmbs.direct.approval'
            },
            {
                heading: '已处理申请',
                route: 'main.csmbs.direct.approved'
            },
            {
                heading: '待处理退货',
                route: 'main.csmbs.direct.return'
            },
            {
                heading: '已处理退货',
                route: 'main.csmbs.direct.returned'
            },
            {
                heading: '科室寄销库存',
                route: 'main.csmbs.direct.temporary'
            }
        ];
    }
})();

/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Vendor.pages.csmbs.qualifications').controller('csmbQualificationsTabCtrl', csmbQualificationsTabCtrl);

    /** @ngInject */
    function csmbQualificationsTabCtrl() {
        this.tabData = [
            {
                heading: '我的申请',
                route: 'main.csmbs.qualifications.query'
            },
            {
                heading: '新的申请',
                route: 'main.csmbs.qualifications.new'
            }
        ];
    }
})();

(function () {
    'use strict';
    angular.module('Vendor.pages.csmbs.purchase')
        .factory('SPApplication', SPApplicationServiceFn);

    /** @ngInject */
    function SPApplicationServiceFn($resource) {
        var service = {
            getStates: getStates,
            getVendorApprovalStates: getVendorApprovalStates,
            getVendorApprovedStates: getVendorApprovedStates
        };

        return angular.extend(service, $resource('/api/v1/consumable/storeroom_purchase_applications/:action/:id', {
            id: '@id',
            action: '@action'
        }, {
            update: {
                method: 'PUT'
            },
            query: {
                method: 'GET'
            }
        }));

        function getStates() {
            return [
                {id: 9, name: "设备科长未确认"},
                {id: 10, name: "设备科长拒绝"},
                {id: 1, name: "采购中心未确认"},
                {id: 2, name: "采购中心已确认"},
                {id: 3, name: "采购中心拒绝"},
                {id: 5, name: "经销商发货中"},
                {id: 6, name: "经销商待补货"},
                {id: 7, name: "经销商补货中"},
                {id: 8, name: "申请终止"},
                {id: 4, name: "申请完成"}
            ];
        }

        function getVendorApprovalStates() {
            return [
                {id: 2, name: "采购中心已确认"},
                {id: 6, name: "经销商待补货"}
            ];
        }

        function getVendorApprovedStates() {
            return [
                {id: 5, name: "经销商发货中"},
                {id: 6, name: "经销商待补货"},
                {id: 7, name: "经销商补货中"},
                {id: 4, name: "申请完成"}
            ];
        }
    }
})();
/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Vendor.pages.csmbs.purchase').controller('purchaseTabCtrl', purchaseTabCtrl);

    /** @ngInject */
    function purchaseTabCtrl() {
        this.tabData = [
            {
                heading: '待处理',
                route: 'main.csmbs.purchase.approval'
            },
            {
                heading: '已处理',
                route: 'main.csmbs.purchase.approved'
            }
        ];
    }
})();

(function () {
    'use strict';
    angular.module('Vendor.pages.csmbs.return')
        .factory('SRApplication', SRApplicationServiceFn);

    /** @ngInject */
    function SRApplicationServiceFn($resource) {
        var service = {
            getStates: getStates
        };

        return angular.extend(service, $resource('/api/v1/consumable/storeroom_return_applications/:action/:id', {
            id: '@id',
            action: '@action'
        }, {
            update: {
                method: 'PUT'
            },
            query: {
                method: 'GET'
            }
        }));

        function getStates() {
            return [
                {id: 2, name: "厂商确认"},
                {id: 3, name: "厂商拒绝"}
            ];
        }
    }
})();
/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Vendor.pages.csmbs.return').controller('returnTabCtrl', returnTabCtrl);

    /** @ngInject */
    function returnTabCtrl() {
        this.tabData = [
            {
                heading: '待处理',
                route: 'main.csmbs.return.approval'
            },
            {
                heading: '已处理',
                route: 'main.csmbs.return.approved'
            }
        ];
    }
})();

/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Vendor.pages.dialogs').controller('editorImageUploadCtrl', editorImageUploadCtrl);

    /** @ngInject */
    function editorImageUploadCtrl($uibModalInstance, clipboard, File, urls, data) {

        var vm = this;
        var result = [];
        vm.images = data.files;
        vm.getDataFromClipboard = getDataFromClipboard;
        vm.upload = upload;
        vm.cancel = $uibModalInstance.dismiss;
        vm.ok = ok;

        function getDataFromClipboard(path) {
            clipboard.copyText(path);
        }

        function upload(file, img, e) {
            File.upload1(urls.IMG_UPLOAD, file, img, e).then(function (data) {
                result[file.name] = data.filename;
            });
        }

        function ok() {
            $uibModalInstance.close(result);
        }
    }

})();

/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Vendor.pages.dialogs').controller('imageCroppedUploadCtrl', imageCroppedUploadCtrl);

    /** @ngInject */
    function imageCroppedUploadCtrl($uibModalInstance, toaster, File, urls, data) {
        var vm = this;
        vm.title = data.title;
        vm.m = {toUrl: urls.IMG_UPLOAD, croppedDataUrl: ''};
        vm.width = data.width;
        vm.height = data.height;
        vm.upload = upload;
        vm.cancel = $uibModalInstance.dismiss;

        function upload(m) {
            File.uploadCroppedImage(m).then(function (url) {
                $uibModalInstance.close(url);
            }, function (errMsg) {
                toaster.error(errMsg);
            });
        }
    }

})();

/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Vendor.pages.info.password').controller('passwordResetCtrl', passwordResetCtrl);

    /** @ngInject */
    function passwordResetCtrl($q, toaster, Auth, $validation) {
        var vm = this;
        vm.user = {};
        vm.submit = submit;

        function submit(form, m) {
            var defer = $q.defer();

            $validation.validate(form).success(function () {
                var pa = {password: m.password};
                Auth.reset(pa, function (resp) {
                    if (resp.result == 0) {
                        toaster.success(resp.msg);
                        defer.resolve();
                        m.password = m.password2 = '';
                        form.$setPristine();
                    } else {
                        toaster.error(resp.msg);
                        defer.reject();
                    }

                }, function (error) {
                    toaster.error(error.password[0]);
                    defer.reject();
                });
            }).error(function () {
                defer.reject();
            });
            return defer.promise;
        }
    }

})();

/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Vendor.pages.info.profile').controller('profileCtrl', profileCtrl);

    /** @ngInject */
    function profileCtrl($q, dialogs, toaster, File, Array, Auth, User, $validation) {
        var vm = this;
        vm.submit = submit;
        vm.reset = reset;

        init();


        function init() {
            vm.info = angular.copy(Auth.getUser());
        }

        function reset(form) {
            form.$setPristine();
            vm.info = angular.copy(Auth.getUser());
        }

        function submit(form, m) {
            var defer = $q.defer();
            $validation.validate(form).success(function () {
                var pa = {
                    bank_name: m.bank_name, bank_account: m.bank_account,
                    s_contact: m.s_contact, s_phone: m.s_phone, note: m.note
                };

                User.update({id: m.id, op: 'edit'}, pa).$promise.then(function (resp) {
                    toaster.success(resp.msg);
                    Auth.setUser(resp.user);
                    defer.resolve();
                }, function () {
                    defer.reject();
                });
            }).error(function () {
                defer.reject();
            });
            return defer.promise;
        }
    }

})();

(function () {
    'use strict';
    angular.module('Vendor.pages.info.profile')
        .factory('User', serviceFn);

    /** @ngInject */
    function serviceFn($resource) {
        var service = {};

        return angular.extend(service, $resource('/api/v1/user/users/:id', {}, {
            update: {
                method: 'PUT'
            },
            query: {
                method: 'GET'
            }
        }));
    }
})();
/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Vendor.pages.qualifications.new').controller('applyQualificationCtrl', applyQualificationCtrl);

    /** @ngInject */
    function applyQualificationCtrl($q, Api, $state, toaster, Auth, $validation, dialogs, File, Array, VendorQType,
                                    VendorQ, Misc) {
        var vm = this;
        var vendorQ;
        vm.deleteAttachment = deleteAttachment;
        vm.upload = upload;
        vm.download = download;
        vm.submit = submit;
        vm.reset = reset;

        init();


        function init() {
            var name = Auth.getUser().dealer;

            if (name) {
                VendorQType.query({opt: 2 /*INDEX_OPTIONS*/}, function (resp) {
                    vm.types = resp.items;
                    vendorQ = {
                        attachments: [],
                        vendor: name,
                        type: vm.types[0],
                        start_time: new Date(),
                        with_sms: false,
                        sorting: ''
                    };
                    vm.m = angular.copy(vendorQ);
                });
            }
        }

        function deleteAttachment($index, m) {
            dialogs.confirm("提示", "确认要移除该附件?").result.then(function () {
                m.attachments.splice($index, 1);
            });
        }

        function upload(file, m, e) {
            File.uploadAttachment(file, m, e);
        }

        function download(attach) {
            File.download(VendorQ.urls.DOWNLOAD, attach);
        }

        function reset(form, m) {
            form.$setPristine();
            vm.m = angular.copy(vendorQ);
        }

        function submit(form, m, state) {
            var defer = $q.defer();
            $validation.validate(form).success(function () {
                if (!File.isAttachmentsUploaded(m)) {
                    Api.w('请等一小会儿,部分附件还在路上');
                } else {
                    var pa = {
                        name: m.name, type_id: m.type.id, start_time: Misc.date2Str(m.start_time),
                        note: m.note, code: m.code, with_sms: m.with_sms, sorting: m.sorting, state: state
                    };
                    if (m.end_time) {
                        pa.end_time = Misc.date2Str(m.end_time);
                    }
                    pa.attachments = Array.map(m.attachments, function (item) {
                        return {
                            name: item.name, mime: item.mime,
                            filename: item.filename, size: item.size
                        }
                    });
                    VendorQ.save(pa).$promise.then(function (resp) {
                        toaster.success(resp.msg);
                        state == 1 ? $state.go('^') : $state.go('^.draft');
                        reset(form, m);
                        defer.resolve();
                    }, function (error) {
                        var resp = error.data;
                        toaster.error(resp.msg);
                        defer.reject();
                    });
                }
            }).error(function () {
                Api.w('请检查表单错误');
                form.$submitted = true;
                defer.reject();
            });
            return defer.promise;
        }
    }

})();

(function () {
    'use strict';
    angular.module('Vendor.pages.qualifications.new')
        .factory('VendorQType', ServiceFn);

    /** @ngInject */
    function ServiceFn($resource) {
        var service = {};

        return angular.extend(service, $resource('/api/v1/vendor/vendor_qualification_types/:id', {}, {
            query: {
                method: 'GET'
            },
            update: {
                method: 'PUT'
            }
        }));
    }
})();
(function () {
    'use strict';

    angular.module('Vendor.theme.components')
        .directive('attachmentPreview', attachmentPreview);

    /** @ngInject */
    function attachmentPreview($http, Array) {
        var office = ['doc', 'docx', 'xls', 'xlsx', 'ppt', 'pptx'];
        var pdf = ['pdf'];
        var img = ['png', 'jpg', 'jpeg', 'bmp'];


        return {
            restrict: 'E',
            templateUrl: 'app/theme/components/attachmentPreview/attachmentPreview.html',
            scope: {
                model: '=ngModel'
            },
            link: function link(scope, iElement, iAttrs, r) {
                var vm = scope;
                vm.preview = preview;
                var type = null;
                var att = scope.model;

                init();


                function init() {
                    var extension = att.filename.split('.').pop().toLowerCase();
                    if (Array.inArray(extension, office) !== -1) {
                        type = 1;  // office
                    } else if (Array.inArray(extension, pdf) !== -1) {
                        type = 2;  // pdf
                    } else if (Array.inArray(extension, img) !== -1) {
                        type = 3;  // img
                    }
                    vm.type = type;
                }

                function preview() {
                    var windowReference = window.open();
                    $http.post('api/v1/file/preview/mk_pub_link', {filename: att.filename})
                        .success(function (resp) {
                            var url = "/api/v1/file/preview?type=" + type + "&filename=" + resp + "&name=" + att.name;
                            windowReference.location = url;
                        });
                }
            }
        };
    }

})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('Vendor.theme.components')
    .controller('BaSidebarCtrl', BaSidebarCtrl);

  /** @ngInject */
  function BaSidebarCtrl($scope, baSidebarService) {

    $scope.menuItems = baSidebarService.getMenuItems();
    $scope.defaultSidebarState = $scope.menuItems[0].stateRef;

    $scope.hoverItem = function ($event) {
      $scope.showHoverElem = true;
      $scope.hoverElemHeight =  $event.currentTarget.clientHeight;
      var menuTopValue = 66;
      $scope.hoverElemTop = $event.currentTarget.getBoundingClientRect().top - menuTopValue;
    };

    $scope.$on('$stateChangeSuccess', function () {
      if (baSidebarService.canSidebarBeHidden()) {
        baSidebarService.setMenuCollapsed(true);
      }
    });
  }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('Vendor.theme.components')
      .directive('baSidebar', baSidebar);

  /** @ngInject */
  function baSidebar($timeout, baSidebarService, baUtil, layoutSizes) {
    var jqWindow = $(window);
    return {
      restrict: 'E',
      templateUrl: 'app/theme/components/baSidebar/ba-sidebar.html',
      controller: 'BaSidebarCtrl',
      link: function(scope, el) {

        scope.menuHeight = el[0].childNodes[0].clientHeight - 84;
        jqWindow.on('click', _onWindowClick);
        jqWindow.on('resize', _onWindowResize);

        scope.$on('$destroy', function() {
          jqWindow.off('click', _onWindowClick);
          jqWindow.off('resize', _onWindowResize);
        });

        function _onWindowClick($evt) {
          if (!baUtil.isDescendant(el[0], $evt.target) &&
              !$evt.originalEvent.$sidebarEventProcessed &&
              !baSidebarService.isMenuCollapsed() &&
              baSidebarService.canSidebarBeHidden()) {
            $evt.originalEvent.$sidebarEventProcessed = true;
            $timeout(function () {
              baSidebarService.setMenuCollapsed(true);
            }, 10);
          }
        }

        // watch window resize to change menu collapsed state if needed
        function _onWindowResize() {
          var newMenuCollapsed = baSidebarService.shouldMenuBeCollapsed();
          var newMenuHeight = _calculateMenuHeight();
          if (newMenuCollapsed != baSidebarService.isMenuCollapsed() || scope.menuHeight != newMenuHeight) {
            scope.$apply(function () {
              scope.menuHeight = newMenuHeight;
              baSidebarService.setMenuCollapsed(newMenuCollapsed)
            });
          }
        }

        function _calculateMenuHeight() {
          return el[0].childNodes[0].clientHeight - 84;
        }
      }
    };
  }

})();
(function () {
    'use strict';

    angular.module('Vendor.theme.components')
        .provider('baSidebarService', baSidebarServiceProvider);

    /** @ngInject */
    function baSidebarServiceProvider() {
        var staticMenuItems = [];

        this.addStaticItem = function () {
            staticMenuItems.push.apply(staticMenuItems, arguments);
        };

        /** @ngInject */
        this.$get = function ($state, layoutSizes, Auth) {
            return new _factory();

            function _factory() {
                var isMenuCollapsed = shouldMenuBeCollapsed();

                this.getMenuItems = function () {
                    var states = defineMenuItemStates();
                    var menuItems = states.filter(function (item) {
                        return item.level == 1;
                    });

                    menuItems.forEach(function (item) {
                        var children = states.filter(function (child) {
                            return child.level == 2 && child.name.indexOf(item.name) === 0;
                        });
                        item.subMenu = children.length ? children : null;
                    });

                    return menuItems.concat(staticMenuItems);
                };

                this.shouldMenuBeCollapsed = shouldMenuBeCollapsed;
                this.canSidebarBeHidden = canSidebarBeHidden;

                this.setMenuCollapsed = function (isCollapsed) {
                    isMenuCollapsed = isCollapsed;
                };

                this.isMenuCollapsed = function () {
                    return isMenuCollapsed;
                };

                this.toggleMenuCollapsed = function () {
                    isMenuCollapsed = !isMenuCollapsed;
                };

                this.getAllStateRefsRecursive = function (item) {
                    var result = [];
                    _iterateSubItems(item);
                    return result;

                    function _iterateSubItems(currentItem) {
                        currentItem.subMenu && currentItem.subMenu.forEach(function (subItem) {
                            subItem.stateRef && result.push(subItem.stateRef);
                            _iterateSubItems(subItem);
                        });
                    }
                };

                function defineMenuItemStates() {
                    return $state.get()
                        .filter(function (s) {
                            return s.sidebarMeta;
                        })
                        .map(function (s) {
                            var meta = s.sidebarMeta;
                            return {
                                name: s.name,
                                title: s.title ? s.title : s.ncyBreadcrumb.label,
                                level: (s.name.match(/\./g) || []).length,
                                order: meta.order,
                                icon: meta.icon,
                                stateRef: s.name,
                            };
                        })
                        .sort(function (a, b) {
                            return (a.level - b.level) * 100 + a.order - b.order;
                        });
                }

                function shouldMenuBeCollapsed() {
                    return window.innerWidth <= layoutSizes.resWidthCollapseSidebar;
                }

                function canSidebarBeHidden() {
                    return window.innerWidth <= layoutSizes.resWidthHideSidebar;
                }
            }

        };

    }
})();

/**
 * @author richard.fan
 * created on 03.05.2016
 */
(function () {
  'use strict';

  angular.module('Vendor.theme.components')
      .directive('baSidebarToggleMenu', baSidebarToggleMenu)
      .directive('baSidebarCollapseMenu', baSidebarCollapseMenu)
      .directive('baSidebarTogglingItem', baSidebarTogglingItem)
      .controller('BaSidebarTogglingItemCtrl', BaSidebarTogglingItemCtrl)
      .directive('baUiSrefTogglingSubmenu', baUiSrefTogglingSubmenu)
      .directive('baUiSrefToggler', baUiSrefToggler);

  /** @ngInject */
  function baSidebarToggleMenu(baSidebarService) {
    return {
      restrict: 'A',
      link: function(scope, elem) {
        elem.on('click', function($evt) {
          $evt.originalEvent.$sidebarEventProcessed = true;
          scope.$apply(function() {
            baSidebarService.toggleMenuCollapsed();
          });
        });
      }
    };
  }

  /** @ngInject */
  function baSidebarCollapseMenu(baSidebarService) {
    return {
      restrict: 'A',
      link: function(scope, elem) {
        elem.on('click', function($evt) {
          $evt.originalEvent.$sidebarEventProcessed = true;
          if (!baSidebarService.isMenuCollapsed()) {
            scope.$apply(function() {
              baSidebarService.setMenuCollapsed(true);
            });
          }
        });
      }
    };
  }

  /** @ngInject */
  function baSidebarTogglingItem() {
    return {
      restrict: 'A',
      controller: 'BaSidebarTogglingItemCtrl'
    };
  }

  /** @ngInject */
  function BaSidebarTogglingItemCtrl($scope, $element, $attrs, $state, baSidebarService) {
    var vm = this;
    var menuItem = vm.$$menuItem = $scope.$eval($attrs.baSidebarTogglingItem);
    if (menuItem && menuItem.subMenu && menuItem.subMenu.length) {
      vm.$$expandSubmenu = function() { console.warn('$$expandMenu should be overwritten by baUiSrefTogglingSubmenu') };
      vm.$$collapseSubmenu = function() { console.warn('$$collapseSubmenu should be overwritten by baUiSrefTogglingSubmenu') };

      var subItemsStateRefs = baSidebarService.getAllStateRefsRecursive(menuItem);

      vm.$expand = function() {
        vm.$$expandSubmenu();
        $element.addClass('ba-sidebar-item-expanded');
      };

      vm.$collapse = function() {
        vm.$$collapseSubmenu();
        $element.removeClass('ba-sidebar-item-expanded');
      };

      vm.$toggle = function() {
        $element.hasClass('ba-sidebar-item-expanded') ?
            vm.$collapse() :
            vm.$expand();
      };

      if (_isState($state.current)) {
        $element.addClass('ba-sidebar-item-expanded');
      }

      $scope.$on('$stateChangeStart', function (event, toState) {
        if (!_isState(toState) && $element.hasClass('ba-sidebar-item-expanded')) {
          vm.$collapse();
          $element.removeClass('ba-sidebar-item-expanded');
        }
      });

      $scope.$on('$stateChangeSuccess', function (event, toState) {
        if (_isState(toState) && !$element.hasClass('ba-sidebar-item-expanded')) {
          vm.$expand();
          $element.addClass('ba-sidebar-item-expanded');
        }
      });
    }

    function _isState(state) {
      return state && subItemsStateRefs.some(function(subItemState) {
            return state.name.indexOf(subItemState) == 0;
          });
    }
  }

  /** @ngInject */
  function baUiSrefTogglingSubmenu($state) {
    return {
      restrict: 'A',
      require: '^baSidebarTogglingItem',
      link: function(scope, el, attrs, baSidebarTogglingItem) {
        baSidebarTogglingItem.$$expandSubmenu = function() { el.slideDown(); };
        baSidebarTogglingItem.$$collapseSubmenu = function() { el.slideUp(); };
      }
    };
  }

  /** @ngInject */
  function baUiSrefToggler(baSidebarService) {
    return {
      restrict: 'A',
      require: '^baSidebarTogglingItem',
      link: function(scope, el, attrs, baSidebarTogglingItem) {
        el.on('click', function() {
          if (baSidebarService.isMenuCollapsed()) {
            // If the whole sidebar is collapsed and this item has submenu. We need to open sidebar.
            // This should not affect mobiles, because on mobiles sidebar should be hidden at all
            scope.$apply(function() {
              baSidebarService.setMenuCollapsed(false);
            });
            baSidebarTogglingItem.$expand();
          } else {
            baSidebarTogglingItem.$toggle();
          }
        });
      }
    };
  }

})();

/**
 * @author richard.fan
 * created on 23.12.2015
 */
(function () {
    'use strict';

    /**
     * Includes basic panel layout inside of current element.
     */
    angular.module('Vendor.theme')
        .directive('baPanel', baPanel);

    /** @ngInject */
    function baPanel(baPanel, baConfig) {
        return angular.extend({}, baPanel, {
            template: function (el, attrs) {
                var res = '<div  class="panel ' + (baConfig.theme.blur ? 'panel-blur' : '') + ' full-invisible ' + (attrs.baPanelClass || '');
                res += '" zoom-in ' + (baConfig.theme.blur ? 'ba-panel-blur' : '') + '>';
                res += baPanel.template(el, attrs);
                res += '</div>';
                return res;
            }
        });
    }
})();


/**
 * @author richard.fan
 * created on 23.12.2015
 */
(function () {
    'use strict';

    angular.module('Vendor.theme')
        .factory('baPanel', baPanel);

    /** @ngInject */
    function baPanel() {

        /** Base baPanel directive */
        return {
            restrict: 'A',
            transclude: true,
            scope: {baPanelTitle: '@', subTitle: '=', toParams: '=', addState: '@'},
            controller: ['$scope', '$state', function ($scope, $state) {
                var pvm = $scope.$parent.vm;
                if (pvm) {
                    var vm = {};
                    vm.add = pvm.add ? pvm.add : add;
                    vm.download = pvm.download;
                    vm.tableReload = pvm.tableReload ? pvm.tableReload : tableReload;
                    $scope.vm = vm;
                }

                function add() {
                    $state.go($scope.addState ? $scope.addState : '^.add', $scope.toParams);
                }

                function tableReload() {
                    if (pvm.tableReload) {
                        pvm.tableReload();
                    }
                }
            }],
            template: function (elem, attrs) {
                var res = '<div class="panel-body" ng-transclude></div>';
                if (angular.isDefined(attrs.baPanelHeader)) {
                    var headerTpl = '';
                    if (!attrs.baPanelHeader) {
                        headerTpl = '<div class="panel-heading clearfix">';
                        headerTpl += '<span class="panel-title">' + attrs.baPanelTitle + '</span>';
                        headerTpl += '<div class="btn-group pull-right" style="margin-top:-6px">';
                        if (angular.isDefined(attrs.downloadBtn)) {
                            headerTpl += '<button class="btn btn-info btn-sm" ng-click="vm.download()">导出</button>';
                        }
                        if (angular.isUndefined(attrs.hideAddBtn)) {
                            headerTpl += '<button class="btn btn-primary btn-sm" ng-click="vm.add()">添加</button>';
                        }
                        headerTpl += '<button class="btn btn-default btn-sm" ng-click="vm.tableReload()">';
                        headerTpl += '<i class="fa fa-refresh"></i></button></div></div>'
                    } else {
                        headerTpl = '<div class="panel-heading clearfix" ng-include="\''
                            + attrs.baPanelHeader + '\'"></div>';
                    }
                    res = headerTpl + res;
                } else if (attrs.baPanelTitle) {
                    var titleTpl = '<div class="panel-heading clearfix"><h3 class="panel-title">' + attrs.baPanelTitle + '<span class="panel-subtitle" ng-bind="subTitle"></span></h3></div>';
                    res = titleTpl + res; // title should be before
                }

                return res;
            }
        };
    }

})();

/**
 * @author richard.fan
 * created on 15.01.2016
 */
(function () {
  'use strict';

  angular.module('Vendor.theme')
      .directive('baPanelBlur', baPanelBlur);

  /** @ngInject */
  function baPanelBlur(baPanelBlurHelper, $window, $rootScope) {
    var bodyBgSize;

    baPanelBlurHelper.bodyBgLoad().then(function() {
      bodyBgSize = baPanelBlurHelper.getBodyBgImageSizes();
    });

    $window.addEventListener('resize', function() {
      bodyBgSize = baPanelBlurHelper.getBodyBgImageSizes();
    });

    return {
      restrict: 'A',
      link: function($scope, elem) {
        if(!$rootScope.$isMobile) {
          baPanelBlurHelper.bodyBgLoad().then(function () {
            setTimeout(recalculatePanelStyle);
          });
          $window.addEventListener('resize', recalculatePanelStyle);

          $scope.$on('$destroy', function () {
            $window.removeEventListener('resize', recalculatePanelStyle);
          });
        }

        function recalculatePanelStyle() {
          if (!bodyBgSize) {
            return;
          }
          elem.css({
            backgroundSize: Math.round(bodyBgSize.width) + 'px ' + Math.round(bodyBgSize.height) + 'px',
            backgroundPosition: Math.floor(bodyBgSize.positionX) + 'px ' + Math.floor(bodyBgSize.positionY) + 'px'
          });
        }

      }
    };
  }

})();

/**
 * @author richard.fan
 * created on 15.01.2016
 */
(function () {
  'use strict';

  angular.module('Vendor.theme')
      .service('baPanelBlurHelper', baPanelBlurHelper);

  /** @ngInject */
  function baPanelBlurHelper($q) {
    var res = $q.defer();
    var computedStyle = getComputedStyle(document.body, ':before');
    var image = new Image();
    image.src = computedStyle.backgroundImage.replace(/url\((['"])?(.*?)\1\)/gi, '$2');
    image.onerror = function() {
      res.reject();
    };
    image.onload = function() {
      res.resolve();
    };

    this.bodyBgLoad = function() {
      return res.promise;
    };

    this.getBodyBgImageSizes = function() {
      var elemW = document.documentElement.clientWidth;
      var elemH = document.documentElement.clientHeight;
      if(elemW <= 640) return;
      var imgRatio = (image.height / image.width);       // original img ratio
      var containerRatio = (elemH / elemW);     // container ratio

      var finalHeight, finalWidth;
      if (containerRatio > imgRatio) {
        finalHeight = elemH;
        finalWidth = (elemH / imgRatio);
      } else {
        finalWidth = elemW;
        finalHeight = (elemW * imgRatio);
      }
      return { width: finalWidth, height: finalHeight, positionX: (elemW - finalWidth)/2, positionY: (elemH - finalHeight)/2};
    };
  }

})();

/**
 * @author richard.fan
 * created on 23.12.2015
 */
(function () {
  'use strict';

  /**
   * Represents current element as panel, adding all necessary classes.
   */
  angular.module('Vendor.theme')
      .directive('baPanelSelf', baPanelSelf);

  /** @ngInject */
  function baPanelSelf(baPanel) {
    return angular.extend({}, baPanel, {
      link: function(scope, el, attrs) {
        el.addClass('panel panel-white');
        if (attrs.baPanelClass) {
          el.addClass(attrs.baPanelClass);
        }
      }
    });
  }

})();

(function() {
  'use strict';

  angular.module('Vendor.theme.components')
    .directive('baWizard', baWizard);

  /** @ngInject */
  function baWizard() {
    return {
      restrict: 'E',
      transclude: true,
      templateUrl: 'app/theme/components/baWizard/baWizard.html',
      controllerAs: '$baWizardController',
      controller: 'baWizardCtrl'
    }
  }
})();

(function() {
  'use strict';

  angular.module('Vendor.theme.components')
    .controller('baWizardCtrl', baWizardCtrl);

  /** @ngInject */
  function baWizardCtrl($scope) {
    var vm = this;
    vm.tabs = [];

    vm.tabNum = 0;
    vm.progress = 0;

    vm.addTab = function(tab) {
      tab.setPrev(vm.tabs[vm.tabs.length - 1]);
      vm.tabs.push(tab);
      vm.selectTab(0);
    };

    $scope.$watch(angular.bind(vm, function () {return vm.tabNum;}), calcProgress);

    vm.selectTab = function (tabNum) {
      vm.tabs[vm.tabNum].submit();
      if (vm.tabs[tabNum].isAvailiable()) {
        vm.tabNum = tabNum;
        vm.tabs.forEach(function (t, tIndex) {
          tIndex == vm.tabNum ? t.select(true) : t.select(false);
        });
      }
    };

    vm.isFirstTab = function () {
      return vm.tabNum == 0;
    };

    vm.isLastTab = function () {
      return vm.tabNum == vm.tabs.length - 1 ;
    };

    vm.nextTab = function () {
      vm.selectTab(vm.tabNum + 1)
    };

    vm.previousTab = function () {
      vm.selectTab(vm.tabNum - 1)
    };

    function calcProgress() {
      vm.progress = ((vm.tabNum + 1) / vm.tabs.length) * 100;
    }
  }
})();


(function() {
  'use strict';

  angular.module('Vendor.theme.components')
    .directive('baWizardStep', baWizardStep);

  /** @ngInject */
  function baWizardStep() {
    return {
      restrict: 'E',
      transclude: true,
      require: '^baWizard',
      scope: {
        form: '='
      },
      templateUrl:  'app/theme/components/baWizard/baWizardStep.html',
      link: function($scope, $element, $attrs, wizard) {
        $scope.selected = true;

        var tab = {
          title: $attrs.title,
          select: select,
          submit: submit,
          isComplete: isComplete,
          isAvailiable: isAvailiable,
          prevTab: undefined,
          setPrev: setPrev
        };

        wizard.addTab(tab);

        function select(isSelected) {
          if (isSelected) {
            $scope.selected = true;
          } else {
            $scope.selected = false;
          }
        }

        function submit() {
          $scope.form && $scope.form.$setSubmitted(true);
        }

        function isComplete() {
          return $scope.form ? $scope.form.$valid : true;
        }

        function isAvailiable() {
          return tab.prevTab ? tab.prevTab.isComplete() : true;
        }

        function setPrev(pTab) {
          tab.prevTab = pTab;
        }
      }
    };
  }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('Vendor.theme.components')
      .directive('backTop', backTop);

  /** @ngInject */
  function backTop() {
    return {
      restrict: 'E',
      templateUrl: 'app/theme/components/backTop/backTop.html',
      controller: function () {
        $('#backTop').backTop({
          'position': 200,
          'speed': 100
        });
      }
    };
  }

})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('Vendor.theme.components')
      .directive('contentTop', contentTop);

  /** @ngInject */
  function contentTop($location, $state) {
    return {
      restrict: 'E',
      templateUrl: 'app/theme/components/contentTop/contentTop.html'
      //link: function($scope) {
      //  $scope.$watch(function () {
      //    //s.title ? s.title : s.ncyBreadcrumb.label
      //    $scope.activePageTitle = $state.current.title;
      //  });
      //}
    };
  }

})();
(function () {
    'use strict';

    angular.module('Vendor.theme.components')
        .directive('csmbSelect', csmbSelect);

    /** @ngInject */
    function csmbSelect(Consumable, Auth, ConsumableVariety, Array) {
        return {
            templateUrl: 'app/theme/components/csmbSelect/csmbSelect.html',
            restrict: 'E',
            replace: true,
            scope: {
                onSelect: '&',
                roomId: '=?',
                model: '=ngModel'
            },
            require: ['^ngModel', '?^form'],
            link: function (scope, iElement, iAttrs, r) {
                var ngModelCtrl = r[0], formCtrl = r[1];
                var vm = scope;
                vm.pager = {total: 0, page: 1, count: 5};
                vm.pageChanged = pageChanged;
                vm.refreshCsmbs = refreshCsmbs;
                vm.touch = touch;
                vm.onSelectItem = onSelectItem;
                vm.clearQuery = clearQuery;

                init();


                function init() {
                    vm.units = ConsumableVariety.getUnits();
                    checkValidity();

                    if (formCtrl) {
                        scope.$watch(function () {
                            return formCtrl.$submitted;
                        }, function (submitted) {
                            if (submitted) iElement.addClass('submitted')
                        });
                    }

                    queryCsmbs();
                }

                function touch() {
                    ngModelCtrl.$setTouched();
                }

                function onSelectItem(model) {
                    ngModelCtrl.$setViewValue(model);
                    checkValidity();
                    if (scope.onSelect()) {
                        scope.onSelect()(model)
                    }
                }


                function pageChanged() {
                    queryCsmbs(vm.queryStr);
                }

                function queryCsmbs(qStr) {
                    return Consumable.query({
                        op: 'option',
                        room_id: vm.roomId,
                        name: qStr,
                        page: vm.pager.page,
                        count: vm.pager.count
                    }).$promise.then(function (resp) {
                        angular.forEach(resp.items, function (item) {
                            item.purchase_unit = Array.getItem(item.purchase_unit, vm.units).name;
                            item.storage_unit = Array.getItem(item.storage_unit, vm.units).name;
                            item.use_unit = Array.getItem(item.use_unit, vm.units).name;
                        });
                        vm.csmbs = resp.items;
                        vm.pager.total = resp.total;
                        vm.csmbs.splice(0, 0, {action: true});
                    })
                }

                function refreshCsmbs($select) {
                    $select.refreshing = true;
                    vm.pager.page = 1;
                    vm.queryStr = $select.search;
                    return queryCsmbs($select.search).finally(function () {
                        $select.refreshing = false;
                    });
                }

                function checkValidity() {
                    var valid = iAttrs.required ? ngModelCtrl.$viewValue : true;
                    ngModelCtrl.$setValidity('required', valid);
                }

                function clearQuery() {
                    vm.queryStr = '';
                    queryCsmbs(vm.queryStr);
                }
            }
        }
    }
})();
(function () {
    'use strict';

    angular.module('Vendor.theme.components')
        .directive('csmbsSelect', csmbsSelect);

    /** @ngInject */
    function csmbsSelect(Consumable, Auth, ConsumableVariety, Array) {
        return {
            templateUrl: 'app/theme/components/csmbSelect/csmbsSelect.html',
            restrict: 'E',
            replace: true,
            scope: {
                onSelect: '&',
                onRemove: '&',
                existCsmbs: '=?',
                model: '=ngModel',
                onlyUse: '=?',
                disabled: '=?'
            },
            require: ['^ngModel', '?^form'],
            link: function (scope, iElement, iAttrs, r) {
                var ngModelCtrl = r[0], formCtrl = r[1];
                var vm = scope;
                vm.m = {selected: vm.model};
                vm.pager = {total: 0, page: 1, count: 5};
                vm.pageChanged = pageChanged;
                vm.refreshCsmbs = refreshCsmbs;
                vm.touch = touch;
                vm.onSelectItem = onSelectItem;
                vm.clearQuery = clearQuery;
                vm.onRemoveItem = onRemoveItem;

                init();


                function init() {
                    vm.units = ConsumableVariety.getUnits();
                    if (angular.isUndefined(vm.m.selected)) {
                        vm.m.selected = [];
                    }
                    if (angular.isUndefined(vm.existCsmbs)) {
                        vm.existCsmbs = [];
                    }
                    if (angular.isUndefined(vm.onlyUse)) {
                        vm.onlyUse = false;
                    }
                    if (angular.isUndefined(vm.disabled)) {
                        vm.disabled = false;
                    }
                    checkValidity();

                    if (formCtrl) {
                        scope.$watch(function () {
                            return formCtrl.$submitted;
                        }, function (submitted) {
                            if (submitted) iElement.addClass('submitted')
                        });
                    }

                    scope.$watch(function () {
                        return vm.m.selected;
                    }, function () {
                        queryCsmbs(vm.queryStr);
                    }, true);

                    scope.$watch(function () {
                        return vm.model;
                    }, function () {
                        vm.m.selected = vm.model;
                    }, true);
                }

                function touch() {
                    ngModelCtrl.$setTouched();
                }

                function onRemoveItem(model) {
                    ngModelCtrl.$setViewValue(vm.m.selected);
                    if (ngModelCtrl.$viewValue.length === 0) checkValidity();
                    if (scope.onRemove()) {
                        scope.onRemove()(model)
                    }
                }

                function onSelectItem(model) {
                    ngModelCtrl.$setViewValue(vm.m.selected);
                    checkValidity();
                    if (scope.onSelect()) {
                        scope.onSelect()(model)
                    }
                }


                function pageChanged() {
                    queryCsmbs(vm.queryStr);
                }

                function queryCsmbs(qStr) {
                    return Consumable.query({
                        op: 'option',
                        name: qStr,
                        page: vm.pager.page,
                        count: vm.pager.count,
                        onlyUse: vm.onlyUse ? '1' : '0'
                    }).$promise.then(function (resp) {
                        angular.forEach(resp.items, function (item) {
                            if (item.type.parent && item.type.parent_id != '1') {
                                item.type.parent = Array.getParent(item.type);
                            }
                            item.type = (item.type.parent && item.type.parent_id != '1') ? (item.type.parent.name + '-' + item.type.name) : item.type.name;
                            item.purchase_unit = Array.getItem(item.purchase_unit, vm.units).name;
                            item.storage_unit = Array.getItem(item.storage_unit, vm.units).name;
                            item.use_unit = Array.getItem(item.use_unit, vm.units).name;
                            if (Array.indexOfKey(item.id, vm.existCsmbs) != -1) {
                                item.hide = true;
                            }
                        });
                        vm.csmbs = resp.items;
                        vm.pager.total = resp.total;
                        vm.csmbs.splice(0, 0, {action: true});
                    })
                }

                function refreshCsmbs($select) {
                    $select.refreshing = true;
                    vm.pager.page = 1;
                    vm.queryStr = $select.search;
                    return queryCsmbs($select.search).finally(function () {
                        $select.refreshing = false;
                    });
                }

                function checkValidity() {
                    var valid = iAttrs.required ? ngModelCtrl.$viewValue : true;
                    ngModelCtrl.$setValidity('required', valid);
                }

                function clearQuery() {
                    vm.queryStr = '';
                    queryCsmbs(vm.queryStr);
                }
            }
        }
    }
})();
(function () {
    'use strict';

    angular.module('Vendor.theme.components')
        .directive('cvSelect', cvSelect);

    /** @ngInject */
    function cvSelect(Auth, ConsumableVariety, Array) {
        return {
            templateUrl: 'app/theme/components/csmbSelect/cvSelect.html',
            restrict: 'E',
            replace: true,
            scope: {
                onSelect: '&',
                roomId: '=?',
                model: '=ngModel'
            },
            require: ['^ngModel', '?^form'],
            link: function (scope, iElement, iAttrs, r) {
                var ngModelCtrl = r[0], formCtrl = r[1];
                var vm = scope;
                vm.pager = {total: 0, page: 1, count: 5};
                vm.pageChanged = pageChanged;
                vm.refreshCsmbs = refreshCsmbs;
                vm.touch = touch;
                vm.onSelectItem = onSelectItem;
                vm.clearQuery = clearQuery;

                init();


                function init() {
                    vm.units = ConsumableVariety.getUnits();
                    checkValidity();

                    if (formCtrl) {
                        scope.$watch(function () {
                            return formCtrl.$submitted;
                        }, function (submitted) {
                            if (submitted) iElement.addClass('submitted')
                        });
                    }

                    queryCsmbs();
                }

                function touch() {
                    ngModelCtrl.$setTouched();
                }

                function onSelectItem(model) {
                    ngModelCtrl.$setViewValue(model);
                    checkValidity();
                    if (scope.onSelect()) {
                        scope.onSelect()(model)
                    }
                }


                function pageChanged() {
                    queryCsmbs(vm.queryStr);
                }

                function queryCsmbs(qStr) {
                    return ConsumableVariety.query({
                        op: 'select',
                        name: qStr,
                        page: vm.pager.page,
                        count: vm.pager.count
                    }).$promise.then(function (resp) {
                        angular.forEach(resp.items, function (item) {
                            item.purchase_unit = Array.getItem(item.purchase_unit, vm.units).name;
                            item.storage_unit = Array.getItem(item.storage_unit, vm.units).name;
                            item.use_unit = Array.getItem(item.use_unit, vm.units).name;
                        });
                        vm.csmbs = resp.items;
                        vm.pager.total = resp.total;
                        vm.csmbs.splice(0, 0, {action: true});
                    })
                }

                function refreshCsmbs($select) {
                    $select.refreshing = true;
                    vm.pager.page = 1;
                    vm.queryStr = $select.search;
                    return queryCsmbs($select.search).finally(function () {
                        $select.refreshing = false;
                    });
                }

                function checkValidity() {
                    var valid = iAttrs.required ? ngModelCtrl.$viewValue : true;
                    ngModelCtrl.$setValidity('required', valid);
                }

                function clearQuery() {
                    vm.queryStr = '';
                    queryCsmbs(vm.queryStr);
                }
            }
        }
    }
})();
(function () {
    'use strict';

    angular.module('Vendor.theme.components')
        .directive('cvsSelect', cvsSelect);

    /** @ngInject */
    function cvsSelect(Auth, ConsumableVariety, Array) {
        return {
            templateUrl: 'app/theme/components/csmbSelect/cvsSelect.html',
            restrict: 'E',
            replace: true,
            scope: {
                onSelect: '&',
                onRemove: '&',
                existCsmbs: '=?',
                model: '=ngModel',
                disabled: '=?'
            },
            require: ['^ngModel', '?^form'],
            link: function (scope, iElement, iAttrs, r) {
                var ngModelCtrl = r[0], formCtrl = r[1];
                var vm = scope;
                vm.m = {selected: vm.model};
                vm.pager = {total: 0, page: 1, count: 5};
                vm.pageChanged = pageChanged;
                vm.refreshCsmbs = refreshCsmbs;
                vm.touch = touch;
                vm.onSelectItem = onSelectItem;
                vm.clearQuery = clearQuery;
                vm.onRemoveItem = onRemoveItem;

                init();


                function init() {
                    vm.units = ConsumableVariety.getUnits();
                    if (angular.isUndefined(vm.m.selected)) {
                        vm.m.selected = [];
                    }
                    if (angular.isUndefined(vm.existCsmbs)) {
                        vm.existCsmbs = [];
                    }
                    if (angular.isUndefined(vm.disabled)) {
                        vm.disabled = false;
                    }
                    checkValidity();

                    if (formCtrl) {
                        scope.$watch(function () {
                            return formCtrl.$submitted;
                        }, function (submitted) {
                            if (submitted) iElement.addClass('submitted')
                        });
                    }

                    scope.$watch(function () {
                        return vm.m.selected;
                    }, function () {
                        queryCsmbs(vm.queryStr);
                    }, true);

                    scope.$watch(function () {
                        return vm.model;
                    }, function () {
                        vm.m.selected = vm.model;
                    }, true);
                }

                function touch() {
                    ngModelCtrl.$setTouched();
                }

                function onRemoveItem(model) {
                    ngModelCtrl.$setViewValue(vm.m.selected);
                    if (ngModelCtrl.$viewValue.length === 0) checkValidity();
                    if (scope.onRemove()) {
                        scope.onRemove()(model)
                    }
                }

                function onSelectItem(model) {
                    ngModelCtrl.$setViewValue(vm.m.selected);
                    checkValidity();
                    if (scope.onSelect()) {
                        scope.onSelect()(model)
                    }
                }


                function pageChanged() {
                    queryCsmbs(vm.queryStr);
                }

                function queryCsmbs(qStr) {
                    return ConsumableVariety.query({
                        opt: 16,
                        vendor_id: Auth.getUser().vendor_id,
                        name: qStr,
                        page: vm.pager.page,
                        count: vm.pager.count
                    }).$promise.then(function (resp) {
                        angular.forEach(resp.items, function (item) {
                            if (item.type.parent && item.type.parent_id != '1') {
                                item.type.parent = Array.getParent(item.type);
                            }
                            item.type = (item.type.parent && item.type.parent_id != '1') ? (item.type.parent.name + '-' + item.type.name) : item.type.name;
                            item.purchase_unit = Array.getItem(item.purchase_unit, vm.units).name;
                            item.storage_unit = Array.getItem(item.storage_unit, vm.units).name;
                            item.use_unit = Array.getItem(item.use_unit, vm.units).name;
                            if (Array.indexOfKey(item.id, vm.existCsmbs) != -1) {
                                item.hide = true;
                            }
                        });
                        vm.csmbs = resp.items;
                        vm.pager.total = resp.total;
                        vm.csmbs.splice(0, 0, {action: true});
                    })
                }

                function refreshCsmbs($select) {
                    $select.refreshing = true;
                    vm.pager.page = 1;
                    vm.queryStr = $select.search;
                    return queryCsmbs($select.search).finally(function () {
                        $select.refreshing = false;
                    });
                }

                function checkValidity() {
                    var valid = iAttrs.required ? ngModelCtrl.$viewValue : true;
                    ngModelCtrl.$setValidity('required', valid);
                }

                function clearQuery() {
                    vm.queryStr = '';
                    queryCsmbs(vm.queryStr);
                }
            }
        }
    }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('Vendor.theme.components')
      .controller('MsgCenterCtrl', MsgCenterCtrl);

  /** @ngInject */
  function MsgCenterCtrl($scope, $sce) {
    $scope.users = {
      0: {
        name: 'Vlad',
      },
      1: {
        name: 'Kostya',
      },
      2: {
        name: 'Andrey',
      },
      3: {
        name: 'Nasta',
      }
    };

    $scope.notifications = [
      {
        userId: 0,
        template: '&name posted a new article.',
        time: '1 min ago'
      },
      {
        userId: 1,
        template: '&name changed his contact information.',
        time: '2 hrs ago'
      },
      {
        image: 'assets/img/shopping-cart.svg',
        template: 'New orders received.',
        time: '5 hrs ago'
      },
      {
        userId: 2,
        template: '&name replied to your comment.',
        time: '1 day ago'
      },
      {
        userId: 3,
        template: 'Today is &name\'s birthday.',
        time: '2 days ago'
      },
      {
        image: 'assets/img/comments.svg',
        template: 'New comments on your post.',
        time: '3 days ago'
      },
      {
        userId: 1,
        template: '&name invited you to join the event.',
        time: '1 week ago'
      }
    ];

    $scope.messages = [
      {
        userId: 3,
        text: 'After you get up and running, you can place Font Awesome icons just about...',
        time: '1 min ago'
      },
      {
        userId: 0,
        text: 'You asked, Font Awesome delivers with 40 shiny new icons in version 4.2.',
        time: '2 hrs ago'
      },
      {
        userId: 1,
        text: 'Want to request new icons? Here\'s how. Need vectors or want to use on the...',
        time: '10 hrs ago'
      },
      {
        userId: 2,
        text: 'Explore your passions and discover new ones by getting involved. Stretch your...',
        time: '1 day ago'
      },
      {
        userId: 3,
        text: 'Get to know who we are - from the inside out. From our history and culture, to the...',
        time: '1 day ago'
      },
      {
        userId: 1,
        text: 'Need some support to reach your goals? Apply for scholarships across a variety of...',
        time: '2 days ago'
      },
      {
        userId: 0,
        text: 'Wrap the dropdown\'s trigger and the dropdown menu within .dropdown, or...',
        time: '1 week ago'
      }
    ];

    $scope.getMessage = function(msg) {
      var text = msg.template;
      if (msg.userId || msg.userId === 0) {
        text = text.replace('&name', '<strong>' + $scope.users[msg.userId].name + '</strong>');
      }
      return $sce.trustAsHtml(text);
    };
  }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('Vendor.theme.components')
      .directive('msgCenter', msgCenter);

  /** @ngInject */
  function msgCenter() {
    return {
      restrict: 'E',
      templateUrl: 'app/theme/components/msgCenter/msgCenter.html',
      controller: 'MsgCenterCtrl'
    };
  }

})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Vendor.theme.components')
        .directive('pageTop', pageTop);

    /** @ngInject */
    function pageTop() {
        return {
            restrict: 'E',
            templateUrl: 'app/theme/components/pageTop/pageTop.html',
            controller: function ($rootScope, $state, Auth) {
                var vm = this;
                vm.vendor = Auth.getUser().dealer;
                vm.logout = function () {
                    Auth.logout(function () {
                        $state.go('login');
                    });
                }
            },
            controllerAs: 'vm'
        };
    }

})();
/**
 * by richard
 */
(function () {
    'use strict';

    angular.module('Vendor.theme.components').factory('Table', tableService);

    /** @ngInject */
    function tableService(NgTableParams, toaster) {
        var service = {
            getOpts: getOpts,
            query: queryItems,
            delItem: delItem,
            load4BgPager: load4BgPager,
            loadMultiSelectedFn: loadMultiSelectedFn,
            _1_BTN: 48,
            _2_BTN: 78,
            _3_BTN: 108,
            _4_BTN: 140,
            _5_BTN: 172,
            _6_BTN: 200,

            _1_CHAR: 48,
            _2_CHAR: 72,
            _3_CHAR: 96,
            _4_CHAR: 128
        };

        return service;

        function delItem(vm, service, id) {
            service.delete({id: id}).$promise.then(function (resp) {
                toaster.success(resp.msg);
                vm.tableReload();
            }, function (error) {
                var resp = error.data;
                toaster.error(resp.msg);
            });
        }

        /**
         * 方便ngTable获取数据
         * @param service 服务名称
         * @param url 参数
         * @param $defer ngTable的参数
         * @param params ngTable的参数
         * @param items 获取的主要数据项，字符串
         * @param cb 回调函数，可选
         */
        function queryItems(service, url, params, cb) {
            return service.query(url).$promise.then(function (data) {
                // console.log(data)
                if (data.total > 0 && data.items.length == 0) {
                    params.page(params.page() - 1);
                    params.reload();
                } else {
                    params.total(data.total);
                    if (angular.isDefined(cb)) {
                        cb(data);
                    }
                    return data.items;
                }
            });
        }

        /**
         * 获得ngtable过滤选项
         * @param items
         * @returns {*[]}
         */
        function getOpts(items) {
            var data = [{id: '', title: '-'}];
            angular.forEach(items, function (item) {
                data.push({id: item.id, title: item.name});
            });
            return data;
        }

        /**
         * 加载ngtable，后台分页
         * @param vm
         * @param options 配置选项
         *  *cols: 数据项
         *  *service： 查询的服务名称，params：查询的额外参数，如opt等，*items：返回的主要数据项名称，注意是string类型
         *  optColWidth：操作列宽度，hideOpt：是否隐藏操作列，hideFilter：是否隐藏过滤行，showSn：是否显示序号列
         *  count： 分页显示时初始每页显示数据条数（默认10），sorting：排序方式（默认 {created_at: 'desc'}）， filter: 初始过滤,
         *  counts: 分页页数选择（默认[10, 30, 50]）
         *  primaryParam: 如果指定了该参数并且params参数列表中该参数为空，则返回暂无数据
         * @param cb 回调函数
         */
        function load4BgPager(vm, options, cb) {
            vm.cols = options.cols;
            angular.forEach(vm.cols, function (col) {
                if (typeof col.show === 'undefined') {
                    col.show = true;
                }
            });
            vm.optColWidth = options.optColWidth;
            vm.hideOpt = options.hideOpt;
            vm.hideFilter = options.hideFilter;
            vm.showSn = options.showSn;
            vm.tableParams = new NgTableParams({
                count: options.count ? options.count : 10, sorting: options.sorting ? options.sorting : {
                    id: 'desc'
                }, filter: options.filter ? options.filter : {}
            }, {
                counts: options.counts ? options.counts : [10, 30, 50],
                getData: function (params) {
                    if (options.primaryParam && !options.params[options.primaryParam]) {
                        return [];
                    } else {
                        var url = params.url();
                        for (var index in options.params) {
                            url[index] = options.params[index];
                        }
                        return queryItems(options.service, url, params, cb);
                    }
                }
            });

            vm.clearFilters = function () {
                vm.tableParams.filter({});
            };

            vm.tableReload = function () {
                vm.tableParams.reload();
            };

            return {
                options: function () {
                    return options;
                }
            }
        }

        function loadMultiSelectedFn(vm) {
            vm.header = {checkAll: false};
            vm.checkOneFn = function (item, items) {
                if (item.is_checked) {
                    vm.header.checkAll = true;
                } else {
                    var allUnchecked = true;
                    for (var i = 0; i < items.length; i++) {
                        if (items[i].is_checked) {
                            allUnchecked = false;
                            break;
                        }
                    }
                    if (allUnchecked) {
                        vm.header.checkAll = false;
                    }
                }
            };
            vm.checkAllFn = function (checkAll, items) {
                if (checkAll) {
                    angular.forEach(items, function (item) {
                        item.is_checked = true;
                    })
                } else {
                    angular.forEach(items, function (item) {
                        item.is_checked = false;
                    })
                }
            };
            return {
                hasChecked: function () {
                    return vm.header.checkAll;
                },
                getCheckedIds: function (items, stage) {
                    var ids = [];
                    angular.forEach(items, function (item) {
                        if (item.is_checked && (!stage || (stage && item.stage.id == stage))) {
                            ids.push(item.id);
                        }
                    });
                    return ids;
                },
                getChecked: function (items, stage) {
                    var checked = [];
                    angular.forEach(items, function (item) {
                        if (item.is_checked && (!stage || (stage && item.stage.id == stage))) {
                            checked.push(item);
                        }
                    });
                    return checked;
                }
            }
        }
    }
})();

/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('Vendor.theme.components')
      .directive('widgets', widgets);

  /** @ngInject */
  function widgets() {
    return {
      restrict: 'EA',
      scope: {
        ngModel: '='
      },
      templateUrl: 'app/theme/components/widgets/widgets.html',
      replace: true
    };
  }

})();
/**
 * @author richard.fan
 * created on 17.12.2015
 */
(function () {
  'use strict';

  angular.module('Vendor.theme')
      .filter('appImage', appImage);

  /** @ngInject */
  function appImage(layoutPaths) {
    return function(input) {
      return layoutPaths.images.root + input;
    };
  }

})();

/**
 * @author richard.fan
 * created on 17.12.2015
 */
(function () {
  'use strict';

  angular.module('Vendor.theme')
      .filter('profilePicture', profilePicture);

  /** @ngInject */
  function profilePicture(layoutPaths) {
    return function(input, ext) {
      ext = ext || 'png';
      return layoutPaths.images.profile + input + '.' + ext;
    };
  }

})();

(function () {
    'use strict';

    angular.module('Vendor.theme')
        .filter('bytes', bytes);

    /** @ngInject */
    function bytes() {
        return function(bytes) {
            if (isNaN(parseFloat(bytes)) || !isFinite(bytes) || bytes == 0) return '0';
            var units = {1: 'KB', 2: 'MB', 3: 'GB', 4: 'TB'},
                measure, floor, precision;
            if (bytes > 1099511627775) {
                measure = 4;
            } else if (bytes > 1048575999 && bytes <= 1099511627775) {
                measure = 3;
            } else if (bytes > 1024000 && bytes <= 1048575999) {
                measure = 2;
            } else if (bytes <= 1024000) {
                measure = 1;
            }
            floor = Math.floor(bytes / Math.pow(1024, measure)).toString().length;
            if (floor > 3) {
                precision = 0
            } else {
                precision = 3 - floor;
            }
            return (bytes / Math.pow(1024, measure)).toFixed(precision) + units[measure];
        }
    }

})();

/**
 * @author a.demeshko
 * created on 23.12.2015
 */
(function () {
  'use strict';

  angular.module('Vendor.theme')
    .filter('plainText', plainText);

  /** @ngInject */
  function plainText() {
    return function(text) {
      return  text ? String(text).replace(/<[^>]+>/gm, '') : '';
    };
  }

})();

(function () {
    'use strict';
    angular.module('Vendor.pages.csmbs.batches')
        .factory('ConsumableBatch', ConsumableBatchServiceFn)
        .factory('Storeroom', StoreroomServiceFn);

    /** @ngInject */
    function ConsumableBatchServiceFn($resource) {
        var service = {
            getStates: getStates
        };

        return angular.extend(service, $resource('/api/v1/consumable/consumable_batches/:id', {}, {
            query: {
                method: 'GET'
            },
            update: {
                method: 'PUT'
            }
        }));

        function getStates() {
            return [
                {id: 1, name: '供应商发货'},
                {id: 2, name: '医院确认'},
                {id: 3, name: '直购库审'},
                {id: 4, name: '直购科审'},
                {id: 5, name: '科室寄销'},
                {id: 6, name: '库房寄销'}
            ];
        }
    }

    /** @ngInject */
    function StoreroomServiceFn($resource) {
        var service = {};

        return angular.extend(service, $resource('/api/v1/consumable/storerooms/:id', {}, {
            query: {
                method: 'GET'
            },
            update: {
                method: 'PUT'
            }
        }));
    }
})();
/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Vendor.pages.csmbs.inventories.storeroom').controller('csmbStoreroomQueryCtrl', csmbStoreroomQueryCtrl);

    /** @ngInject */
    function csmbStoreroomQueryCtrl(Array, Table, Consumable, Auth, Storeroom, ConsumableVariety, ConsumableType, dialogs, $stateParams) {
        var vm = this;
        vm.zoomIn = zoomIn;
        vm.zero_show = false;
        vm.zeroShowChange = zeroShowChange;

        init();


        function init() {
            vm.units = ConsumableVariety.getUnits();
            Storeroom.query({op: 'option'}, function (resp) {
                vm.rooms = resp.items;

                var options = {
                    service: Consumable,
                    params: {op: 'inventory'},
                    optColWidth: Table._1_BTN,
                    cols: [
                        {field: "name", title: "注册证名称", filter: {name: "text"}},
                        {field: "c_name", title: "通用名", filter: {c_name: "text"}},
                        {field: "spec", title: "规格型号", filter: {spec: "text"}},
                        {field: "type", title: "类型", filter: {type: "tree"}, width: 168},
                        {field: "num", title: "数量"},
                        {field: "alarm", title: "库存预警"}
                    ]
                };

                if ($stateParams.room_id) {
                    options.filter = {room_id: $stateParams.room_id, zero_show: vm.zero_show ? 1 : 0};
                } else if (vm.rooms.length > 0) {
                    options.filter = {room_id: vm.rooms[0].id, zero_show: vm.zero_show ? 1 : 0};
                }

                var optionFn = Table.load4BgPager(vm, options, function (resp) {
                    angular.forEach(resp.items, function (item) {
                        item.type = (item.type.parent && item.type.parent_id != '1') ? (Array.getParent(item.type).name + '-' + item.type.name) : item.type.name;
                        item.purchase_unit = Array.getItem(item.purchase_unit, vm.units).name;
                        item.storage_unit = Array.getItem(item.storage_unit, vm.units).name;
                        item.use_unit = Array.getItem(item.use_unit, vm.units).name;
                    });
                }).options;

                ConsumableType.query({opt: 1}, function (resp) {
                    optionFn().cols[3].data = resp.items;
                });

                vm.clearFilters = function () {
                    vm.tableParams.filter({
                        room_id: vm.tableParams.filter()['room_id'],
                        zero_show: vm.zero_show ? 1 : 0
                    });
                };
            });
        }

        function zeroShowChange() {
            vm.tableParams.filter({room_id: vm.tableParams.filter()['room_id'], zero_show: vm.zero_show ? 1 : 0});
        }


        function getCurImg(m) {
            return m.images[m.active];
        }

        function zoomIn(m) {
            var img = getCurImg(m);
            dialogs.create('CsmbLargeImgDlg.html', 'CsmbLargeImgDlgCtrl', img, {size: 'lg'}, 'vm');
        }
    }

})();

/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Vendor.pages.csmbs.inventories.temporary').controller('csmbStoreroomTemporaryCtrl', csmbStoreroomTemporaryCtrl);

    /** @ngInject */
    function csmbStoreroomTemporaryCtrl(Array, Table, Consumable, Auth, Storeroom, ConsumableVariety, ConsumableType, dialogs, $stateParams) {
        var vm = this;
        vm.zoomIn = zoomIn;

        init();


        function init() {
            vm.units = ConsumableVariety.getUnits();
            Storeroom.query({op: 'option'}, function (resp) {
                vm.rooms = resp.items;

                var options = {
                    service: Consumable,
                    params: {op: 'temporary'},
                    optColWidth: Table._1_BTN,
                    cols: [
                        {field: "name", title: "注册证名称", filter: {name: "text"}},
                        {field: "c_name", title: "通用名", filter: {c_name: "text"}},
                        {field: "spec", title: "规格型号", filter: {spec: "text"}},
                        {field: "type", title: "类型", filter: {type: "tree"}, width: 168},
                        {field: "num", title: "数量"}
                    ]
                };

                if ($stateParams.room_id) {
                    options.filter = {room_id: $stateParams.room_id};
                } else if (vm.rooms.length > 0) {
                    options.filter = {room_id: vm.rooms[0].id};
                }

                var optionFn = Table.load4BgPager(vm, options, function (resp) {
                    angular.forEach(resp.items, function (item) {
                        item.num = item.total_num - (item.receive_num ? item.receive_num : 0);
                        item.type = (item.type.parent && item.type.parent_id != '1') ? (Array.getParent(item.type).name + '-' + item.type.name) : item.type.name;
                        item.purchase_unit = Array.getItem(item.purchase_unit, vm.units).name;
                        item.storage_unit = Array.getItem(item.storage_unit, vm.units).name;
                        item.use_unit = Array.getItem(item.use_unit, vm.units).name;
                    });
                }).options;

                ConsumableType.query({opt: 1}, function (resp) {
                    optionFn().cols[3].data = resp.items;
                });

                vm.clearFilters = function () {
                    vm.tableParams.filter({room_id: vm.tableParams.filter()['room_id']});
                };
            });
        }

        function getCurImg(m) {
            return m.images[m.active];
        }

        function zoomIn(m) {
            var img = getCurImg(m);
            dialogs.create('CsmbLargeImgDlg.html', 'CsmbLargeImgDlgCtrl', img, {size: 'lg'}, 'vm');
        }
    }

})();

/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Vendor.pages.csmbs.prices.new').controller('csmbPriceNewCtrl', csmbPriceNewCtrl);

    /** @ngInject */
    function csmbPriceNewCtrl($q, $sce, Api, $state, Auth, $validation, Array, CsmbPrice,
                              Consumable, ConsumableVariety, Misc) {
        var vm = this;
        vm.submit = submit;
        vm.increase = increase;
        vm.decrease = decrease;
        vm.reset = reset;
        vm.csmbSelected = csmbSelected;
        Misc.initEditor(vm);

        init();


        function init() {
            // vm.units = ConsumableVariety.getUnits();
            // Consumable.query({
            //     op: 'price'
            // }, function (resp) {
            //     angular.forEach(resp.items, function (item) {
            //         item.purchase_unit = Array.getItem(item.purchase_unit, vm.units).name;
            //         item.storage_unit = Array.getItem(item.storage_unit, vm.units).name;
            //         item.use_unit = Array.getItem(item.use_unit, vm.units).name;
            //         item.new_price = item.purchase_price;
            //     });
            //     vm.consumables = resp.items;
            //     vm.m = {
            //         consumables: []
            //     };
            // });
            vm.m = {
                consumables: [],
                csmbs: []
            };
        }

        function csmbSelected(m) {
            m.consumables = angular.copy(m.csmbs);
            angular.forEach(m.consumables, function (csmb) {
                csmb.new_price = csmb.purchase_price;
            });
        }

        function reset() {
            init();
        }

        function increase(m) {
            if (m.new_price) {
                m.new_price++;
            } else {
                m.new_price = m.purchase_price;
            }
        }

        function decrease(m) {
            if (m.new_price && m.new_price > 0) {
                m.new_price--;
                if (m.new_price == 0) {
                    m.new_price = m.new_price.toString();
                }
            } else {
                m.new_price = m.purchase_price;
            }
        }

        function submit(form, m) {
            var defer = $q.defer();
            $validation.validate(form).success(function () {
                if (m.consumables.length == 0) {
                    Api.w('请选择耗材');
                    defer.reject();
                } else {
                    var pa = {
                        content: m.content,
                        csmbs: m.consumables
                    };
                    CsmbPrice.save(pa).$promise.then(function (resp) {
                        Api.s(resp.msg);
                        $state.go('^');
                        defer.resolve();
                    }, function () {
                        defer.reject();
                    });
                }
            }).error(function () {
                Api.w('请检查表单错误');
                form.$submitted = true;
                defer.reject();
            });
            return defer.promise;

        }
    }

})();

/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Vendor.pages.csmbs.direct.approval').controller('CsmbDirectApprovalCtrl', CsmbDirectApprovalCtrl);

    /** @ngInject */
    function CsmbDirectApprovalCtrl(Table, CsmbDirectApplication, Auth, Storeroom, $stateParams, dialogs, ConsumableVariety, Array) {
        var vm = this;
        vm.pass = pass;
        vm.changeHide = changeHide;

        init();


        function init() {
            vm.hideSub = true;
            vm.units = ConsumableVariety.getUnits();
            Storeroom.query({op: 'option'}, function (resp) {
                vm.rooms = resp.items;
                var states = CsmbDirectApplication.getVendorApprovalStates();
                var stateOpts = Table.getOpts(states);
                var options = {
                    service: CsmbDirectApplication,
                    params: {op: 'approval'},
                    optColWidth: Table._2_BTN,
                    cols: [
                        {field: 'application_items', title: '待发物资', filter: {item: "text"}},
                        {field: "dept", title: "申请科室", filter: {dept: "text"}, width: 80},
                        {field: "applicant", title: "申请人", filter: {applicant: "text"}, width: 80},
                        {field: "created_at", title: '申请时间', filter: {created_at: 'date_range'}, width: 100},
                        {field: "state", title: '状态', filter: {state: 'select'}, data: stateOpts, width: 80}
                    ]
                };

                if ($stateParams.room_id) {
                    options.filter = {room_id: $stateParams.room_id};
                } else if (vm.rooms.length > 0) {
                    options.filter = {room_id: vm.rooms[0].id};
                }

                Table.load4BgPager(vm, options, function (resp) {
                    angular.forEach(resp.items, function (row) {
                        row.state = Array.getItem(row.state, states);
                        angular.forEach(row.application_items, function (item) {
                            if (vm.tableParams.filter()['item']) {
                                row.expand = true;
                                var name = (item.consumable.name + item.consumable.c_name + item.consumable.sunshine_num + item.consumable.spec).toLowerCase();
                                item.hide = (name.indexOf(vm.tableParams.filter()['item'].toLowerCase()) < 0 && vm.hideSub);
                            }
                            item.diff_num = item.r_num != null ? (parseInt(item.num) > parseInt(item.r_num) ? (parseInt(item.num) - parseInt(item.r_num)) : 0) : item.num;
                            item.consumable.storage_unit = Array.getItem(item.consumable.storage_unit, vm.units).name;
                            item.consumable.purchase_unit = Array.getItem(item.consumable.purchase_unit, vm.units).name;
                            item.consumable.use_unit = Array.getItem(item.consumable.use_unit, vm.units).name;
                        });
                    });
                    vm.items = resp.items;
                });

                vm.clearFilters = function () {
                    vm.tableParams.filter({room_id: vm.tableParams.filter()['room_id']});
                };
            });


        }

        function pass(m) {
            dialogs.create('app/pages/csmbs/direct/dialogs/csmbOut/out.html', 'vendorCsmbDirectOutCtrl', {
                item: m,
                room_id: vm.tableParams.filter()['room_id']
            }, {size: 'lg'}, 'vm').result.then(function () {
                vm.tableReload();
            });
        }

        function changeHide(rows, newVal) {
            if (newVal) {
                angular.forEach(rows, function (row) {
                    angular.forEach(row.application_items, function (item) {
                        var name = (item.consumable.name + item.consumable.c_name + item.consumable.sunshine_num + item.consumable.spec).toLowerCase();
                        item.hide = (name.indexOf(newVal.toLowerCase()) < 0 && vm.hideSub);
                    });
                });
            }
        }

    }

})();

/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Vendor.pages.csmbs.direct.approved').controller('CsmbDirectApprovedCtrl', CsmbDirectApprovedCtrl);

    /** @ngInject */
    function CsmbDirectApprovedCtrl(Table, CsmbDirectApplication, Storeroom, $stateParams, dialogs, Array, ConsumableVariety, Api, $state) {
        var vm = this;
        vm.batch = batch;
        vm.back = back;
        vm.changeHide = changeHide;

        init();


        function init() {
            vm.hideSub = true;
            vm.units = ConsumableVariety.getUnits();
            Storeroom.query({op: 'option'}, function (resp) {
                vm.rooms = resp.items;
                var states = CsmbDirectApplication.getVendorStates();
                var stateOpts = Table.getOpts(states);
                var options = {
                    service: CsmbDirectApplication,
                    params: {op: 'approved'},
                    optColWidth: Table._3_BTN,
                    cols: [
                        {field: 'application_items', title: '申请物资', filter: {item: "text"}},
                        {field: "dept", title: "申请科室", filter: {dept: "text"}, width: 80},
                        {field: "applicant", title: "申请人", filter: {applicant: "text"}, width: 80},
                        {field: "created_at", title: '申请时间', filter: {created_at: 'date_range'}, width: 100},
                        {field: "handle_time", title: '确认时间', filter: {handle_time: 'date_range'}, width: 100},
                        {field: "state", title: '状态', filter: {state: 'select'}, data: stateOpts, width: 80}
                    ]
                };

                if ($stateParams.room_id) {
                    options.filter = {room_id: $stateParams.room_id};
                } else if (vm.rooms.length > 0) {
                    options.filter = {room_id: vm.rooms[0].id};
                }

                Table.load4BgPager(vm, options, function (resp) {
                    angular.forEach(resp.items, function (row) {
                        row.state = Array.getItem(row.state, states);
                        angular.forEach(row.application_items, function (item) {
                            if (vm.tableParams.filter()['item']) {
                                row.expand = true;
                                var name = (item.consumable.name + item.consumable.c_name + item.consumable.sunshine_num + item.consumable.spec).toLowerCase();
                                item.hide = (name.indexOf(vm.tableParams.filter()['item'].toLowerCase()) < 0 && vm.hideSub);
                            }
                            item.consumable.storage_unit = Array.getItem(item.consumable.storage_unit, vm.units).name;
                            item.consumable.purchase_unit = Array.getItem(item.consumable.purchase_unit, vm.units).name;
                            item.consumable.use_unit = Array.getItem(item.consumable.use_unit, vm.units).name;
                        });
                    });
                    vm.items = resp.items;
                });
                vm.clearFilters = function () {
                    vm.tableParams.filter({room_id: vm.tableParams.filter()['room_id']});
                };
            });
        }

        function batch(m) {
            dialogs.create('app/pages/csmbs/direct/dialogs/csmbOut/batch.html', 'vendorCsmbDirectBatchCtrl', {
                m: m
            }, {size: 'lg'}, 'vm');
        }

        function changeHide(rows, newVal) {
            if (newVal) {
                angular.forEach(rows, function (row) {
                    angular.forEach(row.application_items, function (item) {
                        var name = (item.consumable.name + item.consumable.c_name + item.consumable.sunshine_num + item.consumable.spec).toLowerCase();
                        item.hide = (name.indexOf(newVal.toLowerCase()) < 0 && vm.hideSub);
                    });
                });
            }
        }

        function back(row) {
            dialogs.confirm('撤销发货', '确定要<strong class="text-danger">撤销发货并删除发货批次</strong>吗？')
                .result.then(function () {
                CsmbDirectApplication.update({id: row.id, op: 'back'}).$promise.then(function (resp) {
                    Api.s(resp.msg);
                    vm.tableReload();
                }, function (error) {
                    var resp = error.data;
                    Api.e(resp.msg);
                });
            });
        }
    }

})();

/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Vendor.pages.csmbs.direct.returned').controller('CsmbDirectReturnApprovedCtrl', CsmbDirectReturnApprovedCtrl);

    /** @ngInject */
    function CsmbDirectReturnApprovedCtrl(Table, CsmbDirectReturn, Auth, Storeroom, $stateParams, Array, Misc, ConsumableVariety) {
        var vm = this;
        vm.changeHide = changeHide;

        init();


        function init() {
            vm.hideSub = true;

            var states = CsmbDirectReturn.getStates();
            var statesOpts = Table.getOpts(states);
            var units = ConsumableVariety.getUnits();

            Storeroom.query({op: 'option'}, function (resp) {
                vm.rooms = resp.items;

                var options = {
                    service: CsmbDirectReturn,
                    params: {op: 'approved'},
                    optColWidth: Table._1_BTN,
                    cols: [
                        {field: 'itemDesc', title: '退货物资', filter: {item: "text"}, width: '35%'},
                        {field: "dept", title: "申请科室", filter: {dept: "text"}},
                        {field: "applicant", title: "申请人", filter: {applicant: "text"}},
                        {field: "created_at", title: '申请时间', filter: {created_at: 'date_range'}},
                        {field: "state", title: '状态', filter: {state: 'select'}, data: statesOpts}
                    ]
                };

                if ($stateParams.room_id) {
                    options.filter = {room_id: $stateParams.room_id};
                } else if (vm.rooms.length > 0) {
                    options.filter = {room_id: vm.rooms[0].id};
                }

                Table.load4BgPager(vm, options, function (resp) {
                    angular.forEach(resp.items, function (row) {
                        row.state = Array.getItem(row.state, states);
                        var total = 0;
                        var items = [];
                        angular.forEach(row.application_items, function (item) {
                            if (vm.tableParams.filter()['item']) {
                                row.expand = true;
                                var name = (item.consumable.name + item.consumable.c_name + item.consumable.sunshine_num + item.consumable.spec).toLowerCase();
                                item.hide = (name.indexOf(vm.tableParams.filter()['item'].toLowerCase()) < 0 && vm.hideSub);
                            }
                            item.consumable.storage_unit = Array.getItem(item.consumable.storage_unit, units).name;
                            item.consumable.purchase_unit = Array.getItem(item.consumable.purchase_unit, units).name;
                            item.consumable.use_unit = Array.getItem(item.consumable.use_unit, units).name;
                            item.total = Misc.toFixed(item.consumable.use_num * item.num * item.batch.purchase_price, 2);
                            total += item.total;
                            var m = Array.getItem(item.consumable_id, items, 'consumable_id');
                            if (m == null) {
                                items.push(angular.copy(item));
                            } else {
                                m.num = parseInt(m.num) + parseInt(item.num);
                            }
                        });
                        row.total = Misc.toFixed(total, 2);
                        row.itemDesc = items;
                    });

                    vm.items = resp.items;
                });

                vm.clearFilters = function () {
                    vm.tableParams.filter({room_id: vm.tableParams.filter()['room_id']});
                };
            });
        }

        function changeHide(rows, newVal) {
            if (newVal) {
                angular.forEach(rows, function (row) {
                    angular.forEach(row.itemDesc, function (item) {
                        var name = (item.consumable.name + item.consumable.c_name + item.consumable.sunshine_num + item.consumable.spec).toLowerCase();
                        item.hide = (name.indexOf(newVal.toLowerCase()) < 0 && vm.hideSub);
                    });
                });
            }
        }
    }

})();

/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Vendor.pages.csmbs.direct.temporary').controller('csmbDeptTemporaryCtrl', csmbDeptTemporaryCtrl);

    /** @ngInject */
    function csmbDeptTemporaryCtrl(Array, Table, Consumable, Auth, Storeroom, ConsumableVariety, ConsumableType, dialogs, $stateParams) {
        var vm = this;
        vm.zoomIn = zoomIn;

        init();


        function init() {
            vm.units = ConsumableVariety.getUnits();

            var options = {
                service: Consumable,
                params: {op: 'dept_temporary'},
                optColWidth: Table._1_BTN,
                cols: [
                    {field: "name", title: "注册证名称", filter: {name: "text"}},
                    {field: "c_name", title: "通用名", filter: {c_name: "text"}},
                    {field: "spec", title: "规格型号", filter: {spec: "text"}},
                    {field: "type", title: "类型", filter: {type: "tree"}, width: 168},
                    {field: "dept_name", title: "科室", filter: {dept: "text"}},
                    {field: "num", title: "数量"}
                ]
            };

            var optionFn = Table.load4BgPager(vm, options, function (resp) {
                angular.forEach(resp.items, function (item) {
                    item.type = (item.type.parent && item.type.parent_id != '1') ? (Array.getParent(item.type).name + '-' + item.type.name) : item.type.name;
                    item.purchase_unit = Array.getItem(item.purchase_unit, vm.units).name;
                    item.storage_unit = Array.getItem(item.storage_unit, vm.units).name;
                    item.use_unit = Array.getItem(item.use_unit, vm.units).name;
                    item.num = item.total_num - (item.receive_num ? item.receive_num : 0)
                });
            }).options;

            ConsumableType.query({opt: 1}, function (resp) {
                optionFn().cols[3].data = resp.items;
            });
        }

        function getCurImg(m) {
            return m.images[m.active];
        }

        function zoomIn(m) {
            var img = getCurImg(m);
            dialogs.create('CsmbLargeImgDlg.html', 'CsmbLargeImgDlgCtrl', img, {size: 'lg'}, 'vm');
        }
    }

})();

/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Vendor.pages.csmbs.qualifications.new')
        .controller('csmbQANewCtrl', csmbQANewCtrl)
        .controller('csmbQAAddCtrl', csmbQAAddCtrl);

    /** @ngInject */
    function csmbQANewCtrl($q, Api, $state, Auth, $validation, dialogs, ConsumableVariety, CsmbQA, Array, File, VendorQ) {
        var vm = this;
        vm.submit = submit;
        vm.reset = reset;
        vm.add = add;
        vm.remove = remove;
        vm.download = download;
        vm.changeFn = changeFn;
        vm.csmbSelected = csmbSelected;

        init();


        function init() {
            // ConsumableVariety.query({
            //     op: 'option'
            // }, function (resp) {
            //     vm.consumables = resp.items;
            //     vm.m = {
            //         consumables: []
            //     };
            // });
            vm.m = {
                csmbs: [],
                consumables: []
            };
        }

        function reset() {
            init();
        }

        function csmbSelected(m) {
            m.consumables = angular.copy(m.csmbs);
        }

        function add(csmb, items) {
            dialogs.create('csmbQAAdd.html', 'csmbQAAddCtrl',
                {consumable_id: csmb.id}, {size: 'lg'}, 'vm').result.then(function (result) {
                angular.forEach(result, function (item) {
                    if (Array.getItem(item.id, items) != null) {
                        Api.w('请勿重复添加新资质');
                    } else {
                        item.isNew = true;
                        items.push(item)
                    }
                });
            });
        }

        function remove(array, $index) {
            array.splice($index, 1);
        }

        function download(attach) {
            File.download(VendorQ.urls.DOWNLOAD, attach);
        }

        function changeFn(item, m) {
            angular.forEach(m.qualifications, function (q) {
                if (item.change && item.id != q.id) {
                    q.change = false;
                }
            });
        }

        function submit(form, m) {
            var defer = $q.defer();
            $validation.validate(form).success(function () {
                var items = [];
                var canSubmit = false;
                angular.forEach(m.consumables, function (csmb) {
                    angular.forEach(csmb.qualifications, function (q) {
                        if (q.remove) {
                            canSubmit = true;
                            items.push({csmb_id: csmb.id, q_id: q.id, type: 2});
                        }
                        if (q.isNew) {
                            canSubmit = true;
                            items.push({csmb_id: csmb.id, q_id: q.id, type: q.change ? 3 : 1});
                        }
                    });
                });
                var pa = {
                    note: m.note,
                    vendor_id: Auth.VENDOR_ID,
                    items: items
                };

                if (canSubmit) {
                    CsmbQA.save(pa).$promise.then(function (resp) {
                        Api.s(resp.msg);
                        $state.go('^');
                        defer.resolve();
                    }, function () {
                        defer.reject();
                    });
                } else {
                    Api.w('选择的耗材至少需要解绑或新增一个资质');
                    defer.reject();
                }

            }).error(function () {
                Api.w('请检查表单错误');
                form.$submitted = true;
                defer.reject();
            });
            return defer.promise;
        }
    }

    /** @ngInject */
    function csmbQAAddCtrl($uibModalInstance, Api, ConsumableQualification, data) {
        var vm = this;
        vm.cancel = $uibModalInstance.dismiss;
        vm.ok = ok;

        init(data.consumable_id);


        function init(consumableId) {
            vm.m = {consumable_id: consumableId};
            ConsumableQualification.query({
                opt: 2, consumable_id: consumableId, exclude_existing: 1
            }, function (resp) {
                vm.qualifications = resp.items;
            });
        }

        function ok(m) {
            if (!m.qualifications || m.qualifications.length == 0) {
                Api.w('请选择资质');
            } else {
                $uibModalInstance.close(m.qualifications);

            }
        }
    }
})();

/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Vendor.pages.csmbs.purchase.approval').controller('SPAApprovalCtrl', SPAApprovalCtrl);

    /** @ngInject */
    function SPAApprovalCtrl(Table, SPApplication, Auth, Storeroom, $stateParams, dialogs, ConsumableVariety, Array, Api) {
        var vm = this;
        vm.pass = pass;
        vm.info = info;
        vm.changeHide = changeHide;
        vm.remove = remove;

        init();


        function init() {
            vm.hideSub = true;
            vm.units = ConsumableVariety.getUnits();
            Storeroom.query({op: 'option'}, function (resp) {
                vm.rooms = resp.items;
                var states = SPApplication.getVendorApprovalStates();
                var stateOpts = Table.getOpts(states);
                var options = {
                    service: SPApplication,
                    params: {op: 'approval'},
                    optColWidth: Table._4_BTN,
                    cols: [
                        {field: 'application_items', title: '申请物资', filter: {item: "text"}},
                        {field: "applicant", title: "申请人", filter: {applicant: "text"}, width: 80},
                        {field: "created_at", title: '申请时间', filter: {created_at: 'date_range'}, width: 100},
                        {field: "state", title: '状态', filter: {state: 'select'}, data: stateOpts, width: 80}
                    ]
                };

                if ($stateParams.room_id) {
                    options.filter = {room_id: $stateParams.room_id};
                } else if (vm.rooms.length > 0) {
                    options.filter = {room_id: vm.rooms[0].id};
                }

                Table.load4BgPager(vm, options, function (resp) {
                    angular.forEach(resp.items, function (row) {
                        row.state = Array.getItem(row.state, states);
                        angular.forEach(row.application_items, function (item) {
                            if (vm.tableParams.filter()['item']) {
                                row.expand = true;
                                var name = (item.consumable.name + item.consumable.c_name + item.consumable.sunshine_num + item.consumable.spec).toLowerCase();
                                item.hide = (name.indexOf(vm.tableParams.filter()['item'].toLowerCase()) < 0 && vm.hideSub);
                            }
                            var num = row.for_purchase == 1 ? (item.num * item.consumable.storage_num) : item.num;
                            item.diff_num = item.r_num != null ? (parseInt(num) > parseInt(item.r_num) ? (parseInt(num) - parseInt(item.r_num)) : 0) : num;
                            item.l_num = parseInt(item.diff_num / item.consumable.storage_num);
                            item.s_num = item.diff_num % item.consumable.storage_num;
                            item.consumable.storage_unit = Array.getItem(item.consumable.storage_unit, vm.units).name;
                            item.consumable.purchase_unit = Array.getItem(item.consumable.purchase_unit, vm.units).name;
                            item.consumable.use_unit = Array.getItem(item.consumable.use_unit, vm.units).name;
                        });
                    });
                });

                vm.clearFilters = function () {
                    vm.tableParams.filter({room_id: vm.tableParams.filter()['room_id']});
                };
            });
        }

        function pass(m) {
            createDlg(m);
        }

        function createDlg(item) {
            dialogs.create('app/pages/csmbs/purchase/dialogs/csmbOut/out.html', 'vendorCsmbOutCtrl', {
                item: item,
                room_id: vm.tableParams.filter()['room_id']
            }, {size: 'lg'}, 'vm').result.then(function () {
                vm.tableReload();
            });
        }


        function info(m) {
            dialogs.create('app/pages/csmbs/purchase/dialogs/appMsn/msn.html', 'csmbAppMsnCtrl', {m: m},
                {size: 'md'}, 'vm').result.then(function () {
                vm.tableReload();
            });
        }

        function changeHide(rows, newVal) {
            if (newVal) {
                angular.forEach(rows, function (row) {
                    angular.forEach(row.application_items, function (item) {
                        var name = (item.consumable.name + item.consumable.c_name + item.consumable.sunshine_num + item.consumable.spec).toLowerCase();
                        item.hide = (name.indexOf(newVal.toLowerCase()) < 0 && vm.hideSub);
                    });
                });
            }
        }

        function remove(m) {
            dialogs.confirm('终止主动发货申请', '确定要终止主动发货申请吗？')
                .result.then(function () {
                SPApplication.update({id: m.id}, {op: 'remove'}).$promise.then(function (resp) {
                    vm.tableReload();
                    Api.s(resp.msg);
                }, function (error) {
                    var resp = error.data;
                    Api.e(resp.msg);
                });
            });
        }

    }

})();

/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Vendor.pages.csmbs.purchase.approved').controller('SPAApprovedCtrl', SPAApprovedCtrl);

    /** @ngInject */
    function SPAApprovedCtrl(Table, SPApplication, Auth, Storeroom, $stateParams, Api, dialogs, Array, ConsumableVariety) {
        var vm = this;
        vm.info = info;
        vm.batch = batch;
        vm.back = back;
        vm.changeHide = changeHide;

        init();


        function init() {
            vm.hideSub = true;
            vm.units = ConsumableVariety.getUnits();
            Storeroom.query({op: 'option'}, function (resp) {
                vm.rooms = resp.items;
                var states = SPApplication.getVendorApprovedStates();
                var stateOpts = Table.getOpts(states);
                var options = {
                    service: SPApplication,
                    params: {op: 'approved'},
                    optColWidth: Table._4_BTN,
                    cols: [
                        {field: 'application_items', title: '申请物资', filter: {item: "text"}},
                        {field: "applicant", title: "申请人", filter: {applicant: "text"}, width: 80},
                        {field: "created_at", title: '申请时间', filter: {created_at: 'date_range'}, width: 100},
                        {field: "confirmed_time", title: '确认时间', filter: {confirmed_time: 'date_range'}, width: 100},
                        {field: "state", title: '状态', filter: {state: 'select'}, data: stateOpts, width: 80}
                    ]
                };

                if ($stateParams.room_id) {
                    options.filter = {room_id: $stateParams.room_id};
                } else if (vm.rooms.length > 0) {
                    options.filter = {room_id: vm.rooms[0].id};
                }

                Table.load4BgPager(vm, options, function (resp) {
                    angular.forEach(resp.items, function (row) {
                        row.state = Array.getItem(row.state, states);
                        angular.forEach(row.application_items, function (item) {
                            if (vm.tableParams.filter()['item']) {
                                row.expand = true;
                                var name = (item.consumable.name + item.consumable.c_name + item.consumable.sunshine_num + item.consumable.spec).toLowerCase();
                                item.hide = (name.indexOf(vm.tableParams.filter()['item'].toLowerCase()) < 0 && vm.hideSub);
                            }
                            item.consumable.storage_unit = Array.getItem(item.consumable.storage_unit, vm.units).name;
                            item.consumable.purchase_unit = Array.getItem(item.consumable.purchase_unit, vm.units).name;
                            item.consumable.use_unit = Array.getItem(item.consumable.use_unit, vm.units).name;
                        });
                    });
                });
                vm.clearFilters = function () {
                    vm.tableParams.filter({room_id: vm.tableParams.filter()['room_id']});
                };
            });
        }

        function info(m) {
            dialogs.create('app/pages/csmbs/purchase/dialogs/appMsn/msn.html', 'csmbAppMsnCtrl', {m: m},
                {size: 'md'}, 'vm').result.then(function () {
                vm.tableReload();
            });
        }

        function batch(m) {
            dialogs.create('app/pages/csmbs/purchase/dialogs/csmbOut/batch.html', 'vendorCsmbBatchCtrl', {
                m: m
            }, {size: 'lg'}, 'vm');
        }


        function changeHide(rows, newVal) {
            if (newVal) {
                angular.forEach(rows, function (row) {
                    angular.forEach(row.application_items, function (item) {
                        var name = (item.consumable.name + item.consumable.c_name + item.consumable.sunshine_num + item.consumable.spec).toLowerCase();
                        item.hide = (name.indexOf(newVal.toLowerCase()) < 0 && vm.hideSub);
                    });
                });
            }
        }

        function back(row) {
            dialogs.confirm('撤销发货', '确定要<strong class="text-danger">撤销发货并删除发货批次</strong>吗？')
                .result.then(function () {
                SPApplication.update({id: row.id, op: 'back'}).$promise.then(function (resp) {
                    Api.s(resp.msg);
                    vm.tableReload();
                }, function (error) {
                    var resp = error.data;
                    Api.e(resp.msg);
                });
            });
        }

    }

})();

/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Vendor.pages.csmbs.return.approved').controller('SRAApprovedCtrl', SRAApprovedCtrl);

    /** @ngInject */
    function SRAApprovedCtrl(Table, SRApplication, Auth, Storeroom, $stateParams, Array, Misc, ConsumableVariety) {
        var vm = this;
        vm.changeHide = changeHide;

        init();


        function init() {
            vm.hideSub = true;

            var states = SRApplication.getStates();
            var statesOpts = Table.getOpts(states);
            var units = ConsumableVariety.getUnits();

            Storeroom.query({op: 'option'}, function (resp) {
                vm.rooms = resp.items;

                var options = {
                    service: SRApplication,
                    params: {op: 'approved'},
                    optColWidth: Table._1_BTN,
                    cols: [
                        {field: 'itemDesc', title: '退货物资', filter: {item: "text"}, width: '35%'},
                        {field: "applicant", title: "申请人", filter: {applicant: "text"}},
                        {field: "created_at", title: '申请时间', filter: {created_at: 'date_range'}},
                        {field: "state", title: '状态', filter: {state: 'select'}, data: statesOpts}
                    ]
                };

                if ($stateParams.room_id) {
                    options.filter = {room_id: $stateParams.room_id};
                } else if (vm.rooms.length > 0) {
                    options.filter = {room_id: vm.rooms[0].id};
                }

                Table.load4BgPager(vm, options, function (resp) {
                    angular.forEach(resp.items, function (row) {
                        row.state = Array.getItem(row.state, states);
                        var total = 0;
                        var items = [];
                        angular.forEach(row.application_items, function (item) {
                            if (vm.tableParams.filter()['item']) {
                                row.expand = true;
                                var name = (item.consumable.name + item.consumable.c_name + item.consumable.sunshine_num + item.consumable.spec).toLowerCase();
                                item.hide = (name.indexOf(vm.tableParams.filter()['item'].toLowerCase()) < 0 && vm.hideSub);
                            }
                            item.consumable.storage_unit = Array.getItem(item.consumable.storage_unit, units).name;
                            item.consumable.purchase_unit = Array.getItem(item.consumable.purchase_unit, units).name;
                            item.consumable.use_unit = Array.getItem(item.consumable.use_unit, units).name;
                            item.total = Misc.toFixed(item.consumable.use_num * item.num * item.batch.purchase_price, 2);
                            total += item.total;
                            var m = Array.getItem(item.consumable_id, items, 'consumable_id');
                            if (m == null) {
                                items.push(angular.copy(item));
                            } else {
                                m.num = parseInt(m.num) + parseInt(item.num);
                            }
                        });
                        row.total = Misc.toFixed(total, 2);
                        row.itemDesc = items;
                    });

                    vm.items = resp.items;
                });

                vm.clearFilters = function () {
                    vm.tableParams.filter({room_id: vm.tableParams.filter()['room_id']});
                };
            });
        }

        function changeHide(rows, newVal) {
            if (newVal) {
                angular.forEach(rows, function (row) {
                    angular.forEach(row.itemDesc, function (item) {
                        var name = (item.consumable.name + item.consumable.c_name + item.consumable.sunshine_num + item.consumable.spec).toLowerCase();
                        item.hide = (name.indexOf(newVal.toLowerCase()) < 0 && vm.hideSub);
                    });
                });
            }
        }
    }

})();

/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Vendor.pages.qualifications.dialogs').controller('VendorQAShowDlgCtrl', VendorQAShowDlgCtrl);

    /** @ngInject */
    function VendorQAShowDlgCtrl($scope, $uibModalInstance, data) {
        var vm = $scope;
        vm.cancel = $uibModalInstance.dismiss;

        init(data.attachment);

        function init(m) {
            if (m.mime == 'application/pdf') {
                vm.pdfUrl = m.filename;
            }
            vm.m = m;
        }
    }

})();

/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Vendor.pages.qualifications.dialogs').controller('stopApplyCtrl', stopApplyCtrl);

    /** @ngInject */
    function stopApplyCtrl($uibModalInstance, data, toaster) {
        var vm = this;
        vm.title = data.title;
        vm.m = {reason: '', with_sms: false};
        vm.cancel = $uibModalInstance.dismiss;
        vm.ok = ok;

        function ok(m) {
            if (m.reason == '') {
                toaster.error('请输入停用原因');
            } else {
                var pa = {reason: m.reason, with_sms: m.with_sms};
                $uibModalInstance.close(pa);
            }
        }
    }

})();

/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Vendor.pages.qualifications.draft').controller('qualificationDraftCtrl', qualificationDraftCtrl);

    /** @ngInject */
    function qualificationDraftCtrl(Api, File, Array, $state, Table, dialogs, Misc, VendorQ, VendorQType, toaster) {
        var vm = this;
        vm.download = download;
        vm.remove = remove;
        //vm.preview = preview;

        init();


        function init() {
            VendorQType.query({opt: 2/*INDEX_OPTIONS*/}, function (resp) {
                var types = resp.items;
                var typesOpts = Table.getOpts(types);

                var options = {
                    service: VendorQ,
                    params: {op: 'draft'},
                    optColWidth: Table._4_BTN,
                    sorting: {id: 'desc'},
                    cols: [
                        {field: "sorting", title: "排序", sortable: 'sorting'},
                        {field: "name", title: "名称", filter: {name: "text"}},
                        {field: "code", title: "证件号码", filter: {code: "text"}},
                        {field: "type", title: "类型", filter: {type_id: "select"}, data: typesOpts},
                        {field: "end_time", title: "到期时间", filter: {end_time: "date_range"}}
                    ]
                };

                Table.load4BgPager(vm, options, function (data) {
                    angular.forEach(data.items, function (item) {
                        angular.forEach(item.attachments, function (attachment) {
                            attachment.ico = Misc.getIconFromMime(attachment.mime);
                            attachment.size = parseInt(attachment.size);
                        });
                    });
                });
            });
        }

        function download(attach) {
            File.download(VendorQ.urls.DOWNLOAD, attach);
        }

        function remove(m) {
            Api.delTableItem(VendorQ, m.id, vm, '资质', m.name);
        }
    }

})();

/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Vendor.pages.qualifications.query').controller('qualificationEditCtrl', qualificationEditCtrl);

    /** @ngInject */
    function qualificationEditCtrl($stateParams, $q, $filter, $state, uibDateParser, toaster, Auth, Misc, $validation, dialogs,
                                   File, Array, VendorQType, VendorQ, Api) {
        var vm = this;
        vm.deleteAttachment = deleteAttachment;
        vm.upload = upload;
        vm.download = download;
        vm.submit = submit;

        loadModel($stateParams.id);

        function loadModel(id) {
            VendorQType.query({opt: 2 /*INDEX_OPTIONS*/}, function (resp) {
                vm.types = resp.items;
                if (id) {
                    VendorQ.get({id: id}, function (resp) {
                        var item = resp;
                        item.start_time = uibDateParser.parse(item.start_time.substr(0, 10), 'yyyy-MM-dd');
                        if (item.end_time) {
                            item.end_time = uibDateParser.parse(item.end_time.substr(0, 10), 'yyyy-MM-dd');
                        }
                        item.with_sms = false;
                        vm.m = item;
                    });
                }
            });
        }

        function deleteAttachment($index, m) {
            dialogs.confirm("提示", "确认要移除该附件?").result.then(function () {
                m.attachments.splice($index, 1);
            });
        }

        function upload(file, m, e) {
            File.uploadAttachment(file, m, e);
        }

        function download(attach) {
            File.download(VendorQ.urls.DOWNLOAD, attach);
        }


        function submit(form, m, state) {
            var defer = $q.defer();
            $validation.validate(form).success(function () {
                if (!File.isAttachmentsUploaded(m)) {
                    Api.w('请等一小会儿,部分附件还在路上');
                } else {
                    var pa = {
                        name: m.name,
                        type_id: m.type.id,
                        start_time: $filter('date')(m.start_time, 'yyyy-MM-dd'),
                        note: m.note,
                        code: m.code,
                        with_sms: m.with_sms,
                        sorting: m.sorting,
                        state: state
                    };
                    if (m.end_time) {
                        pa.end_time = Misc.date2Str(m.end_time);
                    } else {
                        pa.end_time = null;
                    }
                    pa.attachments = Array.map(m.attachments, function (item) {
                        if (item.id) {
                            return {id: item.id};
                        } else {
                            return {
                                name: item.name, mime: item.mime,
                                filename: item.filename, size: item.size
                            }
                        }
                    });
                    VendorQ.update({id: m.id}, pa).$promise.then(function (resp) {
                        toaster.success(resp.msg);
                        state == 1 ? $state.go('^.^.query') : $state.go('^.^.draft');
                        defer.resolve();
                    }, function (error) {
                        var resp = error.data;
                        toaster.error(resp.msg);
                        defer.reject();
                    });
                }
            }).error(function () {
                defer.reject();
                Api.w('请检查表单错误');
                form.$submitted = true;
            });
            return defer.promise;
        }
    }

})();

/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Vendor.pages.qualifications.query').controller('qualificationCtrl', qualificationCtrl);

    /** @ngInject */
    function qualificationCtrl(Api, File, Array, $state, Table, dialogs, Misc, VendorQ, VendorQType, toaster) {
        var vm = this;
        vm.setStop = setStop;
        vm.download = download;
        vm.remove = remove;
        //vm.preview = preview;
        vm.sort = sort;
        vm.save = save;

        init();


        function init() {
            var states = VendorQ.getStates();
            var statesOpts = Table.getOpts(states);

            VendorQType.query({opt: 2/*INDEX_OPTIONS*/}, function (resp) {
                var types = resp.items;
                var typesOpts = Table.getOpts(types);

                var options = {
                    service: VendorQ,
                    optColWidth: Table._4_BTN,
                    sorting: {sorting: 'asc'},
                    cols: [
                        {field: "sorting", title: "排序", sortable: 'sorting'},
                        {field: "name", title: "名称", filter: {name: "text"}},
                        {field: "code", title: "证件号码", filter: {code: "text"}},
                        {field: "type", title: "类型", filter: {type_id: "select"}, data: typesOpts},
                        {field: "end_time", title: "到期时间", filter: {end_time: "date_range"}},
                        {field: "state", title: "状态", filter: {state: "select"}, data: statesOpts}
                    ]
                };

                Table.load4BgPager(vm, options, function (data) {
                    angular.forEach(data.items, function (item) {
                        item.state = Array.getItem(item.state, states);
                        angular.forEach(item.attachments, function (attachment) {
                            attachment.ico = Misc.getIconFromMime(attachment.mime);
                            attachment.size = parseInt(attachment.size);
                        });
                    });
                });
            });
        }

        function download(attach) {
            File.download(VendorQ.urls.DOWNLOAD, attach);
        }

        function setStop(m) {
            dialogs.create('app/pages/qualifications/dialogs/stopApply/stopApply.html',
                'stopApplyCtrl', {title: '申请停用资质'}, {
                    animation: true,
                    size: 'md'
                }, 'vm'
            ).result.then(function (pa) {
                VendorQ.update({id: m.id, op: 'stop'}, pa).$promise.then(function (resp) {
                    toaster.success(resp.msg);
                    vm.tableReload();
                }, function (error) {
                    var resp = error.data;
                    toaster.error(resp.msg);
                });
            });
        }

        function sort(m) {
            m.$edit = true;
            m.$sortingChanged = m.sorting;
        }

        function save(m) {
            m.$edit = false;
            if (m.$sortingChanged == "") {
                toaster.error(item + '排序不能为空!');
            } else if (m.sorting != m.$sortingChanged) {
                var params = {};
                params['sorting'] = m.$sortingChanged;
                VendorQ.update({id: m.id}, params).$promise.then(function (resp) {
                    toaster.success(resp.msg);
                    m.sorting = parseInt(m.$sortingChanged);
                    vm.tableReload();
                }, function (error) {
                    toaster.error(error.msg);
                });
            }

        }

        function remove(m) {
            Api.delTableItem(VendorQ, m.id, vm, '资质', m.name);
        }
    }

})();

/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Vendor.pages.qualifications.remind').controller('qualificationRemindCtrl', qualificationRemindCtrl);

    /** @ngInject */
    function qualificationRemindCtrl(File, Array, Table, dialogs, Misc, VendorQ, VendorQType, toaster) {
        var vm = this;
        vm.setStop = setStop;
        vm.download = download;

        init();


        function init() {
            var states = VendorQ.getStates();

            VendorQType.query({opt: 2/*INDEX_OPTIONS*/}, function (resp) {
                var types = resp.items;
                var typesOpts = Table.getOpts(types);

                var options = {
                    service: VendorQ,
                    params: {op: 'remind', showRemind: vm.showRemind},
                    optColWidth: Table._3_BTN,
                    cols: [
                        {field: "name", title: "名称", filter: {name: "text"}},
                        {field: "code", title: "证件号码", filter: {code: "text"}},
                        {field: "type", title: "类型", filter: {type_id: "select"}, data: typesOpts},
                        {field: "end_time", title: "到期时间", filter: {end_time: "date_range"}},
                        {field: "remind_time", title: "提醒时间", filter: {remind_time: "date_range"}}
                    ]
                };

                Table.load4BgPager(vm, options, function (data) {
                    vm.num = data.num;
                    var today = new Date(data.today);
                    angular.forEach(data.items, function (item) {
                        item.state = Array.getItem(item.state, states);
                        item.warning = (new Date(item.remind_time) <= today) && (new Date(item.end_time) > today);
                        item.danger = new Date(item.end_time) <= today;
                        angular.forEach(item.attachments, function (attachment) {
                            attachment.ico = Misc.getIconFromMime(attachment.mime);
                            attachment.size = parseInt(attachment.size);
                        });
                    });
                });
            });
        }

        function download(attach) {
            File.download(VendorQ.urls.DOWNLOAD, attach);
        }

        function setStop(m) {
            dialogs.create('app/pages/qualifications/dialogs/stopApply/stopApply.html',
                'stopApplyCtrl', {title: '申请停用资质'}, {
                    animation: true,
                    size: 'md'
                }, 'vm'
            ).result.then(function (pa) {
                VendorQ.update({id: m.id, op: 'stop'}, pa).$promise.then(function (resp) {
                    toaster.success(resp.msg);
                    vm.tableReload();
                }, function (error) {
                    var resp = error.data;
                    toaster.error(resp.msg);
                });
            });
        }
    }

})();

/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Vendor.pages.qualifications.remind').controller('qualificationSetCtrl', qualificationSetCtrl);

    /** @ngInject */
    function qualificationSetCtrl($stateParams, $q, $filter, $state, uibDateParser, toaster, $validation, VendorQ) {
        var vm = this;
        vm.submit = submit;

        loadModel($stateParams.id);

        function loadModel(id) {
            if (id) {
                VendorQ.get({id: id}, function (resp) {
                    var item = resp;
                    item.remind_time = uibDateParser.parse(item.remind_time.substr(0, 10), 'yyyy-MM-dd');
                    item.start_time = uibDateParser.parse(item.start_time.substr(0, 10), 'yyyy-MM-dd');
                    item.end_time = uibDateParser.parse(item.end_time.substr(0, 10), 'yyyy-MM-dd');
                    vm.m = item;
                });
            }
        }

        function submit(form, m) {
            var defer = $q.defer();
            if (m.remind_time > m.end_time || m.remind_time < m.start_time) {
                toaster.error('提醒时间不在资质期限范围内');
                defer.reject();
            } else {
                $validation.validate(form).success(function () {

                    var pa = {
                        remind_time: $filter('date')(m.remind_time, 'yyyy-MM-dd'),
                        op: 'remind'
                    };
                    VendorQ.update({id: m.id}, pa).$promise.then(function (resp) {
                        toaster.success(resp.msg);
                        $state.go('^.list');
                        defer.resolve();
                    }, function (error) {
                        var resp = error.data;
                        toaster.error(resp.msg);
                        defer.reject();
                    });
                }).error(function () {
                    defer.reject();
                });
            }
            return defer.promise;
        }
    }

})();

/* Minified js for jQuery BackTop */
!function(o){o.fn.backTop=function(e){var n=this,i=o.extend({position:400,speed:500,color:"white"},e),t=i.position,c=i.speed,d=i.color;n.addClass("white"==d?"white":"red"==d?"red":"green"==d?"green":"black"),n.css({right:40,bottom:40,position:"fixed"}),o(document).scroll(function(){var e=o(window).scrollTop();e>=t?n.fadeIn(c):n.fadeOut(c)}),n.click(function(){o("html, body").animate({scrollTop:0},{duration:1200})})}}(jQuery);
(function () {
    'use strict';

    angular.module('Vendor.theme.components')
        .directive('tableOptionTab', tableOptionTab);

    function tableOptionTab() {
        return {
            templateUrl: 'app/theme/components/table/tableOptionTab/tableOptionTab.html',
            restrict: 'E',
            scope: {
                options: '=',
                curOptionId: '=ngModel',
                filterName: '@',
                tagTitle: '@'
            },
            require: ['^ngModel'],
            link: link
        }
    }


    function link(scope) {
        var parentCtrl = scope.$parent.vm;
        scope.optionSelected = optionSelected;

        function optionSelected(option) {
            var filter = parentCtrl.tableParams.filter();
            scope.curOptionId = filter[scope.filterName] = option.id;
            if (!option.id) delete filter[scope.filterName];
            parentCtrl.tableParams.filter(filter);
        }
    }

})();
/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Vendor.pages.csmbs.batches.batch').controller('CBEditCtrl', CBEditCtrl);

    /** @ngInject */
    function CBEditCtrl($validation, $q, $state, Misc, toaster, ConsumableBatch, Storeroom, Auth, ConsumableVariety, Array, Api) {
        var vm = this;
        vm.submit = submit;
        vm.reset = reset;
        vm.roomSelectedFn = roomSelectedFn;
        vm.csmbSelectedFn = csmbSelectedFn;
        vm.dateSelected = dateSelected;
        vm.noSelected = noSelected;
        vm.checkPrice = checkPrice;
        vm.add = add;
        vm.remove = remove;
        vm.dateOptions = {
            maxDate: new Date()
        };
        vm.index = 0;
        vm.dateInput = dateInput;

        loadModel();

        function loadModel() {
            vm.units = ConsumableVariety.getUnits();
            Storeroom.query({op: 'option'}, function (resp) {
                vm.rooms = resp.items;
                vm.m = {with_sms: false, disinfect: false, gift: false, temporary: false};
                if (vm.rooms.length > 0) {
                    roomSelectedFn(vm.rooms[0], vm.m);
                }

            });
        }

        function reset(form, m) {
            form.$setPristine();
            loadModel();
        }

        function roomSelectedFn(item, m) {
            m.room = item;
            m.consumable = null;
            csmbSelectedFn(m);
        }

        function csmbSelectedFn(m) {
            m.batches = [];
            m.batches[0] = {index: vm.index++, l_num: null, s_num: null};
            //m.batches[0].l_num = null;
            //m.batches[0].s_num = null;
            if (m.consumable) {
                m.sd_purchase_price = m.consumable.sd_purchase_price;
                m.price = m.consumable.purchase_price;
                //高值耗材或者体外试剂类型可以修改发货
                if (m.consumable.type.parent && m.consumable.type.parent_id != '1') {
                    m.consumable.type.parent = Array.getParent(m.consumable.type);
                }
                // m.canEditPrice = m.consumable.is_high_value == '1' || m.consumable.type_id == '10' ||
                //     (m.consumable.type.parent && m.consumable.type.parent.id == '10');
                //2020-1-13 除行政物资，不能修改价格
                m.canEditPrice = false;
                m.canIncreasePrice = m.consumable.type_id == '167' || (m.consumable.type.parent && m.consumable.type.parent.id == '167');
                checkPrice(m);
                noSelected(m, m.batches[0]);
            }
        }

        function noSelected(m, batch) {
            if (batch.no) {
                ConsumableBatch.query({op: 'out', consumable_id: m.consumable.id, no: batch.no}, function (resp) {
                    if (resp.batch) {
                        batch.production_date = new Date(resp.batch.production_date);
                        if (m.consumable.has_life == '1') {
                            batch.deadline = new Date(resp.batch.deadline);
                        } else {
                            batch.deadline = null;
                        }
                    } else {
                        batch.production_date = batch.deadline = null;
                    }
                });
            }
        }

        function dateSelected(m, batch, type) {
            if (m.consumable && m.consumable.has_life == '1') {
                if (type == 1) {
                    var date = new Date(batch.production_date);
                    date.setFullYear(date.getFullYear() + parseInt(m.consumable.year_shelf_life));
                    date.setMonth(date.getMonth() + parseInt(m.consumable.month_shelf_life));
                    date.setDate(date.getDate() - 1 + parseInt(m.consumable.shelf_life));
                    batch.deadline = date;
                    batch.production_date2 = null;
                } else {
                    var date = new Date(batch.deadline);
                    date.setFullYear(date.getFullYear() - parseInt(m.consumable.year_shelf_life));
                    date.setMonth(date.getMonth() - parseInt(m.consumable.month_shelf_life));
                    date.setDate(date.getDate() + 1 - parseInt(m.consumable.shelf_life));
                    batch.production_date2 = Misc.date2Str(date);
                }
            } else {
                batch.deadline = null;
            }
        }

        function dateInput(batch) {
            batch.production_date = Misc.str2Date(batch.production_date2);
            batch.production_date2 = null;
        }

        function checkPrice(m) {
            if (m.consumable) {
                if (m.gift) {
                    m.price = '0';
                } else {
                    m.price = m.consumable.purchase_price;
                }
            }
        }

        function add(m) {
            m.batches.push({index: vm.index++, l_num: null, s_num: null});
        }

        function remove(m, index) {
            m.batches.splice(index, 1);
        }

        function submit(form, m) {
            var defer = $q.defer();
            var hasZero = false;
            var dateError = false;
            if (m.batches.length > 0) {
                for (var i = 0; i < m.batches.length; i++) {
                    if ((m.batches[i].l_num && m.batches[i].l_num == 0 && m.batches[i].s_num == 0) || (!m.batches[i].l_num && m.batches[i].s_num
                        == 0) || (!m.batches[i].s_num && m.batches[i].l_num == 0)) {
                        hasZero = true;
                        var msg = '批次' + m.batches[i].no + '发货量不能为0';
                        break;
                    }
                }

                for (var j = 0; j < m.batches.length; j++) {
                    if (m.batches[j].deadline && m.batches[j].deadline < new Date()) {
                        dateError = true;
                        var msg = '批次' + m.batches[j].no + '失效日期错误';
                        break;
                    }
                }
            }

            if (!m.consumable) {
                Api.w('请选择耗材');
                defer.reject();
            } else if (m.consumable.storeroom_id != m.room.id) {
                Api.w('选择的耗材不属于接收库房');
                defer.reject();
            } else if (hasZero || dateError) {
                Api.w(msg);
                defer.reject();
            } else {
                $validation.validate(form).success(function () {
                    var pa = {
                        batches: [],
                        room_id: m.room.id,
                        temporary: m.temporary ? '1' : '0'
                    };
                    var total = 0;
                    angular.forEach(m.batches, function (batch) {
                        var num = batch.l_num ? (batch.l_num * m.consumable.storage_num + parseInt(batch.s_num)) : parseInt(batch.s_num);
                        pa.batches.push({
                            consumable_id: m.consumable.id,
                            purchase_price: m.price,
                            sd_purchase_price: m.sd_purchase_price ? m.sd_purchase_price : null,
                            sell_price: m.consumable.sell_price,
                            year_shelf_life: m.consumable.year_shelf_life,
                            month_shelf_life: m.consumable.month_shelf_life,
                            production_date: Misc.date2Str(batch.production_date),
                            deadline: batch.deadline ? Misc.date2Str(batch.deadline) : null,
                            shelf_life: m.consumable.shelf_life,
                            num: num,
                            apply_num: num,
                            no: batch.no,
                            note: m.note,
                            vendor_id: Auth.VENDOR_ID,
                            with_sms: m.with_sms,
                            room_id: m.room.id,
                            disinfect: m.disinfect ? '1' : '0',
                            gift: m.gift,
                            canIncreasePrice: m.canIncreasePrice
                        });
                        total += num;
                    });
                    pa.total = total;
                    ConsumableBatch.save(pa).$promise.then(function (resp) {
                        toaster.success(resp.msg);
                        defer.resolve();
                        $state.go('^');
                    }, function (error) {
                        var resp = error.data;
                        toaster.error(resp.msg);
                        defer.reject();
                    });
                }).error(function () {
                    defer.reject();
                    toaster.error('表单中有错误');
                });
            }
            return defer.promise;
        }
    }

})();

/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Vendor.pages.csmbs.batches.batch').controller('CBCtrl', CBCtrl);

    /** @ngInject */
    function CBCtrl(Table, $stateParams, ConsumableBatch, Api, Array, dialogs, Auth, Storeroom, Misc, ConsumableType, ConsumableVariety) {
        var vm = this;
        vm.zoomIn = zoomIn;
        vm.show = show;
        vm.qrcode = qrcode;

        init();


        function init() {
            vm.units = ConsumableVariety.getUnits();
            var states = ConsumableBatch.getStates();
            var statesOpts = Table.getOpts(states);

            Storeroom.query({op: 'option'}, function (resp) {
                vm.rooms = resp.items;

                var options = {
                    service: ConsumableBatch,
                    params: {op: 'vendor'},
                    optColWidth: Table._3_BTN,
                    cols: [
                        {field: "created_at", title: "出库时间", filter: {created_at: "date_range"}},
                        {field: "consumable", title: "注册证名称", filter: {consumable: "text"}},
                        {field: "c_name", title: "通用名", filter: {c_name: "text"}},
                        {field: "spec", title: "规格型号", filter: {spec: "text"}},
                        {field: "sn", title: "批次", filter: {sn: "text"}},
                        {field: "no", title: "厂家批次", filter: {no: "text"}},
                        {field: "code", title: "编号", filter: {code: "text"}},
                        {field: "type", title: "类型", filter: {type: "tree"}, width: 168},
                        {field: "apply_num", title: "申请量"},
                        {field: "c_num", title: "发货量"},
                        {field: "c_r_num", title: "实际量"},
                        {field: "price", title: "实际金额"},
                        {field: "state", title: "状态", filter: {state: "select"}, data: statesOpts, width: 120}
                    ]
                };

                if ($stateParams.room_id) {
                    options.filter = {room_id: $stateParams.room_id};
                } else if (vm.rooms.length > 0) {
                    options.filter = {room_id: vm.rooms[0].id};
                }

                var optionFn = Table.load4BgPager(vm, options, function (data) {
                    angular.forEach(data.items, function (item) {
                        item.state = Array.getItem(item.state, states);
                        item.created_at = item.created_at.substr(0, 10);
                        var l_num = parseInt(item.num / item.consumable.storage_num),
                            s_num = item.num % item.consumable.storage_num,
                            app_l_num = parseInt(item.apply_num / item.consumable.storage_num),
                            app_s_num = item.apply_num % item.consumable.storage_num,
                            l_unit = Array.getItem(item.consumable.purchase_unit, vm.units).name,
                            s_unit = Array.getItem(item.consumable.storage_unit, vm.units).name;
                        if (l_num > 0) {
                            item.c_num = l_num + l_unit;
                            if (s_num > 0) {
                                item.c_num += s_num + s_unit;
                            }
                        } else {
                            item.c_num = s_num + s_unit;
                        }

                        if (app_l_num > 0) {
                            item.apply_num = app_l_num + l_unit;
                            if (app_s_num > 0) {
                                item.apply_num += app_s_num + s_unit;
                            }
                        } else {
                            item.apply_num = app_s_num + s_unit;
                        }

                        if (item.r_num) {
                            var r_l_num = parseInt(item.r_num / item.consumable.storage_num),
                                r_s_num = item.r_num % item.consumable.storage_num;
                            if (r_l_num > 0) {
                                item.c_r_num = r_l_num + l_unit;
                                if (r_s_num > 0) {
                                    item.c_r_num += r_s_num + s_unit;
                                }
                            } else {
                                item.c_r_num = r_s_num + s_unit;
                            }
                        }

                        item.consumable.purchase_unit = Array.getItem(item.consumable.purchase_unit, vm.units).name;
                        item.consumable.storage_unit = Array.getItem(item.consumable.storage_unit, vm.units).name;
                        item.consumable.use_unit = Array.getItem(item.consumable.use_unit, vm.units).name;
                        item.consumable.type = (item.consumable.type.parent && item.consumable.type.parent_id != 1) ? (Array.getParent(item.consumable.type).name + '-' + item.consumable.type.name) : item.consumable.type.name;
                        angular.forEach(item.consumable.images, function (img) {
                            img.path = img.path + '?' + new Date().getTime();
                        });
                        item.qrUrl = {app: 'oa.csmb', type: 3, consumable_id: item.consumable.id, batch_id: item.id};
                        item.price = Misc.toFixed(item.purchase_price * item.r_num * item.consumable.use_num, 2);
                    });
                    vm.items = data.items;
                }).options;

                ConsumableType.query({opt: 1}, function (resp) {
                    optionFn().cols[7].data = resp.items;
                });

                vm.clearFilters = function () {
                    vm.tableParams.filter({room_id: vm.tableParams.filter()['room_id']});
                };
            });
        }

        function zoomIn(m) {
            var img = getCurImg(m);
            dialogs.create('CsmbLargeImgDlg.html', 'CsmbLargeImgDlgCtrl', img, {size: 'lg'}, 'vm');
        }

        function getCurImg(m) {
            return m.consumable.images[m.active];
        }

        function show(m, op) {
            if (op) {
                dialogs.create('app/pages/csmbs/batches/dialogs/batchDetail/history.html', 'CsmbBatchHistoryCtrl', {id: m.id}, {
                    size: 'lg'
                }, 'vm');
            } else {
                dialogs.create('app/pages/csmbs/batches/dialogs/directDetail/history.html', 'DirectBatchHistoryCtrl', {id: m.id}, {
                    size: 'lg'
                }, 'vm');
            }
        }

        function getBatchPrintHtml(m) {
            var html = '';
            var qrUrl = $('#QrCode' + m.id + ' .qrcode')[0].toDataURL();
            var title = m.consumable.name + (m.consumable.c_name ? '(' + m.consumable.c_name + ')' : '');
            var titleClass;
            if (title.length > 30) {
                titleClass = 'title-small'
            } else {
                titleClass = 'title'
            }
            // for (var i = 0; i < m.num; i++) {
                html += '<div class="paging">';
                html += '<div class="' + titleClass + '">' + title + '</div>';
                html += '<div class="info"><div class="img"><img src="' + qrUrl + '" width="100" height="100"></div>' +
                    '<div class="note"><div>规格型号：</div><div>' + m.consumable.spec + '</div>' +
                    '<div>批号：</div><div>' + m.no + '</div>' +
                    '<div>有效期：</div><div>' + m.production_date + '~' + (m.deadline ? m.deadline : '永久') + '</div>' +
                    '</div></div></div>';
            // }

            return html;
        }


        function qrcode(m) {
            Misc.print(window.open('', '打印预览'), 'app/pages/csmbs/batches/dialogs/invoice/csmbBatch.html', function () {
                var html = getBatchPrintHtml(m);
                return html;
            });
        }
    }

})();

(function () {
    'use strict';

    angular.module('Vendor.pages.csmbs.direct.dialogs')
        .controller('CsmbBatchHistoryCtrl', CsmbBatchHistoryCtrl);

    /** @ngInject */
    function CsmbBatchHistoryCtrl($uibModalInstance, Array, data, CsmbBatchItem, Table) {
        var vm = this;
        vm.cancel = $uibModalInstance.dismiss;

        init(data.id);

        function init(id) {
            var states = CsmbBatchItem.getStates();
            var options = {
                service: CsmbBatchItem,
                params: {op: 'default', batch_id: id},
                hideOpt: true,
                cols: [
                    {title: "收货人", field: 'receiver', filter: {receiver: "text"}},
                    {title: "数量", field: 'num', filter: {num: "text"}},
                    {title: "状态", field: "state", filter: {state: "select"}, data: Table.getOpts(states), width: '20%'},
                    {title: "确认时间", field: "receive_time", filter: {receive_time: "date_range"}}
                ]
            };

            Table.load4BgPager(vm, options, function (data) {
                angular.forEach(data.items, function (item) {
                    item.state = Array.getItem(item.state, states);
                });
            });
        }
    }
})();
(function () {
    'use strict';

    angular.module('Vendor.pages.csmbs.direct.dialogs')
        .controller('DirectBatchHistoryCtrl', DirectBatchHistoryCtrl);

    /** @ngInject */
    function DirectBatchHistoryCtrl($uibModalInstance, Array, data, DirectBatchItem, Table) {
        var vm = this;
        vm.cancel = $uibModalInstance.dismiss;

        init(data.id);

        function init(id) {
            var states = DirectBatchItem.getStates();
            var options = {
                service: DirectBatchItem,
                params: {op: 'default', batch_id: id},
                hideOpt: true,
                cols: [
                    {title: "收货人", field: 'receiver', filter: {receiver: "text"}},
                    {title: "数量", field: 'num', filter: {num: "text"}},
                    {title: "状态", field: "state", filter: {state: "select"}, data: Table.getOpts(states), width: '20%'},
                    {title: "确认时间", field: "receive_time", filter: {receive_time: "date_range"}}
                ]
            };

            Table.load4BgPager(vm, options, function (data) {
                angular.forEach(data.items, function (item) {
                    item.state = Array.getItem(item.state, states);
                });
            });
        }
    }
})();
/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Vendor.pages.csmbs.batches.dialogs').controller('vendorInvoiceCtrl', vendorInvoiceCtrl);

    /** @ngInject */
    function vendorInvoiceCtrl($uibModalInstance, data, Misc) {
        var vm = this;
        vm.print = print;
        vm.room = data.room;
        vm.cancel = $uibModalInstance.dismiss;
        vm.printBatch = printBatch;

        init(data.items);

        function init(items) {
            vm.m = {app: 'oa.csmb', type: data.dept ? 1 : 2, id: data.ap_id};

            var batches = {};

            for (var i = 0; i < items.length; i++) {
                if (batches[items[i].consumable_id]) {
                    batches[items[i].consumable_id].push(items[i])
                } else {
                    batches[items[i].consumable_id] = [items[i]]
                }
            }
            vm.items = [];
            var TotalMoney = 0;
            angular.forEach(batches, function (items) {
                var subTotalNum = 0, subTotalMoney = 0;
                angular.forEach(items, function (item, i) {
                    item.qrUrl = {app: 'oa.csmb', type: 3, consumable_id: item.consumable.id, batch_id: item.id};
                    item.money = Misc.toFixed(item.purchase_price * item.consumable.use_num * item.num, 2);
                    subTotalMoney += item.money;
                    subTotalNum += parseInt(item.num);
                    if (i == items.length - 1) {
                        item.subTotalMoney = Misc.toFixed(subTotalMoney, 2);
                        item.subTotalNum = subTotalNum;
                        var l_num = parseInt(item.subTotalNum / item.consumable.storage_num),
                            s_num = item.subTotalNum % item.consumable.storage_num;
                        if (l_num > 0) {
                            item.subTotalNum = l_num + item.consumable.purchase_unit;
                            if (s_num > 0) {
                                item.subTotalNum += s_num + item.consumable.storage_unit;
                            }
                        } else {
                            item.subTotalNum = s_num + item.consumable.storage_unit;
                        }
                    }
                    vm.items.push(item);
                });
                TotalMoney += subTotalMoney;
            });
            vm.items.TotalMoney = Misc.toFixed(TotalMoney, 2);
        }

        function getPrintHtml() {
            var html = '';
            var qrUrl = $('#QrCode .qrcode')[0].toDataURL();

            html += '<div class="qrcode"><img style="width: 100px;height: 100px" src="' + qrUrl + '"></div>';
            html += '<h3>耗材发货单</h3>';
            if (data.dept) {
                html += '<h5><span>接收库房:' + data.room.name + '</span><span>接收科室:' + data.dept.name + '</span><span>' +
                    '供应商:成都云慈健康科技有限公司</span><span>打印时间:'
                    + Misc.datetime2Str(new Date()) + '</span></h5>';
            } else {
                html += '<h5><span>接收库房:' + data.room.name + '</span><span>供应商:成都云慈健康科技有限公司</span><span>打印时间:'
                    + Misc.datetime2Str(new Date()) + '</span></h5>';
            }

            html += '<h4>耗材明细（单号：' + data.number + '）</h4>';
            html += angular.element('#invoice-table').html();
            html += '<div style="text-align: right;margin-right: 200px;margin-top: 20px">签收人:</div>';
            html += '<div style="text-align: right;margin-right: 200px;margin-top: 10px">签收时间:</div>';
            return html;
        }

        function print() {
            Misc.print(window.open('', '打印预览'), 'app/pages/csmbs/batches/dialogs/invoice/print.html', function () {
                var html = getPrintHtml();
                return html;
            });

        }

        function getBatchPrintHtml(items) {
            var html = '';
            angular.forEach(items, function (m) {
                var codeUrlName = '#QrCode' + m.id;
                var qrUrl = $(codeUrlName + ' .qrcode')[0].toDataURL();
                var title = m.consumable.name + (m.consumable.c_name ? '(' + m.consumable.c_name + ')' : '');
                var titleClass;
                if (title.length > 30) {
                    titleClass = 'title-small'
                } else {
                    titleClass = 'title'
                }
                for (var i = 0; i < m.num; i++) {
                    html += '<div class="paging">';
                    html += '<div class="' + titleClass + '">' + title + '</div>';
                    html += '<div class="info"><div class="img"><img src="' + qrUrl + '" width="100" height="100"></div>' +
                        '<div class="note"><div>规格型号：</div><div>' + m.consumable.spec + '</div>' +
                        '<div>批号：</div><div>' + m.no + '</div>' +
                        '<div>有效期：</div><div>' + m.production_date + '~' + (m.deadline ? m.deadline : '永久') + '</div>' +
                        '</div></div></div>';
                }
            });
            return html;
        }

        function printBatch() {
            Misc.print(window.open('', '打印预览'), 'app/pages/csmbs/batches/dialogs/invoice/csmbBatch.html', function () {
                var html = getBatchPrintHtml(vm.items);
                return html;
            });
        }
    }

})();

/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Vendor.pages.csmbs.categories.cStop').controller('ConsumableCStopCtrl', ConsumableCStopCtrl);

    /** @ngInject */
    function ConsumableCStopCtrl($stateParams, $validation, $state, $q, Api, CsmbStop, Array, ConsumableVariety) {
        var vm = this;
        vm.csmbSelected = csmbSelected;
        vm.submit = submit;

        init($stateParams.id);


        function init(id) {
            vm.units = ConsumableVariety.getUnits();
            if (id) {
                CsmbStop.get({id: id, op: 'vendor'}, function (resp) {
                    var csmbs = [];
                    angular.forEach(resp.items, function (item) {
                        if (item.consumable.type.parent && item.consumable.type.parent_id != '1') {
                            item.consumable.type.parent = Array.getParent(item.consumable.type);
                        }
                        item.consumable.type = (item.consumable.type.parent && item.consumable.type.parent_id != '1') ? (item.consumable.type.parent.name + '-' + item.consumable.type.name) : item.consumable.type.name;
                        item.consumable.purchase_unit = Array.getItem(item.consumable.purchase_unit, vm.units).name;
                        item.consumable.storage_unit = Array.getItem(item.consumable.storage_unit, vm.units).name;
                        item.consumable.use_unit = Array.getItem(item.consumable.use_unit, vm.units).name;
                        angular.forEach(item.consumable.images, function (img) {
                            img.path = img.path + '?' + new Date().getTime();
                        });
                        csmbs.push(item.consumable);
                    });
                    vm.m = {
                        id: resp.id,
                        consumables: angular.copy(csmbs),
                        csmbs: csmbs,
                        note: resp.note
                    };
                });
            } else {
                vm.m = {
                    consumables: [],
                    csmbs: []
                };
            }
        }

        function csmbSelected(m) {
            m.consumables = angular.copy(m.csmbs);
        }


        function submit(m, form) {
            if (m.consumables.length == 0) {
                Api.w('请选择耗材');
            } else {
                var defer = $q.defer();
                $validation.validate(form).success(function () {
                    var promise;
                    var pa = {
                        op: 'vendor',
                        csmbs: [],
                        note: m.note
                    };
                    angular.forEach(m.consumables, function (csmb) {
                        pa.csmbs.push({csmb_id: csmb.id})
                    });

                    if (m.id) { //修改
                        promise = CsmbStop.update({id: m.id}, pa).$promise;
                    } else { //添加
                        promise = CsmbStop.save(pa).$promise;
                    }
                    promise.then(function (resp) {
                        Api.s(resp.msg);
                        $state.go('^.list');
                    }, function (error) {
                        var data = error.data;
                        if (data.msg) Api.e(data.msg);
                    }).finally(function () {
                        defer.resolve();
                    });
                }).error(function () {
                    Api.w('请检查表单错误');
                    form.$submitted = true;
                    defer.reject();
                });
                return defer.promise;
            }
        }
    }
})();

/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Vendor.pages.csmbs.categories.cStop')
        .controller('ConsumableCStopListCtrl', ConsumableCStopListCtrl)
    ;

    /** @ngInject */
    function ConsumableCStopListCtrl(Table, CsmbStop, Api, dialogs, Array, ConsumableVariety) {
        var vm = this;
        vm.zoomIn = zoomIn;
        vm.remove = remove;

        init();


        function init() {
            vm.units = ConsumableVariety.getUnits();
            var states = CsmbStop.getStates();
            var statesOpts = Table.getOpts(states);
            var options = {
                service: CsmbStop,
                params: {op: 'vendor'},
                optColWidth: Table._3_BTN,
                cols: [
                    {field: "items", title: "耗材", filter: {items: "text"}},
                    {field: "created_at", title: "申请时间", filter: {created_at: "date_range"}},
                    {field: "note", title: "停用原因", filter: {note: "text"}},
                    {field: "state", title: "状态", filter: {state: "select"}, data: statesOpts}

                ]
            };
            Table.load4BgPager(vm, options, function (resp) {
                angular.forEach(resp.items, function (item) {
                    item.state = Array.getItem(item.state, states);
                    angular.forEach(item.items, function (item) {
                        if (item.consumable.type.parent && item.consumable.type.parent_id != '1') {
                            item.consumable.type.parent = Array.getParent(item.consumable.type);
                        }
                        item.consumable.type = (item.consumable.type.parent && item.consumable.type.parent_id != '1') ? (item.consumable.type.parent.name + '-' + item.consumable.type.name) : item.consumable.type.name;
                        item.consumable.purchase_unit = Array.getItem(item.consumable.purchase_unit, vm.units).name;
                        item.consumable.storage_unit = Array.getItem(item.consumable.storage_unit, vm.units).name;
                        item.consumable.use_unit = Array.getItem(item.consumable.use_unit, vm.units).name;
                        angular.forEach(item.consumable.images, function (img) {
                            img.path = img.path + '?' + new Date().getTime();
                        });
                    });
                });
            });

        }

        function getCurImg(m, type) {
            return type ? m.consumable.images[m.active] : m.images[m.active1];
        }

        function zoomIn(m, type) {
            var img = getCurImg(m, type);
            dialogs.create('CsmbLargeImgDlg.html', 'CsmbLargeImgDlgCtrl', img, {size: 'lg'}, 'vm');
        }


        function remove(m) {
            Api.delTableItem(CsmbStop, m.id, vm, '申请', '');
        }
    }
})();

/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Vendor.pages.csmbs.categories.category').controller('ConsumableAddDlgCtrl', ConsumableAddDlgCtrl);

    /** @ngInject */
    function ConsumableAddDlgCtrl($stateParams, $validation, $state, $q, Api, Consumable, ConsumableVariety, dialogs, Auth, Array) {
        var vm = this;
        vm.setImg = setImg;
        vm.editImg = editImg;
        vm.delImg = delImg;
        vm.zoomIn = zoomIn;
        vm.ok = ok;
        vm.tagTransform = tagTransform;
        vm.varietySelectFn = varietySelectFn;
        vm.specs = [];
        vm.hisFeeTypes = Consumable.getHisFeeTypes();

        init($stateParams.id);


        function init(id) {
            if (id) {
                Consumable.get({id: id}, function (resp) {
                    var c = resp;
                    c.has_price = c.has_price == '1';
                    angular.forEach(c.images, function (img) {
                        img.path = img.path + '?' + new Date().getTime();
                    });
                    if (c.type.parent && c.type.parent_id != '1') {
                        c.type.parent = Array.getParent(c.type);
                    }
                    c.is_admin = c.type_id == '167' || c.type_id == '293' || (c.type.parent && (c.type.parent.id == '167' || c.type.parent.id == '293'));
                    if (c.his_fee_type) c.his_fee_type = Array.getItem(c.his_fee_type, vm.hisFeeTypes);
                    vm.m = c;
                });
            } else {
                vm.m = {
                    images: [], has_price: true, specs: []
                };

                // ConsumableVariety.query({
                //     op: 'option'
                // }, function (resp) {
                //     vm.varieties = resp.items;
                //     vm.m = {
                //         images: [], has_price: true, specs: []
                //     };
                // });
            }
        }


        function varietySelectFn(m) {
            if (m.variety) {
                if (m.variety.type.parent && m.variety.type.parent_id != '1') {
                    m.variety.type.parent = Array.getParent(m.variety.type);
                }
                m.is_admin = m.variety.type_id == '167' || m.variety.type_id == '293' || (m.variety.type.parent && (m.variety.type.parent.id == '167' || m.variety.type.parent.id == '293'));
            }
        }

        function tagTransform(newTag) {
            return {name: newTag};
        }

        function setImg(m) {
            dialogs.create('app/pages/dialogs/imageCropped/upload-md.html',
                'imageCroppedUploadCtrl', {title: '设置耗材图片', width: 1200, height: 900},
                {size: 'md'}, 'vm'
            ).result.then(function (url) {
                m.images.push({path: url});
            });
        }

        function editImg(p) {
            dialogs.create('app/pages/dialogs/imageCropped/upload-md.html',
                'imageCroppedUploadCtrl', {title: '设置耗材图片', width: 1200, height: 900},
                {size: 'md'}, 'vm'
            ).result.then(function (url) {
                p.path = url;
            });
        }

        function zoomIn(p) {
            dialogs.create('CsmbLargeImgDlg.html', 'CsmbLargeImgDlgCtrl', p, {size: 'lg'}, 'vm');
        }

        function delImg(m, index) {
            dialogs.confirm("提示", "确认要移除该图片?").result.then(function () {
                m.images.splice(index, 1);
            });
        }


        function ok(m, Form, state) {
            if (!m.variety && !m.id) {
                Api.w('请选择品种');
            }else if (m.images.length == 0) {
                Api.w('请设置图片');
            } else if (!m.id && m.specs.length == 0) {
                Api.w('请添加规格型号');
            } else if (!m.his_fee_type) {
                Api.w('请设置his计费类型');
            } else {
                var defer = $q.defer();
                $validation.validate(Form).success(function () {
                    var promise;
                    var pa = {
                        images: m.images,
                        sunshine_num: m.sunshine_num,
                        purchase_price: m.purchase_price,
                        sd_purchase_price: m.sd_purchase_price ? m.sd_purchase_price : null,
                        has_price: m.has_price == '1',
                        note: m.note,
                        state: state,
                        m_code: m.m_code,
                        c_code: m.c_code,
                        his_fee_type: m.his_fee_type.id
                    };

                    if (m.id) { //修改
                        pa.variety_id = m.variety_id;
                        pa.spec = m.spec;
                        promise = Consumable.update({id: m.id}, pa).$promise;
                    } else { //添加
                        pa.variety_id = m.variety.id;
                        pa.specs = m.specs;
                        promise = Consumable.save(pa).$promise;
                    }
                    promise.then(function (resp) {
                        Api.s(resp.msg);
                        $state.go('^.list');
                    }, function (error) {
                        var data = error.data;
                        if (data.msg) Api.e(data.msg);
                    }).finally(function () {
                        defer.resolve();
                    });
                }).error(function () {
                    Api.w('请检查表单错误');
                    Form.$submitted = true;
                    defer.reject();
                });

                return defer.promise;
            }
        }
    }
})();

/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Vendor.pages.csmbs.categories.category')
        .controller('consumableCategoryCtrl', consumableCategoryCtrl)
        .controller('CsmbDealerPriceDlgCtrl', CsmbDealerPriceDlgCtrl)
        .controller('CsmbDealerPriceHistoryDlgCtrl', CsmbDealerPriceHistoryDlgCtrl)
        .controller('CsmbStopDlgCtrl', CsmbStopDlgCtrl)
        .controller('CsmbCodeDlgCtrl', CsmbCodeDlgCtrl)
    ;

    /** @ngInject */
    function consumableCategoryCtrl(Table, Consumable, ConsumableType, Api, ConsumableImg, ConsumableVariety, dialogs,
                                    Array, Auth, Storeroom, File) {
        var vm = this;
        vm.addEditImg = addEditImg;
        vm.rmImg = rmImg;
        vm.zoomIn = zoomIn;
        vm.remove = remove;
        vm.download = download;
        vm.sPrice = sPrice;
        vm.setPrice = setPrice;
        vm.setCode = setCode;
        vm.stop = stop;

        init();


        function init() {
            vm.units = ConsumableVariety.getUnits();
            vm.states = Consumable.getStates();
            vm.groups = ConsumableVariety.getGroups();
            vm.hisFeeTypes = Consumable.getHisFeeTypes();
            vm.manageTypes = ConsumableVariety.getManageTypes();

            var options = {
                service: Consumable,
                optColWidth: Table._6_BTN,
                cols: [
                    {field: "name", title: "注册证名称", filter: {name: "text"}},
                    {field: "c_name", title: "通用名", filter: {c_name: "text"}},
                    {field: "type", title: "类型", filter: {type: "tree"}, width: 168},
                    {field: "group", title: "组别", filter: {group: "select"}, data: Table.getOpts(vm.groups)},
                    {field: "code", title: "编号", filter: {code: "text"}},
                    {field: "spec", title: "规格型号", filter: {spec: "text"}},
                    {field: "sunshine_num", title: "阳光流水号", filter: {sunshine_num: "text"}},
                    {field: "storeroom", title: "所属库房", filter: {storeroom_id: "select"}},
                    {field: "m_code", title: "国家医保材料代码", filter: {m_code: "text"}},
                    {field: "c_code", title: "成都市编码", filter: {c_code: "text"}},
                    {field: "state", title: "状态", filter: {state: "select"}, data: Table.getOpts(vm.states)},
                    {field: "manage_type", title: "管理类别", filter: {manage_type: "select"}, data: Table.getOpts(vm.manageTypes)},

                ]
            };
            var optionFn = Table.load4BgPager(vm, options, function (resp) {
                angular.forEach(resp.items, function (item) {
                    item.type = (item.type.parent && item.type.parent_id != '1') ? (Array.getParent(item.type).name + '-' + item.type.name) : item.type.name;
                    item.purchase_unit = Array.getItem(item.purchase_unit, vm.units).name;
                    item.storage_unit = Array.getItem(item.storage_unit, vm.units).name;
                    item.use_unit = Array.getItem(item.use_unit, vm.units).name;
                    item.state = Array.getItem(item.state, vm.states);
                    item.group = Array.getItem(item.group, vm.groups);
                    item.fee = Array.getItem(item.his_fee_type, vm.hisFeeTypes);
                    item.manage_type = Array.getItem(item.manage_type, vm.manageTypes);

                    angular.forEach(item.images, function (img) {
                        img.path = img.path + '?' + new Date().getTime();
                    });
                })
            }).options;

            ConsumableType.query({opt: 1}, function (resp) {
                optionFn().cols[2].data = resp.items;
            });
            Storeroom.query({op: 'option'}, function (resp) {
                optionFn().cols[7].data = Table.getOpts(resp.items);
            });
        }

        function getCurImg(m) {
            return m.images[m.active];
        }

        function reloadImg(m) {
            ConsumableImg.query({opt: 2, consumable_id: m.id}, function (resp) {
                angular.forEach(resp.items, function (item) {
                    item.path = item.path + '?' + new Date().getTime();
                });
                m.images = resp.items;
            });
        }

        function addEditImg(m, isEdit) {
            var pa = {consumable_id: m.id};
            if (isEdit) {
                pa.id = getCurImg(m).id;
            }
            dialogs.create('ConsumableImgDlg.html', 'ConsumableImgDlgCtrl', pa, {size: 'md'}, 'vm')
                .result.then(function () {
                reloadImg(m);
            });
        }

        function rmImg(m) {
            var img = getCurImg(m);
            dialogs.confirm('删除耗材图片', '确定要删除<strong>' + img.name + '</strong>'
                + '耗材图片吗？')
                .result.then(function () {
                ConsumableImg.delete({id: img.id}).$promise.then(function (resp) {
                    Api.s(resp.msg);
                    reloadImg(m);
                });
            });
        }

        function zoomIn(m) {
            var img = getCurImg(m);
            dialogs.create('CsmbLargeImgDlg.html', 'CsmbLargeImgDlgCtrl', img, {size: 'lg'}, 'vm');
        }

        function remove(m) {
            Api.delTableItem(Consumable, m.id, vm, '型号', m.name);
        }

        function download() {
            var title = Auth.getUser().dealer + '耗材型号明细';
            File.dnExcel('api/v1/consumable/consumables/cj_download', {
                title: title
            }, title + '.xls');
        }

        function sPrice(m) {
            dialogs.create('CsmbDealerPriceHistoryDlg.html', 'CsmbDealerPriceHistoryDlgCtrl', {
                id: m.id
            }, {size: 'lg'}, 'vm').result.then(function () {
                vm.tableReload();
            });
        }

        function setPrice(m) {
            dialogs.create('CsmbDealerPriceDlg.html', 'CsmbDealerPriceDlgCtrl', {
                m: m
            }, {size: 'md'}, 'vm').result.then(function () {
                vm.tableReload();
            });
        }

        function setCode(m) {
            dialogs.create('CsmbCodeDlg.html', 'CsmbCodeDlgCtrl', {
                m: m
            }, {size: 'md'}, 'vm').result.then(function () {
                vm.tableReload();
            });
        }

        function stop(m) {
            dialogs.create('CsmbStopDlg.html', 'CsmbStopDlgCtrl', {
                id: m.id
            }, {size: 'md'}, 'vm').result.then(function () {
                vm.tableReload();
            });
        }
    }

    /** @ngInject */
    function CsmbDealerPriceDlgCtrl($uibModalInstance, $validation, $q, data, SecondaryDealer, Array, Api) {
        var vm = this;
        vm.cancel = $uibModalInstance.dismiss;
        vm.ok = ok;

        init();

        function init() {
            vm.m = angular.copy(data.m);
        }

        function ok(m, form) {
            var defer = $q.defer();
            $validation.validate(form).success(function () {
                var pa = {
                    op: 'set_price',
                    csmb_id: m.id,
                    sd_purchase_price: m.sd_purchase_price
                };
                SecondaryDealer.save(pa).$promise.then(function (resp) {
                    Api.s(resp.msg);
                    $uibModalInstance.close();
                    defer.resolve();
                }, function () {
                    defer.reject();
                });

            }).error(function () {
                Api.w('请检查表单错误');
                form.$submitted = true;
                defer.reject();
            });
            return defer.promise;
        }
    }

    /** @ngInject */
    function CsmbDealerPriceHistoryDlgCtrl($uibModalInstance, data, CsmbSdPrice, Table) {
        var vm = this;
        vm.cancel = $uibModalInstance.dismiss;

        init(data.id);


        function init(id) {
            var options = {
                service: CsmbSdPrice,
                params: {csmb_id: id},
                hideOpt: true,
                hideFilter: true,
                cols: [
                    {field: "old_purchase_price", title: "原价"},
                    {field: "purchase_price", title: "改价"},
                    {field: "updated_at", title: "改动时间"}
                ]
            };
            Table.load4BgPager(vm, options);
        }
    }

    /** @ngInject */
    function CsmbStopDlgCtrl($uibModalInstance, $q, $validation, data, CsmbStop, Api) {
        var vm = this;
        vm.cancel = $uibModalInstance.dismiss;
        vm.ok = ok;

        init(data.id);

        function init(id) {
            vm.m = {id: id};
        }

        function ok(m, Form) {
            var defer = $q.defer();
            $validation.validate(Form).success(function () {
                CsmbStop.save({
                    op: 'csmb',
                    csmb_id: m.id,
                    note: m.note
                }).$promise.then(function (resp) {
                    Api.s(resp.msg);
                    $uibModalInstance.close();
                }).finally(function () {
                    defer.resolve();
                });
            }).error(function () {
                Api.w('请检查表单错误');
                Form.$submitted = true;
                defer.reject();
            });

            return defer.promise;
        }
    }

    /** @ngInject */
    function CsmbCodeDlgCtrl($uibModalInstance, $validation, $q, data, Consumable, Array, Api) {
        var vm = this;
        vm.cancel = $uibModalInstance.dismiss;
        vm.ok = ok;
        vm.hisFeeTypes = Consumable.getHisFeeTypes();

        init();

        function init() {
            vm.m = angular.copy(data.m);
            if (vm.m.his_fee_type) vm.m.his_fee_type = Array.getItem(vm.m.his_fee_type, vm.hisFeeTypes);
        }

        function ok(m, form) {
            var defer = $q.defer();
            if (!m.his_fee_type) {
                Api.w('请设置his计费类型');
                defer.reject();
                return;
            }
            $validation.validate(form).success(function () {
                var pa = {
                    m_code: m.m_code,
                    c_code: m.c_code,
                    his_fee_type: m.his_fee_type.id
                };
                Consumable.update({id: m.id, op: 'code'}, pa).$promise.then(function (resp) {
                    Api.s(resp.msg);
                    $uibModalInstance.close();
                    defer.resolve();
                }, function () {
                    defer.reject();
                });

            }).error(function () {
                Api.w('请检查表单错误');
                form.$submitted = true;
                defer.reject();
            });
            return defer.promise;
        }
    }
})();

/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Vendor.pages.csmbs.categories.category')
        .controller('ConsumablePriceDlgCtrl', ConsumablePriceDlgCtrl)
    ;
    /** @ngInject */
    function ConsumablePriceDlgCtrl(Table, $stateParams, CsmbPrice) {
        var vm = this;

        init($stateParams.id);


        function init(id) {
            var options = {
                service: CsmbPrice,
                params: {opt: 2/*INDEX_PRICE_HISTORY*/, consumable_id: id},
                hideOpt: true,
                hideFilter: true,
                cols: [
                    {field: "old_purchase_price", title: "原价"},
                    {field: "purchase_price", title: "改价"},
                    {field: "updated_at", title: "改动时间"}
                ]
            };
            Table.load4BgPager(vm, options);
        }
    }
})();

/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Vendor.pages.csmbs.categories.update').controller('ConsumableUpdateCtrl', ConsumableUpdateCtrl);

    /** @ngInject */
    function ConsumableUpdateCtrl($stateParams, $validation, $state, $q, Api, CsmbUpdate, dialogs, Array) {
        var vm = this;
        vm.csmbSelected = csmbSelected;
        vm.submit = submit;
        vm.setImg = setImg;
        vm.editImg = editImg;
        vm.delImg = delImg;
        vm.zoomIn = zoomIn;
        vm.keepImg = keepImg;

        init($stateParams.id);


        function init(id) {
            if (id) {
                CsmbUpdate.get({id: id, op: 'vendor'}, function (resp) {
                    var csmbs = [];
                    angular.forEach(resp.items, function (item) {
                        item.consumable.item_id = item.id;
                        item.consumable.newImages = item.images;
                        item.consumable.sunshine_num = item.sunshine_num;
                        item.consumable.spec = item.spec;
                        item.consumable.note = item.note;
                        csmbs.push(item.consumable);
                    });
                    vm.m = {
                        id: resp.id,
                        consumables: angular.copy(csmbs),
                        csmbs: csmbs
                    };
                });
            } else {
                vm.m = {
                    consumables: [],
                    csmbs: []
                };
            }
        }

        function csmbSelected(m) {
            var csmbs = angular.copy(m.csmbs);
            angular.forEach(csmbs, function (csmb) {
                csmb.newImages = [];
            });
            if (m.consumables.length > 0) {
                angular.forEach(m.consumables, function (csmb) {
                    var index = Array.indexOfKey(csmb.id, csmbs);
                    if (index != -1) {
                        csmbs[index].newImages = csmb.newImages;
                    }
                });
            }
            m.consumables = csmbs;
        }

        function keepImg(m) {
            var images = [];
            angular.forEach(m.images, function (image) {
                images.push({name: image.name, path: image.path})
            });
            m.newImages = images;
        }

        function getCurImg(m, type) {
            return type ? m.images[m.active] : m.newImages[m.active1];
        }

        function setImg(m) {
            dialogs.create('app/pages/dialogs/imageCropped/upload-md.html',
                'imageCroppedUploadCtrl', {title: '设置耗材图片', width: 1200, height: 900},
                {size: 'md'}, 'vm'
            ).result.then(function (url) {
                m.newImages.push({path: url});
            });
        }

        function editImg(m) {
            var img = getCurImg(m);
            dialogs.create('app/pages/dialogs/imageCropped/upload-md.html',
                'imageCroppedUploadCtrl', {title: '设置耗材图片', width: 1200, height: 900},
                {size: 'md'}, 'vm'
            ).result.then(function (url) {
                img.path = url;
            });
        }

        function delImg(m) {
            var index = m.active1;
            dialogs.confirm("提示", "确认要移除该图片?").result.then(function () {
                m.newImages.splice(index, 1);
            });
        }

        function zoomIn(m, type) {
            var img = getCurImg(m, type);
            dialogs.create('CsmbLargeImgDlg.html', 'CsmbLargeImgDlgCtrl', img, {size: 'lg'}, 'vm');
        }


        function submit(m, form) {
            var noImg = false;
            for (var i = 0; i < m.consumables.length; i++) {
                if (m.consumables[i].newImages.length == 0) {
                    noImg = true;
                    break;
                }
            }
            if (m.consumables.length == 0) {
                Api.w('请选择耗材');
            } else if (noImg) {
                Api.w('请设置图片');
            } else {
                var defer = $q.defer();
                $validation.validate(form).success(function () {
                    var promise;
                    var pa = {
                        op: 'vendor',
                        csmbs: []
                    };
                    angular.forEach(m.consumables, function (csmb) {
                        pa.csmbs.push({
                            item_id: csmb.item_id ? csmb.item_id : null,
                            csmb_id: csmb.id,
                            sunshine_num: csmb.sunshine_num,
                            spec: csmb.spec,
                            note: csmb.note,
                            images: csmb.newImages
                        })
                    });

                    if (m.id) { //修改
                        promise = CsmbUpdate.update({id: m.id}, pa).$promise;
                    } else { //添加
                        promise = CsmbUpdate.save(pa).$promise;
                    }
                    promise.then(function (resp) {
                        Api.s(resp.msg);
                        $state.go('^.list');
                    }, function (error) {
                        var data = error.data;
                        if (data.msg) Api.e(data.msg);
                        Api.e('无法更新，存在重复的或有审批退回的耗材型号');
                    }).finally(function () {
                        defer.resolve();
                    });
                }).error(function () {
                    Api.w('请检查表单错误');
                    form.$submitted = true;
                    defer.reject();
                });
                return defer.promise;
            }
        }
    }
})();

/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Vendor.pages.csmbs.categories.update')
        .controller('ConsumableUpdateListCtrl', ConsumableUpdateListCtrl)
    ;
    /** @ngInject */
    function ConsumableUpdateListCtrl(Table, CsmbUpdate, Api, dialogs, Array) {
        var vm = this;
        vm.zoomIn = zoomIn;
        vm.remove = remove;

        init();


        function init() {
            var states = CsmbUpdate.getStates();
            var statesOpts = Table.getOpts(states);
            var options = {
                service: CsmbUpdate,
                params: {op: 'vendor'},
                optColWidth: Table._3_BTN,
                cols: [
                    {field: "items", title: "耗材", filter: {item: "text"}},
                    {field: "created_at", title: "申请时间", filter: {created_at: "date_range"}},
                    {field: "state", title: "状态", filter: {state: "select"}, data: statesOpts}

                ]
            };
            Table.load4BgPager(vm, options, function (resp) {
                angular.forEach(resp.items, function (item) {
                    item.state = Array.getItem(item.state, states);
                });
            });

        }

        function getCurImg(m, type) {
            return type ? m.consumable.images[m.active] : m.images[m.active1];
        }

        function zoomIn(m, type) {
            var img = getCurImg(m, type);
            dialogs.create('CsmbLargeImgDlg.html', 'CsmbLargeImgDlgCtrl', img, {size: 'lg'}, 'vm');
        }


        function remove(m) {
            Api.delTableItem(CsmbUpdate, m.id, vm, '申请', '');
        }
    }
})();

/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Vendor.pages.csmbs.categories.vStop').controller('ConsumableVStopCtrl', ConsumableVStopCtrl);

    /** @ngInject */
    function ConsumableVStopCtrl($stateParams, $validation, $state, $q, Api, CVStop, ConsumableVariety, Array) {
        var vm = this;
        vm.csmbSelected = csmbSelected;
        vm.submit = submit;

        init($stateParams.id);


        function init(id) {
            vm.units = ConsumableVariety.getUnits();
            if (id) {
                CVStop.get({id: id, op: 'vendor'}, function (resp) {
                    var csmbs = [];
                    angular.forEach(resp.items, function (item) {
                        if (item.variety.type.parent && item.variety.type.parent_id != '1') {
                            item.variety.type.parent = Array.getParent(item.variety.type);
                        }
                        item.variety.type = (item.variety.type.parent && item.variety.type.parent_id != '1') ? (item.variety.type.parent.name + '-' + item.variety.type.name) : item.variety.type.name;
                        item.variety.purchase_unit = Array.getItem(item.variety.purchase_unit, vm.units).name;
                        item.variety.storage_unit = Array.getItem(item.variety.storage_unit, vm.units).name;
                        item.variety.use_unit = Array.getItem(item.variety.use_unit, vm.units).name;
                        csmbs.push(item.variety);
                    });
                    vm.m = {
                        id: resp.id,
                        consumables: angular.copy(csmbs),
                        csmbs: csmbs,
                        note: resp.note
                    };
                });
            } else {
                vm.m = {
                    consumables: [],
                    csmbs: []
                };
            }
        }

        function csmbSelected(m) {
            m.consumables = angular.copy(m.csmbs);
        }


        function submit(m, form) {
            if (m.consumables.length == 0) {
                Api.w('请选择耗材');
            } else {
                var defer = $q.defer();
                $validation.validate(form).success(function () {
                    var promise;
                    var pa = {
                        op: 'vendor',
                        csmbs: [],
                        note: m.note
                    };
                    angular.forEach(m.consumables, function (csmb) {
                        pa.csmbs.push({variety_id: csmb.id})
                    });

                    if (m.id) { //修改
                        promise = CVStop.update({id: m.id}, pa).$promise;
                    } else { //添加
                        promise = CVStop.save(pa).$promise;
                    }
                    promise.then(function (resp) {
                        Api.s(resp.msg);
                        $state.go('^.list');
                    }, function (error) {
                        var data = error.data;
                        if (data.msg) Api.e(data.msg);
                    }).finally(function () {
                        defer.resolve();
                    });
                }).error(function () {
                    Api.w('请检查表单错误');
                    form.$submitted = true;
                    defer.reject();
                });
                return defer.promise;
            }
        }
    }
})();

/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Vendor.pages.csmbs.categories.vStop')
        .controller('ConsumableVStopListCtrl', ConsumableVStopListCtrl)
    ;

    /** @ngInject */
    function ConsumableVStopListCtrl(Table, CVStop, Api, dialogs, Array, ConsumableVariety) {
        var vm = this;
        vm.remove = remove;

        init();


        function init() {
            vm.units = ConsumableVariety.getUnits();
            var states = CVStop.getStates();
            var statesOpts = Table.getOpts(states);
            var options = {
                service: CVStop,
                params: {op: 'vendor'},
                optColWidth: Table._3_BTN,
                cols: [
                    {field: "items", title: "耗材", filter: {items: "text"}},
                    {field: "created_at", title: "申请时间", filter: {created_at: "date_range"}},
                    {field: "note", title: "停用原因", filter: {note: "text"}},
                    {field: "state", title: "状态", filter: {state: "select"}, data: statesOpts}

                ]
            };
            Table.load4BgPager(vm, options, function (resp) {
                angular.forEach(resp.items, function (item) {
                    item.state = Array.getItem(item.state, states);
                    angular.forEach(item.items, function (item) {
                        if (item.variety.type.parent && item.variety.type.parent_id != '1') {
                            item.variety.type.parent = Array.getParent(item.variety.type);
                        }
                        item.variety.type = (item.variety.type.parent && item.variety.type.parent_id != '1') ? (item.variety.type.parent.name + '-' + item.variety.type.name) : item.variety.type.name;
                        item.variety.purchase_unit = Array.getItem(item.variety.purchase_unit, vm.units).name;
                        item.variety.storage_unit = Array.getItem(item.variety.storage_unit, vm.units).name;
                        item.variety.use_unit = Array.getItem(item.variety.use_unit, vm.units).name;
                    });
                });
            });

        }

        function remove(m) {
            Api.delTableItem(CVStop, m.id, vm, '申请', '');
        }
    }
})();

/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Vendor.pages.csmbs.categories.variety')
        .controller('consumableVarietyEditCtrl', consumableVarietyEditCtrl)
        .controller('CsmbCategoryDlgCtrl', CsmbCategoryDlgCtrl)
    ;

    /** @ngInject */
    function consumableVarietyEditCtrl($scope, $q, $validation, $state, ConsumableVariety, ConsumableType, Auth, Storeroom, dialogs,
                                       $stateParams, Api, VendorQ, Array, Province, Country, Producer) {
        var vm = this;
        vm.ok = ok;
        vm.tagTransform = tagTransform;
        vm.importChangeFn = importChangeFn;
        vm.addEditCategory = addEditCategory;
        vm.delCategory = delCategory;
        vm.roomSelectFn = roomSelectFn;
        vm.opt = {};
        vm.names = [];

        init($stateParams.id);


        function init(id) {
            $q.all([
                ConsumableType.query({opt: 1}).$promise,
                Storeroom.query({op: 'option'}).$promise,
                VendorQ.query({op: 'option'}).$promise,
                Province.query({opt: 2}).$promise,
                Country.query({opt: 2}).$promise,
                Producer.query({opt: 2}).$promise
            ]).then(function (respArray) {
                vm.types = convert(respArray[0].items);
                vm.rooms = respArray[1].items;
                vm.qualifications = respArray[2].items;
                vm.provinces = respArray[3].items;
                vm.countries = respArray[4].items;
                vm.producers = respArray[5].items;
                vm.units = ConsumableVariety.getUnits();
                vm.groups = ConsumableVariety.getGroups();
                vm.manageTypes = ConsumableVariety.getManageTypes();
                if (id) {
                    ConsumableVariety.get({id: id}, function (resp) {
                        var c = resp;
                        c.has_life = c.has_life == '1';
                        c.is_high_value = c.is_high_value == '1';
                        c.is_import = c.is_import == '1';
                        c.purchase_unit = Array.getItem(c.purchase_unit, vm.units);
                        c.storage_unit = Array.getItem(c.storage_unit, vm.units);
                        c.use_unit = Array.getItem(c.use_unit, vm.units);
                        c.group = Array.getItem(c.group, vm.groups);
                        c.manage_type = Array.getItem(c.manage_type, vm.manageTypes);
                        if (c.state == 3 || c.state == 4 || c.state == 6) {
                            c.purchase_unit = null;
                            c.storage_unit = null;
                            c.use_unit = null;
                            c.use_num = null;
                            c.storage_num = null;
                        }
                        var qualifications = [];
                        angular.forEach(c.qualifications, function (q) {
                            var qualification = Array.getItem(q.id, vm.qualifications);
                            if (qualification != null) {
                                qualifications.push(qualification);
                            } else {
                                vm.names.push(q.name);
                            }
                        });
                        c.qualifications = qualifications;
                        var producers = [];
                        if (c.producer_id) {
                            c.producer = Array.getItem(c.producer_id, vm.producers);
                            producers.push(c.producer);
                        }
                        c.producers = producers;
                        c.categories = c.consumables;
                        if (c.type.parent && c.type.parent_id != '1') {
                            c.type.parent = Array.getParent(c.type);
                        }
                        c.lifeType = c.shelf_life > 0 ? '3' : c.month_shelf_life > 0 ? '2' : '1';
                        c.is_admin = c.type_id == '167' || c.type_id == '293' || (c.type.parent && (c.type.parent.id == '167' || c.type.parent.id == '293'));
                        vm.m = c;
                    });
                } else {
                    vm.m = {
                        is_import: false,
                        has_life: false,
                        is_high_value: false,
                        lifeType: '1',
                        remind_day: '90',
                        country: vm.countries[36],
                        qualifications: [],
                        categories: [],
                        producers: []
                    };
                }
            });
        }

        function convert(types) {
            angular.forEach(types, function (type) {
                if (type.parent && type.parent_id != '1') {
                    type.parent = Array.getParent(type);
                }
                if (type.children && type.children.length > 0) {
                    convert(type.children);
                }
            });
            return types;
        }

        function importChangeFn(m) {
            if (!m.is_import && vm.countries) {
                m.country = vm.countries[36];

            }

            if (m.is_import && vm.countries) {
                m.country = vm.countries[0];

            }
        }

        $scope.$watch('vm.m.type', function (newVal, oldVal) {
            if (newVal) {
                if (newVal.id == '167' || newVal.id == '293' || (newVal.parent && (newVal.parent.id == '167' || newVal.parent.id == '293'))) {
                    // vm.m.storeroom = vm.rooms[1];
                    vm.m.is_admin = true;
                    vm.m.is_high_value = false;
                } else {
                    vm.m.is_admin = false;
                }
            }
        });

        function tagTransform(newTag) {
            var item = Array.getItem(newTag, vm.producers, 'name');
            if (item) {
                return none;
            }
            return {name: newTag};
        }

        function roomSelectFn(m) {
            if (m.storeroom.id == 6) {
                m.remind_day = 200;
            }
        }

        function addEditCategory(m, index) {
            dialogs.create('CsmbCategoryDlg.html', 'CsmbCategoryDlgCtrl', {
                m: m, index: index
            }, {
                size: 'md'
            }, 'vm').result.then(function (category) {
                if (index == 0) {
                    angular.forEach(category, function (c) {
                        m.categories.push(c);
                    });
                } else {
                    m.categories[index - 1] = category;
                }
            });
        }

        function delCategory(m, index, category) {
            dialogs.confirm("提示", "确认要移除" + category.spec + "吗?").result.then(function () {
                m.categories.splice(index, 1);
            });
        }

        function ok(m, Form, state) {
            if (!m.type) {
                Api.w('请选择类型');
            } else if (!m.is_import && !m.province && !m.is_admin) {
                Api.w('请选择省/市');
            } else if (!m.storeroom) {
                Api.w('请选择库房');
            } else if (m.producers.length == 0 && !m.is_admin) {
                Api.w('请选择生产商');
            } else if (!m.use_unit || !m.storage_unit || !m.purchase_unit) {
                Api.w('请选择计量单位');
            } else if ((m.use_unit.id == m.storage_unit.id && m.use_num > 1) || (m.purchase_unit.id == m.storage_unit.id
                && m.storage_num > 1) || m.use_num == 0 || m.storage_num == 0) {
                Api.w('请检查单位换算');
            } else if (m.qualifications.length == 0 && !m.is_admin) {
                Api.w('至少添加一个资质');
            } else if (m.categories.length == 0) {
                Api.w('至少添加一个耗材型号');
            } else {
                var defer = $q.defer();
                $validation.validate(Form).success(function () {
                    var promise;
                    var pa = {
                        name: m.name,
                        en: m.en,
                        type_id: m.type.id,
                        producers: m.producers,
                        dealer_id: Auth.VENDOR_ID,
                        storage_unit: m.storage_unit.id,
                        use_unit: m.use_unit.id,
                        storage_num: m.storage_num,
                        use_num: m.use_num,
                        note: m.note,
                        has_life: m.has_life ? '1' : '0',
                        is_high_value: m.is_high_value ? '1' : '0',
                        storeroom_id: m.storeroom.id,
                        c_name: m.c_name,
                        r_num: m.r_num,
                        is_import: m.is_import ? '1' : '0',
                        country_id: m.country.id,
                        categories: m.categories,
                        lead_time: m.lead_time,
                        purchase_unit: m.purchase_unit.id,
                        qualifications: [],
                        state: state,
                        s_dealer_id: Auth.getUser().dealer_id,
                        group: m.group ? m.group.id : null,
                        manage_type: m.manage_type ? m.manage_type.id : null
                    };
                    if (m.has_life) {
                        pa.year_shelf_life = pa.month_shelf_life = pa.shelf_life = '0';
                        switch (m.lifeType) {
                            case '1':
                                pa.year_shelf_life = m.year_shelf_life;
                                break;
                            case '2':
                                pa.month_shelf_life = m.month_shelf_life;
                                break;
                            case '3':
                                pa.shelf_life = m.shelf_life;
                                break;
                        }
                        pa.remind_day = m.remind_day;
                    }
                    if (!m.is_import && m.province) {
                        pa.province_id = m.province.id;
                    }

                    angular.forEach(m.qualifications, function (qualification) {
                        pa.qualifications.push(qualification.id);
                    });
                    if (m.id && (m.state == 1 || m.state == 2 || m.state == 5)) { //修改
                        promise = ConsumableVariety.update({id: m.id}, pa).$promise;
                    } else { //添加
                        promise = ConsumableVariety.save(pa).$promise;
                    }
                    promise.then(function (resp) {
                        Api.s(resp.msg);
                        $state.go('^.list');
                    }, function (error) {
                        var resp = error.data;
                        Api.e(resp.msg);
                        defer.reject();
                    }).finally(function () {
                        defer.resolve();
                    });
                }).error(function () {
                    Api.w('请检查表单错误');
                    Form.$submitted = true;
                    defer.reject();
                });

                return defer.promise;
            }
        }
    }

    /** @ngInject */
    function CsmbCategoryDlgCtrl($uibModalInstance, $validation, $q, Api, dialogs, data, Array, Auth, Consumable) {
        var vm = this;
        vm.cancel = $uibModalInstance.dismiss;
        vm.setImg = setImg;
        vm.editImg = editImg;
        vm.delImg = delImg;
        vm.zoomIn = zoomIn;
        vm.ok = ok;
        vm.tagTransform = tagTransform;
        vm.specs = [];
        vm.hisFeeTypes = Consumable.getHisFeeTypes();

        init(data.m, data.index);


        function init(m, index) {
            vm.index = index;
            vm.is_admin = m.is_admin;
            if (index == 0) {
                vm.m = {images: [], has_price: true, specs: []};
            } else {
                vm.m = angular.copy(m.categories[index - 1]);
                if (vm.m.his_fee_type) vm.m.his_fee_type = Array.getItem(vm.m.his_fee_type, vm.hisFeeTypes);
            }
        }

        function tagTransform(newTag) {
            return {name: newTag};
        }

        function setImg(m) {
            dialogs.create('app/pages/dialogs/imageCropped/upload-md.html',
                'imageCroppedUploadCtrl', {title: '设置耗材图片', width: 1200, height: 900}, {
                    size: 'md'
                }, 'vm'
            ).result.then(function (url) {
                m.images.push({path: url});
            });
        }

        function editImg(p) {
            dialogs.create('app/pages/dialogs/imageCropped/upload-md.html',
                'imageCroppedUploadCtrl', {title: '设置耗材图片', width: 1200, height: 900}, {
                    size: 'md'
                }, 'vm'
            ).result.then(function (url) {
                p.path = url;
            });
        }

        function zoomIn(p) {
            dialogs.create('CsmbLargeImgDlg.html', 'CsmbLargeImgDlgCtrl', p, {size: 'lg'}, 'vm');
        }

        function delImg(m, index) {
            dialogs.confirm("提示", "确认要移除该图片?").result.then(function () {
                m.images.splice(index, 1);
            });
        }

        function ok(m, Form) {
            if (m.images.length == 0) {
                Api.w('请设置图片');
            } else if (vm.index == 0 && m.specs.length == 0) {
                Api.w('请添加规格型号');
            } else {
                var defer = $q.defer();
                $validation.validate(Form).success(function () {
                    if (vm.index == 0) {
                        var items = Array.map(m.specs, function (item) {
                            return {
                                images: m.images,
                                sunshine_num: m.sunshine_num,
                                spec: item.name,
                                purchase_price: m.purchase_price,
                                has_price: m.has_price,
                                note: m.note,
                                sd_purchase_price: m.sd_purchase_price ? m.sd_purchase_price : null,
                                c_code: m.c_code,
                                m_code: m.m_code
                            }
                        });

                        m = items;
                    } else {
                        m.his_fee_type = m.his_fee_type.id
                    }
                    $uibModalInstance.close(m);
                }).error(function () {
                    Api.w('请检查表单错误');
                    Form.$submitted = true;
                    defer.reject();
                });

                return defer.promise;
            }
        }
    }

})();

/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Vendor.pages.csmbs.categories.variety')
        .controller('consumableVarietyCtrl', consumableVarietyCtrl)
        .controller('ConsumableQualificationCtrl', ConsumableQualificationCtrl)
        .controller('ConsumableImgDlgCtrl', ConsumableImgDlgCtrl)
        .controller('ConsumableDlgCtrl', ConsumableDlgCtrl)
        .controller('CsmbLargeImgDlgCtrl', CsmbLargeImgDlgCtrl)
        .controller('ConsumableCategoryDlgCtrl', ConsumableCategoryDlgCtrl)
        .controller('VarietyStopDlgCtrl', VarietyStopDlgCtrl)
        .controller('CsmbTypeDlgCtrl', CsmbTypeDlgCtrl)
    ;

    /** @ngInject */
    function consumableVarietyCtrl(Table, ConsumableVariety, ConsumableType, Array, dialogs, Auth, Storeroom, Api) {
        var vm = this;
        vm.showQualification = showQualification;
        vm.showCategory = showCategory;
        vm.remove = remove;
        vm.stop = stop;
        vm.setType = setType;

        init();


        function init() {
            vm.units = ConsumableVariety.getUnits();
            vm.states = ConsumableVariety.getStates();
            vm.groups = ConsumableVariety.getGroups();
            vm.manageTypes = ConsumableVariety.getManageTypes();

            var options = {
                service: ConsumableVariety,
                optColWidth: Table._6_BTN,
                cols: [
                    {field: "name", title: "注册证名称", filter: {name: "text"}},
                    {field: "c_name", title: "通用名", filter: {c_name: "text"}},
                    {field: "type", title: "类型", filter: {type: "tree"}, width: 168},
                    {field: "group", title: "组别", filter: {group: "select"}, data: Table.getOpts(vm.groups)},
                    {field: "storeroom", title: "所属库房", filter: {storeroom_id: "select"}},
                    {field: "state", title: "状态", filter: {state: "select"}, data: Table.getOpts(vm.states)},
                    {field: "manage_type", title: "管理类别", filter: {manage_type: "select"}, data: Table.getOpts(vm.manageTypes)},
                ]
            };
            var optionFn = Table.load4BgPager(vm, options, function (resp) {
                angular.forEach(resp.items, function (item) {
                    if (item.type.parent && item.type.parent_id != '1') {
                        item.type.parent = Array.getParent(item.type);
                    }
                    item.is_admin = item.type_id == '167' || item.type_id == '293' || (item.type.parent && (item.type.parent.id == '167' || item.type.parent.id == '293'));
                    item.type = (item.type.parent && item.type.parent_id != '1') ? (item.type.parent.name + '-' + item.type.name) : item.type.name;
                    item.purchase_unit = Array.getItem(item.purchase_unit, vm.units).name;
                    item.storage_unit = Array.getItem(item.storage_unit, vm.units).name;
                    item.use_unit = Array.getItem(item.use_unit, vm.units).name;
                    item.state = Array.getItem(item.state, vm.states);
                    item.group = Array.getItem(item.group, vm.groups);
                    item.manage_type = Array.getItem(item.manage_type, vm.manageTypes);

                    angular.forEach(item.qualifications, function (qualification) {
                        if (qualification.pivot.is_invalid == '1') {
                            item.expired = true;
                        }
                    });
                })
            }).options;
            ConsumableType.query({opt: 1}, function (resp) {
                optionFn().cols[2].data = resp.items;
            });
            Storeroom.query({op: 'option'}, function (resp) {
                optionFn().cols[4].data = Table.getOpts(resp.items);
            });
        }

        function showQualification(m) {
            dialogs.create('ConsumableQualification.html', 'ConsumableQualificationCtrl',
                {consumable_id: m.id}, {size: 'lg'}, 'vm');
        }

        function showCategory(m) {
            dialogs.create('ConsumableCategoryDlg.html', 'ConsumableCategoryDlgCtrl',
                {
                    consumable_id: m.id,
                    state: m.state.id,
                    is_stop: m.is_stop == '1',
                    is_admin: m.is_admin
                }, {size: 'lg'}, 'vm');
        }

        function remove(m) {
            Api.delTableItem(ConsumableVariety, m.id, vm, '品种', m.name);
        }

        function stop(m) {
            dialogs.create('VarietyStopDlg.html', 'VarietyStopDlgCtrl', {
                id: m.id
            }, {size: 'md'}, 'vm').result.then(function () {
                vm.tableReload();
            });
        }

        function setType(m) {
            dialogs.create('CsmbTypeDlg.html', 'CsmbTypeDlgCtrl', {
                m: m
            }, {size: 'md'}, 'vm').result.then(function () {
                vm.tableReload();
            });
        }

    }

    /** @ngInject */
    function ConsumableCategoryDlgCtrl($uibModalInstance, Consumable, ConsumableImg, ConsumableType, Table, Array, Api,
                                       dialogs, Storeroom, data, ConsumableVariety, Auth) {
        var vm = this;
        vm.addEdit = addEdit;
        vm.addEditImg = addEditImg;
        vm.rmImg = rmImg;
        vm.zoomIn = zoomIn;
        vm.cancel = $uibModalInstance.dismiss;
        vm.sPrice = sPrice;
        vm.setPrice = setPrice;

        init(data.consumable_id);


        function init(consumableId) {
            vm.state = data.state;
            vm.is_stop = data.is_stop;
            vm.units = ConsumableVariety.getUnits();
            vm.states = Consumable.getStates();
            var options = {
                service: Consumable,
                params: {op: 'category', variety_id: consumableId},
                optColWidth: Table._3_BTN,
                cols: [
                    {field: "spec", title: "规格型号", filter: {spec: "text"}},
                    {field: "sunshine_num", title: "阳光流水号", filter: {sunshine_num: "text"}},
                    {field: "storeroom", title: "所属库房", filter: {storeroom_id: "select"}},
                    {field: "type", title: "类型", filter: {type: "tree"}, width: 168},
                    {
                        field: "state",
                        title: "状态",
                        filter: {state: "select"},
                        data: Table.getOpts(vm.states),
                        show: vm.state != 6
                    }
                ]
            };
            var optionFn = Table.load4BgPager(vm, options, function (resp) {
                angular.forEach(resp.items, function (item) {
                    if (item.type.parent && item.type.parent_id != '1') {
                        item.type.parent = Array.getParent(item.type);
                    }
                    item.type = (item.type.parent && item.type.parent_id != '1') ? (item.type.parent.name + '-' + item.type.name) : item.type.name;
                    item.purchase_unit = Array.getItem(item.purchase_unit, vm.units).name;
                    item.storage_unit = Array.getItem(item.storage_unit, vm.units).name;
                    item.use_unit = Array.getItem(item.use_unit, vm.units).name;
                    item.state = Array.getItem(item.state, vm.states);

                    angular.forEach(item.images, function (img) {
                        img.path = img.path + '?' + new Date().getTime();
                    });
                });
            }).options;
            ConsumableType.query({opt: 1}, function (resp) {
                optionFn().cols[3].data = resp.items;
            });
            Storeroom.query({op: 'option'}, function (resp) {
                optionFn().cols[2].data = Table.getOpts(resp.items);
            });
        }

        function addEdit(m) {
            dialogs.create('ConsumableDlg.html', 'ConsumableDlgCtrl',
                {
                    consumable_id: data.consumable_id,
                    m: m,
                    is_admin: data.is_admin
                }, {size: 'md'}, 'vm').result.then(function () {
                vm.tableReload();
            });
        }

        function getCurImg(m) {
            return m.images[m.active];
        }


        function reloadImg(m) {
            ConsumableImg.query({opt: 2, consumable_id: m.id}, function (resp) {
                angular.forEach(resp.items, function (item) {
                    item.path = item.path + '?' + new Date().getTime();
                });
                m.images = resp.items;
            });
        }

        function addEditImg(m, isEdit) {
            var pa = {consumable_id: m.id};
            if (isEdit) {
                pa.id = getCurImg(m).id;
            }
            dialogs.create('ConsumableImgDlg.html', 'ConsumableImgDlgCtrl', pa, {size: 'md'}, 'vm')
                .result.then(function () {
                reloadImg(m);
            });
        }

        function rmImg(m) {
            var img = getCurImg(m);
            dialogs.confirm('删除耗材图片', '确定要删除<strong>' + img.name + '</strong>'
                + '耗材图片吗？')
                .result.then(function () {
                ConsumableImg.delete({id: img.id}).$promise.then(function (resp) {
                    Api.s(resp.msg);
                    reloadImg(m);
                });
            });
        }

        function zoomIn(m) {
            var img = getCurImg(m);
            dialogs.create('CsmbLargeImgDlg.html', 'CsmbLargeImgDlgCtrl', img, {size: 'lg'}, 'vm');
        }

        function sPrice(m) {
            dialogs.create('CsmbDealerPriceHistoryDlg.html', 'CsmbDealerPriceHistoryDlgCtrl', {
                id: m.id
            }, {size: 'lg'}, 'vm').result.then(function () {
                vm.tableReload();
            });
        }

        function setPrice(m) {
            dialogs.create('CsmbDealerPriceDlg.html', 'CsmbDealerPriceDlgCtrl', {
                m: m
            }, {size: 'md'}, 'vm').result.then(function () {
                vm.tableReload();
            });
        }
    }

    /** @ngInject */
    function ConsumableDlgCtrl($uibModalInstance, $q, $validation, Api, Consumable, data, dialogs, Auth) {
        var vm = this;
        vm.cancel = $uibModalInstance.dismiss;
        vm.setImg = setImg;
        vm.editImg = editImg;
        vm.delImg = delImg;
        vm.ok = ok;
        vm.tagTransform = tagTransform;
        vm.specs = [];
        vm.is_admin = data.is_admin;
        vm.hisFeeTypes = Consumable.getHisFeeTypes();

        init(data.m);


        function init(m) {
            if (m) {
                Consumable.get({id: m.id}, function (resp) {
                    var c = resp;
                    c.has_price = c.has_price == '1';
                    angular.forEach(c.images, function (img) {
                        img.path = img.path + '?' + new Date().getTime();
                    });
                    if (c.his_fee_type) c.his_fee_type = Array.getItem(c.his_fee_type, vm.hisFeeTypes);
                    vm.m = c;
                });
            } else {
                vm.m = {
                    images: [], has_price: true, variety_id: data.consumable_id, specs: []
                };
            }
        }

        function tagTransform(newTag) {
            return {name: newTag};
        }

        function setImg(m) {
            dialogs.create('app/pages/dialogs/imageCropped/upload-md.html',
                'imageCroppedUploadCtrl', {title: '设置耗材图片', width: 1200, height: 900},
                {size: 'md'}, 'vm'
            ).result.then(function (url) {
                m.images.push({path: url});
            });
        }

        function editImg(p) {
            dialogs.create('app/pages/dialogs/imageCropped/upload-md.html',
                'imageCroppedUploadCtrl', {title: '设置耗材图片', width: 1200, height: 900},
                {size: 'md'}, 'vm'
            ).result.then(function (url) {
                p.path = url;
            });
        }

        function delImg(m, index) {
            dialogs.confirm("提示", "确认要移除该图片?").result.then(function () {
                m.images.splice(index, 1);
            });
        }

        function ok(m, Form, state) {
            if (m.images.length == 0) {
                Api.w('请设置图片');
            } else if (!m.id && m.specs.length == 0) {
                Api.w('请添加规格型号');
            } else if (!m.his_fee_type) {
                Api.w('请设置his计费类型');
            } else {
                var defer = $q.defer();
                $validation.validate(Form).success(function () {
                    var promise;
                    var pa = {
                        images: m.images,
                        sunshine_num: m.sunshine_num,
                        purchase_price: m.purchase_price,
                        sd_purchase_price: m.sd_purchase_price ? m.sd_purchase_price : null,
                        has_price: m.has_price == '1',
                        variety_id: m.variety_id,
                        note: m.note,
                        state: state,
                        m_code: m.m_code,
                        c_code: m.c_code,
                        his_fee_type: m.his_fee_type.id
                    };

                    if (m.id) { //修改
                        pa.spec = m.spec;
                        promise = Consumable.update({id: m.id}, pa).$promise;
                    } else { //添加
                        pa.specs = m.specs;
                        promise = Consumable.save(pa).$promise;
                    }
                    promise.then(function (resp) {
                        Api.s(resp.msg);
                        $uibModalInstance.close();
                    }, function (error) {
                        var resp = error.data;
                        Api.e(resp.msg);
                        defer.reject();
                    }).finally(function () {
                        defer.resolve();
                    });
                }).error(function () {
                    Api.w('请检查表单错误');
                    Form.$submitted = true;
                    defer.reject();
                });

                return defer.promise;
            }
        }
    }

    /** @ngInject */
    function ConsumableImgDlgCtrl($uibModalInstance, $validation, $q, Api, dialogs, ConsumableImg, data) {
        var vm = this;
        vm.cancel = $uibModalInstance.dismiss;
        vm.setImg = setImg;
        vm.ok = ok;

        init(data.id);


        function init(id) {
            if (id) {
                ConsumableImg.get({id: id}, function (resp) {
                    var img = resp;
                    img.path = img.path + '?' + new Date().getTime();
                    vm.m = img;
                });
            } else {
                vm.m = {};
            }
        }

        function setImg(m) {
            dialogs.create('app/pages/dialogs/imageCropped/upload-md.html',
                'imageCroppedUploadCtrl', {title: '设置耗材图片', width: 1200, height: 900}, {
                    size: 'md'
                }, 'vm'
            ).result.then(function (url) {
                m.path = url;
            });
        }

        function ok(m, Form) {
            if (!m.path) {
                Api.w('请设置图片');
            } else {
                var defer = $q.defer();
                $validation.validate(Form).success(function () {
                    var promise;
                    var pa = {
                        path: m.path, consumable_id: data.consumable_id
                    };
                    if (m.id) { //修改
                        promise = ConsumableImg.update({id: m.id, opt: 1/*EDIT_SAVE*/}, pa).$promise;
                    } else { //添加
                        promise = ConsumableImg.save(pa).$promise;
                    }
                    promise.then(function (resp) {
                        Api.s(resp.msg);
                        $uibModalInstance.close();
                    }, function (error) {
                        var resp = error.data;
                        Api.e(resp.msg);
                        defer.reject();
                    }).finally(function () {
                        defer.resolve();
                    });
                }).error(function () {
                    Api.w('请检查表单错误');
                    Form.$submitted = true;
                    defer.reject();
                });

                return defer.promise;
            }
        }
    }

    /** @ngInject */
    function ConsumableQualificationCtrl($uibModalInstance, data, Table, ConsumableQualification) {
        var vm = this;
        vm.cancel = $uibModalInstance.dismiss;

        init(data.consumable_id);


        function init(consumableId) {
            vm.consumable_id = consumableId;
            var options = {
                service: ConsumableQualification,
                params: {
                    opt: 1, consumable_id: consumableId
                },
                optColWidth: Table._1_BTN, hideFilter: true,
                cols: [
                    {field: "name", title: "名称"},
                    {field: "type", title: "类型"},
                    {field: "limit", title: "资质期限"}
                ]
            };
            Table.load4BgPager(vm, options)
        }
    }

    /** @ngInject */
    function CsmbLargeImgDlgCtrl($uibModalInstance, data) {
        var vm = this;
        vm.cancel = $uibModalInstance.dismiss;
        vm.m = data;
    }

    /** @ngInject */
    function VarietyStopDlgCtrl($uibModalInstance, $q, $validation, data, CVStop, Api) {
        var vm = this;
        vm.cancel = $uibModalInstance.dismiss;
        vm.ok = ok;

        init(data.id);

        function init(id) {
            vm.m = {id: id};
        }

        function ok(m, Form) {
            var defer = $q.defer();
            $validation.validate(Form).success(function () {
                CVStop.save({
                    op: 'variety',
                    variety_id: m.id,
                    note: m.note
                }).$promise.then(function (resp) {
                    Api.s(resp.msg);
                    $uibModalInstance.close();
                }).finally(function () {
                    defer.resolve();
                });
            }).error(function () {
                Api.w('请检查表单错误');
                Form.$submitted = true;
                defer.reject();
            });

            return defer.promise;
        }
    }

    /** @ngInject */
    function CsmbTypeDlgCtrl($uibModalInstance, $validation, $q, data, ConsumableVariety, Array, Api) {
        var vm = this;
        vm.cancel = $uibModalInstance.dismiss;
        vm.ok = ok;
        vm.manageTypes = ConsumableVariety.getManageTypes();

        init();

        function init() {
            vm.m = angular.copy(data.m);
            if (vm.m.manage_type) vm.m.manage_type = Array.getItem(vm.m.manage_type.id, vm.manageTypes);
        }

        function ok(m, form) {
            var defer = $q.defer();
            $validation.validate(form).success(function () {
                var pa = {
                    manage_type: m.manage_type ? m.manage_type.id : null
                };
                ConsumableVariety.update({id: m.id, op: 'type'}, pa).$promise.then(function (resp) {
                    Api.s(resp.msg);
                    $uibModalInstance.close();
                    defer.resolve();
                }, function () {
                    defer.reject();
                });

            }).error(function () {
                Api.w('请检查表单错误');
                form.$submitted = true;
                defer.reject();
            });
            return defer.promise;
        }
    }
})();

/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Vendor.pages.csmbs.prices.query').controller('csmbPriceEditCtrl', csmbPriceEditCtrl);

    /** @ngInject */
    function csmbPriceEditCtrl($stateParams, $q, $state, $validation, Consumable, CsmbPrice, ConsumableVariety, Api, Misc, Auth, Array) {
        var vm = this;
        vm.submit = submit;
        vm.increase = increase;
        vm.decrease = decrease;
        vm.csmbSelected = csmbSelected;
        Misc.initEditor(vm);

        loadModel($stateParams.id);

        function loadModel(id) {
            if (id) {
                vm.units = ConsumableVariety.getUnits();
                // Consumable.query({
                //     op: 'price'
                // }, function (resp) {
                //     angular.forEach(resp.items, function (item) {
                //         item.purchase_unit = Array.getItem(item.purchase_unit, vm.units).name;
                //         item.storage_unit = Array.getItem(item.storage_unit, vm.units).name;
                //         item.use_unit = Array.getItem(item.use_unit, vm.units).name;
                //         item.new_price = item.purchase_price;
                //     });
                //     vm.consumables = resp.items;
                CsmbPrice.get({id: id}, function (resp) {
                    var m = resp;
                    var csmbs = [];
                    angular.forEach(m.items, function (item) {
                        var consumable = item.consumable;
                        consumable.item_id = item.id;
                        consumable.purchase_price = item.old_purchase_price;
                        consumable.new_price = item.purchase_price;
                        consumable.purchase_unit = Array.getItem(consumable.purchase_unit, vm.units).name;
                        consumable.storage_unit = Array.getItem(consumable.storage_unit, vm.units).name;
                        consumable.use_unit = Array.getItem(consumable.use_unit, vm.units).name;
                        csmbs.push(consumable);
                    });
                    vm.m = {
                        id: resp.id,
                        consumables: angular.copy(csmbs),
                        csmbs: csmbs,
                        content: resp.content
                    };
                });
                // });
            }

        }

        function csmbSelected(m) {
            m.consumables = angular.copy(m.csmbs);
            angular.forEach(m.consumables, function (csmb) {
                csmb.new_price = csmb.purchase_price;
            });
        }

        function increase(m) {
            if (m.new_price) {
                m.new_price++;
            } else {
                m.new_price = m.purchase_price;
            }
        }

        function decrease(m) {
            if (m.new_price && m.new_price > 0) {
                m.new_price--;
                if (m.new_price == 0) {
                    m.new_price = m.new_price.toString();
                }
            } else {
                m.new_price = m.purchase_price;
            }
        }

        function submit(form, m) {
            var defer = $q.defer();
            $validation.validate(form).success(function () {
                if (m.consumables.length == 0) {
                    Api.w('请选择耗材');
                    defer.reject();
                } else {
                    var pa = {
                        content: m.content,
                        csmbs: m.consumables
                    };
                    CsmbPrice.update({id: m.id, opt: 1}, pa).$promise.then(function (resp) {
                        Api.s(resp.msg);
                        $state.go('^');
                        defer.resolve();
                    }, function () {
                        defer.reject();
                    });
                }
            }).error(function () {
                Api.w('请检查表单错误');
                form.$submitted = true;
                defer.reject();
            });
            return defer.promise;

        }
    }

})();

/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Vendor.pages.csmbs.prices.query').controller('csmbPriceQueryCtrl', csmbPriceQueryCtrl);

    /** @ngInject */
    function csmbPriceQueryCtrl(Api, $sce, Array, Table, CsmbPrice, ConsumableVariety) {
        var vm = this;
        vm.remove = remove;
        vm.changeHide = changeHide;

        init();


        function init() {
            vm.hideSub = true;
            vm.units = ConsumableVariety.getUnits();
            var states = CsmbPrice.getStates();
            var statesOpts = Table.getOpts(states);
            var options = {
                service: CsmbPrice,
                params: {opt: 1/*INDEX_ALL*/},
                optColWidth: Table._3_BTN,
                cols: [
                    {field: "items", title: "变价耗材", filter: {item: "text"}},
                    {field: "state", title: "状态", filter: {state: "select"}, data: statesOpts},
                    {field: "created_at", title: "申请时间", filter: {created_at: "date_range"}}
                ]
            };

            Table.load4BgPager(vm, options, function (data) {
                angular.forEach(data.items, function (row) {
                    row.state = Array.getItem(row.state, states);
                    row.content = $sce.trustAsHtml(row.content);
                    angular.forEach(row.items, function (item) {
                        if (vm.tableParams.filter()['item']) {
                            row.expand = true;
                            var name = (item.consumable.name + item.consumable.c_name + item.consumable.sunshine_num + item.consumable.id + item.consumable.spec).toLowerCase();
                            item.hide = (name.indexOf(vm.tableParams.filter()['item'].toLowerCase()) < 0 && vm.hideSub);
                        }
                        item.consumable.purchase_unit = Array.getItem(item.consumable.purchase_unit, vm.units).name;
                        item.consumable.storage_unit = Array.getItem(item.consumable.storage_unit, vm.units).name;
                        item.consumable.use_unit = Array.getItem(item.consumable.use_unit, vm.units).name;
                    });
                });
                vm.items = data.items;
            });
        }

        function remove(m) {
            Api.delTableItem(CsmbPrice, m.id, vm, '申请', '');
        }

        function changeHide(rows, newVal) {
            if (newVal) {
                angular.forEach(rows, function (row) {
                    angular.forEach(row.items, function (item) {
                        var name = (item.consumable.name + item.consumable.c_name + item.consumable.sunshine_num + item.consumable.id + item.consumable.spec).toLowerCase();
                        item.hide = (name.indexOf(newVal.toLowerCase()) < 0 && vm.hideSub);
                    });
                });
            }
        }
    }

})();

/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Vendor.pages.csmbs.direct.dialogs').controller('vendorCsmbDirectBatchCtrl', vendorCsmbDirectBatchCtrl);

    /** @ngInject */
    function vendorCsmbDirectBatchCtrl($uibModalInstance, Table, ConsumableBatch, Array, dialogs,
                                       ConsumableType, ConsumableVariety, data, Api, Auth, Misc) {
        var vm = this;
        vm.zoomIn = zoomIn;
        vm.invoice = invoice;
        vm.show = show;
        vm.cancel = $uibModalInstance.dismiss;
        vm.qrcode = qrcode;

        init(data.m);


        function init(m) {
            var states = ConsumableBatch.getStates();
            var statesOpts = Table.getOpts(states);
            vm.units = ConsumableVariety.getUnits();
            var options = {
                service: ConsumableBatch,
                params: {op: 'direct', application_id: m.id},
                optColWidth: Table._4_BTN,
                cols: [
                    {field: "created_at", title: "出库时间", filter: {created_at: "date_range"}},
                    {field: "consumable", title: "注册证名称", filter: {consumable: "text"}},
                    {field: "c_name", title: "通用名", filter: {c_name: "text"}},
                    {field: "spec", title: "规格型号", filter: {spec: "text"}},
                    {field: "sn", title: "批次", filter: {sn: "text"}},
                    {field: "type", title: "类型", filter: {type: "tree"}, width: 168},
                    {field: "code", title: "编号", filter: {code: "text"}},
                    {field: "c_num", title: "发货量"},
                    {field: "c_r_num", title: "实际量"},
                    {field: "price", title: "实际金额"},
                    {field: "state", title: "状态", filter: {state: "select"}, data: statesOpts, width: 120}
                ]
            };

            var optionFn = Table.load4BgPager(vm, options, function (data) {
                vm.batches = data.batches;
                vm.totalPrice = data.totalPrice;
                angular.forEach(data.items, function (item) {
                    item.state = Array.getItem(item.state, states);
                    item.created_at = item.created_at.substr(0, 10);
                    var l_num = parseInt(item.num / item.consumable.storage_num),
                        s_num = item.num % item.consumable.storage_num,
                        app_l_num = parseInt(item.apply_num / item.consumable.storage_num),
                        app_s_num = item.apply_num % item.consumable.storage_num,
                        l_unit = Array.getItem(item.consumable.purchase_unit, vm.units).name,
                        s_unit = Array.getItem(item.consumable.storage_unit, vm.units).name;
                    if (l_num > 0) {
                        item.c_num = l_num + l_unit;
                        if (s_num > 0) {
                            item.c_num += s_num + s_unit;
                        }
                    } else {
                        item.c_num = s_num + s_unit;
                    }

                    //if (app_l_num > 0) {
                    //    item.apply_num = app_l_num + l_unit;
                    //    if (app_s_num > 0) {
                    //        item.apply_num += app_s_num + s_unit;
                    //    }
                    //} else {
                    //    item.apply_num = app_s_num + s_unit;
                    //}

                    if (item.r_num) {
                        var r_l_num = parseInt(item.r_num / item.consumable.storage_num),
                            r_s_num = item.r_num % item.consumable.storage_num;
                        if (r_l_num > 0) {
                            item.c_r_num = r_l_num + l_unit;
                            if (r_s_num > 0) {
                                item.c_r_num += r_s_num + s_unit;
                            }
                        } else {
                            item.c_r_num = r_s_num + s_unit;
                        }
                    }

                    item.consumable.purchase_unit = Array.getItem(item.consumable.purchase_unit, vm.units).name;
                    item.consumable.storage_unit = Array.getItem(item.consumable.storage_unit, vm.units).name;
                    item.consumable.use_unit = Array.getItem(item.consumable.use_unit, vm.units).name;
                    item.consumable.type = (item.consumable.type.parent && item.consumable.type.parent_id != 1) ? (Array.getParent(item.consumable.type).name + '-' + item.consumable.type.name) : item.consumable.type.name;
                    angular.forEach(item.consumable.images, function (img) {
                        img.path = img.path + '?' + new Date().getTime();
                    });
                    item.qrUrl = {app: 'oa.csmb', type: 3, consumable_id: item.consumable.id, batch_id: item.id};
                    item.price = Misc.toFixed(item.purchase_price * item.r_num * item.consumable.use_num, 2);
                });
            }).options;

            ConsumableType.query({opt: 1}, function (resp) {
                optionFn().cols[5].data = resp.items;
            });
        }

        function zoomIn(m) {
            var img = getCurImg(m);
            dialogs.create('CsmbLargeImgDlg.html', 'CsmbLargeImgDlgCtrl', img, {size: 'lg'}, 'vm');
        }

        function getCurImg(m) {
            return m.consumable.images[m.active];
        }

        function invoice() {
            var items = [];
            angular.forEach(angular.copy(vm.batches), function (item) {
                if (item.state == 3) {
                    item.created_at = item.created_at.substr(0, 10);
                    var l_num = parseInt(item.num / item.consumable.storage_num),
                        s_num = item.num % item.consumable.storage_num,
                        app_l_num = parseInt(item.apply_num / item.consumable.storage_num),
                        app_s_num = item.apply_num % item.consumable.storage_num,
                        l_unit = Array.getItem(item.consumable.purchase_unit, vm.units).name,
                        s_unit = Array.getItem(item.consumable.storage_unit, vm.units).name;
                    if (l_num > 0) {
                        item.c_num = l_num + l_unit;
                        if (s_num > 0) {
                            item.c_num += s_num + s_unit;
                        }
                    } else {
                        item.c_num = s_num + s_unit;
                    }

                    if (app_l_num > 0) {
                        item.apply_num = app_l_num + l_unit;
                        if (app_s_num > 0) {
                            item.apply_num += app_s_num + s_unit;
                        }
                    } else {
                        item.apply_num = app_s_num + s_unit;
                    }

                    if (item.r_num) {
                        var r_l_num = parseInt(item.r_num / item.consumable.storage_num),
                            r_s_num = item.r_num % item.consumable.storage_num;
                        if (r_l_num > 0) {
                            item.c_r_num = r_l_num + l_unit;
                            if (r_s_num > 0) {
                                item.c_r_num += r_s_num + s_unit;
                            }
                        } else {
                            item.c_r_num = r_s_num + s_unit;
                        }
                    }

                    item.consumable.purchase_unit = Array.getItem(item.consumable.purchase_unit, vm.units).name;
                    item.consumable.storage_unit = Array.getItem(item.consumable.storage_unit, vm.units).name;
                    item.consumable.use_unit = Array.getItem(item.consumable.use_unit, vm.units).name;
                    item.consumable.type = (item.consumable.type.parent && item.consumable.type.parent_id != 1) ? (Array.getParent(item.consumable.type).name + '-' + item.consumable.type.name) : item.consumable.type.name;
                    items.push(item)
                }
            });
            if (items.length > 0) {
                dialogs.create('app/pages/csmbs/batches/dialogs/invoice/invoice.html', 'vendorInvoiceCtrl', {
                    items: items,
                    room: data.m.room,
                    dept: data.m.dept,
                    ap_id: data.m.id,
                    vendor: Auth.getUser().vendor_name,
                    number: data.m.number
                }, {
                    size: 'lg'
                }, 'vm');
            } else {
                Api.e('暂无未收货的批次');
            }
        }

        function show(m) {
            dialogs.create('app/pages/csmbs/batches/dialogs/directDetail/history.html', 'DirectBatchHistoryCtrl', {id: m.id}, {
                size: 'lg'
            }, 'vm');

        }


        function getBatchPrintHtml(m) {
            var html = '';
            var qrUrl = $('#QrCode' + m.id + ' .qrcode')[0].toDataURL();
            var title = m.consumable.name + (m.consumable.c_name ? '(' + m.consumable.c_name + ')' : '');
            var titleClass;
            if (title.length > 30) {
                titleClass = 'title-small'
            } else {
                titleClass = 'title'
            }
            for (var i = 0; i < m.num; i++) {
                html += '<div class="paging">';
                html += '<div class="' + titleClass + '">' + title + '</div>';
                html += '<div class="info"><div class="img"><img src="' + qrUrl + '" width="100" height="100"></div>' +
                    '<div class="note"><div>规格型号：</div><div>' + m.consumable.spec + '</div>' +
                    '<div>批号：</div><div>' + m.no + '</div>' +
                    '<div>有效期：</div><div>' + m.production_date + '~' + (m.deadline ? m.deadline : '永久') + '</div>' +
                    '</div></div></div>';
            }
            return html;
        }


        function qrcode(m) {
            Misc.print(window.open('', '打印预览'), 'app/pages/csmbs/batches/dialogs/invoice/csmbBatch.html', function () {
                var html = getBatchPrintHtml(m);
                return html;
            });
        }
    }

})();

/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Vendor.pages.csmbs.direct.dialogs').controller('vendorCsmbDirectOutCtrl', vendorCsmbDirectOutCtrl);

    /** @ngInject */
    function vendorCsmbDirectOutCtrl($uibModalInstance, $validation, $q, data, Misc, Api, CsmbDirectApplication, Array,
                                     ConsumableBatch, Auth) {
        var vm = this;
        vm.submit = submit;
        vm.cancel = $uibModalInstance.dismiss;
        vm.dateSelected = dateSelected;
        vm.noSelected = noSelected;
        vm.remove = remove;
        vm.add = add;
        vm.numChange = numChange;
        vm.priceChange = priceChange;
        vm.disinfect = false;
        vm.dateOptions = {
            maxDate: new Date()
        };
        vm.index = 0;
        vm.dateInput = dateInput;

        init();

        function init() {
            var csmbs = [];
            angular.forEach(data.item.application_items, function (m) {
                if (m.diff_num > 0) {
                    if (m.consumable.type.parent && m.consumable.type.parent_id != '1') {
                        m.consumable.type.parent = Array.getParent(m.consumable.type);
                    }
                    var record = {
                        id: m.consumable_id,
                        item_id: m.id,
                        reNum: m.consumable.r_num,
                        code: m.consumable.code,
                        application_id: data.item.id,
                        name: m.consumable.name,
                        c_name: m.consumable.c_name,
                        spec: m.consumable.spec,
                        num: m.num,
                        s_dealer: m.consumable.s_dealer,
                        sd_purchase_price: m.consumable.sd_purchase_price ? m.consumable.sd_purchase_price : null,
                        purchase_price: m.consumable.purchase_price,
                        price: m.consumable.purchase_price,
                        sell_price: m.consumable.sell_price,
                        storage_unit: m.consumable.storage_unit,
                        purchase_unit: m.consumable.purchase_unit,
                        use_unit: m.consumable.use_unit,
                        for_purchase: data.item.for_purchase,
                        use_num: m.consumable.use_num,
                        storage_num: m.consumable.storage_num,
                        l_num: '0',
                        s_num: m.num,
                        diff_num: m.diff_num,
                        has_life: m.consumable.has_life,
                        shelf_life: m.consumable.shelf_life,
                        year_shelf_life: m.consumable.year_shelf_life,
                        month_shelf_life: m.consumable.month_shelf_life,
                        canEditPrice: false,
                        canIncreasePrice: m.consumable.type_id == '167' || (m.consumable.type.parent && m.consumable.type.parent.id == '167'),
                        batches: []
                    };
                    record.batches[0] = {
                        index: vm.index++,
                        n_l_num: '0',
                        n_s_num: m.diff_num
                    };
                    numChange(record);
                    csmbs.push(record);
                }
            });

            vm.csmbs = csmbs;
            getTotalAll(vm.csmbs);
        }

        function noSelected(m, batch) {
            ConsumableBatch.query({op: 'out', consumable_id: m.id, no: batch.no}, function (resp) {
                if (resp.batch) {
                    batch.production_date = new Date(resp.batch.production_date);
                    if (m.has_life == '1') {
                        batch.deadline = new Date(resp.batch.deadline);
                    } else {
                        batch.deadline = null;
                    }
                } else {
                    batch.production_date = batch.deadline = null;
                }
            });
        }

        function dateSelected(m, batch, type) {
            if (m.has_life == '1') {
                if (type == 1) {
                    var date = new Date(batch.production_date);
                    date.setFullYear(date.getFullYear() + parseInt(m.year_shelf_life));
                    date.setMonth(date.getMonth() + parseInt(m.month_shelf_life));
                    date.setDate(date.getDate() - 1 + parseInt(m.shelf_life));
                    batch.deadline = date;
                    batch.production_date2 = null;
                } else {
                    var date = new Date(batch.deadline);
                    date.setFullYear(date.getFullYear() - parseInt(m.year_shelf_life));
                    date.setMonth(date.getMonth() - parseInt(m.month_shelf_life));
                    date.setDate(date.getDate() + 1 - parseInt(m.shelf_life));
                    batch.production_date2 = Misc.date2Str(date);
                }
            } else {
                batch.deadline = null;
            }
        }

        function dateInput(batch) {
            batch.production_date = Misc.str2Date(batch.production_date2);
            batch.production_date2 = null;
        }

        function add(m) {
            m.batches.push({index: vm.index++, n_l_num: null, n_s_num: null});
        }

        function remove(m, index) {
            m.batches.splice(index, 1);
            numChange(m)
        }

        function numChange(m) {
            m.n_l_num = m.n_s_num = 0;
            angular.forEach(m.batches, function (batch) {
                m.n_l_num += parseInt(batch.n_l_num ? batch.n_l_num : '0');
                m.n_s_num += parseInt(batch.n_s_num ? batch.n_s_num : '0');
            });
            priceChange(m);
        }

        function priceChange(m) {
            var total = 0;
            angular.forEach(m.batches, function (batch) {
                total += batch.n_l_num * m.storage_num * m.use_num * m.purchase_price + batch.n_s_num * m.use_num * m.purchase_price;
            });
            m.total = Misc.toFixed(total, 2);
            if (vm.csmbs) {
                getTotalAll(vm.csmbs);
            }
        }

        function getTotalAll(csmbs) {
            var totalAll = 0;
            angular.forEach(csmbs, function (csmb) {
                totalAll += csmb.total;
            });
            csmbs.totalAll = Misc.toFixed(totalAll, 2);
        }

        function submit(form, m) {

            var defer = $q.defer();

            for (var j = 0; j < m.length; j++) {
                for (var l = 0; l < m[j].batches.length; l++) {
                    if (m[j].batches[l].deadline && m[j].batches[l].deadline < new Date()) {
                        Api.w((m[j].name != '' ? m[j].name : m[j].c_name) + '失效日期错误');
                        defer.reject();
                        return;
                    }
                }
            }

            var canSubmit = false;
            for (var i = 0; i < m.length; i++) {
                if (m[i].n_l_num > 0 || m[i].n_s_num > 0) {
                    if ((m[i].n_l_num * m[i].storage_num + parseInt(m[i].n_s_num)) > parseInt(m[i].diff_num)) {
                        Api.w((m[i].name != '' ? m[i].name : m[i].c_name) + '发货数量大于差额数量');
                        defer.reject();
                        return;
                    }
                    canSubmit = true;
                }
            }

            if (!canSubmit) {
                Api.w('至少发货一种耗材');
                defer.reject();
                return;
            }

            $validation.validate(form).success(function () {
                var pa = {room_id: data.room_id, vendor_id: Auth.VENDOR_ID};
                var csmbs = [];
                angular.forEach(angular.copy(m), function (csmb) {
                    csmb.r_num = parseInt(csmb.n_l_num * csmb.storage_num) + parseInt(csmb.n_s_num);
                    csmb.apply_num = csmb.diff_num;
                    if (csmb.r_num > 0) {
                        angular.forEach(csmb.batches, function (batch) {
                            batch.r_num = (batch.n_l_num ? parseInt(batch.n_l_num * csmb.storage_num) : 0)
                                + (batch.n_s_num ? parseInt(batch.n_s_num) : 0);
                            batch.production_date = Misc.date2Str(batch.production_date);
                            if (batch.deadline) {
                                batch.deadline = Misc.date2Str(batch.deadline);
                            }
                        });
                        csmb.disinfect = vm.disinfect ? '1' : '0';
                        csmbs.push(csmb);
                    }
                });
                pa.csmbs = csmbs;

                CsmbDirectApplication.update({
                    id: data.item.id,
                    op: 'out'
                }, pa).$promise.then(function (resp) {
                    Api.s(resp.msg);
                    defer.resolve();
                    $uibModalInstance.close();
                }, function (error) {
                    var resp = error.data;
                    Api.e(resp.msg);
                    defer.reject();
                });
            }).error(function () {
                form.$submitted = true;
                Api.e('表单中存在错误');
                defer.reject();
            });

            return defer.promise;
        }
    }

})();

///**
// * @author richard.fan
// * created on 16.12.2015
// */
//(function () {
//    'use strict';
//
//    angular.module('Vendor.pages.csmbs.direct.dialogs').controller('vendorCsmbDirectReissuesCtrl', vendorCsmbDirectReissuesCtrl);
//
//    /** @ngInject */
//    function vendorCsmbDirectReissuesCtrl($uibModalInstance, Table, CsmbDirectReissues, Array, data, ConsumableVariety) {
//        var vm = this;
//        vm.cancel = $uibModalInstance.dismiss;
//
//        init(data.m);
//
//
//        function init(m) {
//            vm.units = ConsumableVariety.getUnits();
//            var options = {
//                service: CsmbDirectReissues,
//                params: {opt: 4, application_id: m.id},
//                optColWidth: Table._1_BTN,
//                cols: [
//                    {field: "consumable", title: "申请耗材", filter: {consumable: "text"}},
//                    {field: 'dept', title: '申请科室', filter: {dept: "text"}},
//                    {field: 'apply_num', title: '申请量'},
//                    {field: 'diff_num', title: '差额'},
//                    {field: "created_at", title: "生成时间", filter: {created_at: "date_range"}}
//                ]
//            };
//
//            Table.load4BgPager(vm, options, function (resp) {
//                angular.forEach(resp.items, function (item) {
//                    item.diff = parseInt(item.apply_num) - parseInt(item.num);
//                    var l_num = parseInt(item.diff / item.consumable.storage_num), s_num = item.diff % item.consumable.storage_num,
//                        app_l_num = parseInt(item.apply_num / item.consumable.storage_num), app_s_num = item.apply_num % item.consumable.storage_num,
//                        l_unit = Array.getItem(item.consumable.purchase_unit, vm.units).name, s_unit = Array.getItem(item.consumable.storage_unit, vm.units).name;
//                    if (l_num > 0) {
//                        item.diff_num = l_num + l_unit;
//                        if (s_num > 0) {
//                            item.c_num += s_num + s_unit;
//                        }
//                    } else {
//                        item.diff_num = s_num + s_unit;
//                    }
//
//                    if (app_l_num > 0) {
//                        item.apply_num = app_l_num + l_unit;
//                        if (app_s_num > 0) {
//                            item.apply_num += app_s_num + s_unit;
//                        }
//                    } else {
//                        item.apply_num = app_s_num + s_unit;
//                    }
//                });
//            });
//        }
//    }
//
//})();

/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Vendor.pages.csmbs.direct.return').controller('CsmbDirectReturnHandleCtrl', CsmbDirectReturnHandleCtrl);

    /** @ngInject */
    function CsmbDirectReturnHandleCtrl($stateParams, $q, Api, $state, $validation, CsmbDirectReturn, ConsumableVariety, Misc, Array) {
        var vm = this;
        vm.handle = handle;

        loadModel($stateParams.id);

        function loadModel(id) {
            vm.units = ConsumableVariety.getUnits();
            if (id) {
                CsmbDirectReturn.get({id: id}, function (resp) {
                    var m = resp;
                    var total = 0;
                    angular.forEach(m.application_items, function (item) {
                        item.consumable.storage_unit = Array.getItem(item.consumable.storage_unit, vm.units).name;
                        item.consumable.purchase_unit = Array.getItem(item.consumable.purchase_unit, vm.units).name;
                        item.consumable.use_unit = Array.getItem(item.consumable.use_unit, vm.units).name;
                        item.total = Misc.toFixed(item.num * item.batch.purchase_price * item.consumable.use_num, 2);
                        total += item.total;
                    });
                    m.total = Misc.toFixed(total, 2);
                    m.sms = false;
                    vm.m = m;
                });
            }
        }

        function handle(form, m, op) {
            var defer = $q.defer();
            if (op == 2 && (m.opinion == null || m.opinion == "")) {
                Api.w('请输入拒绝意见');
                defer.reject();
            } else {
                $validation.validate(form).success(function () {
                    var pa = {
                        sms: m.sms,
                        opinion: m.opinion,
                        is_accept: op == 1
                    };
                    CsmbDirectReturn.update({id: m.id}, pa).$promise.then(function (resp) {
                        Api.s(resp.msg);
                        $state.go('^.list');
                        defer.resolve();
                    }, function (error) {
                        var resp = error.data;
                        Api.e(resp.msg);
                        defer.reject();
                    });
                }).error(function () {
                    defer.reject();
                });
            }
            return defer.promise;
        }
    }

})();

/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Vendor.pages.csmbs.direct.return').controller('CsmbDirectReturnApprovalCtrl', CsmbDirectReturnApprovalCtrl);

    /** @ngInject */
    function CsmbDirectReturnApprovalCtrl(Table, CsmbDirectReturn, Auth, Storeroom, $stateParams, Array, ConsumableVariety, Misc) {
        var vm = this;
        vm.changeHide = changeHide;

        init();


        function init() {
            vm.hideSub = true;
            var units = ConsumableVariety.getUnits();
            Storeroom.query({op: 'option'}, function (resp) {
                vm.rooms = resp.items;

                var options = {
                    service: CsmbDirectReturn,
                    params: {op: 'approval'},
                    optColWidth: Table._2_BTN,
                    cols: [
                        {field: 'itemDesc', title: '退货物资', filter: {item: "text"}, width: '35%'},
                        {field: "dept", title: "申请科室", filter: {dept: "text"}},
                        {field: "applicant", title: "申请人", filter: {applicant: "text"}},
                        {field: "created_at", title: '申请时间', filter: {created_at: 'date_range'}}
                    ]
                };

                if ($stateParams.room_id) {
                    options.filter = {room_id: $stateParams.room_id};
                } else if (vm.rooms.length > 0) {
                    options.filter = {room_id: vm.rooms[0].id};
                }

                Table.load4BgPager(vm, options, function (resp) {
                    angular.forEach(resp.items, function (row) {
                        var total = 0;
                        var items = [];
                        angular.forEach(row.application_items, function (item) {
                            if (vm.tableParams.filter()['item']) {
                                row.expand = true;
                               var name = (item.consumable.name + item.consumable.c_name + item.consumable.sunshine_num + item.consumable.spec).toLowerCase();
                                item.hide = (name.indexOf(vm.tableParams.filter()['item'].toLowerCase()) < 0 && vm.hideSub);
                            }
                            item.consumable.storage_unit = Array.getItem(item.consumable.storage_unit, units).name;
                            item.consumable.purchase_unit = Array.getItem(item.consumable.purchase_unit, units).name;
                            item.consumable.use_unit = Array.getItem(item.consumable.use_unit, units).name;
                            item.total = Misc.toFixed(item.consumable.use_num * item.num * item.batch.purchase_price, 2);
                            total += item.total;
                            var m = Array.getItem(item.consumable_id, items, 'consumable_id');
                            if (m == null) {
                                items.push(angular.copy(item));
                            } else {
                                m.num = parseInt(m.num) + parseInt(item.num);
                            }
                        });
                        row.total = Misc.toFixed(total, 2);
                        row.itemDesc = items;
                    });

                    vm.items = resp.items;
                });

                vm.clearFilters = function () {
                    vm.tableParams.filter({room_id: vm.tableParams.filter()['room_id']});
                };
            });
        }

        function changeHide(rows, newVal) {
            if (newVal) {
                angular.forEach(rows, function (row) {
                    angular.forEach(row.itemDesc, function (item) {
                       var name = (item.consumable.name + item.consumable.c_name + item.consumable.sunshine_num + item.consumable.spec).toLowerCase();
                        item.hide = (name.indexOf(newVal.toLowerCase()) < 0 && vm.hideSub);
                    });
                });
            }
        }
    }

})();

/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Vendor.pages.csmbs.qualifications.query').controller('csmbQAEditCtrl', csmbQAEditCtrl);

    /** @ngInject */
    function csmbQAEditCtrl($stateParams, $q, $state, $validation, ConsumableVariety, CsmbQA, Api, Auth, Array, dialogs, File, VendorQ) {
        var vm = this;
        vm.submit = submit;
        vm.add = add;
        vm.remove = remove;
        vm.download = download;
        vm.changeFn = changeFn;
        vm.csmbSelected = csmbSelected;

        init($stateParams.id);


        function init(id) {
            // ConsumableVariety.query({
            //     op:'option'
            // }, function (resp) {
            //     vm.consumables = resp.items;
                CsmbQA.get({id: id}, function (resp) {
                    var consumables = [];
                    angular.forEach(resp.items, function (item) {
                        var consumable = item.consumable;
                        var csmb = Array.getItem(consumable.id, consumables);
                        if (csmb == null) {
                            var q = Array.getItem(item.qualification_id, consumable.qualifications);
                            if (q != null) {
                                q.remove = true;
                            } else {
                                item.qualification.isNew = true;
                                item.qualification.change = item.type == 3;
                                consumable.qualifications.push(item.qualification);
                            }
                            consumables.push(consumable);
                        } else {
                            var q = Array.getItem(item.qualification_id, csmb.qualifications);
                            if (q != null) {
                                q.remove = true;
                            } else {
                                item.qualification.isNew = true;
                                item.qualification.change = item.type == 3;
                                csmb.qualifications.push(item.qualification);
                            }
                        }
                    });
                    vm.m = {
                        id: id,
                        consumables: angular.copy(consumables),
                        csmbs: consumables,
                        note: resp.note
                    };
                });

            // });


        }

        function csmbSelected(m) {
            m.consumables = angular.copy(m.csmbs);
        }


        function add(csmb, items) {
            dialogs.create('csmbQAAdd.html', 'csmbQAAddCtrl',
                {consumable_id: csmb.id}, {size: 'lg'}, 'vm').result.then(function (result) {
                angular.forEach(result, function (item) {
                    if (Array.getItem(item.id, items) != null) {
                        Api.w('请勿重复添加新资质');
                    } else {
                        item.isNew = true;
                        items.push(item)
                    }
                });
            });
        }

        function remove(array, $index) {
            array.splice($index, 1);
        }

        function download(attach) {
            File.download(VendorQ.urls.DOWNLOAD, attach);
        }

        function changeFn(item, m) {
            angular.forEach(m.qualifications, function (q) {
                if (item.change && item.id != q.id) {
                    q.change = false;
                }
            });
        }

        function submit(form, m) {
            var defer = $q.defer();
            $validation.validate(form).success(function () {
                var items = [];
                var canSubmit = false;
                angular.forEach(m.consumables, function (csmb) {
                    angular.forEach(csmb.qualifications, function (q) {
                        if (q.remove) {
                            canSubmit = true;
                            items.push({csmb_id: csmb.id, q_id: q.id, type: 2});
                        }
                        if (q.isNew) {
                            canSubmit = true;
                            items.push({csmb_id: csmb.id, q_id: q.id, type: q.change ? 3 : 1});
                        }
                    });
                });
                var pa = {
                    note: m.note,
                    items: items
                };
                if (canSubmit) {
                    CsmbQA.update({id: m.id, opt: 1}, pa).$promise.then(function (resp) {
                        Api.s(resp.msg);
                        $state.go('^');
                        defer.resolve();
                    }, function () {
                        defer.reject();
                    });
                } else {
                    Api.w('选择的耗材至少需要解绑或新增一个资质');
                    defer.reject();
                }
            }).error(function () {
                Api.w('请检查表单错误');
                form.$submitted = true;
                defer.reject();
            });
            return defer.promise;
        }
    }

})();

/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Vendor.pages.csmbs.qualifications.query')
        .controller('csmbQAQueryCtrl', csmbQAQueryCtrl)
    ;

    /** @ngInject */
    function csmbQAQueryCtrl(Table, CsmbQA, Array, Api, dialogs, File, VendorQ) {
        var vm = this;
        vm.remove = remove;
        vm.download = download;
        vm.changeHide = changeHide;

        init();


        function init() {
            vm.hideSub = true;
            var states = CsmbQA.getStates();
            var types = CsmbQA.getTypes();
            var options = {
                service: CsmbQA,
                params: {opt: 1/*INDEX_ALL*/},
                optColWidth: Table._2_BTN,
                cols: [
                    {field: "items", title: "变更详情", filter: {item: "text"}},
                    {field: "state", title: "状态", filter: {state: "select"}, data: Table.getOpts(states)},
                    {field: "created_at", title: "申请时间", filter: {created_at: "date_range"}}
                ]
            };

            Table.load4BgPager(vm, options, function (resp) {
                angular.forEach(resp.items, function (item) {
                    item.state = Array.getItem(item.state, states);
                    angular.forEach(item.items, function (item) {
                        if (vm.tableParams.filter()['item']) {
                            var name = (item.consumable.name + item.consumable.c_name).toLowerCase();
                            item.hide = (name.indexOf(vm.tableParams.filter()['item'].toLowerCase()) < 0 && vm.hideSub);
                        }
                        item.type = Array.getItem(item.type, types);
                    });
                });
                vm.items = resp.items;
            });
        }

        function download(attach) {
            File.download(VendorQ.urls.DOWNLOAD, attach);
        }

        function remove(m) {
            Api.delTableItem(CsmbQA, m.id, vm, '申请', '');
        }

        function changeHide(rows, newVal) {
            if (newVal) {
                angular.forEach(rows, function (row) {
                    angular.forEach(row.items, function (item) {
                        var name = (item.consumable.name + item.consumable.c_name).toLowerCase();
                        item.hide = (name.indexOf(newVal.toLowerCase()) < 0 && vm.hideSub);
                    });
                });
            }
        }

    }
})();

/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Vendor.pages.csmbs.purchase.dialogs').controller('csmbAppMsnCtrl', csmbAppMsnCtrl);

    /** @ngInject */
    function csmbAppMsnCtrl($uibModalInstance, $validation, $q, data, Api, SPApplication) {
        var vm = this;
        vm.submit = submit;
        vm.cancel = $uibModalInstance.dismiss;

        init(data.m);

        function init(m) {
            vm.m = m;
        }


        function submit(form, m) {

            var defer = $q.defer();

            $validation.validate(form).success(function () {
                var pa = {msn: m.msn};
                SPApplication.update({id: m.id, op: 'info'}, pa).$promise.then(function (resp) {
                    Api.s(resp.msg);
                    defer.resolve();
                    $uibModalInstance.close();
                }, function (error) {
                    var resp = error.data;
                    Api.e(resp.msg);
                    defer.reject();
                });
            }).error(function () {
                Api.e('表单中存在错误');
                defer.reject();
            });

            return defer.promise;
        }
    }

})();

/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Vendor.pages.csmbs.purchase.dialogs').controller('vendorCsmbBatchCtrl', vendorCsmbBatchCtrl);

    /** @ngInject */
    function vendorCsmbBatchCtrl($uibModalInstance, Table, ConsumableBatch, Array, dialogs,
                                 ConsumableType, ConsumableVariety, data, Auth, Api,Misc) {
        var vm = this;
        vm.invoice = invoice;
        vm.zoomIn = zoomIn;
        vm.show = show;
        vm.cancel = $uibModalInstance.dismiss;
        vm.qrcode = qrcode;

        init(data.m);


        function init(m) {
            vm.units = ConsumableVariety.getUnits();
            var options = {
                service: ConsumableBatch,
                params: {op: 'application', ap_id: m.id},
                optColWidth: Table._4_BTN,
                cols: [
                    {field: "created_at", title: "出库时间", filter: {created_at: "date_range"}},
                    {field: "consumable", title: "注册证名称", filter: {consumable: "text"}},
                    {field: "c_name", title: "通用名", filter: {c_name: "text"}},
                    {field: "spec", title: "规格型号", filter: {spec: "text"}},
                    {field: "sn", title: "批次", filter: {sn: "text"}},
                    {field: "type", title: "类型", filter: {type: "tree"}, width: 168},
                    {field: "code", title: "编号", filter: {code: "text"}},
                    {field: "c_num", title: "发货量"},
                    {field: "c_r_num", title: "实际量"},
                    {field: "price", title: "实际金额"}
                ]
            };

            var optionFn = Table.load4BgPager(vm, options, function (data) {
                angular.forEach(data.items, function (item) {
                    item.created_at = item.created_at.substr(0, 10);
                    var l_num = parseInt(item.num / item.consumable.storage_num),
                        s_num = item.num % item.consumable.storage_num,
                        app_l_num = parseInt(item.apply_num / item.consumable.storage_num),
                        app_s_num = item.apply_num % item.consumable.storage_num,
                        l_unit = Array.getItem(item.consumable.purchase_unit, vm.units).name,
                        s_unit = Array.getItem(item.consumable.storage_unit, vm.units).name;
                    if (l_num > 0) {
                        item.c_num = l_num + l_unit;
                        if (s_num > 0) {
                            item.c_num += s_num + s_unit;
                        }
                    } else {
                        item.c_num = s_num + s_unit;
                    }

                    if (item.r_num) {
                        var r_l_num = parseInt(item.r_num / item.consumable.storage_num),
                            r_s_num = item.r_num % item.consumable.storage_num;
                        if (r_l_num > 0) {
                            item.c_r_num = r_l_num + l_unit;
                            if (r_s_num > 0) {
                                item.c_r_num += r_s_num + s_unit;
                            }
                        } else {
                            item.c_r_num = r_s_num + s_unit;
                        }
                    }

                    item.consumable.purchase_unit = Array.getItem(item.consumable.purchase_unit, vm.units).name;
                    item.consumable.storage_unit = Array.getItem(item.consumable.storage_unit, vm.units).name;
                    item.consumable.use_unit = Array.getItem(item.consumable.use_unit, vm.units).name;
                    item.consumable.type = (item.consumable.type.parent && item.consumable.type.parent_id != 1) ? (Array.getParent(item.consumable.type).name + '-' + item.consumable.type.name) : item.consumable.type.name;
                    angular.forEach(item.consumable.images, function (img) {
                        img.path = img.path + '?' + new Date().getTime();
                    });
                    item.qrUrl = {app: 'oa.csmb', type: 3, consumable_id: item.consumable.id, batch_id: item.id};
                    item.price = Misc.toFixed(item.purchase_price * item.r_num * item.consumable.use_num, 2);
                });
                vm.batches = data.batches;
                vm.totalPrice = data.totalPrice;
            }).options;

            ConsumableType.query({opt: 1}, function (resp) {
                optionFn().cols[5].data = resp.items;
            });
        }

        function zoomIn(m) {
            var img = getCurImg(m);
            dialogs.create('CsmbLargeImgDlg.html', 'CsmbLargeImgDlgCtrl', img, {size: 'lg'}, 'vm');
        }

        function getCurImg(m) {
            return m.consumable.images[m.active];
        }

        function invoice() {
            var items = [];
            angular.forEach(angular.copy(vm.batches), function (item) {
                if (item.state == 1) {
                    item.created_at = item.created_at.substr(0, 10);
                    var l_num = parseInt(item.num / item.consumable.storage_num),
                        s_num = item.num % item.consumable.storage_num,
                        app_l_num = parseInt(item.apply_num / item.consumable.storage_num),
                        app_s_num = item.apply_num % item.consumable.storage_num,
                        l_unit = Array.getItem(item.consumable.purchase_unit, vm.units).name,
                        s_unit = Array.getItem(item.consumable.storage_unit, vm.units).name;
                    if (l_num > 0) {
                        item.c_num = l_num + l_unit;
                        if (s_num > 0) {
                            item.c_num += s_num + s_unit;
                        }
                    } else {
                        item.c_num = s_num + s_unit;
                    }

                    if (app_l_num > 0) {
                        item.apply_num = app_l_num + l_unit;
                        if (app_s_num > 0) {
                            item.apply_num += app_s_num + s_unit;
                        }
                    } else {
                        item.apply_num = app_s_num + s_unit;
                    }

                    if (item.r_num) {
                        var r_l_num = parseInt(item.r_num / item.consumable.storage_num),
                            r_s_num = item.r_num % item.consumable.storage_num;
                        if (r_l_num > 0) {
                            item.c_r_num = r_l_num + l_unit;
                            if (r_s_num > 0) {
                                item.c_r_num += r_s_num + s_unit;
                            }
                        } else {
                            item.c_r_num = r_s_num + s_unit;
                        }
                    }

                    item.consumable.purchase_unit = Array.getItem(item.consumable.purchase_unit, vm.units).name;
                    item.consumable.storage_unit = Array.getItem(item.consumable.storage_unit, vm.units).name;
                    item.consumable.use_unit = Array.getItem(item.consumable.use_unit, vm.units).name;
                    item.consumable.type = (item.consumable.type.parent && item.consumable.type.parent_id != 1) ? (Array.getParent(item.consumable.type).name + '-' + item.consumable.type.name) : item.consumable.type.name;
                    items.push(item)
                }
            });
            if (items.length > 0) {
                dialogs.create('app/pages/csmbs/batches/dialogs/invoice/invoice.html', 'vendorInvoiceCtrl', {
                    items: items,
                    room: data.m.room,
                    ap_id: data.m.id,
                    number: data.m.number
                }, {
                    size: 'lg'
                }, 'vm');
            } else {
                Api.e('暂无未收货的批次');
            }
        }

        function show(m) {
            dialogs.create('app/pages/csmbs/batches/dialogs/batchDetail/history.html', 'CsmbBatchHistoryCtrl', {id: m.id}, {
                size: 'lg'
            }, 'vm');
        }

        function getBatchPrintHtml(m) {
            var html = '';
            var qrUrl = $('#QrCode' + m.id + ' .qrcode')[0].toDataURL();
            var title = m.consumable.name + (m.consumable.c_name ? '(' + m.consumable.c_name + ')' : '');
            var titleClass;
            if (title.length > 30) {
                titleClass = 'title-small'
            } else {
                titleClass = 'title'
            }
            for (var i = 0; i < m.num; i++) {
                html += '<div class="paging">';
                html += '<div class="' + titleClass + '">' + title + '</div>';
                html += '<div class="info"><div class="img"><img src="' + qrUrl + '" width="100" height="100"></div>' +
                    '<div class="note"><div>规格型号：</div><div>' + m.consumable.spec + '</div>' +
                    '<div>批号：</div><div>' + m.no + '</div>' +
                    '<div>有效期：</div><div>' + m.production_date + '~' + (m.deadline ? m.deadline : '永久') + '</div>' +
                    '</div></div></div>';
            }

            return html;
        }


        function qrcode(m) {
            Misc.print(window.open('', '打印预览'), 'app/pages/csmbs/batches/dialogs/invoice/csmbBatch.html', function () {
                var html = getBatchPrintHtml(m);
                return html;
            });
        }
    }

})();

/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Vendor.pages.csmbs.purchase.dialogs').controller('vendorCsmbOutCtrl', vendorCsmbOutCtrl);

    /** @ngInject */
    function vendorCsmbOutCtrl($uibModalInstance, $validation, $q, data, Misc, Api, SPApplication, Array,
                               ConsumableBatch, Auth) {
        var vm = this;
        vm.submit = submit;
        vm.cancel = $uibModalInstance.dismiss;
        vm.dateSelected = dateSelected;
        vm.noSelected = noSelected;
        vm.remove = remove;
        vm.add = add;
        vm.numChange = numChange;
        vm.priceChange = priceChange;
        vm.disinfect = false;
        vm.dateOptions = {
            maxDate: new Date()
        };
        vm.index = 0;
        vm.dateInput = dateInput;

        init();

        function init() {
            var csmbs = [];
            if (data.item) {
                angular.forEach(data.item.application_items, function (m) {
                    if (m.diff_num > 0) {
                        if (m.consumable.type.parent && m.consumable.type.parent_id != '1') {
                            m.consumable.type.parent = Array.getParent(m.consumable.type);
                        }
                        var l_num = parseInt(m.diff_num / m.consumable.storage_num),
                            s_num = m.diff_num % m.consumable.storage_num;
                        var record = {
                            id: m.consumable_id,
                            reNum: m.consumable.r_num,
                            code: m.consumable.code,
                            item_id: m.id,
                            name: m.consumable.name,
                            c_name: m.consumable.c_name,
                            spec: m.consumable.spec,
                            s_dealer: m.consumable.s_dealer,
                            sd_purchase_price: m.consumable.sd_purchase_price ? m.consumable.sd_purchase_price : null,
                            purchase_price: m.consumable.purchase_price,
                            price: m.consumable.purchase_price,
                            sell_price: m.consumable.sell_price,
                            storage_unit: m.consumable.storage_unit,
                            purchase_unit: m.consumable.purchase_unit,
                            use_unit: m.consumable.use_unit,
                            for_purchase: data.item.for_purchase,
                            use_num: m.consumable.use_num,
                            storage_num: m.consumable.storage_num,
                            l_num: l_num > 0 ? l_num : '0',
                            s_num: s_num > 0 ? s_num : '0',
                            has_life: m.consumable.has_life,
                            shelf_life: m.consumable.shelf_life,
                            year_shelf_life: m.consumable.year_shelf_life,
                            month_shelf_life: m.consumable.month_shelf_life,
                            canEditPrice: false,
                            canIncreasePrice: m.consumable.type_id == '167' || (m.consumable.type.parent && m.consumable.type.parent.id == '167'),
                            batches: []
                        };
                        record.batches[0] = {
                            index: vm.index++,
                            n_l_num: l_num > 0 ? l_num : '0',
                            n_s_num: s_num > 0 ? s_num : '0'
                        };
                        numChange(record);
                        csmbs.push(record);
                    }
                });
            }
            vm.csmbs = csmbs;
            getTotalAll(vm.csmbs);
        }

        function noSelected(m, batch) {
            ConsumableBatch.query({op: 'out', consumable_id: m.id, no: batch.no}, function (resp) {
                if (resp.batch) {
                    batch.production_date = new Date(resp.batch.production_date);
                    if (m.has_life == '1') {
                        batch.deadline = new Date(resp.batch.deadline);
                    } else {
                        batch.deadline = null;
                    }
                } else {
                    batch.production_date = batch.deadline = null;
                }
            });
        }

        function dateSelected(m, batch, type) {
            if (m.has_life == '1') {
                if (type == 1) {
                    var date = new Date(batch.production_date);
                    date.setFullYear(date.getFullYear() + parseInt(m.year_shelf_life));
                    date.setMonth(date.getMonth() + parseInt(m.month_shelf_life));
                    date.setDate(date.getDate() - 1 + parseInt(m.shelf_life));
                    batch.deadline = date;
                    batch.production_date2 = null;
                } else {
                    var date = new Date(batch.deadline);
                    date.setFullYear(date.getFullYear() - parseInt(m.year_shelf_life));
                    date.setMonth(date.getMonth() - parseInt(m.month_shelf_life));
                    date.setDate(date.getDate() + 1 - parseInt(m.shelf_life));
                    batch.production_date2 = Misc.date2Str(date);
                }
            } else {
                batch.deadline = null;
            }
        }

        function dateInput(batch) {
            batch.production_date = Misc.str2Date(batch.production_date2);
            batch.production_date2 = null;
        }

        function add(m) {
            m.batches.push({index: vm.index++, n_l_num: null, n_s_num: null});
        }

        function remove(m, index) {
            m.batches.splice(index, 1);
            numChange(m)
        }

        function numChange(m) {
            m.n_l_num = m.n_s_num = 0;
            angular.forEach(m.batches, function (batch) {
                m.n_l_num += parseInt(batch.n_l_num ? batch.n_l_num : '0');
                m.n_s_num += parseInt(batch.n_s_num ? batch.n_s_num : '0');
            });
            priceChange(m);
        }

        function priceChange(m) {
            var total = 0;
            angular.forEach(m.batches, function (batch) {
                total += batch.n_l_num * m.storage_num * m.use_num * m.purchase_price + batch.n_s_num * m.use_num * m.purchase_price;
            });
            m.total = Misc.toFixed(total, 2);
            if (vm.csmbs) {
                getTotalAll(vm.csmbs);
            }
        }

        function getTotalAll(csmbs) {
            var totalAll = 0;
            angular.forEach(csmbs, function (csmb) {
                totalAll += csmb.total;
            });
            csmbs.totalAll = Misc.toFixed(totalAll, 2);
        }

        function submit(form, m) {
            var defer = $q.defer();

            for (var j = 0; j < m.length; j++) {
                for (var l = 0; l < m[j].batches.length; l++) {
                    if (m[j].batches[l].deadline && m[j].batches[l].deadline < new Date()) {
                        Api.w((m[j].name != '' ? m[j].name : m[j].c_name) + '失效日期错误');
                        defer.reject();
                        return;
                    }
                }
            }

            var canSubmit = false;
            for (var i = 0; i < m.length; i++) {
                if (m[i].n_l_num > 0 || m[i].n_s_num > 0) {
                    if ((m[i].n_l_num * m[i].storage_num + parseInt(m[i].n_s_num)) > (m[i].l_num * m[i].storage_num + parseInt(m[i].s_num))) {
                        Api.w((m[i].name != '' ? m[i].name : m[i].c_name) + '发货数量大于差额数量');
                        defer.reject();
                        return;
                    }
                    canSubmit = true;
                }
            }

            if (!canSubmit) {
                Api.w('至少发货一种耗材');
                defer.reject();
                return;
            }


            $validation.validate(form).success(function () {
                var pa = {room_id: data.room_id, vendor_id: Auth.VENDOR_ID};
                var csmbs = [];

                angular.forEach(angular.copy(m), function (csmb) {
                    csmb.r_num = parseInt(csmb.n_l_num * csmb.storage_num) + parseInt(csmb.n_s_num);
                    csmb.apply_num = parseInt(csmb.l_num * csmb.storage_num) + parseInt(csmb.s_num);
                    if (csmb.r_num > 0) {
                        angular.forEach(csmb.batches, function (batch) {
                            batch.r_num = (batch.n_l_num ? parseInt(batch.n_l_num * csmb.storage_num) : 0)
                                + (batch.n_s_num ? parseInt(batch.n_s_num) : 0);
                            batch.production_date = Misc.date2Str(batch.production_date);
                            if (batch.deadline) {
                                batch.deadline = Misc.date2Str(batch.deadline);
                            }
                        });

                        csmb.disinfect = vm.disinfect ? '1' : '0';
                        csmbs.push(csmb);
                    }
                });
                pa.csmbs = csmbs;
                SPApplication.update({
                    id: data.item.id,
                    op: 'out'
                }, pa).$promise.then(function (resp) {
                    Api.s(resp.msg);
                    defer.resolve();
                    $uibModalInstance.close();
                }, function (error) {
                    var resp = error.data;
                    Api.e(resp.msg);
                    defer.reject();
                });
            }).error(function () {
                form.$submitted = true;
                Api.e('表单中存在错误');
                defer.reject();
            });

            return defer.promise;
        }
    }

})();

/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Vendor.pages.csmbs.return.approval').controller('SRAHandleCtrl', SRAHandleCtrl);

    /** @ngInject */
    function SRAHandleCtrl($stateParams, $q, Api, $state, $validation, SRApplication, ConsumableVariety, Misc, Array) {
        var vm = this;
        vm.handle = handle;

        loadModel($stateParams.id);

        function loadModel(id) {
            vm.units = ConsumableVariety.getUnits();
            if (id) {
                SRApplication.get({id: id}, function (resp) {
                    var m = resp;
                    var total = 0;
                    angular.forEach(m.application_items, function (item) {
                        item.consumable.storage_unit = Array.getItem(item.consumable.storage_unit, vm.units).name;
                        item.consumable.purchase_unit = Array.getItem(item.consumable.purchase_unit, vm.units).name;
                        item.consumable.use_unit = Array.getItem(item.consumable.use_unit, vm.units).name;
                        item.total = Misc.toFixed(item.num * item.batch.purchase_price * item.consumable.use_num, 2);
                        total += item.total;
                    });
                    m.total = Misc.toFixed(total, 2);
                    m.sms = false;
                    vm.m = m;
                });
            }
        }

        function handle(form, m, opt) {
            var defer = $q.defer();
            if (opt == '4' && (m.opinion == null || m.opinion == "")) {
                Api.w('请输入拒绝意见');
                defer.reject();
            } else {
                $validation.validate(form).success(function () {
                    var pa = {
                        sms: m.sms,
                        opinion: m.opinion,
                        opt: opt
                    };
                    SRApplication.update({id: m.id}, pa).$promise.then(function (resp) {
                        Api.s(resp.msg);
                        $state.go('^.list');
                        defer.resolve();
                    }, function (error) {
                        var resp = error.data;
                        Api.e(resp.msg);
                        defer.reject();
                    });
                }).error(function () {
                    defer.reject();
                });
            }
            return defer.promise;
        }
    }

})();

/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Vendor.pages.csmbs.return.approval').controller('SRAApprovalCtrl', SRAApprovalCtrl);

    /** @ngInject */
    function SRAApprovalCtrl(Table, SRApplication, Auth, Storeroom, $stateParams, Array, ConsumableVariety, Misc) {
        var vm = this;
        vm.changeHide = changeHide;

        init();


        function init() {
            vm.hideSub = true;
            var units = ConsumableVariety.getUnits();
            Storeroom.query({op: 'option'}, function (resp) {
                vm.rooms = resp.items;

                var options = {
                    service: SRApplication,
                    params: {op: 'approval'},
                    optColWidth: Table._2_BTN,
                    cols: [
                        {field: 'itemDesc', title: '退货物资', filter: {item: "text"}, width: '35%'},
                        {field: "applicant", title: "申请人", filter: {applicant: "text"}},
                        {field: "created_at", title: '申请时间', filter: {created_at: 'date_range'}}
                    ]
                };

                if ($stateParams.room_id) {
                    options.filter = {room_id: $stateParams.room_id};
                } else if (vm.rooms.length > 0) {
                    options.filter = {room_id: vm.rooms[0].id};
                }

                Table.load4BgPager(vm, options, function (resp) {
                    angular.forEach(resp.items, function (row) {
                        var total = 0;
                        var items = [];
                        angular.forEach(row.application_items, function (item) {
                            if (vm.tableParams.filter()['item']) {
                                row.expand = true;
                                var name = (item.consumable.name + item.consumable.c_name + item.consumable.sunshine_num + item.consumable.spec).toLowerCase();
                                item.hide = (name.indexOf(vm.tableParams.filter()['item'].toLowerCase()) < 0 && vm.hideSub);
                            }
                            item.consumable.storage_unit = Array.getItem(item.consumable.storage_unit, units).name;
                            item.consumable.purchase_unit = Array.getItem(item.consumable.purchase_unit, units).name;
                            item.consumable.use_unit = Array.getItem(item.consumable.use_unit, units).name;
                            item.total = Misc.toFixed(item.consumable.use_num * item.num * item.batch.purchase_price, 2);
                            total += item.total;
                            var m = Array.getItem(item.consumable_id, items, 'consumable_id');
                            if (m == null) {
                                items.push(angular.copy(item));
                            } else {
                                m.num = parseInt(m.num) + parseInt(item.num);
                            }
                        });
                        row.total = Misc.toFixed(total, 2);
                        row.itemDesc = items;
                    });

                    vm.items = resp.items;
                });

                vm.clearFilters = function () {
                    vm.tableParams.filter({room_id: vm.tableParams.filter()['room_id']});
                };
            });
        }

        function changeHide(rows, newVal) {
            if (newVal) {
                angular.forEach(rows, function (row) {
                    angular.forEach(row.itemDesc, function (item) {
                        var name = (item.consumable.name + item.consumable.c_name + item.consumable.sunshine_num + item.consumable.spec).toLowerCase();
                        item.hide = (name.indexOf(newVal.toLowerCase()) < 0 && vm.hideSub);
                    });
                });
            }
        }
    }

})();

angular.module("Vendor").run(["$templateCache", function($templateCache) {$templateCache.put("app/pages/auth/auth.html","<main class=\"auth-main\"><div class=\"auth-block\"><h2>成办分院经销商平台登录</h2><form class=\"form-horizontal\" name=\"Form\"><div class=\"form-group\"><label for=\"inputEmail3\" class=\"col-sm-2 control-label\">用户名</label><div class=\"col-sm-10\"><input type=\"username\" ng-model=\"vm.user.username\" validator=\"required,minlen=4\" class=\"form-control\" id=\"inputEmail3\" placeholder=\"请输入用户名\" minlen-error-message=\"用户名长度至少为4\"></div></div><div class=\"form-group\"><label for=\"inputPassword3\" class=\"col-sm-2 control-label\"><div ng-if=\"!vm.smsLogin\">密码</div><div ng-if=\"vm.smsLogin\">动态密码</div></label><div class=\"col-sm-10\"><div class=\"input-group\"><input type=\"password\" ng-model=\"vm.user.password\" validator=\"required,minlen=6,password\" class=\"form-control\" id=\"inputPassword3\" placeholder=\"{{vm.smsLogin?\'动态\':\'\'}}密码\" minlen-error-message=\"密码长度至少为6\"> <span class=\"input-group-btn\" style=\"vertical-align: top\"><div ng-if=\"!vm.smsLogin\"><button class=\"btn btn-warning\" type=\"button\" ng-click=\"vm.smsLogin=true\"><strong>未设置或已忘记?</strong></button></div><div ng-if=\"vm.smsLogin\"><button class=\"btn btn-warning\" type=\"button\" ng-click=\"vm.getSmsPassword()\" ng-disabled=\"vm.remain>0\"><strong>{{vm.getSmsBtnText()}}</strong></button></div></span></div></div></div><div class=\"form-group\"><div class=\"col-sm-offset-2 col-sm-10\"><button class=\"btn btn-default btn-auth\" validation-submit=\"Form\" ng-click=\"vm.login(vm.user)\">登录</button> <a href=\"\" class=\"forgot-pass\" ng-click=\"vm.smsLogin=!vm.smsLogin\" style=\"font-size: 18px;font-weight: bold; margin-top: 10px\"><div ng-if=\"!vm.smsLogin\">未设初始密码或忘记?</div><div ng-if=\"vm.smsLogin\">切换回用户名密码登录</div></a></div></div></form></div></main>");
$templateCache.put("app/pages/dashboard/dashboard.html","<div class=\"row pie-charts\"><a class=\"pie-chart-item-container\" ng-repeat=\"chart in charts\" ui-sref=\"{{::chart.route}}\" ng-switch=\"chart.description\"><div ng-switch-default=\"\"><div class=\"panel animated zoomIn\"><div class=\"panel-body {{chart.bg}}\"><div class=\"pie-chart-item\"><div class=\"description hidden-xs\"><div>{{ ::chart.description }}</div><div class=\"description-stats\">{{ chart.count }}</div></div><div class=\"chart-icon text-center\"><i class=\"fa fa-4x {{::chart.icon}}\"></i><div class=\"mt-5\">{{::chart.subtext}}</div></div></div></div></div></div></a></div><div class=\"row\"><div class=\"col-md-6\"><div><div class=\"home-blk-title purchase-bg\"><i class=\"fa fa-shopping-cart fa-fw\"></i> <a ui-sref=\"main.csmbs.purchase.approval\">供货申请</a></div><a ui-sref=\"main.csmbs.purchase.approval\" class=\"home-more\">进入处理>></a><div class=\"table-responsive home-blk-table purchase-bg\" style=\"height: 300px\"><table class=\"table\"><tbody><tr ng-repeat=\"p in purchaseList track by p.id\"><td width=\"120\"><span ng-bind=\"p.room.name\"></span></td><td><span ng-repeat=\"i in p.application_items\" ng-hide=\"i.diff_num==0\">{{i.consumable.name!=\'\'?i.consumable.name:i.consumable.c_name}} <span class=\"badge bulletin-subject-col\">{{i.consumable.spec}}</span> <span class=\"text-danger\" ng-bind=\"i.diff_num+(p.for_purchase==\'1\'?i.consumable.purchase_unit:i.consumable.storage_unit)\"></span> <span ng-show=\"!$last\">,</span></span></td></tr><tr ng-if=\"purchaseList.length==0\" style=\"height:280px\" class=\"table-no-data\"><td colspan=\"10\" align=\"center\" style=\"vertical-align:middle\"><span class=\"text-gray\" style=\"background: transparent\">暂无申请</span></td></tr></tbody></table></div></div></div><div class=\"col-md-6\"><div><div class=\"home-blk-title return-bg\"><i class=\"fa fa-undo fa-fw\"></i><a ui-sref=\"main.csmbs.return.approval.list\">退货申请</a></div><a ui-sref=\"main.csmbs.return.approval.list\" class=\"home-more\">进入处理>></a><div class=\"table-responsive home-blk-table return-bg\" style=\"height: 300px\"><table class=\"table\"><tbody><tr ng-repeat=\"r in returnList track by r.id\"><td width=\"120\"><span ng-bind=\"r.room.name\"></span></td><td><span ng-repeat=\"i in r.itemDesc\">{{i.consumable.name!=\'\'?i.consumable.name:i.consumable.c_name}} <span class=\"badge bulletin-subject-col\">{{i.consumable.spec}}</span> <span class=\"text-danger\" ng-bind=\"i.num+i.consumable.storage_unit\"></span> <span ng-show=\"!$last\">,</span></span></td></tr><tr ng-if=\"returnList.length==0\" style=\"height:280px\" class=\"table-no-data\"><td colspan=\"10\" align=\"center\" style=\"vertical-align:middle\"><span class=\"text-gray\" style=\"background: transparent\">暂无申请</span></td></tr></tbody></table></div></div></div></div><div class=\"row\"><div class=\"col-md-6\"><div><div class=\"home-blk-title purchase-bg\"><i class=\"fa fa-shopping-cart fa-fw\"></i> <a ui-sref=\"main.csmbs.direct.approval\">直购申请</a></div><a ui-sref=\"main.csmbs.direct.approval\" class=\"home-more\">进入处理>></a><div class=\"table-responsive home-blk-table purchase-bg\" style=\"height: 300px\"><table class=\"table\"><tbody><tr ng-repeat=\"d in directList track by d.id\"><td width=\"120\"><span ng-bind=\"d.dept.name\"></span></td><td><span ng-repeat=\"i in d.application_items\" ng-hide=\"i.diff_num==0\">{{i.consumable.name!=\'\'?i.consumable.name:i.consumable.c_name}} <span class=\"badge bulletin-subject-col\">{{i.consumable.spec}}</span> <span class=\"text-danger\" ng-bind=\"i.diff_num+i.consumable.storage_unit\"></span> <span ng-show=\"!$last\">,</span></span></td></tr><tr ng-if=\"directList.length==0\" style=\"height:280px\" class=\"table-no-data\"><td colspan=\"10\" align=\"center\" style=\"vertical-align:middle\"><span class=\"text-gray\" style=\"background: transparent\">暂无申请</span></td></tr></tbody></table></div></div></div><div class=\"col-md-6\"><div><div class=\"home-blk-title return-bg\"><i class=\"fa fa-undo fa-fw\"></i><a ui-sref=\"main.csmbs.direct.return.list\">直购退货</a></div><a ui-sref=\"main.csmbs.direct.return.list\" class=\"home-more\">进入处理>></a><div class=\"table-responsive home-blk-table return-bg\" style=\"height: 300px\"><table class=\"table\"><tbody><tr ng-repeat=\"r in directReturnList track by r.id\"><td width=\"120\"><span ng-bind=\"r.dept.name\"></span></td><td><span ng-repeat=\"i in r.itemDesc\">{{i.consumable.name!=\'\'?i.consumable.name:i.consumable.c_name}} <span class=\"badge bulletin-subject-col\">{{i.consumable.spec}}</span> <span class=\"text-danger\" ng-bind=\"i.num+i.consumable.storage_unit\"></span> <span ng-show=\"!$last\">,</span></span></td></tr><tr ng-if=\"directReturnList.length==0\" style=\"height:280px\" class=\"table-no-data\"><td colspan=\"10\" align=\"center\" style=\"vertical-align:middle\"><span class=\"text-gray\" style=\"background: transparent\">暂无申请</span></td></tr></tbody></table></div></div></div></div>");
$templateCache.put("app/pages/main/main.html","<main ng-if=\"$pageFinishedLoading\" ng-class=\"{ \'menu-collapsed\': $baSidebarService.isMenuCollapsed() }\"><ba-sidebar></ba-sidebar><page-top></page-top><div class=\"al-main\"><div class=\"al-content\"><content-top></content-top><div ui-view=\"\"></div></div></div><footer class=\"al-footer clearfix\"><div class=\"al-footer-right\">Created with <i class=\"fa fa-heart\"></i></div><div class=\"al-footer-main clearfix\"><div class=\"al-copy\">&copy;2017 西藏自治区人民政府驻成都办事处医院.</div></div></footer><back-top></back-top></main>");
$templateCache.put("app/pages/dialogs/editor/upload.html","<div class=\"modal-header dialog-header-confirm\"><button type=\"button\" class=\"close\" ng-click=\"vm.cancel()\">&times;</button><h4 class=\"modal-title\"><i class=\"fa fa-picture-o\">上传本地图片</i></h4></div><div class=\"modal-body\"><div><p>检测到拷贝内容中引用了本地图片，为保证正常显示需将其上传到服务器.</p><p>由于浏览器安全性限制，无法直接读取本地图片数据，<span class=\"text-red\">请按照说明操作</span>：</p><p>先点击<strong>上传</strong>按钮，再在弹出的<strong>打开文件对话框</strong>中<strong>文件名栏</strong>里<strong>直接粘贴(Ctrl+V)</strong> 已存放在剪贴板中的图片路径，最后点击<strong>打开</strong>确认上传.</p></div><div ng-repeat=\"img in vm.images\"><a ngf-select=\"vm.upload($file,img,$invalidFiles)\" ng-hide=\"img.filename||img.inProgress\" ng-click=\"vm.getDataFromClipboard(img.path)\" ngf-max-size=\"4MB\" ngf-pattern=\"\'image/*\'\" accept=\"image/*\">上传</a> <span>{{img.name}}</span><div class=\"progress attach-progress\" ng-show=\"img.inProgress\">&nbsp;<div class=\"progress-bar progress-bar-info\" role=\"progressbar\" aria-valuenow=\"{{img.progress}}\" aria-valuemin=\"0\" aria-valuemax=\"100\" ng-style=\"{width:img.progress+\'%\'}\"></div></div><span class=\"text-success\" ng-if=\"img.filename\">上传成功</span></div></div><div class=\"modal-footer\"><button class=\"btn btn-primary\" ng-click=\"vm.ok()\">确认</button> <button class=\"btn btn-default\" ng-click=\"vm.cancel()\">取消</button></div>");
$templateCache.put("app/pages/dialogs/imageCropped/upload-md.html","<div class=\"modal-header dialog-header-notify\"><button type=\"button\" class=\"close\" ng-click=\"vm.cancel()\">&times;</button> <span><i class=\"fa fa-picture-o modal-icon\"></i>{{vm.title}}</span></div><div class=\"modal-body\"><div><form name=\"Form\" class=\"form-horizontal\" novalidate=\"\"><div class=\"cropArea ca-md\"><ui-cropper image=\"vm.m.imgFile| ngfDataUrl\" result-image=\"vm.m.croppedDataUrl\" result-image-size=\"{w:vm.width,h:vm.height}\" area-type=\"rectangle\"></ui-cropper></div><div ng-show=\"vm.m.imgFile\"><label style=\"margin-top:8px\">预览窗口</label><div><img class=\"img-responsive\" ng-src=\"{{vm.m.croppedDataUrl}}\"></div></div></form></div><div class=\"progress\" style=\"margin-top:8px\" ng-show=\"vm.m.inProgress\"><div class=\"progress-bar progress-bar-info\" role=\"progressbar\" aria-valuenow=\"{{vm.m.progress}}\" aria-valuemin=\"0\" aria-valuemax=\"100\" ng-style=\"{width:vm.m.progress+\'%\'}\"></div></div></div><div class=\"modal-footer\"><button class=\"btn btn-primary\" ngf-select=\"\" ng-model=\"vm.m.imgFile\" ngf-max-size=\"20MB\" accept=\"image/*\"><span ng-show=\"vm.m.imgFile\">重新</span>选择</button> <button class=\"btn btn-success\" ng-click=\"vm.upload(vm.m)\" ng-if=\"vm.m.imgFile\" ngf-pattern=\"\'image/*\'\" accept=\"image/*\">上传</button> <button class=\"btn btn-default\" ng-click=\"vm.cancel()\">取消</button></div>");
$templateCache.put("app/pages/dialogs/imageCropped/upload.html","<div class=\"modal-header dialog-header-notify\"><button type=\"button\" class=\"close\" ng-click=\"vm.cancel()\">&times;</button> <span><i class=\"fa fa-picture-o modal-icon\"></i>{{vm.title}}</span></div><div class=\"modal-body\"><div><form name=\"Form\" class=\"form-horizontal\" novalidate=\"\"><div class=\"cropArea ca-sm\"><ui-cropper image=\"vm.m.imgFile| ngfDataUrl\" result-image=\"vm.m.croppedDataUrl\" area-init-size=\"{w:vm.width,h:vm.height}\" result-image-size=\"{w:vm.width,h:vm.height}\" area-type=\"rectangle\"></ui-cropper></div><div ng-show=\"vm.m.imgFile\"><label style=\"margin-top:8px\">预览窗口</label><div><img class=\"img-responsive\" ng-src=\"{{vm.m.croppedDataUrl}}\"></div></div></form></div><div class=\"progress\" style=\"margin-top:8px\" ng-show=\"vm.m.inProgress\"><div class=\"progress-bar progress-bar-info\" role=\"progressbar\" aria-valuenow=\"{{vm.m.progress}}\" aria-valuemin=\"0\" aria-valuemax=\"100\" ng-style=\"{width:vm.m.progress+\'%\'}\"></div></div></div><div class=\"modal-footer\"><button class=\"btn btn-primary\" ngf-select=\"\" ng-model=\"vm.m.imgFile\" ngf-max-size=\"20MB\" accept=\"image/*\"><span ng-show=\"vm.m.imgFile\">重新</span>选择</button> <button class=\"btn btn-success\" ng-click=\"vm.upload(vm.m)\" ng-if=\"vm.m.imgFile\" ngf-pattern=\"\'image/*\'\" accept=\"image/*\">上传</button> <button class=\"btn btn-default\" ng-click=\"vm.cancel()\">取消</button></div>");
$templateCache.put("app/pages/info/password/reset.html","<div class=\"row\"><div class=\"col-lg-5 col-md-6 col-sm-8\"><div ba-panel=\"\" ba-panel-class=\"light-text tab-content-panel\" ba-panel-title=\"<span ncy-breadcrumb-last></span>\"><form name=\"Form\" class=\"form-horizontal\" novalidate=\"\"><div class=\"form-group\"><label class=\"col-md-3 col-lg-4 control-label\">新密码</label><div class=\"col-md-9 col-lg-8\"><input class=\"form-control\" type=\"password\" name=\"password\" ng-model=\"vm.user.password\" validator=\"required,minlen=6,password,password2\" minlen-error-message=\"密码长度至少为6\"></div></div><div class=\"form-group\"><label class=\"col-md-3 col-lg-4 control-label\">密码确认</label><div class=\"col-md-9 col-lg-8\"><input class=\"form-control\" type=\"password\" name=\"password2\" ng-model=\"vm.user.password2\" validator=\"required,password2\"></div></div><div class=\"form-group\"><div class=\"col-md-offset-3 col-md-9\"><div class=\"pull-right\"><submit-button btn-class=\"btn-primary\" btn-click=\"vm.submit(Form,vm.user)\">提交</submit-button><button class=\"btn btn-default\" ui-sref=\"^\">取消</button></div></div></div></form></div></div></div>");
$templateCache.put("app/pages/info/profile/show.html","<div ba-panel=\"\" ba-panel-class=\"profile-page\"><div class=\"panel-content\"><form name=\"Form\" class=\"form-horizontal\" novalidate=\"\"><h3 class=\"with-line\">基本信息</h3><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label for=\"inputDealer\" class=\"col-sm-3 control-label\">经销商名称</label><div class=\"col-sm-9\"><input type=\"text\" class=\"form-control\" id=\"inputDealer\" name=\"dealer\" ng-model=\"vm.info.dealer\" disabled=\"\"></div></div></div></div><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">开户行名称</label><div class=\"col-sm-9\"><input type=\"text\" class=\"form-control\" id=\"inputBankName\" name=\"BankName\" ng-model=\"vm.info.bank_name\"></div></div></div><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">开户行账号</label><div class=\"col-sm-9\"><input type=\"text\" class=\"form-control\" id=\"inputAccount\" name=\"account\" ng-model=\"vm.info.bank_account\"></div></div></div></div><h3 class=\"with-line\">经销商平台负责人</h3><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label for=\"inputName\" class=\"col-sm-3 control-label\">姓名</label><div class=\"col-sm-9\"><input type=\"text\" class=\"form-control\" id=\"inputName\" name=\"username\" ng-model=\"vm.info.name\" disabled=\"\"></div></div></div><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label for=\"inputPhone\" class=\"col-sm-3 control-label\">账户/手机</label><div class=\"col-sm-9\"><input type=\"text\" class=\"form-control\" id=\"inputPhone\" name=\"phone\" ng-model=\"vm.info.username\" disabled=\"\"></div></div></div></div><h3 class=\"with-line\">其他联系人</h3><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">第二联系人</label><div class=\"col-sm-9\"><input type=\"text\" class=\"form-control\" id=\"inputContact\" name=\"s_contact\" ng-model=\"vm.info.s_contact\"></div></div></div><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">电话</label><div class=\"col-sm-9\"><input type=\"text\" class=\"form-control\" id=\"inputSPhone\" name=\"s_phone\" ng-model=\"vm.info.s_phone\" validator=\"required=s_contact\" required-error-message=\"您已指定了此联系人，请填写他的联系电话\"></div></div></div></div><h3 class=\"with-line\">更多</h3><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">备注</label><div class=\"col-sm-9\"><textarea class=\"form-control\" id=\"inputNote\" maxlength=\"200\" name=\"note\" ng-model=\"vm.info.note\"></textarea></div></div></div></div><br><div class=\"row\"><div class=\"col-md-offset-3 col-md-9\"><div class=\"form-group\"><div class=\"pull-right\" style=\"margin-right:16px\"><button ng-click=\"vm.reset(Form)\" class=\"btn btn-default\"><i class=\"fa fa-refresh\"></i>&nbsp;重置</button><submit-button btn-class=\"btn-primary\" btn-click=\"vm.submit(Form,vm.info)\"><i class=\"ion-android-checkmark-circle\"></i>&nbsp;更新个人资料</submit-button></div></div></div></div></form></div></div>");
$templateCache.put("app/pages/qualifications/new/apply.html","<div ba-panel=\"\" ba-panel-class=\"profile-page\" ba-panel-title=\"<span ncy-breadcrumb-last></span>\"><div class=\"panel-content\"><form name=\"Form\" class=\"form-horizontal\" scroll-form=\"\" novalidate=\"\"><div class=\"form-group\"><label class=\"col-md-2 control-label\">厂商名称</label><div class=\"col-md-6\"><div class=\"input-group\"><input class=\"form-control\" type=\"text\" name=\"vendor\" ng-model=\"vm.m.vendor\" disabled=\"\"> <span class=\"input-group-addon\"><label class=\"checkbox-label\"><input type=\"checkbox\" ng-model=\"vm.m.with_sms\"> <small>短信通知审批人</small></label></span></div></div></div><div class=\"form-group\"><label class=\"col-md-2 control-label\">资质类型</label><div class=\"col-md-6\"><ui-select name=\"type\" ng-class=\"{\'submitted\':Form.$submitted}\" ng-model=\"vm.m.type\" search-enabled=\"false\" required=\"\"><ui-select-match placeholder=\"选择资质类型...\">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat=\"type in vm.types | filter: $select.search\"><div ng-bind-html=\"type.name | highlight: $select.search\"></div></ui-select-choices></ui-select><div ng-show=\"Form.$submitted||Form.type.$touched\"><span ng-show=\"Form.type.$error.required\" class=\"validation-invalid\">必填项!!</span></div></div></div><div class=\"form-group\"><label class=\"col-md-2 control-label\">资质名称</label><div class=\"col-md-6\"><input class=\"form-control\" type=\"text\" name=\"name\" ng-model=\"vm.m.name\" validator=\"required,maxlen=80\"></div></div><div class=\"form-group\"><label class=\"col-md-2 control-label\">证件号码</label><div class=\"col-md-6\"><input class=\"form-control\" type=\"text\" name=\"code\" ng-model=\"vm.m.code\"></div></div><div class=\"form-group\"><label class=\"col-md-2 control-label\">资质期限</label><div class=\"col-md-6\"><div class=\"row\"><div class=\"col-md-6\"><div class=\"input-group\"><span class=\"input-group-addon\">从</span> <input type=\"text\" class=\"form-control\" uib-datepicker-popup=\"yyyy-MM-dd\" name=\"start_time\" ng-model=\"vm.m.start_time\" is-open=\"opened1\" ng-required=\"true\" ng-click=\"opened1=true\"></div><div ng-show=\"Form.$submitted||Form.start_time.$touched\"><span ng-show=\"Form.start_time.$error.required\" class=\"validation-invalid\">必填项!!</span></div></div><div class=\"col-md-6\"><div class=\"input-group\"><span class=\"input-group-addon\">到</span> <input type=\"text\" class=\"form-control\" uib-datepicker-popup=\"yyyy-MM-dd\" name=\"end_time\" ng-model=\"vm.m.end_time\" placeholder=\"永久\" is-open=\"opened2\" ng-click=\"opened2=true\"></div></div></div></div></div><div class=\"form-group\"><label class=\"col-md-2 control-label\">列表排序</label><div class=\"col-md-6\"><input class=\"form-control\" type=\"text\" input-number=\"\" name=\"sorting\" ng-model=\"vm.m.sorting\" validator=\"required\" placeholder=\"请输入数字\"></div></div><div class=\"form-group\"><label class=\"col-md-2 control-label\">备注</label><div class=\"col-md-6\"><textarea class=\"form-control\" id=\"inputNote\" placeholder=\"200字内...\" maxlength=\"200\" name=\"note\" ng-model=\"vm.m.note\"></textarea></div></div><div class=\"form-group\"><label class=\"col-md-2 control-label\"><button class=\"btn btn-success btn-sm btn-raised\" type=\"file\" name=\"file\" ngf-select=\"vm.upload($file,vm.m,$invalidFiles)\" ngf-max-size=\"100MB\"><span ng-if=\"vm.m.attachments.length==0\">添加附件</span> <span ng-if=\"vm.m.attachments.length>0\">继续添加</span></button></label><div class=\"col-md-6 attachments\"><div ng-if=\"vm.m.attachments.length==0\" class=\"text-muted\">无附件</div><div class=\"attachment\" ng-if=\"vm.m.attachments.length>0\" ng-repeat=\"attachment in vm.m.attachments\"><span class=\"fa fa-paperclip\" ng-class=\"{\'text-muted\':attachment.inProgress}\" ng-bind=\"attachment.name\"></span> <span class=\"text-muted\" ng-show=\"attachment.size\">({{attachment.size|bytes}})</span><div class=\"progress attach-progress\" ng-show=\"attachment.progress>0&&attachment.progress<100\"><div class=\"progress-bar progress-bar-info\" role=\"progressbar\" aria-valuenow=\"{{attachment.progress}}\" aria-valuemin=\"0\" aria-valuemax=\"100\" ng-style=\"{width:attachment.progress+\'%\'}\"></div></div><a ng-show=\"!attachment.inProgress\" ng-click=\"vm.deleteAttachment($index,vm.m)\">删除</a> <a ng-show=\"!attachment.inProgress\" ng-click=\"vm.download(attachment)\">下载</a>&nbsp; <span ng-show=\"attachment.downloading\" class=\"fa fa-circle-o-notch fa-spin text-muted\"></span></div></div></div><div class=\"form-group\"><div class=\"col-md-offset-3 col-md-9\"><div class=\"pull-right\"><button ng-click=\"vm.reset(Form)\" class=\"btn btn-default\"><i class=\"fa fa-refresh\"></i>&nbsp;重置</button><submit-button btn-class=\"btn-info\" btn-click=\"vm.submit(Form,vm.m,5)\">保存草稿</submit-button><submit-button btn-class=\"btn-primary\" btn-click=\"vm.submit(Form,vm.m,1)\">发送申请</submit-button></div></div></div></form></div></div>");
$templateCache.put("app/theme/components/attachmentPreview/attachmentPreview.html","<span><a ng-if=\"type\" ng-click=\"preview()\">预览</a></span>");
$templateCache.put("app/theme/components/baPanel/header.html","<span class=\"panel-title\">{{baPanelTitle}}</span><div class=\"btn-group pull-right\" style=\"margin-top:-6px\"><button class=\"btn btn-info btn-sm\" ng-click=\"vm.download()\">导出</button> <button class=\"btn btn-primary btn-sm\" ng-click=\"vm.add()\">添加</button> <button class=\"btn btn-default btn-sm\" ng-click=\"vm.tableReload()\"><i class=\"fa fa-refresh\"></i></button></div>");
$templateCache.put("app/theme/components/baSidebar/ba-sidebar.html","<aside class=\"al-sidebar\" ng-swipe-right=\"$baSidebarService.setMenuCollapsed(false)\" ng-swipe-left=\"$baSidebarService.setMenuCollapsed(true)\" ng-mouseleave=\"hoverElemTop=selectElemTop\"><ul class=\"al-sidebar-list\" slimscroll=\"{height: \'{{menuHeight}}px\'}\" slimscroll-watch=\"menuHeight\"><li ng-repeat=\"item in ::menuItems\" class=\"al-sidebar-list-item\" ng-class=\"::{\'with-sub-menu\': item.subMenu}\" ui-sref-active=\"selected\" ba-sidebar-toggling-item=\"item\"><a ng-mouseenter=\"hoverItem($event, item)\" ui-state=\"item.stateRef || \'\'\" ng-href=\"{{::(item.fixedHref ? item.fixedHref: \'\')}}\" ng-if=\"::!item.subMenu\" class=\"al-sidebar-list-link\"><i class=\"{{ ::item.icon }}\"></i><span>{{ ::item.title }}</span></a> <a ng-mouseenter=\"hoverItem($event, item)\" ng-if=\"::item.subMenu\" class=\"al-sidebar-list-link\" ba-ui-sref-toggler=\"\"><i class=\"{{ ::item.icon }}\"></i><span>{{ ::item.title }}</span> <b class=\"fa fa-angle-down\" ui-sref-active=\"fa-angle-up\" ng-if=\"::item.subMenu\"></b></a><ul ng-if=\"::item.subMenu\" class=\"al-sidebar-sublist\" ng-class=\"{\'slide-right\': item.slideRight}\" ba-ui-sref-toggling-submenu=\"\"><li ng-repeat=\"subitem in ::item.subMenu\" ng-class=\"::{\'with-sub-menu\': subitem.subMenu}\" ui-sref-active=\"selected\" ba-sidebar-toggling-item=\"subitem\" class=\"ba-sidebar-sublist-item\"><a ng-mouseenter=\"hoverItem($event, item)\" ng-if=\"::subitem.subMenu\" ba-ui-sref-toggler=\"\" class=\"al-sidebar-list-link subitem-submenu-link\"><span>{{ ::subitem.title }}</span> <b class=\"fa\" ng-class=\"{\'fa-angle-up\': subitem.expanded, \'fa-angle-down\': !subitem.expanded}\" ng-if=\"::subitem.subMenu\"></b></a><ul ng-if=\"::subitem.subMenu\" class=\"al-sidebar-sublist subitem-submenu-list\" ng-class=\"{expanded: subitem.expanded, \'slide-right\': subitem.slideRight}\" ba-ui-sref-toggling-submenu=\"\"><li ng-mouseenter=\"hoverItem($event, item)\" ng-repeat=\"subSubitem in ::subitem.subMenu\" ui-sref-active=\"selected\"><a ng-mouseenter=\"hoverItem($event, item)\" href=\"\" ng-if=\"::subSubitem.disabled\" class=\"al-sidebar-list-link\">{{ ::subSubitem.title }}</a> <a ng-mouseenter=\"hoverItem($event, item)\" ui-state=\"subSubitem.stateRef || \'\'\" ng-if=\"::!subSubitem.disabled\" ng-href=\"{{::(subSubitem.fixedHref ? subSubitem.fixedHref: \'\')}}\">{{::subSubitem.title }}</a></li></ul><a ng-mouseenter=\"hoverItem($event, item)\" href=\"\" ng-if=\"::(!subitem.subMenu && subitem.disabled)\" class=\"al-sidebar-list-link\">{{ ::subitem.title }}</a> <a ng-mouseenter=\"hoverItem($event, item)\" target=\"{{::(subitem.blank ? \'_blank\' : \'_self\')}}\" ng-if=\"::(!subitem.subMenu && !subitem.disabled)\" ui-state=\"subitem.stateRef || \'\'\" ng-href=\"{{::(subitem.fixedHref ? subitem.fixedHref: \'\')}}\">{{ ::subitem.title}}</a></li></ul></li></ul><div class=\"sidebar-hover-elem\" ng-style=\"{top: hoverElemTop + \'px\', height: hoverElemHeight + \'px\'}\" ng-class=\"{\'show-hover-elem\': showHoverElem }\"></div></aside>");
$templateCache.put("app/theme/components/baWizard/baWizard.html","<div class=\"ba-wizard\"><div class=\"ba-wizard-navigation-container\"><div ng-repeat=\"t in $baWizardController.tabs\" class=\"ba-wizard-navigation {{$baWizardController.tabNum == $index ? \'active\' : \'\'}}\" ng-click=\"$baWizardController.selectTab($index)\">{{t.title}}</div></div><div class=\"progress ba-wizard-progress\"><div class=\"progress-bar progress-bar-danger active\" role=\"progressbar\" aria-valuemin=\"0\" aria-valuemax=\"100\" ng-style=\"{width: $baWizardController.progress + \'%\'}\"></div></div><div class=\"steps\" ng-transclude=\"\"></div><nav><ul class=\"pager ba-wizard-pager\"><li class=\"previous\"><button ng-disabled=\"$baWizardController.isFirstTab()\" ng-click=\"$baWizardController.previousTab()\" type=\"button\" class=\"btn btn-primary\"><span aria-hidden=\"true\">&larr;</span> previous</button></li><li class=\"next\"><button ng-disabled=\"$baWizardController.isLastTab()\" ng-click=\"$baWizardController.nextTab()\" type=\"button\" class=\"btn btn-primary\">next <span aria-hidden=\"true\">&rarr;</span></button></li></ul></nav></div>");
$templateCache.put("app/theme/components/baWizard/baWizardStep.html","<section ng-show=\"selected\" class=\"step\" ng-transclude=\"\"></section>");
$templateCache.put("app/theme/components/backTop/backTop.html","<i class=\"fa fa-angle-up back-top\" id=\"backTop\" title=\"回到顶部\"></i>");
$templateCache.put("app/theme/components/contentTop/contentTop.html","<div class=\"content-top clearfix\"><h1 class=\"al-title\"><span ncy-breadcrumb-last=\"\"></span></h1><div class=\"al-breadcrumb\" ncy-breadcrumb=\"\"></div></div>");
$templateCache.put("app/theme/components/csmbSelect/csmbSelect.html","<div class=\"csmb-select\" ng-click=\"touch()\"><ui-select fix-focus-on-touch=\"\" ng-model=\"model\" title=\"请输入名称/型号查询...\" on-select=\"onSelectItem(model)\" spinner-enabled=\"true\"><ui-select-match placeholder=\"请输入名称/型号查询...\">{{$select.selected.name!=\'\'?$select.selected.name:$select.selected.c_name}}&lt;{{$select.selected.spec}}&gt;</ui-select-match><ui-select-choices repeat=\"csmb in csmbs\" ui-disable-choice=\"csmb.action\" refresh=\"refreshCsmbs($select)\" refresh-delay=\"500\" position=\"down\"><div ng-if=\"csmb.action\" class=\"clearfix\" style=\"border-bottom: solid 1px darkgray\"><uib-pagination total-items=\"pager.total\" ng-model=\"pager.page\" items-per-page=\"pager.count\" ng-if=\"pager.total>pager.count\" force-ellipses=\"true\" class=\"pagination-sm\" style=\"margin-bottom: 0; margin-top: 0\" max-size=\"3\" previous-text=\"&lsaquo;\" next-text=\"&rsaquo;\" first-text=\"&laquo;\" last-text=\"&raquo;\" ng-change=\"pageChanged()\"></uib-pagination><div ng-show=\"queryStr\"><small style=\"display: inline-block; color: #333\"><i class=\"fa fa-filter\">过滤：</i> {{queryStr}} <button type=\"button\" class=\"close\" style=\"margin-left: 6px;margin-top: -4px;\" ng-click=\"clearQuery()\">&times;</button></small></div></div><span ng-if=\"!csmb.action\" ng-bind-html=\"csmb.name!=\'\'?csmb.name:csmb.c_name | highlight: $select.search\"></span> <small ng-if=\"!csmb.action\">&lt;{{csmb.spec}}&gt;</small> <strong ng-if=\"csmbs.length==1\">暂无相关数据</strong></ui-select-choices></ui-select></div>");
$templateCache.put("app/theme/components/csmbSelect/csmbsSelect.html","<div class=\"csmbs-select\" ng-click=\"touch()\"><ui-select multiple=\"\" fix-focus-on-touch=\"\" close-on-select=\"false\" ng-disabled=\"disabled\" reset-search-input=\"{{!queryStr}}\" ng-model=\"m.selected\" title=\"请输入名称/型号查询...\" on-select=\"onSelectItem($item,m.selected)\" on-remove=\"onRemoveItem($item,m.selected)\" spinner-enabled=\"true\"><ui-select-match placeholder=\"请输入名称/型号查询...\">{{$item.name!=\'\'?$item.name:$item.c_name}}&lt;{{$item.spec}}&gt;</ui-select-match><ui-select-choices repeat=\"csmb in csmbs track by csmb.id\" ui-disable-choice=\"csmb.action||csmb.hide\" refresh=\"refreshCsmbs($select)\" refresh-delay=\"500\" position=\"down\"><div ng-if=\"csmb.action\" class=\"clearfix\" style=\"border-bottom: solid 1px darkgray\"><uib-pagination total-items=\"pager.total\" ng-model=\"pager.page\" items-per-page=\"pager.count\" ng-if=\"pager.total>pager.count\" force-ellipses=\"true\" class=\"pagination-sm\" style=\"margin-bottom: 0; margin-top: 0\" max-size=\"3\" previous-text=\"&lsaquo;\" next-text=\"&rsaquo;\" first-text=\"&laquo;\" last-text=\"&raquo;\" ng-change=\"pageChanged()\"></uib-pagination><div ng-if=\"queryStr\"><small style=\"display: inline-block; color: #333\"><i class=\"fa fa-filter\">过滤：</i> {{queryStr}} <button type=\"button\" class=\"close\" style=\"margin-left: 6px;margin-top: -4px;\" ng-click=\"clearQuery()\">&times;</button></small></div></div><span ng-if=\"!csmb.action\" ng-bind-html=\"csmb.name!=\'\'?csmb.name:csmb.c_name | highlight: $select.search\"></span> <small ng-if=\"!csmb.action\">&lt;{{csmb.spec}}&gt;</small> <small ng-if=\"!csmb.action&&csmb.hide\" class=\"text-danger\">已存在</small> <strong ng-if=\"csmbs.length==1\">暂无相关数据</strong></ui-select-choices></ui-select></div>");
$templateCache.put("app/theme/components/csmbSelect/cvSelect.html","<div class=\"csmb-select\" ng-click=\"touch()\"><ui-select fix-focus-on-touch=\"\" ng-model=\"model\" title=\"请输入名称查询...\" on-select=\"onSelectItem(model)\" spinner-enabled=\"true\"><ui-select-match placeholder=\"请输入名称查询...\">{{$select.selected.name}}{{$select.selected.c_name?(\'(\'+$select.selected.c_name+\')\'):\'\'}}</ui-select-match><ui-select-choices repeat=\"csmb in csmbs\" ui-disable-choice=\"csmb.action\" refresh=\"refreshCsmbs($select)\" refresh-delay=\"500\" position=\"down\"><div ng-if=\"csmb.action\" class=\"clearfix\" style=\"border-bottom: solid 1px darkgray\"><uib-pagination total-items=\"pager.total\" ng-model=\"pager.page\" items-per-page=\"pager.count\" ng-if=\"pager.total>pager.count\" force-ellipses=\"true\" class=\"pagination-sm\" style=\"margin-bottom: 0; margin-top: 0\" max-size=\"3\" previous-text=\"&lsaquo;\" next-text=\"&rsaquo;\" first-text=\"&laquo;\" last-text=\"&raquo;\" ng-change=\"pageChanged()\"></uib-pagination><div ng-show=\"queryStr\"><small style=\"display: inline-block; color: #333\"><i class=\"fa fa-filter\">过滤：</i> {{queryStr}} <button type=\"button\" class=\"close\" style=\"margin-left: 6px;margin-top: -4px;\" ng-click=\"clearQuery()\">&times;</button></small></div></div><span ng-if=\"!csmb.action\" ng-bind-html=\"csmb.name+(csmb.c_name?(\'(\'+csmb.c_name+\')\'):\'\') | highlight: $select.search\"></span> <strong ng-if=\"csmbs.length==1\">暂无相关数据</strong></ui-select-choices></ui-select></div>");
$templateCache.put("app/theme/components/csmbSelect/cvsSelect.html","<div class=\"csmbs-select\" ng-click=\"touch()\"><ui-select multiple=\"\" fix-focus-on-touch=\"\" close-on-select=\"false\" ng-disabled=\"disabled\" reset-search-input=\"{{!queryStr}}\" ng-model=\"m.selected\" title=\"请输入名称查询...\" on-select=\"onSelectItem($item,m.selected)\" on-remove=\"onRemoveItem($item,m.selected)\" spinner-enabled=\"true\"><ui-select-match placeholder=\"请输入名称查询...\">{{$item.name}}{{$item.c_name?(\'(\'+$item.c_name+\')\'):\'\'}}</ui-select-match><ui-select-choices repeat=\"csmb in csmbs track by csmb.id\" ui-disable-choice=\"csmb.action||csmb.hide\" refresh=\"refreshCsmbs($select)\" refresh-delay=\"500\" position=\"down\"><div ng-if=\"csmb.action\" class=\"clearfix\" style=\"border-bottom: solid 1px darkgray\"><uib-pagination total-items=\"pager.total\" ng-model=\"pager.page\" items-per-page=\"pager.count\" ng-if=\"pager.total>pager.count\" force-ellipses=\"true\" class=\"pagination-sm\" style=\"margin-bottom: 0; margin-top: 0\" max-size=\"3\" previous-text=\"&lsaquo;\" next-text=\"&rsaquo;\" first-text=\"&laquo;\" last-text=\"&raquo;\" ng-change=\"pageChanged()\"></uib-pagination><div ng-if=\"queryStr\"><small style=\"display: inline-block; color: #333\"><i class=\"fa fa-filter\">过滤：</i> {{queryStr}} <button type=\"button\" class=\"close\" style=\"margin-left: 6px;margin-top: -4px;\" ng-click=\"clearQuery()\">&times;</button></small></div></div><span ng-if=\"!csmb.action\" ng-bind-html=\"csmb.name+(csmb.c_name?(\'(\'+csmb.c_name+\')\'):\'\') | highlight: $select.search\"></span> <small ng-if=\"!csmb.action&&csmb.hide\" class=\"text-danger\">已存在</small> <strong ng-if=\"csmbs.length==1\">暂无相关数据</strong></ui-select-choices></ui-select></div>");
$templateCache.put("app/theme/components/msgCenter/msgCenter.html","<ul class=\"al-msg-center clearfix\"><li uib-dropdown=\"\"><a href=\"\" uib-dropdown-toggle=\"\"><i class=\"fa fa-bell-o\"></i><span>5</span><div class=\"notification-ring\"></div></a><div uib-dropdown-menu=\"\" class=\"top-dropdown-menu\"><i class=\"dropdown-arr\"></i><div class=\"header clearfix\"><strong>Notifications</strong> <a href=\"\">Mark All as Read</a> <a href=\"\">Settings</a></div><div class=\"msg-list\"><a href=\"\" class=\"clearfix\" ng-repeat=\"msg in notifications\"><div class=\"img-area\"><img ng-class=\"{\'photo-msg-item\' : !msg.image}\" ng-src=\"{{::( msg.image || (users[msg.userId].name | profilePicture) )}}\"></div><div class=\"msg-area\"><div ng-bind-html=\"getMessage(msg)\"></div><span>{{ msg.time }}</span></div></a></div><a href=\"\">See all notifications</a></div></li><li uib-dropdown=\"\"><a href=\"\" class=\"msg\" uib-dropdown-toggle=\"\"><i class=\"fa fa-envelope-o\"></i><span>5</span><div class=\"notification-ring\"></div></a><div uib-dropdown-menu=\"\" class=\"top-dropdown-menu\"><i class=\"dropdown-arr\"></i><div class=\"header clearfix\"><strong>Messages</strong> <a href=\"\">Mark All as Read</a> <a href=\"\">Settings</a></div><div class=\"msg-list\"><a href=\"\" class=\"clearfix\" ng-repeat=\"msg in messages\"><div class=\"img-area\"><img class=\"photo-msg-item\" ng-src=\"{{::( users[msg.userId].name | profilePicture )}}\"></div><div class=\"msg-area\"><div>{{ msg.text }}</div><span>{{ msg.time }}</span></div></a></div><a href=\"\">See all messages</a></div></li></ul>");
$templateCache.put("app/theme/components/pageTop/pageTop.html","<div class=\"page-top clearfix\" scroll-position=\"scrolled\" max-height=\"50\" ng-class=\"{\'scrolled\': scrolled}\"><a href=\"#/dashboard\" class=\"al-logo clearfix hidden-sm hidden-xs\"><span>成办医院</span>经销商平台&nbsp;<small>{{::vm.vendor}}</small></a> <a href=\"\" class=\"collapse-menu-link fa fa-bars\" ba-sidebar-toggle-menu=\"\"></a><div class=\"user-profile clearfix\"><div class=\"al-user-profile\" uib-dropdown=\"\"><a uib-dropdown-toggle=\"\" class=\"profile-toggle-link\"><img ng-src=\"/vendor/assets/img/profile/somebody.png\"></a><ul class=\"top-dropdown-menu profile-dropdown\" uib-dropdown-menu=\"\"><li><i class=\"dropdown-arr\"></i></li><li><a ui-sref=\"main.info\"><i class=\"fa fa-user\"></i>用户资料</a></li><li><a href=\"\" class=\"signout\" ng-click=\"vm.logout()\"><i class=\"fa fa-power-off\"></i>注销</a></li></ul></div></div></div>");
$templateCache.put("app/theme/components/pdf/viewer.html","<div class=\"pdf-controls\"><div class=\"toolbar\"><div class=\"btn-group toolbarLeft\"><span>页面:</span> <input class=\"input-sm form-control-36\" input-number=\"\" ng-model=\"pageNum\"> <span>/ {{pageCount}}</span></div><div class=\"outerCenter\"><div class=\"btn-group innerCenter\"><button class=\"btn btn-sm btn-default\" ng-click=\"zoomOut()\"><i class=\"fa fa-minus fa-fw\"></i></button> <button class=\"btn btn-sm btn-default\" ng-click=\"zoomIn()\"><i class=\"fa fa-plus fa-fw\"></i></button> <button class=\"btn btn-sm btn-default\" ng-click=\"fit()\">适应页面</button></div></div></div></div><div ng-if=\"loading\" class=\"loading-icon text-aqua\" style=\"top:50%\"><span class=\"fa fa-spinner fa-pulse fa-4x\"></span></div><div class=\"text-center pdf-viewer\"><abbr class=\"prev-page\"><i class=\"fa fa-arrow-left fa-4x\" ng-click=\"goPrevious()\"></i></abbr> <abbr class=\"next-page\"><i class=\"fa fa-arrow-right fa-4x\" ng-click=\"goNext()\"></i></abbr><canvas id=\"pdf\" class=\"rotate0\"></canvas></div><div class=\"pdf-controls\"><div class=\"toolbar\"><div class=\"btn-group toolbarLeft\"><span>页面:</span> <input class=\"input-sm form-control-36\" input-number=\"\" ng-model=\"pageNum\"> <span>/ {{pageCount}}</span></div><div class=\"outerCenter\"><div class=\"btn-group innerCenter\"><button class=\"btn btn-sm btn-default\" ng-click=\"zoomOut()\"><i class=\"fa fa-minus fa-fw\"></i></button> <button class=\"btn btn-sm btn-default\" ng-click=\"zoomIn()\"><i class=\"fa fa-plus fa-fw\"></i></button> <button class=\"btn btn-sm btn-default\" ng-click=\"fit()\">适应页面</button></div></div></div></div><br>");
$templateCache.put("app/theme/components/table/batch_header.html","<tr><th width=\"{{vm.cbWidth}}\"><label class=\"custom-checkbox nowrap\"><input ng-model=\"vm.header.checkAll\" type=\"checkbox\" ng-change=\"vm.checkAllFn(vm.header.checkAll,$data)\"> <span></span></label></th><th ng-if=\"::vm.switchSpot\" ng-repeat=\"col in vm.cols\" ng-show=\"col.show\" width=\"{{::col.width}}\" class=\"text-left\" ng-class=\"{\'sortable\': col.sortable, \'sort-asc\': vm.tableParams.isSortBy(col.sortable, \'asc\'), \'sort-desc\': vm.tableParams.isSortBy(col.sortable, \'desc\')}\" ng-click=\"col.sortable ? vm.tableParams.sorting(col.sortable, vm.tableParams.isSortBy(col.sortable, \'asc\') ? \'desc\' : \'asc\') : \'\';\"><div ng-bind=\"col.title\" ng-class=\"\'sort-indicator\'\"></div></th><th class=\"text-center\" width=\"{{::vm.optColWidth}}\" ng-if=\"!vm.hideOpt\">操作</th><th ng-if=\"!vm.switchSpot\" ng-repeat=\"col in vm.cols\" ng-show=\"col.show\" width=\"{{::col.width}}\" class=\"text-left\" ng-class=\"{\'sortable\': col.sortable, \'sort-asc\': vm.tableParams.isSortBy(col.sortable, \'asc\'), \'sort-desc\': vm.tableParams.isSortBy(col.sortable, \'desc\')}\" ng-click=\"col.sortable ? vm.tableParams.sorting(col.sortable, vm.tableParams.isSortBy(col.sortable, \'asc\') ? \'desc\' : \'asc\') : \'\';\"><div ng-bind=\"col.title\" ng-class=\"\'sort-indicator\'\"></div></th></tr><tr ng-if=\"!vm.hideFilter\"><th class=\"text-center\"><span class=\"fa-stack\" uib-tooltip=\"该行用来设置各种筛选条件!\" tooltip-class=\"tooltipInfo\" tooltip-append-to-body=\"true\"><i class=\"fa fa-filter\"></i></span></th><th ng-if=\"!vm.hideOpt&&!vm.switchSpot\"><button ng-click=\"vm.clearFilters()\" class=\"btn btn-default btn-block btn-sm\" style=\"height:34px;\" uib-tooltip=\"清除所有筛选条件！\" tooltip-class=\"tooltipInfo\" tooltip-append-to-body=\"true\"><span class=\"fa-stack\"><i class=\"fa fa-filter\"></i> <i class=\"fa fa-ban fa-stack-2x text-danger\"></i></span></button></th><th ng-repeat=\"col in vm.cols\" ng-show=\"col.show\" class=\"text-left\"><div ng-repeat=\"(name, filter) in col.filter\"><div ng-include=\"\'app/theme/components/table/filters/\' + filter + \'.html\'\"></div></div></th><th class=\"text-right\" ng-if=\"!vm.hideOpt&&vm.switchSpot\"><button ng-click=\"vm.clearFilters()\" class=\"btn btn-default btn-block btn-sm\" style=\"height: 34px;\" uib-tooltip=\"清除所有筛选条件!\" tooltip-class=\"tooltipInfo\"><span class=\"fa-stack\"><i class=\"fa fa-filter\"></i> <i class=\"fa fa-ban fa-stack-2x text-danger\"></i></span></button></th></tr>");
$templateCache.put("app/theme/components/table/header.html","<tr><th class=\"text-left\" width=\"50\" ng-if=\"vm.showSn\">序号</th><th ng-if=\"::vm.switchSpot\" ng-repeat=\"col in vm.cols\" ng-show=\"col.show\" width=\"{{::col.width}}\" class=\"text-left\" ng-class=\"{\'sortable\': col.sortable, \'sort-asc\': vm.tableParams.isSortBy(col.sortable, \'asc\'), \'sort-desc\': vm.tableParams.isSortBy(col.sortable, \'desc\')}\" ng-click=\"col.sortable ? vm.tableParams.sorting(col.sortable, vm.tableParams.isSortBy(col.sortable, \'asc\') ? \'desc\' : \'asc\') : \'\';\"><div ng-bind=\"col.title\" ng-class=\"\'sort-indicator\'\"></div></th><th class=\"text-center\" width=\"{{::vm.optColWidth}}\" ng-if=\"!vm.hideOpt\">操作</th><th ng-if=\"!vm.switchSpot\" ng-repeat=\"col in vm.cols\" ng-show=\"col.show\" width=\"{{::col.width}}\" class=\"text-left\" ng-class=\"{\'sortable\': col.sortable, \'sort-asc\': vm.tableParams.isSortBy(col.sortable, \'asc\'), \'sort-desc\': vm.tableParams.isSortBy(col.sortable, \'desc\')}\" ng-click=\"col.sortable ? vm.tableParams.sorting(col.sortable, vm.tableParams.isSortBy(col.sortable, \'asc\') ? \'desc\' : \'asc\') : \'\';\"><div ng-bind=\"col.title\" ng-class=\"\'sort-indicator\'\"></div></th></tr><tr ng-if=\"!vm.hideFilter\"><th class=\"text-left\" ng-if=\"vm.showSn\"><span class=\"fa-stack\" tooltip=\"该行用来设置各种筛选条件！\" tooltip-class=\"tooltipInfo\" tooltip-append-to-body=\"true\"><i class=\"fa fa-filter\"></i></span></th><th ng-if=\"!vm.hideOpt&&!vm.switchSpot\"><button ng-click=\"vm.clearFilters()\" class=\"btn btn-default btn-block btn-sm\" style=\"height:34px;\" uib-tooltip=\"清除所有筛选条件！\" tooltip-class=\"tooltipInfo\" tooltip-append-to-body=\"true\"><span class=\"fa-stack\"><i class=\"fa fa-filter\"></i> <i class=\"fa fa-ban fa-stack-2x text-danger\"></i></span></button></th><th ng-repeat=\"col in vm.cols\" ng-show=\"col.show\" class=\"text-left\"><div ng-repeat=\"(name, filter) in col.filter\"><div ng-include=\"\'app/theme/components/table/filters/\' + filter + \'.html\'\"></div></div></th><th ng-if=\"!vm.hideOpt&&vm.switchSpot\"><button ng-click=\"vm.clearFilters()\" class=\"btn btn-default btn-block btn-sm\" style=\"height:34px;\" uib-tooltip=\"清除所有筛选条件！\" tooltip-class=\"tooltipInfo\" tooltip-append-to-body=\"true\"><span class=\"fa-stack\"><i class=\"fa fa-filter\"></i> <i class=\"fa fa-ban fa-stack-2x text-danger\"></i></span></button></th></tr>");
$templateCache.put("app/theme/components/widgets/widgets.html","<div class=\"widgets\"><div ng-repeat=\"widgetBlock in ngModel\" ng-class=\"{\'row\': widgetBlock.widgets.length > 1}\"><div ng-repeat=\"widgetCol in widgetBlock.widgets\" ng-class=\"{\'col-md-6\': widgetBlock.widgets.length === 2}\" ng-model=\"widgetCol\" class=\"widgets-block\"><div ba-panel=\"\" ba-panel-title=\"{{::widget.title}}\" ng-repeat=\"widget in widgetCol\" ba-panel-class=\"with-scroll {{widget.panelClass}}\"><div ng-include=\"widget.url\"></div></div></div></div></div>");
$templateCache.put("app/pages/csmbs/direct/approval/approval.html","<div ba-panel=\"\" ba-panel-class=\"light-text tab-content-panel\" ba-panel-header=\"\" hide-add-btn=\"true\" ba-panel-title=\"<span ncy-breadcrumb-last></span>列表\"><table-option-tab ng-model=\"vm.roomId\" options=\"vm.rooms\" tag-title=\"申请库房\" filter-name=\"room_id\"></table-option-tab><div class=\"order-number-query\"><a class=\"font-sm\" ng-click=\"vm.tableParams.openNumberQuery=true\">按单号查询</a> <input type=\"text\" focus-me=\"vm.tableParams.openNumberQuery\" ng-model=\"vm.tableParams.filter()[\'number\']\"></div><label class=\"cb-label-wrapper\" ng-if=\"vm.tableParams.filter()[\'item\']\"><checkbox ng-model=\"vm.hideSub\" ng-change=\"vm.changeHide(vm.items,vm.tableParams.filter()[\'item\'])\"></checkbox><strong>隐藏其余筛选子项</strong></label><div class=\"table-responsive min-h418\" loading-container=\"vm.tableParams.settings().$loading\"><table class=\"table table-hover table-row-clicked\" ng-table=\"vm.tableParams\" template-header=\"app/theme/components/table/header.html\"><tr ng-repeat-start=\"row in $data track by row.id\" ng-click=\"row.showDetail=!row.showDetail\"><td ng-click=\"$event.stopPropagation()\"><button type=\"button\" class=\"btn btn-default btn-xs\" style=\"margin-right:2px\" ng-if=\"row.op==1\" ng-click=\"row.showDetail=!row.showDetail\"><i class=\"glyphicon glyphicon-chevron-down\" ng-if=\"!row.showDetail\"></i> <i class=\"glyphicon glyphicon-chevron-up\" ng-if=\"row.showDetail\"></i></button> <button class=\"btn btn-primary btn-xs\" ng-click=\"vm.pass(row)\"><i class=\"fa fa-edit\"></i></button></td><td ng-repeat=\"col in vm.cols\" ng-switch=\"col.field\" ng-if=\"col.show\"><span ng-switch-when=\"created_at\">{{row[col.field].date}}</span><div ng-switch-when=\"application_items\"><span ng-if=\"row.number\">单号:{{row.number}}</span> <span class=\"tag tag-danger\" title=\"加急\" ng-show=\"row[\'is_urgent\']==1\">急</span> <span class=\"tag tag-danger\" title=\"手术耗材\" ng-show=\"row[\'op\']==1\">手术耗材</span><table class=\"table table-bordered table-condensed\"><tbody><tr ng-repeat=\"i in row[col.field]\" ng-hide=\"i.hide||i.diff_num==0\" ng-if=\"row.expand||$index<4\"><td>{{i.consumable.name!=\'\'?i.consumable.name:i.consumable.c_name}} <span class=\"badge bulletin-subject-col\">{{i.consumable.spec}}</span> <span class=\"text-danger\" ng-bind=\"i.diff_num+i.consumable.storage_unit\"></span></td><td>{{i.consumable.producer?i.consumable.producer.name:\'暂无生产商\'}}</td></tr></tbody></table><a class=\"pull-right\" ng-if=\"row[col.field].length>4\" ng-click=\"row.expand=!row.expand\"><span ng-if=\"row.expand\" class=\"fa fa-chevron-up\">收起</span> <span ng-if=\"!row.expand\" class=\"fa fa-chevron-down\">展开剩余{{row[col.field].length-4}}项...</span></a></div><span ng-switch-default=\"\">{{row[col.field].name}}</span></td></tr><tr ng-repeat-end=\"\" ng-if=\"row.showDetail&&row.op==1\" class=\"bg-gray-light\"><td colspan=\"99\"><table class=\"table table-bordered table-condensed\" style=\"margin-bottom:0\"><thead><tr><th>上台主刀医生</th><th>病人姓名</th><th>性别</th><th>年龄</th><th>住院号</th><th>床号</th><th>手术名称</th><th>手术日期</th><th>诊断</th></tr></thead><tbody><tr ng-repeat=\"item in row.info track by item.id\"><td>{{item.doctor?item.doctor:\'未填写\'}} <small class=\"tag tag-info\" ng-bind=\"item.is_out==\'1\'?\'院外\':\'院内\'\" ng-if=\"item.doctor\"></small></td><td>{{item.name}}</td><td>{{item.sex==\'1\'?\'男\':\'女\'}}</td><td>{{item.age}}</td><td>{{item.no}}</td><td>{{item.bed}}</td><td>{{item.title}}</td><td>{{item.time.substr(0, 10)}}</td><td>{{item.diagnosis}}</td></tr></tbody></table></td></tr><tr ng-if=\"!vm.tableParams.settings().$loading&&($data==null||$data.length==0)\" class=\"table-no-data\"><td colspan=\"99\" align=\"center\"><span>暂无数据</span></td></tr></table></div></div>");
$templateCache.put("app/pages/csmbs/direct/approved/approved.html","<div ba-panel=\"\" ba-panel-class=\"light-text tab-content-panel\" ba-panel-header=\"\" hide-add-btn=\"true\" ba-panel-title=\"<span ncy-breadcrumb-last></span>列表\"><table-option-tab ng-model=\"vm.roomId\" options=\"vm.rooms\" filter-name=\"room_id\" tag-title=\"申请库房\"></table-option-tab><div class=\"order-number-query\"><a class=\"font-sm\" ng-click=\"vm.tableParams.openNumberQuery=true\">按单号查询</a> <input type=\"text\" focus-me=\"vm.tableParams.openNumberQuery\" ng-model=\"vm.tableParams.filter()[\'number\']\"></div><label class=\"cb-label-wrapper\" ng-if=\"vm.tableParams.filter()[\'item\']\"><checkbox ng-model=\"vm.hideSub\" ng-change=\"vm.changeHide(vm.items,vm.tableParams.filter()[\'item\'])\"></checkbox><strong>隐藏其余筛选子项</strong></label><div class=\"table-responsive\" loading-container=\"vm.tableParams.settings().$loading\"><table class=\"table table-hover table-row-clicked\" ng-table=\"vm.tableParams\" template-header=\"app/theme/components/table/header.html\"><tr ng-repeat-start=\"row in $data track by row.id\" ng-click=\"row.showDetail=!row.showDetail\"><td ng-click=\"$event.stopPropagation()\"><button type=\"button\" class=\"btn btn-default btn-xs\" style=\"margin-right:2px\" ng-if=\"row.op==1\" ng-click=\"row.showDetail=!row.showDetail\"><i class=\"glyphicon glyphicon-chevron-down\" ng-if=\"!row.showDetail\"></i> <i class=\"glyphicon glyphicon-chevron-up\" ng-if=\"row.showDetail\"></i></button> <button class=\"btn btn-primary btn-xs\" uib-tooltip=\"发货批次\" tooltip-class=\"tooltipInfo\" tooltip-append-to-body=\"true\" ng-click=\"vm.batch(row)\"><i class=\"fa fa-stack-overflow\"></i></button> <button class=\"btn btn-danger btn-xs\" uib-tooltip=\"撤销发货\" tooltip-class=\"tooltipInfo\" ng-if=\"row.state.id==10||row.state.id==14\" ng-click=\"vm.back(row)\"><i class=\"fa fa-reply\"></i></button></td><td ng-repeat=\"col in vm.cols\" ng-switch=\"col.field\" ng-if=\"col.show\"><span ng-switch-when=\"created_at\">{{row[col.field].date}}</span> <span ng-switch-when=\"handle_time\">{{row[col.field]}}</span><div ng-switch-when=\"application_items\"><span ng-if=\"row.number\">单号:{{row.number}}</span> <span class=\"tag tag-danger\" title=\"加急\" ng-show=\"row[\'is_urgent\']==1\">急</span> <span class=\"tag tag-danger\" title=\"手术耗材\" ng-show=\"row[\'op\']==1\">手术耗材</span><table class=\"table table-bordered table-condensed\"><tbody><tr ng-repeat=\"i in row[col.field]\" ng-hide=\"i.hide\" ng-if=\"row.expand||$index<4\"><td>{{i.consumable.name!=\'\'?i.consumable.name:i.consumable.c_name}} <span class=\"badge bulletin-subject-col\">{{i.consumable.spec}}</span> <span class=\"text-danger\" ng-bind=\"i.num+i.consumable.storage_unit\"></span></td><td>{{i.consumable.producer?i.consumable.producer.name:\'暂无生产商\'}}</td></tr></tbody></table><a class=\"pull-right\" ng-if=\"row[col.field].length>4\" ng-click=\"row.expand=!row.expand\"><span ng-if=\"row.expand\" class=\"fa fa-chevron-up\">收起</span> <span ng-if=\"!row.expand\" class=\"fa fa-chevron-down\">展开剩余{{row[col.field].length-4}}项...</span></a></div><span ng-switch-default=\"\">{{row[col.field].name}}</span></td></tr><tr ng-repeat-end=\"\" ng-if=\"row.showDetail&&row.op==1\" class=\"bg-gray-light\"><td colspan=\"99\"><table class=\"table table-bordered table-condensed\" style=\"margin-bottom:0\"><thead><tr><th>上台主刀医生</th><th>病人姓名</th><th>性别</th><th>年龄</th><th>住院号</th><th>床号</th><th>手术名称</th><th>手术日期</th><th>诊断</th></tr></thead><tbody><tr ng-repeat=\"item in row.info track by item.id\"><td>{{item.doctor?item.doctor:\'未填写\'}} <small class=\"tag tag-info\" ng-bind=\"item.is_out==\'1\'?\'院外\':\'院内\'\" ng-if=\"item.doctor\"></small></td><td>{{item.name}}</td><td>{{item.sex==\'1\'?\'男\':\'女\'}}</td><td>{{item.age}}</td><td>{{item.no}}</td><td>{{item.bed}}</td><td>{{item.title}}</td><td>{{item.time.substr(0, 10)}}</td><td>{{item.diagnosis}}</td></tr></tbody></table></td></tr><tr ng-if=\"!vm.tableParams.settings().$loading&&($data==null||$data.length==0)\" class=\"table-no-data\"><td colspan=\"99\" align=\"center\"><span>暂无数据</span></td></tr></table></div></div>");
$templateCache.put("app/pages/csmbs/direct/returned/approved.html","<div ba-panel=\"\" ba-panel-class=\"light-text tab-content-panel\" ba-panel-header=\"\" hide-add-btn=\"true\" ba-panel-title=\"<span ncy-breadcrumb-last></span>列表\"><table-option-tab ng-model=\"vm.roomId\" options=\"vm.rooms\" tag-title=\"退货库房\" filter-name=\"room_id\"></table-option-tab><label class=\"cb-label-wrapper\" ng-if=\"vm.tableParams.filter()[\'item\']\"><checkbox ng-model=\"vm.hideSub\" ng-change=\"vm.changeHide(vm.items,vm.tableParams.filter()[\'item\'])\"></checkbox><strong>隐藏其余筛选子项</strong></label><div class=\"table-responsive\" loading-container=\"vm.tableParams.settings().$loading\"><table class=\"table table-hover table-row-clicked\" ng-table=\"vm.tableParams\" template-header=\"app/theme/components/table/header.html\"><tr ng-repeat-start=\"row in $data track by row.id\"><td><button type=\"button\" class=\"btn btn-default btn-xs\" ng-click=\"row.showDetail=!row.showDetail\"><i class=\"fa fa-chevron-down\" ng-hide=\"row.showDetail\"></i> <i class=\"fa fa-chevron-up\" ng-show=\"row.showDetail\"></i></button></td><td ng-repeat=\"col in vm.cols\" ng-switch=\"col.field\" ng-if=\"col.show\"><div ng-switch-when=\"created_at\">{{row[col.field]}}</div><div ng-switch-when=\"itemDesc\"><table class=\"table table-bordered table-condensed\"><tbody><tr ng-repeat=\"i in row[col.field]\" ng-hide=\"i.hide\" ng-if=\"row.expand||$index<4\"><td>{{i.consumable.name!=\'\'?i.consumable.name:i.consumable.c_name}} <span class=\"badge bulletin-subject-col\">{{i.consumable.spec}}</span> <span class=\"text-danger\" ng-bind=\"i.num+(row.for_purchase==\'1\'?i.consumable.purchase_unit:i.consumable.storage_unit)\"></span></td><td>{{i.consumable.producer?i.consumable.producer.name:\'暂无生产商\'}}</td></tr></tbody></table><a class=\"pull-right\" ng-if=\"row[col.field].length>4\" ng-click=\"row.expand=!row.expand\"><span ng-if=\"row.expand\" class=\"fa fa-chevron-up\">收起</span> <span ng-if=\"!row.expand\" class=\"fa fa-chevron-down\">展开剩余{{row[col.field].length-4}}项...</span></a></div><div ng-switch-default=\"\">{{row[col.field].name}}</div></td></tr><tr ng-repeat-end=\"\" ng-if=\"row.showDetail\" class=\"bg-gray-light\"><td colspan=\"99\"><table class=\"table table-hover\"><tbody><tr><td>库房审批意见：<span ng-bind=\"row.storeroom_opinion?row.storeroom_opinion:\'暂无\'\"></span></td></tr><tr><td>库房确认时间：<span ng-bind=\"row.storeroom_confirmed_time\"></span></td></tr><tr><td>经销商审批意见：<span ng-bind=\"row.vendor_opinion?row.vendor_opinion:\'暂无\'\"></span></td></tr><tr><td>经销商审批时间：<span ng-bind=\"row.vendor_confirmed_time\"></span></td></tr><tr><td>备注：<span ng-bind=\"row.note?row.note:\'暂无\'\"></span></td></tr><tr><td><table class=\"table table-bordered table-condensed\" style=\"margin-bottom:0\"><thead><tr><th>耗材</th><th>规格型号</th><th>单位</th><th>批次</th><th>经销商批次</th><th>进价</th><th>数量</th><th>合计</th></tr></thead><tbody><tr ng-repeat=\"item in row.application_items track by item.id\"><td>{{item.consumable.name!=\'\'?item.consumable.name:item.consumable.c_name}}</td><td>{{item.consumable.spec}}</td><td><span ng-if=\"item.consumable.purchase_unit!=item.consumable.storage_unit\">每{{item.consumable.purchase_unit}}{{item.consumable.storage_num}}{{item.consumable.storage_unit}}</span> <span ng-if=\"item.consumable.storage_unit!=item.consumable.use_unit\">每{{item.consumable.storage_unit}}{{item.consumable.use_num}}{{item.consumable.use_unit}}</span> <span ng-if=\"(item.consumable.purchase_unit==item.consumable.storage_unit)&&(item.consumable.storage_unit==item.consumable.use_unit)\">{{item.consumable.storage_unit}}</span></td><td>{{item.batch.sn}}</td><td>{{item.batch.no}}</td><td>{{item.batch.purchase_price}}/{{item.consumable.use_unit}}</td><td>{{item.num}}{{item.consumable.storage_unit}}</td><td>{{item.total}}</td></tr><tr><td colspan=\"7\">总计</td><td ng-bind=\"row.total\"></td></tr></tbody></table></td></tr><tr ng-if=\"!tableParams.settings().$loading&&($data==null||$data.length==0)\" height=\"160px\"><td colspan=\"99\" align=\"center\" style=\"vertical-align:middle\"><span class=\"table-no-data\">暂无数据</span></td></tr></tbody></table></td></tr><tr ng-if=\"!vm.tableParams.settings().$loading&&($data==null||$data.length==0)\" class=\"table-no-data\"><td colspan=\"99\" align=\"center\"><span>暂无数据</span></td></tr></table></div></div>");
$templateCache.put("app/pages/csmbs/direct/temporary/temporary.html","<script type=\"text/ng-template\" id=\"CsmbLargeImgDlg.html\"><div fullscreen=\"isFullscreen\"> <div class=\"modal-header dialog-header-confirm\"> <button type=\"button\" class=\"close\" ng-click=\"vm.cancel()\">&times;</button> <button type=\"button\" class=\"close\" ng-click=\"isFullscreen=!isFullscreen\" style=\"padding-right:6px\"> <i class=\"fa fa-square-o\"></i></button> <h4 class=\"modal-title\"> <i class=\"fa fa-photo\"></i>&nbsp;耗材图片 </h4> </div> <div class=\"modal-body\"> <img class=\"img-responsive poster\" ng-src=\"{{vm.m.path}}\"><br> </div> <div class=\"modal-footer\"> <button class=\"btn btn-default\" ng-click=\"vm.cancel()\">返回</button> </div> </div></script><div ba-panel=\"\" ba-panel-class=\"light-text tab-content-panel\" ba-panel-header=\"\" hide-add-btn=\"true\" ba-panel-title=\"<span ncy-breadcrumb-last></span>列表\"><div class=\"table-responsive\" loading-container=\"vm.tableParams.settings().$loading\"><table class=\"table table-hover table-row-clicked\" ng-table=\"vm.tableParams\" template-header=\"app/theme/components/table/header.html\"><tr ng-repeat-start=\"row in $data\" ng-click=\"row.showDetail=!row.showDetail\"><td ng-click=\"$event.stopPropagation()\"><button type=\"button\" class=\"btn btn-default btn-xs\" ng-click=\"row.showDetail=!row.showDetail\"><i class=\"glyphicon glyphicon-chevron-down\" ng-hide=\"row.showDetail\"></i> <i class=\"glyphicon glyphicon-chevron-up\" ng-show=\"row.showDetail\"></i></button></td><td ng-repeat=\"col in vm.cols\" ng-switch=\"col.field\" ng-if=\"col.show\"><div ng-switch-when=\"name\"><span ng-bind=\"row[col.field]\" style=\"vertical-align:top\"></span> <span class=\"tag tag-danger\" title=\"停用\" ng-if=\"row.is_stop==\'1\'\">停</span></div><span ng-switch-default=\"\">{{row[col.field]}}</span></td></tr><tr ng-repeat-end=\"\" ng-if=\"row.showDetail\" class=\"bg-gray-light\"><td colspan=\"9\"><table class=\"table table-hover\"><tbody><tr><td rowspan=\"8\" width=\"256\"><div style=\"position:relative\"><div style=\"position:absolute;right:0;top:0;z-index:1001\"><button type=\"button\" class=\"btn btn-success btn-xs\" ng-if=\"row.images.length>0\" ng-click=\"vm.zoomIn(row)\"><i class=\"fa fa-search-plus fa-fw\"></i></button></div><div style=\"height:180px\"><div uib-carousel=\"\" interval=\"5000\" no-wrap=\"false\" active=\"row.active\"><div uib-slide=\"\" ng-repeat=\"image in row.images track by image.id\" index=\"$index\"><img ng-src=\"{{image.path}}\" style=\"margin:auto;height:180px\"></div></div></div></div></td><td height=\"36\">生产商：{{row.producer.name}}</td><td height=\"36\">经销商：{{row.dealer.name}}</td></tr><tr ng-if=\"row.s_dealer\"><td height=\"36\">二级经销商：{{row.s_dealer.name}}</td><td height=\"36\">二级经销商进价：{{row.sd_purchase_price!=null?(row.sd_purchase_price +\'元/\'+row.use_unit):\'暂无\'}}</td></tr><tr><td height=\"36\">注册证号：{{row[\'r_num\']}}</td><td height=\"36\">原产地：{{row.is_import==\'1\'?row.country.cn+\'lt;\'+row.country.en+\'&gt;\':(row.country.cn+(row.province?\'&lt;\'+row.province.name+\'&gt;\':\'\'))}}</td></tr><tr><td height=\"36\">出厂价格：{{row[\'purchase_price\']}}元/{{row.use_unit}}</td><td height=\"36\">阳光流水号：{{row[\'sunshine_num\']?row[\'sunshine_num\']:\'暂无\'}}</td></tr><tr ng-if=\"row.has_life==\'1\'\"><td height=\"36\">保质期： {{row[\'year_shelf_life\']>0?row[\'year_shelf_life\']+\'年\':\'\'}} {{row[\'month_shelf_life\']>0?row[\'month_shelf_life\']+\'月\':\'\'}} {{row[\'shelf_life\']>0?row[\'shelf_life\']+\'天\':\'\'}}</td><td height=\"36\">到期提醒：{{row[\'remind_day\']}}天</td></tr><tr><td height=\"36\">高值耗材： <span ng-class=\"{true:\'text-red\',false:\'text-default\'}[row.is_high_value==\'1\']\" ng-bind=\"row.is_high_value==\'1\'?\'是\':\'否\'\"></span></td><td height=\"36\">正常到货周期：{{row.lead_time?(row.lead_time+\'天\'):\'未设置\'}}</td></tr><tr><td height=\"36\" colspan=\"2\">按 <span class=\"text-red\" ng-bind=\"row[\'storage_unit\']\"></span> 领用, <span ng-if=\"row[\'purchase_unit\']!=row[\'storage_unit\']\">每 <span class=\"text-red\" ng-bind=\"row[\'purchase_unit\']\"></span> <span class=\"text-red\" ng-bind=\"row[\'storage_num\']\"></span> <span class=\"text-red\" ng-bind=\"row[\'storage_unit\']\"></span></span> <span ng-if=\"row[\'storage_unit\']!=row[\'use_unit\']\">每 <span class=\"text-red\" ng-bind=\"row[\'storage_unit\']\"></span> <span class=\"text-red\" ng-bind=\"row[\'use_num\']\"></span> <span class=\"text-red\" ng-bind=\"row[\'use_unit\']\"></span> ,</span> <span ng-switch=\"row.level\" class=\"text-info\"><span ng-switch-when=\"1\">可直接领用</span> <span ng-switch-when=\"2\">需科主任审批</span> <span ng-switch-when=\"3\">需分管院领导审批</span> <span ng-switch-when=\"4\">需主管院领导审批</span></span>.</td></tr><tr><td colspan=\"2\">备注：<span ng-bind=\"row.note?row.note:\'暂无备注\'\"></span></td></tr></tbody></table></td></tr><tr ng-if=\"!vm.tableParams.settings().$loading&&($data==null||$data.length==0)\" class=\"table-no-data\"><td colspan=\"99\" align=\"center\"><span>暂无数据</span></td></tr></table></div></div>");
$templateCache.put("app/pages/csmbs/inventories/storeroom/storeroom.html","<script type=\"text/ng-template\" id=\"CsmbLargeImgDlg.html\"><div fullscreen=\"isFullscreen\"> <div class=\"modal-header dialog-header-confirm\"> <button type=\"button\" class=\"close\" ng-click=\"vm.cancel()\">&times;</button> <button type=\"button\" class=\"close\" ng-click=\"isFullscreen=!isFullscreen\" style=\"padding-right:6px\"> <i class=\"fa fa-square-o\"></i></button> <h4 class=\"modal-title\"> <i class=\"fa fa-photo\"></i>&nbsp;耗材图片 </h4> </div> <div class=\"modal-body\"> <img class=\"img-responsive poster\" ng-src=\"{{vm.m.path}}\"><br> </div> <div class=\"modal-footer\"> <button class=\"btn btn-default\" ng-click=\"vm.cancel()\">返回</button> </div> </div></script><div ba-panel=\"\" ba-panel-class=\"light-text tab-content-panel\" ba-panel-header=\"\" hide-add-btn=\"true\" ba-panel-title=\"<span ncy-breadcrumb-last></span>列表\"><table-option-tab ng-model=\"vm.roomId\" options=\"vm.rooms\" filter-name=\"room_id\" tag-title=\"库房\"></table-option-tab><div class=\"table-responsive\" loading-container=\"vm.tableParams.settings().$loading\"><label class=\"cb-label-wrapper\"><span class=\"text-default\">显示零库存</span> <input type=\"checkbox\" ng-model=\"vm.zero_show\" ng-change=\"vm.zeroShowChange()\" class=\"title-cb\"></label><table class=\"table table-hover table-row-clicked\" ng-table=\"vm.tableParams\" template-header=\"app/theme/components/table/header.html\"><tr ng-repeat-start=\"row in $data track by row.id\" ng-click=\"row.showDetail=!row.showDetail\"><td ng-click=\"$event.stopPropagation()\"><button type=\"button\" class=\"btn btn-default btn-xs\" ng-click=\"row.showDetail=!row.showDetail\"><i class=\"glyphicon glyphicon-chevron-down\" ng-hide=\"row.showDetail\"></i> <i class=\"glyphicon glyphicon-chevron-up\" ng-show=\"row.showDetail\"></i></button></td><td ng-repeat=\"col in vm.cols\" ng-switch=\"col.field\" ng-if=\"col.show\"><div ng-switch-when=\"name\"><span ng-bind=\"row[col.field]\" style=\"vertical-align:top\"></span> <span class=\"tag tag-danger\" title=\"停用\" ng-if=\"row.is_stop==\'1\'\">停</span></div><div ng-switch-when=\"num\"><span ng-bind=\"row.num\"></span> <i ng-if=\"row.num>=+row.max&&+row.max>0\" class=\"fa fa-arrow-up fa-fw text-green\" style=\"border-bottom: 2px solid #00a65a\" uib-tooltip=\"超过库存上限\" tooltip-class=\"tooltipInfo\" tooltip-append-to-body=\"true\"></i> <i ng-if=\"row.num<+row.min\" class=\"fa fa-arrow-down fa-fw text-red\" style=\"border-top: 2px solid #dd4b39\" uib-tooltip=\"库存不足\" tooltip-class=\"tooltipInfo\" tooltip-append-to-body=\"true\"></i></div><div ng-switch-when=\"alarm\"><div style=\"line-height:22px\" ng-if=\"row.max>0\"><i class=\"fa fa-arrow-up fa-fw text-green\" style=\"border-top: 2px solid #00a65a\" uib-tooltip=\"库存上限\" tooltip-class=\"tooltipInfo\" tooltip-append-to-body=\"true\"></i> <span ng-if=\"row.max>0\" ng-bind=\"row.max\"></span></div><div style=\"line-height:22px\" ng-if=\"row.min>0\"><i class=\"fa fa-arrow-down fa-fw text-red\" style=\"border-bottom: 2px solid #dd4b39\" uib-tooltip=\"库存下限\" tooltip-class=\"tooltipInfo\" tooltip-append-to-body=\"true\"></i> <span ng-if=\"row.min>0\" ng-bind=\"row.min\"></span></div></div><span ng-switch-default=\"\">{{row[col.field]}}</span></td></tr><tr ng-repeat-end=\"\" ng-if=\"row.showDetail\" class=\"bg-gray-light\"><td colspan=\"9\"><table class=\"table table-hover\"><tbody><tr><td rowspan=\"8\" width=\"256\"><div style=\"position:relative\"><div style=\"position:absolute;right:0;top:0;z-index:1001\"><button type=\"button\" class=\"btn btn-success btn-xs\" ng-if=\"row.images.length>0\" ng-click=\"vm.zoomIn(row)\"><i class=\"fa fa-search-plus fa-fw\"></i></button></div><div style=\"height:180px\"><div uib-carousel=\"\" interval=\"5000\" no-wrap=\"false\" active=\"row.active\"><div uib-slide=\"\" ng-repeat=\"image in row.images track by image.id\" index=\"$index\"><img ng-src=\"{{image.path}}\" style=\"margin:auto;height:180px\"></div></div></div></div></td><td height=\"36\">生产商：{{row.producer.name}}</td><td height=\"36\">经销商：{{row.dealer.name}}</td></tr><tr ng-if=\"row.s_dealer\"><td height=\"36\">二级经销商：{{row.s_dealer.name}}</td><td height=\"36\">二级经销商进价：{{row.sd_purchase_price!=null?(row.sd_purchase_price +\'元/\'+row.use_unit):\'暂无\'}}</td></tr><tr><td height=\"36\">注册证号：{{row[\'r_num\']}}</td><td height=\"36\">原产地：{{row.is_import==\'1\'?row.country.cn+\'lt;\'+row.country.en+\'&gt;\':(row.country.cn+(row.province?\'&lt;\'+row.province.name+\'&gt;\':\'\'))}}</td></tr><tr><td height=\"36\">出厂价格：{{row[\'purchase_price\']}}元/{{row.use_unit}}</td><td height=\"36\">阳光流水号：{{row[\'sunshine_num\']?row[\'sunshine_num\']:\'暂无\'}}</td></tr><tr ng-if=\"row.has_life==\'1\'\"><td height=\"36\">保质期： {{row[\'year_shelf_life\']>0?row[\'year_shelf_life\']+\'年\':\'\'}} {{row[\'month_shelf_life\']>0?row[\'month_shelf_life\']+\'月\':\'\'}} {{row[\'shelf_life\']>0?row[\'shelf_life\']+\'天\':\'\'}}</td><td height=\"36\">到期提醒：{{row[\'remind_day\']}}天</td></tr><tr><td height=\"36\">高值耗材： <span ng-class=\"{true:\'text-red\',false:\'text-default\'}[row.is_high_value==\'1\']\" ng-bind=\"row.is_high_value==\'1\'?\'是\':\'否\'\"></span></td><td height=\"36\">正常到货周期：{{row.lead_time?(row.lead_time+\'天\'):\'未设置\'}}</td></tr><tr><td height=\"36\" colspan=\"2\">按 <span class=\"text-red\" ng-bind=\"row[\'storage_unit\']\"></span> 领用, <span ng-if=\"row[\'purchase_unit\']!=row[\'storage_unit\']\">每 <span class=\"text-red\" ng-bind=\"row[\'purchase_unit\']\"></span> <span class=\"text-red\" ng-bind=\"row[\'storage_num\']\"></span> <span class=\"text-red\" ng-bind=\"row[\'storage_unit\']\"></span></span> <span ng-if=\"row[\'storage_unit\']!=row[\'use_unit\']\">每 <span class=\"text-red\" ng-bind=\"row[\'storage_unit\']\"></span> <span class=\"text-red\" ng-bind=\"row[\'use_num\']\"></span> <span class=\"text-red\" ng-bind=\"row[\'use_unit\']\"></span> ,</span> <span ng-switch=\"row.level\" class=\"text-info\"><span ng-switch-when=\"1\">可直接领用</span> <span ng-switch-when=\"2\">需科主任审批</span> <span ng-switch-when=\"3\">需分管院领导审批</span> <span ng-switch-when=\"4\">需主管院领导审批</span></span>.</td></tr><tr><td colspan=\"2\">备注：<span ng-bind=\"row.note?row.note:\'暂无备注\'\"></span></td></tr></tbody></table></td></tr><tr ng-if=\"!vm.tableParams.settings().$loading&&($data==null||$data.length==0)\" class=\"table-no-data\"><td colspan=\"99\" align=\"center\"><span>暂无数据</span></td></tr></table></div></div>");
$templateCache.put("app/pages/csmbs/inventories/temporary/temporary.html","<script type=\"text/ng-template\" id=\"CsmbLargeImgDlg.html\"><div fullscreen=\"isFullscreen\"> <div class=\"modal-header dialog-header-confirm\"> <button type=\"button\" class=\"close\" ng-click=\"vm.cancel()\">&times;</button> <button type=\"button\" class=\"close\" ng-click=\"isFullscreen=!isFullscreen\" style=\"padding-right:6px\"> <i class=\"fa fa-square-o\"></i></button> <h4 class=\"modal-title\"> <i class=\"fa fa-photo\"></i>&nbsp;耗材图片 </h4> </div> <div class=\"modal-body\"> <img class=\"img-responsive poster\" ng-src=\"{{vm.m.path}}\"><br> </div> <div class=\"modal-footer\"> <button class=\"btn btn-default\" ng-click=\"vm.cancel()\">返回</button> </div> </div></script><div ba-panel=\"\" ba-panel-class=\"light-text tab-content-panel\" ba-panel-header=\"\" hide-add-btn=\"true\" ba-panel-title=\"<span ncy-breadcrumb-last></span>列表\"><table-option-tab ng-model=\"vm.roomId\" options=\"vm.rooms\" filter-name=\"room_id\" tag-title=\"库房\"></table-option-tab><div class=\"table-responsive\" loading-container=\"vm.tableParams.settings().$loading\"><table class=\"table table-hover table-row-clicked\" ng-table=\"vm.tableParams\" template-header=\"app/theme/components/table/header.html\"><tr ng-repeat-start=\"row in $data track by row.id\" ng-click=\"row.showDetail=!row.showDetail\"><td ng-click=\"$event.stopPropagation()\"><button type=\"button\" class=\"btn btn-default btn-xs\" ng-click=\"row.showDetail=!row.showDetail\"><i class=\"glyphicon glyphicon-chevron-down\" ng-hide=\"row.showDetail\"></i> <i class=\"glyphicon glyphicon-chevron-up\" ng-show=\"row.showDetail\"></i></button></td><td ng-repeat=\"col in vm.cols\" ng-switch=\"col.field\" ng-if=\"col.show\"><div ng-switch-when=\"name\"><span ng-bind=\"row[col.field]\" style=\"vertical-align:top\"></span> <span class=\"tag tag-danger\" title=\"停用\" ng-if=\"row.is_stop==\'1\'\">停</span></div><span ng-switch-default=\"\">{{row[col.field]}}</span></td></tr><tr ng-repeat-end=\"\" ng-if=\"row.showDetail\" class=\"bg-gray-light\"><td colspan=\"9\"><table class=\"table table-hover\"><tbody><tr><td rowspan=\"8\" width=\"256\"><div style=\"position:relative\"><div style=\"position:absolute;right:0;top:0;z-index:1001\"><button type=\"button\" class=\"btn btn-success btn-xs\" ng-if=\"row.images.length>0\" ng-click=\"vm.zoomIn(row)\"><i class=\"fa fa-search-plus fa-fw\"></i></button></div><div style=\"height:180px\"><div uib-carousel=\"\" interval=\"5000\" no-wrap=\"false\" active=\"row.active\"><div uib-slide=\"\" ng-repeat=\"image in row.images track by image.id\" index=\"$index\"><img ng-src=\"{{image.path}}\" style=\"margin:auto;height:180px\"></div></div></div></div></td><td height=\"36\">生产商：{{row.producer.name}}</td><td height=\"36\">经销商：{{row.dealer.name}}</td></tr><tr ng-if=\"row.s_dealer\"><td height=\"36\">二级经销商：{{row.s_dealer.name}}</td><td height=\"36\">二级经销商进价：{{row.sd_purchase_price!=null?(row.sd_purchase_price +\'元/\'+row.use_unit):\'暂无\'}}</td></tr><tr><td height=\"36\">注册证号：{{row[\'r_num\']}}</td><td height=\"36\">原产地：{{row.is_import==\'1\'?row.country.cn+\'lt;\'+row.country.en+\'&gt;\':(row.country.cn+(row.province?\'&lt;\'+row.province.name+\'&gt;\':\'\'))}}</td></tr><tr><td height=\"36\">出厂价格：{{row[\'purchase_price\']}}元/{{row.use_unit}}</td><td height=\"36\">阳光流水号：{{row[\'sunshine_num\']?row[\'sunshine_num\']:\'暂无\'}}</td></tr><tr ng-if=\"row.has_life==\'1\'\"><td height=\"36\">保质期： {{row[\'year_shelf_life\']>0?row[\'year_shelf_life\']+\'年\':\'\'}} {{row[\'month_shelf_life\']>0?row[\'month_shelf_life\']+\'月\':\'\'}} {{row[\'shelf_life\']>0?row[\'shelf_life\']+\'天\':\'\'}}</td><td height=\"36\">到期提醒：{{row[\'remind_day\']}}天</td></tr><tr><td height=\"36\">高值耗材： <span ng-class=\"{true:\'text-red\',false:\'text-default\'}[row.is_high_value==\'1\']\" ng-bind=\"row.is_high_value==\'1\'?\'是\':\'否\'\"></span></td><td height=\"36\">正常到货周期：{{row.lead_time?(row.lead_time+\'天\'):\'未设置\'}}</td></tr><tr><td height=\"36\" colspan=\"2\">按 <span class=\"text-red\" ng-bind=\"row[\'storage_unit\']\"></span> 领用, <span ng-if=\"row[\'purchase_unit\']!=row[\'storage_unit\']\">每 <span class=\"text-red\" ng-bind=\"row[\'purchase_unit\']\"></span> <span class=\"text-red\" ng-bind=\"row[\'storage_num\']\"></span> <span class=\"text-red\" ng-bind=\"row[\'storage_unit\']\"></span></span> <span ng-if=\"row[\'storage_unit\']!=row[\'use_unit\']\">每 <span class=\"text-red\" ng-bind=\"row[\'storage_unit\']\"></span> <span class=\"text-red\" ng-bind=\"row[\'use_num\']\"></span> <span class=\"text-red\" ng-bind=\"row[\'use_unit\']\"></span> ,</span> <span ng-switch=\"row.level\" class=\"text-info\"><span ng-switch-when=\"1\">可直接领用</span> <span ng-switch-when=\"2\">需科主任审批</span> <span ng-switch-when=\"3\">需分管院领导审批</span> <span ng-switch-when=\"4\">需主管院领导审批</span></span>.</td></tr><tr><td colspan=\"2\">备注：<span ng-bind=\"row.note?row.note:\'暂无备注\'\"></span></td></tr></tbody></table></td></tr><tr ng-if=\"!vm.tableParams.settings().$loading&&($data==null||$data.length==0)\" class=\"table-no-data\"><td colspan=\"99\" align=\"center\"><span>暂无数据</span></td></tr></table></div></div>");
$templateCache.put("app/pages/csmbs/prices/new/apply.html","<div ba-panel=\"\" ba-panel-class=\"profile-page\" ba-panel-title=\"<span ncy-breadcrumb-last></span>\"><div class=\"panel-content\"><form name=\"Form\" class=\"form-horizontal\" scroll-form=\"\" novalidate=\"\"><div class=\"form-group\"><label class=\"col-md-2 control-label\">变价耗材</label><div class=\"col-md-8\"><csmbs-select ng-model=\"vm.m.csmbs\" name=\"csmbs\" only-use=\"true\" on-select=\"vm.csmbSelected(vm.m)\" on-remove=\"vm.csmbSelected(vm.m)\"></csmbs-select><div ng-show=\"Form.$submitted||Form.csmbs.$touched\"><span ng-show=\"vm.m.csmbs.length==0\" class=\"validation-invalid control-label\">必填项!!</span></div></div></div><div class=\"form-group\"><label class=\"col-md-2 control-label\">耗材明细</label><div class=\"col-md-8\"><table class=\"table table-bordered table-condensed\"><thead><tr><th width=\"108\">耗材名称</th><th width=\"72\">规格型号</th><th width=\"72\">单位</th><th width=\"72\">原价</th><th width=\"108\">现价</th></tr></thead><tbody><tr ng-repeat=\"row in vm.m.consumables track by row.id\"><td>{{row.name!=\'\'?row.name:row.c_name}}</td><td>{{row.spec}}</td><td><span ng-if=\"row.storage_unit!=row.use_unit\">每{{row.storage_unit}}{{row.use_num}}{{row.use_unit}}</span> <span ng-if=\"row.storage_unit==row.use_unit\">{{row.storage_unit}}</span></td><td>{{row.purchase_price}}/{{row.use_unit}}</td><td><input type=\"text\" input-float=\"2\" class=\"form-control input-xs\" style=\"display:inline-block;width:80px\" ng-model=\"row.new_price\" validator=\"required\"> /{{row.use_unit}}<div class=\"btn-group\"><button class=\"btn btn-xs btn-success\" ng-click=\"vm.increase(row)\"><i class=\"fa fa-plus\"></i></button> <button class=\"btn btn-xs btn-danger\" ng-click=\"vm.decrease(row)\"><i class=\"fa fa-minus\"></i></button></div></td></tr><tr ng-if=\"vm.m.consumables==null||vm.m.consumables.length==0\" height=\"160px\"><td colspan=\"11\" align=\"center\" style=\"vertical-align:middle\"><span class=\"table-no-data\">暂无数据</span></td></tr></tbody></table></div></div><div class=\"form-group\"><label class=\"col-md-2 control-label\">变价原因</label><div class=\"col-md-8\"><div ckeditor=\"\" ng-model=\"vm.m.content\" ready=\"vm.onCKReady(\'editor\')\" id=\"editor\" name=\"content\" required=\"\"></div><div ng-if=\"Form.$submitted||Form.content.$touched\"><span ng-show=\"Form.content.$error.required\" class=\"validation-invalid\">必填项!!</span></div></div></div><div class=\"form-group\"><div class=\"col-md-offset-3 col-md-9\"><div class=\"pull-right\"><button ng-click=\"vm.reset(Form)\" class=\"btn btn-default\"><i class=\"fa fa-refresh\"></i>&nbsp;重置</button><submit-button btn-class=\"btn-primary\" btn-click=\"vm.submit(Form,vm.m)\">提交</submit-button></div></div></div></form></div></div>");
$templateCache.put("app/pages/csmbs/purchase/approval/approval.html","<div ba-panel=\"\" ba-panel-class=\"light-text tab-content-panel\" ba-panel-header=\"\" hide-add-btn=\"true\" ba-panel-title=\"<span ncy-breadcrumb-last></span>列表\"><table-option-tab ng-model=\"vm.roomId\" options=\"vm.rooms\" tag-title=\"申请库房\" filter-name=\"room_id\"></table-option-tab><div class=\"order-number-query\"><a class=\"font-sm\" ng-click=\"vm.tableParams.openNumberQuery=true\">按单号查询</a> <input type=\"text\" focus-me=\"vm.tableParams.openNumberQuery\" ng-model=\"vm.tableParams.filter()[\'number\']\"></div><label class=\"cb-label-wrapper\" ng-if=\"vm.tableParams.filter()[\'item\']\"><checkbox ng-model=\"vm.hideSub\" ng-change=\"vm.changeHide(vm.items,vm.tableParams.filter()[\'item\'])\"></checkbox><strong>隐藏其余筛选子项</strong></label><div class=\"table-responsive min-h418\" loading-container=\"vm.tableParams.settings().$loading\"><table class=\"table table-hover table-row-clicked\" ng-table=\"vm.tableParams\" template-header=\"app/theme/components/table/header.html\"><tr ng-repeat-start=\"row in $data track by row.id\"><td ng-click=\"$event.stopPropagation()\"><button type=\"button\" class=\"btn btn-default btn-xs\" ng-click=\"row.showDetail=!row.showDetail\"><i class=\"glyphicon glyphicon-chevron-down\" ng-hide=\"row.showDetail\"></i> <i class=\"glyphicon glyphicon-chevron-up\" ng-show=\"row.showDetail\"></i></button> <button class=\"btn btn-primary btn-xs\" ng-click=\"vm.pass(row)\"><i class=\"fa fa-edit\"></i></button> <button class=\"btn btn-info btn-xs\" ng-click=\"vm.info(row)\"><i class=\"fa fa-commenting\"></i></button> <button class=\"btn btn-danger btn-xs\" ng-if=\"row.direct==1&&row.state.id==2\" ng-click=\"vm.remove(row)\"><i class=\"fa fa-trash\"></i></button></td><td ng-repeat=\"col in vm.cols\" ng-switch=\"col.field\" ng-if=\"col.show\"><span ng-switch-when=\"created_at\">{{row[col.field]}}</span><div ng-switch-when=\"application_items\"><span ng-if=\"row.number\">单号:{{row.number}}</span> <span class=\"tag tag-warning\" title=\"经销商主动发货\" ng-show=\"row.direct==1\">主动发货</span> <span class=\"tag tag-danger\" title=\"暂存库房\" ng-show=\"row.temporary==1\">暂存库房</span><table class=\"table table-bordered table-condensed\"><tbody><tr ng-repeat=\"i in row[col.field]\" ng-hide=\"i.hide||i.diff_num==0\" ng-if=\"row.expand||$index<4\"><td>{{i.consumable.name != \'\' ? i.consumable.name : i.consumable.c_name}} <span class=\"badge bulletin-subject-col\">{{i.consumable.spec}}</span> <span class=\"text-danger\" ng-bind=\"(i.l_num>0?i.l_num+i.consumable.purchase_unit:\'\')+(i.s_num>0?i.s_num+i.consumable.storage_unit:\'\')\"></span></td><td>{{i.consumable.producer ? i.consumable.producer.name : \'暂无生产商\'}}</td></tr></tbody></table><a class=\"pull-right\" ng-if=\"row[col.field].length>4\" ng-click=\"row.expand=!row.expand\"><span ng-if=\"row.expand\" class=\"fa fa-chevron-up\">收起</span> <span ng-if=\"!row.expand\" class=\"fa fa-chevron-down\">展开剩余{{row[col.field].length - 4}}项...</span></a></div><span ng-switch-default=\"\">{{row[col.field].name}}</span></td></tr><tr ng-repeat-end=\"\" ng-if=\"row.showDetail\" class=\"bg-gray-light\"><td colspan=\"5\"><table class=\"table table-hover\"><tbody><tr><td>设备科负责人审批意见：<span ng-bind=\"row.leader_opinion?row.leader_opinion:\'暂无\'\"></span></td></tr><tr><td>采购中心审批意见：<span ng-bind=\"row.opinion?row.opinion:\'暂无\'\"></span></td></tr><tr><td>备注：<span ng-bind=\"row.note?row.note:\'暂无\'\"></span></td></tr><tr><td>经销商补充信息：<span ng-bind=\"row.msn?row.msn:\'暂无\'\"></span></td></tr></tbody></table></td></tr><tr ng-if=\"!vm.tableParams.settings().$loading&&($data==null||$data.length==0)\" class=\"table-no-data\"><td colspan=\"99\" align=\"center\"><span>暂无数据</span></td></tr></table></div></div>");
$templateCache.put("app/pages/csmbs/purchase/approved/approved.html","<div ba-panel=\"\" ba-panel-class=\"light-text tab-content-panel\" ba-panel-header=\"\" hide-add-btn=\"true\" ba-panel-title=\"<span ncy-breadcrumb-last></span>列表\"><table-option-tab ng-model=\"vm.roomId\" options=\"vm.rooms\" filter-name=\"room_id\" tag-title=\"申请库房\"></table-option-tab><div class=\"order-number-query\"><a class=\"font-sm\" ng-click=\"vm.tableParams.openNumberQuery=true\">按单号查询</a> <input type=\"text\" focus-me=\"vm.tableParams.openNumberQuery\" ng-model=\"vm.tableParams.filter()[\'number\']\"></div><label class=\"cb-label-wrapper\" ng-if=\"vm.tableParams.filter()[\'item\']\"><checkbox ng-model=\"vm.hideSub\" ng-change=\"vm.changeHide(vm.items,vm.tableParams.filter()[\'item\'])\"></checkbox><strong>隐藏其余筛选子项</strong></label><div class=\"table-responsive\" loading-container=\"vm.tableParams.settings().$loading\"><table class=\"table table-hover table-row-clicked\" ng-table=\"vm.tableParams\" template-header=\"app/theme/components/table/header.html\"><tr ng-repeat-start=\"row in $data track by row.id\"><td ng-click=\"$event.stopPropagation()\"><button type=\"button\" class=\"btn btn-default btn-xs\" ng-click=\"row.showDetail=!row.showDetail\"><i class=\"glyphicon glyphicon-chevron-down\" ng-hide=\"row.showDetail\"></i> <i class=\"glyphicon glyphicon-chevron-up\" ng-show=\"row.showDetail\"></i></button> <button class=\"btn btn-primary btn-xs\" uib-tooltip=\"发货批次\" tooltip-class=\"tooltipInfo\" ng-click=\"vm.batch(row)\"><i class=\"fa fa-stack-overflow\"></i></button> <button class=\"btn btn-info btn-xs\" uib-tooltip=\"补充信息\" tooltip-class=\"tooltipInfo\" ng-click=\"vm.info(row)\"><i class=\"fa fa-commenting\"></i></button> <button class=\"btn btn-danger btn-xs\" uib-tooltip=\"撤销发货\" tooltip-class=\"tooltipInfo\" ng-if=\"row.state.id==5||row.state.id==7\" ng-click=\"vm.back(row)\"><i class=\"fa fa-reply\"></i></button></td><td ng-repeat=\"col in vm.cols\" ng-switch=\"col.field\" ng-if=\"col.show\"><span ng-switch-when=\"applicant\">{{row[col.field].name}}</span> <span ng-switch-when=\"state\">{{row[col.field].name}}</span><div ng-switch-when=\"application_items\"><span ng-if=\"row.number\">单号:{{row.number}}</span> <span class=\"tag tag-warning\" title=\"经销商主动发货\" ng-show=\"row.direct==1\">主动发货</span> <span class=\"tag tag-danger\" title=\"暂存库房\" ng-show=\"row.temporary==1\">暂存库房</span><table class=\"table table-bordered table-condensed\"><tbody><tr ng-repeat=\"i in row[col.field]\" ng-hide=\"i.hide\" ng-if=\"row.expand||$index<4\"><td>{{i.consumable.name != \'\' ? i.consumable.name : i.consumable.c_name}} <span class=\"badge bulletin-subject-col\">{{i.consumable.spec}}</span> <span class=\"text-danger\" ng-bind=\"i.num+(row.for_purchase==\'1\'?i.consumable.purchase_unit:i.consumable.storage_unit)\"></span></td><td>{{i.consumable.producer ? i.consumable.producer.name : \'暂无生产商\'}}</td></tr></tbody></table><a class=\"pull-right\" ng-if=\"row[col.field].length>4\" ng-click=\"row.expand=!row.expand\"><span ng-if=\"row.expand\" class=\"fa fa-chevron-up\">收起</span> <span ng-if=\"!row.expand\" class=\"fa fa-chevron-down\">展开剩余{{row[col.field].length - 4}}项...</span></a></div><span ng-switch-default=\"\">{{row[col.field]}}</span></td></tr><tr ng-repeat-end=\"\" ng-if=\"row.showDetail\" class=\"bg-gray-light\"><td colspan=\"6\"><table class=\"table table-hover\"><tbody><tr><td>设备科负责人审批意见：<span ng-bind=\"row.leader_opinion?row.leader_opinion:\'暂无\'\"></span></td></tr><tr><td>采购中心审批意见：<span ng-bind=\"row.opinion?row.opinion:\'暂无\'\"></span></td></tr><tr><td>备注：<span ng-bind=\"row.note?row.note:\'暂无\'\"></span></td></tr><tr><td>经销商补充信息：<span ng-bind=\"row.msn?row.msn:\'暂无\'\"></span></td></tr></tbody></table></td></tr><tr ng-if=\"!vm.tableParams.settings().$loading&&($data==null||$data.length==0)\" class=\"table-no-data\"><td colspan=\"99\" align=\"center\"><span>暂无数据</span></td></tr></table></div></div>");
$templateCache.put("app/pages/csmbs/qualifications/new/apply.html","<script type=\"text/ng-template\" id=\"csmbQAAdd.html\"><div class=\"modal-header dialog-header-confirm\"> <button type=\"button\" class=\"close\" ng-click=\"vm.cancel()\">&times;</button> <h4 class=\"modal-title\"> <i class=\"fa fa-plus\">选择耗材资质</i> </h4> </div> <div class=\"modal-body\"> <form name=\"Form\" class=\"form-horizontal\" novalidate> <div class=\"alert bg-danger\" ng-if=\"vm.qualifications.length==0\"><strong>没有可添加的资质!</strong></div> <div class=\"form-group\" ng-if=\"vm.qualifications.length>0\"> <label class=\"col-md-3 control-label\">选择资质</label> <div class=\"col-md-7\"> <ui-select ng-model=\"vm.m.qualifications\" multiple close-on-select=\"false\"> <ui-select-match placeholder=\"选择资质...\"><span ng-bind=\"$item.name\" title={{$item.name}}></span> </ui-select-match> <ui-select-choices repeat=\"qualification in vm.qualifications | filter: $select.search\"> <span ng-bind-html=\"qualification.name | highlight: $select.search\" title={{qualification.name}}></span> </ui-select-choices> </ui-select> </div> </div> </form> </div> <div class=\"modal-footer\"> <button class=\"btn btn-primary\" ng-click=\"vm.ok(vm.m)\" promise-btn ng-if=\"vm.qualifications.length>0\">确认 </button> <button class=\"btn btn-default\" ng-click=\"vm.cancel()\">取消</button> </div></script><div ba-panel=\"\" ba-panel-class=\"profile-page\" ba-panel-title=\"<span ncy-breadcrumb-last></span>\"><div class=\"panel-content\"><form name=\"Form\" class=\"form-horizontal\" scroll-form=\"\" novalidate=\"\"><div class=\"form-group\"><label class=\"col-md-1 control-label\">变更耗材</label><div class=\"col-md-10\"><cvs-select ng-model=\"vm.m.csmbs\" name=\"csmbs\" required=\"\" on-select=\"vm.csmbSelected(vm.m)\" on-remove=\"vm.csmbSelected(vm.m)\"></cvs-select><div ng-show=\"Form.$submitted||Form.csmbs.$touched\"><span ng-show=\"vm.m.csmbs.length==0\" class=\"validation-invalid control-label\">必填项!!</span></div></div></div><div class=\"form-group\" ng-if=\"vm.m.consumables.length>0\"><div class=\"col-md-10 col-md-offset-1 mb-10\" ng-repeat=\"csmb in vm.m.consumables track by csmb.id\"><table class=\"table table-hover table-bordered table-condensed\" style=\"margin-bottom:0\"><thead style=\"background:azure\"><tr><th colspan=\"6\">{{csmb.name+(csmb.c_name?(\'<\'+csmb.c_name+\'>\'):\'\')}}资质详情</\'+csmb.c_name+\'></th></tr></thead><tbody><tr><td>名称</td><td>证件号</td><td>类型</td><td>资质期限</td><td width=\"260\">附件</td><td width=\"160\">操作</td></tr><tr ng-repeat=\"item in csmb.qualifications\"><td>{{item.name}} <span class=\"tag tag-danger\" title=\"停用\" ng-if=\"item.pivot.is_stop==1\">停</span> <span class=\"tag tag-danger\" title=\"禁用\" ng-if=\"item.pivot.is_invalid==1\">禁</span> <span class=\"tag tag-info\" title=\"新资质\" ng-if=\"item.isNew\">新</span></td><td>{{item.code}}</td><td>{{item.type.name}}</td><td>{{item.start_time}}~{{item.end_time?item.end_time:\'永久\'}}</td><td><div class=\"att-item\" ng-repeat=\"attachment in item.attachments\"><div class=\"att-name\"><span ng-bind=\"attachment.name\"></span> <span class=\"text-muted\">({{attachment.size|bytes}})</span> <a ng-click=\"vm.download(attachment)\">下载</a>&nbsp; <span ng-show=\"attachment.downloading\" class=\"fa fa-circle-o-notch fa-spin text-muted\"></span><attachment-preview ng-model=\"attachment\"></attachment-preview></div></div></td><td align=\"center\"><label class=\"cb-label-wrapper\" ng-if=\"!item.isNew\"><checkbox ng-model=\"item.remove\"></checkbox><strong>解绑</strong></label> <label class=\"cb-label-wrapper\" ng-if=\"item.isNew&&item.type_id==18\"><checkbox ng-model=\"item.change\" ng-change=\"vm.changeFn(item,csmb)\"></checkbox><strong>更换注册证号</strong></label> <button type=\"button\" ng-if=\"item.isNew\" class=\"btn btn-danger btn-xs\" ng-click=\"vm.remove(csmb.qualifications, $index)\"><i class=\"fa fa-trash\"></i></button></td></tr></tbody><tfoot><tr><td colspan=\"5\"></td><td><button type=\"button\" class=\"btn btn-success btn-xs\" ng-click=\"vm.add(csmb,csmb.qualifications)\">添加资质</button></td></tr></tfoot></table></div></div><div class=\"form-group\"><label class=\"col-md-1 control-label\">备注</label><div class=\"col-md-10\"><textarea class=\"form-control\" id=\"inputNote\" placeholder=\"200字内...\" maxlength=\"200\" name=\"note\" ng-model=\"vm.m.note\"></textarea></div></div><div class=\"form-group\"><div class=\"col-md-offset-3 col-md-9\"><div class=\"pull-right\"><button ng-click=\"vm.reset(Form)\" class=\"btn btn-default\"><i class=\"fa fa-refresh\"></i>&nbsp;重置</button><submit-button btn-class=\"btn-primary\" btn-click=\"vm.submit(Form,vm.m)\">提交</submit-button></div></div></div></form></div></div>");
$templateCache.put("app/pages/csmbs/return/approved/approved.html","<div ba-panel=\"\" ba-panel-class=\"light-text tab-content-panel\" ba-panel-header=\"\" hide-add-btn=\"true\" ba-panel-title=\"<span ncy-breadcrumb-last></span>列表\"><table-option-tab ng-model=\"vm.roomId\" options=\"vm.rooms\" tag-title=\"退货库房\" filter-name=\"room_id\"></table-option-tab><label class=\"cb-label-wrapper\" ng-if=\"vm.tableParams.filter()[\'item\']\"><checkbox ng-model=\"vm.hideSub\" ng-change=\"vm.changeHide(vm.items,vm.tableParams.filter()[\'item\'])\"></checkbox><strong>隐藏其余筛选子项</strong></label><div class=\"table-responsive\" loading-container=\"vm.tableParams.settings().$loading\"><table class=\"table table-hover table-row-clicked\" ng-table=\"vm.tableParams\" template-header=\"app/theme/components/table/header.html\"><tr ng-repeat-start=\"row in $data track by row.id\"><td><button type=\"button\" class=\"btn btn-default btn-xs\" ng-click=\"row.showDetail=!row.showDetail\"><i class=\"fa fa-chevron-down\" ng-hide=\"row.showDetail\"></i> <i class=\"fa fa-chevron-up\" ng-show=\"row.showDetail\"></i></button></td><td ng-repeat=\"col in vm.cols\" ng-switch=\"col.field\" ng-if=\"col.show\"><div ng-switch-when=\"created_at\">{{row[col.field]}}</div><div ng-switch-when=\"itemDesc\"><table class=\"table table-bordered table-condensed\"><tbody><tr ng-repeat=\"i in row[col.field]\" ng-hide=\"i.hide\" ng-if=\"row.expand||$index<4\"><td>{{i.consumable.name!=\'\'?i.consumable.name:i.consumable.c_name}} <span class=\"badge bulletin-subject-col\">{{i.consumable.spec}}</span> <span class=\"text-danger\" ng-bind=\"i.num+(row.for_purchase==\'1\'?i.consumable.purchase_unit:i.consumable.storage_unit)\"></span></td><td>{{i.consumable.producer?i.consumable.producer.name:\'暂无生产商\'}}</td></tr></tbody></table><a class=\"pull-right\" ng-if=\"row[col.field].length>4\" ng-click=\"row.expand=!row.expand\"><span ng-if=\"row.expand\" class=\"fa fa-chevron-up\">收起</span> <span ng-if=\"!row.expand\" class=\"fa fa-chevron-down\">展开剩余{{row[col.field].length-4}}项...</span></a></div><div ng-switch-default=\"\">{{row[col.field].name}}</div></td></tr><tr ng-repeat-end=\"\" ng-if=\"row.showDetail\" class=\"bg-gray-light\"><td colspan=\"5\"><table class=\"table table-hover\"><tbody><tr><td>经销商审批时间：<span ng-bind=\"row.confirmed_time\"></span></td></tr><tr><td>经销商审批意见：<span ng-bind=\"row.opinion?row.opinion:\'暂无\'\"></span></td></tr><tr><td>备注：<span ng-bind=\"row.note?row.note:\'暂无\'\"></span></td></tr><tr><td><table class=\"table table-bordered table-condensed\" style=\"margin-bottom:0\"><thead><tr><th>耗材</th><th>规格型号</th><th>单位</th><th>批次</th><th>经销商批次</th><th>进价</th><th>数量</th><th>合计</th></tr></thead><tbody><tr ng-repeat=\"item in row.application_items track by item.id\"><td>{{item.consumable.name!=\'\'?item.consumable.name:item.consumable.c_name}}</td><td>{{item.consumable.spec}}</td><td><span ng-if=\"item.consumable.purchase_unit!=item.consumable.storage_unit\">每{{item.consumable.purchase_unit}}{{item.consumable.storage_num}}{{item.consumable.storage_unit}}</span> <span ng-if=\"item.consumable.storage_unit!=item.consumable.use_unit\">每{{item.consumable.storage_unit}}{{item.consumable.use_num}}{{item.consumable.use_unit}}</span> <span ng-if=\"(item.consumable.purchase_unit==item.consumable.storage_unit)&&(item.consumable.storage_unit==item.consumable.use_unit)\">{{item.consumable.storage_unit}}</span></td><td>{{item.batch.sn}}</td><td>{{item.batch.no}}</td><td>{{item.batch.purchase_price}}/{{item.consumable.use_unit}}</td><td>{{item.num}}{{item.consumable.storage_unit}}</td><td>{{item.total}}</td></tr><tr><td colspan=\"7\">总计</td><td ng-bind=\"row.total\"></td></tr></tbody></table></td></tr><tr ng-if=\"!tableParams.settings().$loading&&($data==null||$data.length==0)\" height=\"160px\"><td colspan=\"11\" align=\"center\" style=\"vertical-align:middle\"><span class=\"table-no-data\">暂无数据</span></td></tr></tbody></table></td></tr><tr ng-if=\"!vm.tableParams.settings().$loading&&($data==null||$data.length==0)\" class=\"table-no-data\"><td colspan=\"99\" align=\"center\"><span>暂无数据</span></td></tr></table></div></div>");
$templateCache.put("app/pages/qualifications/dialogs/attachmentShow/attachmentShow.html","<div fullscreen=\"isFullscreen\"><div class=\"modal-header dialog-header-confirm\"><button type=\"button\" class=\"close\" ng-click=\"cancel()\">&times;</button> <button type=\"button\" class=\"close\" ng-click=\"isFullscreen=!isFullscreen\" style=\"padding-right:6px\"><i class=\"fa fa-square-o\"></i></button><h4 class=\"modal-title\"><i class=\"fa fa-file-text-o\">文件预览</i></h4></div><div class=\"modal-body\"><div ng-if=\"m.mime===\'image/jpeg\'||m.mime===\'image/png\'||m.mime===\'image/bmp\'\"><img class=\"img-responsive\" ng-src=\"{{m.filename}}\"></div><div ng-if=\"m.mime===\'application/pdf\'\"><div oc-lazy-load=\"[\'/ocLazyLoad/pdf/compatibility.js\',\'/ocLazyLoad/pdf/pdf.js\',\'/ocLazyLoad/pdf/angular-pdf.min.js\']\"><div class=\"pdf-wrapper\" style=\"overflow-y: auto;\" fullscreen=\"isFullscreen\"><ng-pdf template-url=\"app/theme/components/pdf/viewer.html\" canvasid=\"pdf\" scale=\"page-fit\"></ng-pdf></div></div></div></div><div class=\"modal-footer\"><button class=\"btn btn-default\" ng-click=\"cancel()\">取消</button></div></div>");
$templateCache.put("app/pages/qualifications/dialogs/stopApply/stopApply.html","<div class=\"modal-header dialog-header-confirm\"><button type=\"button\" class=\"close\" ng-click=\"vm.cancel()\">&times;</button> <span><i class=\"fa fa-edit modal-icon\"></i>{{vm.title}}</span></div><div class=\"modal-body\"><form name=\"From\" class=\"form-horizontal\" novalidate=\"\"><div class=\"form-group\"><label class=\"col-md-4 control-label\">停用原因</label><div class=\"col-md-6\"><textarea maxlength=\"50\" class=\"form-control\" rows=\"4\" name=\"reason\" ng-model=\"vm.m.reason\"></textarea></div></div><div class=\"form-group\"><label class=\"col-md-4 control-label\">短信通知审批人</label><div class=\"col-md-6\"><switch id=\"with_sms\" name=\"with_sms\" ng-model=\"vm.m.with_sms\" on=\"是\" off=\"否\" class=\"green\"></switch></div></div></form></div><div class=\"modal-footer\"><button class=\"btn btn-primary\" ng-click=\"vm.ok(vm.m)\">确认</button> <button class=\"btn btn-default\" ng-click=\"vm.cancel()\">取消</button></div>");
$templateCache.put("app/pages/qualifications/draft/list/list.html","<div ba-panel=\"\" ba-panel-class=\"light-text tab-content-panel\" ba-panel-header=\"\" hide-add-btn=\"true\" ba-panel-title=\"<span ncy-breadcrumb-last></span>列表\"><div class=\"table-responsive\" loading-container=\"vm.tableParams.settings().$loading\"><table class=\"table table-hover table-row-clicked\" ng-table=\"vm.tableParams\" template-header=\"app/theme/components/table/header.html\"><tr ng-repeat-start=\"row in $data track by row.id\" ng-click=\"row.showDetail=!row.showDetail\"><td ng-click=\"$event.stopPropagation()\"><button type=\"button\" class=\"btn btn-default btn-xs\" ng-click=\"row.showDetail=!row.showDetail\"><i class=\"glyphicon glyphicon-chevron-down\" ng-hide=\"row.showDetail\"></i> <i class=\"glyphicon glyphicon-chevron-up\" ng-show=\"row.showDetail\"></i></button> <button class=\"btn btn-danger btn-xs\" ng-click=\"vm.remove(row)\"><span class=\"glyphicon glyphicon-trash\"></span></button> <button class=\"btn btn-primary btn-xs\" ui-sref=\"^.edit({id:row.id})\" uib-tooltip=\"修改\" tooltip-class=\"tooltipInfo\"><span class=\"glyphicon glyphicon-pencil\"></span></button></td><td ng-repeat=\"col in vm.cols\" ng-switch=\"col.field\" ng-if=\"col.show\"><div ng-switch-when=\"name\"><span ng-bind=\"row[col.field]\" style=\"vertical-align:top\"></span> <span ng-if=\"row.attachments.length>0\" class=\"fa fa-paperclip\" style=\"vertical-align:middle\"></span></div><div ng-switch-when=\"code\"><span ng-bind=\"row.code?row.code:\'暂无\'\"></span></div><div ng-switch-when=\"end_time\"><span ng-bind=\"row.end_time?row.end_time:\'永久\'\"></span></div><div ng-switch-when=\"sorting\"><span ng-bind=\"row.sorting?row.sorting:\'暂无\'\"></span></div><span ng-switch-default=\"\">{{row[col.field].name}}</span></td></tr><tr ng-repeat-end=\"\" ng-if=\"row.showDetail\" class=\"bg-gray-light\"><td colspan=\"7\"><table class=\"table table-hover\"><tbody><tr><td>资质期限：{{row.start_time}}~{{row.end_time?row.end_time:\'永久\'}}</td><td>提醒时间：{{row.remind_time?row.remind_time:\'暂无\'}}</td></tr><tr ng-if=\"row.attachments!=null&&row.attachments.length>0\" ng-repeat=\"attachment in row.attachments\"><td colspan=\"2\"><div class=\"att-item\"><div class=\"att-ico\"><i class=\"fa fa-{{attachment.ico}} fa-2x text-info\"></i></div><div class=\"att-name\"><span ng-bind=\"attachment.name\"></span> <span class=\"text-muted\">({{attachment.size|bytes}})</span> <a ng-click=\"vm.download(attachment)\">下载</a>&nbsp; <span ng-show=\"attachment.downloading\" class=\"fa fa-circle-o-notch fa-spin text-muted\"></span><attachment-preview ng-model=\"attachment\"></attachment-preview></div></div></td></tr><tr ng-if=\"row.note!=null\"><td colspan=\"2\">备注：{{row.note}}</td></tr><tr ng-if=\"row.reason!=null\"><td colspan=\"2\">停用原因：{{row.reason}}</td></tr></tbody></table></td></tr><tr ng-if=\"!vm.tableParams.settings().$loading&&($data==null||$data.length==0)\" class=\"table-no-data\"><td colspan=\"99\" align=\"center\"><span>暂无数据</span></td></tr></table></div></div>");
$templateCache.put("app/pages/qualifications/query/edit/edit.html","<div class=\"row\"><div class=\"col-lg-6 col-md-8 col-sm-8\"><div ba-panel=\"\" ba-panel-class=\"light-text tab-content-panel\" ba-panel-title=\"<span ncy-breadcrumb-last></span>\"><form name=\"Form\" class=\"form-horizontal\" novalidate=\"\"><div class=\"form-group\"><label class=\"col-md-3 control-label\">厂商名称</label><div class=\"col-md-9\"><div class=\"input-group\"><input class=\"form-control\" type=\"text\" name=\"vendor\" ng-model=\"vm.m.s_dealer.name\" disabled=\"\"> <span class=\"input-group-addon\"><label class=\"checkbox-label\"><input type=\"checkbox\" ng-model=\"vm.m.with_sms\"> <small>短信通知审批人</small></label></span></div></div></div><div class=\"form-group\"><label class=\"col-md-3 control-label\">资质类型</label><div class=\"col-md-9\"><ui-select name=\"type\" ng-class=\"{\'submitted\':Form.$submitted}\" ng-model=\"vm.m.type\" search-enabled=\"false\" required=\"\"><ui-select-match placeholder=\"选择资质类型...\">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat=\"type in vm.types | filter: $select.search\"><div ng-bind-html=\"type.name | highlight: $select.search\"></div></ui-select-choices></ui-select><div ng-show=\"Form.$submitted||Form.type.$touched\"><span ng-show=\"Form.type.$error.required\" class=\"validation-invalid\">必填项!!</span></div></div></div><div class=\"form-group\"><label class=\"col-md-3 control-label\">资质名称</label><div class=\"col-md-9\"><input class=\"form-control\" type=\"text\" name=\"name\" ng-model=\"vm.m.name\" validator=\"required,maxlen=80\"></div></div><div class=\"form-group\"><label class=\"col-md-3 control-label\">证件号码</label><div class=\"col-md-9\"><input class=\"form-control\" type=\"text\" name=\"code\" ng-model=\"vm.m.code\"></div></div><div class=\"form-group\"><label class=\"col-md-3 control-label\">资质期限</label><div class=\"col-md-9\"><div class=\"row\"><div class=\"col-md-6\"><div class=\"input-group\"><span class=\"input-group-addon\">从</span> <input type=\"text\" class=\"form-control\" uib-datepicker-popup=\"yyyy-MM-dd\" name=\"start_time\" ng-model=\"vm.m.start_time\" is-open=\"opened1\" ng-required=\"true\" ng-click=\"opened1=true\"></div><div ng-show=\"Form.$submitted||Form.start_time.$touched\"><span ng-show=\"Form.start_time.$error.required\" class=\"validation-invalid\">必填项!!</span></div></div><div class=\"col-md-6\"><div class=\"input-group\"><span class=\"input-group-addon\">到</span> <input type=\"text\" class=\"form-control\" uib-datepicker-popup=\"yyyy-MM-dd\" name=\"end_time\" ng-model=\"vm.m.end_time\" placeholder=\"永久\" is-open=\"opened2\" ng-click=\"opened2=true\"></div></div></div></div></div><div class=\"form-group\"><label class=\"col-md-3 control-label\">列表排序</label><div class=\"col-md-9\"><input class=\"form-control\" type=\"text\" input-number=\"\" name=\"sorting\" ng-model=\"vm.m.sorting\" validator=\"required\" placeholder=\"请输入数字\"></div></div><div class=\"form-group\"><label class=\"col-md-3 control-label\">备注</label><div class=\"col-md-9\"><textarea class=\"form-control\" id=\"inputNote\" maxlength=\"200\" name=\"note\" ng-model=\"vm.m.note\"></textarea></div></div><div class=\"form-group\"><label class=\"col-md-3 control-label\"><button class=\"btn btn-success btn-sm btn-raised\" type=\"file\" name=\"file\" ngf-select=\"vm.upload($file,vm.m,$invalidFiles)\" ngf-max-size=\"100MB\"><span ng-if=\"vm.m.attachments.length==0\">添加附件</span> <span ng-if=\"vm.m.attachments.length>0\">继续添加</span></button></label><div class=\"col-md-9 attachments\"><div ng-if=\"vm.m.attachments.length==0\" class=\"text-muted\">无附件</div><div class=\"attachment\" ng-if=\"vm.m.attachments.length>0\" ng-repeat=\"attachment in vm.m.attachments\"><span class=\"fa fa-paperclip\" ng-class=\"{\'text-muted\':attachment.inProgress}\" ng-bind=\"attachment.name\"></span> <span class=\"text-muted\" ng-show=\"attachment.size\">({{attachment.size|bytes}})</span><div class=\"progress attach-progress\" ng-show=\"attachment.progress>0&&attachment.progress<100\"><div class=\"progress-bar progress-bar-info\" role=\"progressbar\" aria-valuenow=\"{{attachment.progress}}\" aria-valuemin=\"0\" aria-valuemax=\"100\" ng-style=\"{width:attachment.progress+\'%\'}\"></div></div><a ng-show=\"!attachment.inProgress\" ng-click=\"vm.deleteAttachment($index,vm.m)\">删除</a> <a ng-show=\"!attachment.inProgress\" ng-click=\"vm.download(attachment)\">下载</a>&nbsp; <span ng-show=\"attachment.downloading\" class=\"fa fa-circle-o-notch fa-spin text-muted\"></span></div></div></div><div class=\"form-group\"><div class=\"col-md-offset-3 col-md-9\"><div class=\"pull-right\"><submit-button btn-class=\"btn-info\" btn-click=\"vm.submit(Form,vm.m,5)\" ng-if=\"vm.m.state==5\">保存草稿</submit-button><submit-button btn-class=\"btn-primary\" btn-click=\"vm.submit(Form,vm.m,1)\">发送申请</submit-button><button class=\"btn btn-default\" ui-sref=\"^.list\">取消</button></div></div></div></form></div></div></div>");
$templateCache.put("app/pages/qualifications/query/list/list.html","<div ba-panel=\"\" ba-panel-class=\"light-text tab-content-panel\" ba-panel-header=\"\" hide-add-btn=\"true\" ba-panel-title=\"<span ncy-breadcrumb-last></span>列表\"><div class=\"table-responsive\" loading-container=\"vm.tableParams.settings().$loading\"><table class=\"table table-hover table-row-clicked\" ng-table=\"vm.tableParams\" template-header=\"app/theme/components/table/header.html\"><tr ng-repeat-start=\"row in $data track by row.id\" ng-click=\"row.showDetail=!row.showDetail\"><td ng-click=\"$event.stopPropagation()\"><button type=\"button\" class=\"btn btn-default btn-xs\" ng-click=\"row.showDetail=!row.showDetail\"><i class=\"glyphicon glyphicon-chevron-down\" ng-hide=\"row.showDetail\"></i> <i class=\"glyphicon glyphicon-chevron-up\" ng-show=\"row.showDetail\"></i></button> <button class=\"btn btn-xs btn-danger\" ng-click=\"vm.setStop(row)\" ng-if=\"row.state.id==2\" uib-tooltip=\"申请停用\" tooltip-class=\"tooltipInfo\" tooltip-append-to-body=\"true\"><i class=\"fa fa-ban\"></i></button> <button class=\"btn btn-xs btn-info\" ui-sref=\"^.edit({id:row.id})\" ng-if=\"row.state.id==4\" uib-tooltip=\"重新申请\" tooltip-class=\"tooltipInfo\" tooltip-append-to-body=\"true\"><i class=\"fa fa-pencil-square-o\"></i></button> <button class=\"btn btn-info btn-xs\" ui-sref=\"^.edit({id:row.id})\" ng-if=\"row.state.id==1\" uib-tooltip=\"修改\" tooltip-class=\"tooltipInfo\"><span class=\"glyphicon glyphicon-pencil\"></span></button> <button class=\"btn btn-xs btn-default\" ng-click=\"vm.sort(row)\" ng-if=\"!row.$edit\" uib-tooltip=\"修改排序\" tooltip-class=\"tooltipInfo\" tooltip-append-to-body=\"true\"><i class=\"fa fa-sort-amount-asc\"></i></button> <button class=\"btn btn-danger btn-xs\" ng-if=\"row.state.id==1||row.state.id==4\" ng-click=\"vm.remove(row)\"><span class=\"glyphicon glyphicon-trash\"></span></button></td><td ng-repeat=\"col in vm.cols\" ng-switch=\"col.field\" ng-if=\"col.show\"><div ng-switch-when=\"name\"><span ng-bind=\"row[col.field]\" style=\"vertical-align:top\"></span> <span ng-if=\"row.attachments.length>0\" class=\"fa fa-paperclip\" style=\"vertical-align:middle\"></span> <span class=\"tag tag-danger\" title=\"停用\" ng-if=\"row.state.id==4\">停</span></div><div ng-switch-when=\"sorting\"><span ng-hide=\"row.$edit\" ng-bind=\"row.sorting\"></span><div ng-show=\"row.$edit\"><div class=\"input-group\"><input type=\"text\" input-number=\"\" class=\"form-control\" ng-model=\"row.$sortingChanged\"> <span class=\"input-group-btn\"><button class=\"btn btn-warning\"><i class=\"glyphicon glyphicon-ok\" ng-click=\"vm.save(row);$event.stopPropagation()\"></i></button></span></div></div></div><div ng-switch-when=\"code\"><span ng-bind=\"row.code?row.code:\'暂无\'\"></span></div><div ng-switch-when=\"end_time\"><span ng-bind=\"row.end_time?row.end_time:\'永久\'\"></span></div><span ng-switch-default=\"\">{{row[col.field].name}}</span></td></tr><tr ng-repeat-end=\"\" ng-if=\"row.showDetail\" class=\"bg-gray-light\"><td colspan=\"7\"><table class=\"table table-hover\"><tbody><tr><td>资质期限：{{row.start_time}}~{{row.end_time?row.end_time:\'永久\'}}</td><td>提醒时间：{{row.remind_time?row.remind_time:\'暂无\'}}</td></tr><tr ng-if=\"row.attachments!=null&&row.attachments.length>0\" ng-repeat=\"attachment in row.attachments\"><td colspan=\"2\"><div class=\"att-item\"><div class=\"att-ico\"><i class=\"fa fa-{{attachment.ico}} fa-2x text-info\"></i></div><div class=\"att-name\"><span ng-bind=\"attachment.name\"></span> <span class=\"text-muted\">({{attachment.size|bytes}})</span> <a ng-click=\"vm.download(attachment)\">下载</a>&nbsp; <span ng-show=\"attachment.downloading\" class=\"fa fa-circle-o-notch fa-spin text-muted\"></span><attachment-preview ng-model=\"attachment\"></attachment-preview></div></div></td></tr><tr ng-if=\"row.note!=null\"><td colspan=\"2\">备注：{{row.note}}</td></tr><tr ng-if=\"row.reason!=null\"><td colspan=\"2\">停用原因：{{row.reason}}</td></tr></tbody></table></td></tr><tr ng-if=\"!vm.tableParams.settings().$loading&&($data==null||$data.length==0)\" class=\"table-no-data\"><td colspan=\"99\" align=\"center\"><span>暂无数据</span></td></tr></table></div></div>");
$templateCache.put("app/pages/qualifications/remind/list/list.html","<div ba-panel=\"\" ba-panel-class=\"light-text tab-content-panel\" ba-panel-header=\"\" hide-add-btn=\"true\" ba-panel-title=\"<span ncy-breadcrumb-last></span>列表\"><div class=\"row\"><div class=\"col-md-3\"><span>即将过期资质<span class=\"text-danger\" ng-bind=\"vm.num\"></span>个</span></div></div><div class=\"table-responsive\" loading-container=\"vm.tableParams.settings().$loading\"><table class=\"table table-hover table-row-clicked\" ng-table=\"vm.tableParams\" template-header=\"app/theme/components/table/header.html\"><tr ng-repeat-start=\"row in $data track by row.id\"><td><button type=\"button\" class=\"btn btn-default btn-xs\" ng-click=\"row.showDetail=!row.showDetail\"><i class=\"glyphicon glyphicon-chevron-down\" ng-hide=\"row.showDetail\"></i> <i class=\"glyphicon glyphicon-chevron-up\" ng-show=\"row.showDetail\"></i></button> <button class=\"btn btn-xs btn-danger\" ng-click=\"vm.setStop(row)\" ng-if=\"row.state.id==2\" uib-tooltip=\"申请停用\" tooltip-class=\"tooltipInfo\" tooltip-append-to-body=\"true\"><i class=\"fa fa-ban\"></i></button> <button class=\"btn btn-warning btn-xs\" uib-tooltip=\"设置提醒时间\" tooltip-class=\"tooltipInfo\" tooltip-append-to-body=\"true\" ui-sref=\"^.set({id:row.id})\"><i class=\"fa fa-clock-o\"></i></button></td><td ng-repeat=\"col in vm.cols\" ng-switch=\"col.field\" ng-if=\"col.show\"><div ng-switch-when=\"name\"><span ng-bind=\"row[col.field]\" style=\"vertical-align:top\"></span> <span ng-if=\"row.attachments.length>0\" class=\"fa fa-paperclip\" style=\"vertical-align:middle\"></span> <span class=\"tag tag-danger\" title=\"即将过期\" ng-if=\"row.warning\">即将过期</span> <span class=\"tag tag-danger\" title=\"已过期\" ng-if=\"row.danger\">已过期</span></div><div ng-switch-when=\"type\"><span ng-bind=\"row[col.field].name\"></span></div><div ng-switch-when=\"code\"><span ng-bind=\"row.code?row.code:\'暂无\'\"></span></div><span ng-switch-default=\"\">{{row[col.field]}}</span></td></tr><tr ng-repeat-end=\"\" ng-if=\"row.showDetail\" class=\"bg-gray-light\"><td colspan=\"6\"><table class=\"table table-hover\"><tbody><tr><td>资质期限：{{row.start_time}}~{{row.end_time?row.end_time:\'永久\'}}</td></tr><tr ng-if=\"row.attachments!=null&&row.attachments.length>0\" ng-repeat=\"attachment in row.attachments\"><td><div class=\"att-item\"><div class=\"att-ico\"><i class=\"fa fa-{{attachment.ico}} fa-2x text-info\"></i></div><div class=\"att-name\"><span ng-bind=\"attachment.name\"></span> <span class=\"text-muted\">({{attachment.size|bytes}})</span> <a ng-click=\"vm.download(attachment)\">下载</a>&nbsp; <span ng-show=\"attachment.downloading\" class=\"fa fa-circle-o-notch fa-spin text-muted\"></span><attachment-preview ng-model=\"attachment\"></attachment-preview></div></div></td></tr><tr ng-if=\"row.note!=null\"><td>备注：{{row.note}}</td></tr><tr ng-if=\"row.reason!=null\"><td>停用原因：{{row.reason}}</td></tr></tbody></table></td></tr><tr ng-if=\"!vm.tableParams.settings().$loading&&($data==null||$data.length==0)\" class=\"table-no-data\"><td colspan=\"99\" align=\"center\"><span>暂无数据</span></td></tr></table></div></div>");
$templateCache.put("app/pages/qualifications/remind/set/set.html","<div class=\"row\"><div class=\"col-lg-6 col-md-8 col-sm-8\"><div ba-panel=\"\" ba-panel-class=\"light-text tab-content-panel\" ba-panel-title=\"<span ncy-breadcrumb-last></span>\"><form name=\"Form\" class=\"form-horizontal\" novalidate=\"\"><div class=\"form-group\"><label class=\"col-md-2 control-label\">名称</label><div class=\"col-md-10\"><input type=\"text\" disabled=\"\" class=\"form-control\" name=\"name\" ng-model=\"vm.m.name\" required=\"\"></div></div><div class=\"form-group\"><label class=\"col-md-2 control-label\">资质期限</label><div class=\"col-md-10\"><div class=\"row\"><div class=\"col-md-6\"><div class=\"input-group\"><span class=\"input-group-addon\">从</span> <input type=\"text\" class=\"form-control\" uib-datepicker-popup=\"yyyy-MM-dd\" name=\"start_time\" ng-model=\"vm.m.start_time\" disabled=\"\" is-open=\"opened1\" ng-required=\"true\" ng-click=\"opened1=true\"></div></div><div class=\"col-md-6\"><div class=\"input-group\"><span class=\"input-group-addon\">到</span> <input type=\"text\" class=\"form-control\" uib-datepicker-popup=\"yyyy-MM-dd\" name=\"end_time\" ng-model=\"vm.m.end_time\" disabled=\"\" is-open=\"opened2\" ng-required=\"true\" ng-click=\"opened2=true\"></div></div></div></div></div><div class=\"form-group\"><label class=\"col-md-2 control-label\">提醒时间</label><div class=\"col-md-10\"><div class=\"input-group\"><input type=\"text\" class=\"form-control\" uib-datepicker-popup=\"yyyy-MM-dd\" style=\"margin-right:8px;border-radius:4px\" name=\"remind_time\" ng-model=\"vm.m.remind_time\" is-open=\"opened3\" ng-required=\"true\" ng-click=\"opened3=true\"></div><div ng-show=\"Form.$submitted||Form.remind_time.$touched\"><span ng-show=\"Form.remind_time.$error.required\" class=\"validation-invalid\">必填项!!</span></div></div></div><div class=\"form-group\"><div class=\"col-md-offset-3 col-md-9\"><div class=\"pull-right\"><submit-button btn-class=\"btn-primary\" btn-click=\"vm.submit(Form,vm.m)\">提交</submit-button><button class=\"btn btn-default\" ui-sref=\"^.list\">取消</button></div></div></div></form></div></div></div>");
$templateCache.put("app/theme/components/table/filters/date_range.html","<div class=\"btn-group filter-date-range\" style=\"width:100%\" dropdown=\"\" auto-close=\"outsideClick\"><button type=\"button\" data-toggle=\"dropdown\" style=\"text-align: left !important;\" class=\"btn btn-default dropdown-toggle btn-block\"><span ng-show=\"params.filter()[\'start.\'+name] != null && params.filter()[\'end.\'+name] != null\">从<strong>{{params.filter()[\'start.\'+name] | date : \'yyyy年M月d日\'}}</strong>到<strong>{{params.filter()[\'end.\'+name] | date : \'yyyy年M月d日\'}}</strong></span> <span ng-show=\"params.filter()[\'start.\'+name] != null && params.filter()[\'end.\'+name] == null\">在<strong>{{params.filter()[\'start.\'+name] | date : \'yyyy年M月d日\'}}</strong>之后</span> <span ng-show=\"params.filter()[\'start.\'+name] == null && params.filter()[\'end.\'+name] != null\">在<strong>{{params.filter()[\'end.\'+name] | date : \'yyyy年M月d日\'}}</strong>之前</span> <span ng-show=\"params.filter()[\'start.\'+name] == null && params.filter()[\'end.\'+name] == null\">{{placeHolder?placeHolder:\'选择日期范围\'}}</span></button><ul class=\"dropdown-menu list-inline\"><li class=\"col-xs-6\"><input type=\"text\" class=\"form-control\" uib-datepicker-popup=\"\" ng-model=\"params.filter()[\'start.\'+name]\" max-date=\"params.filter()[\'end.\'+name]\" datepicker-mode=\"\'year\'\" show-weeks=\"false\" is-open=\"opened1\" placeholder=\"从\" ng-focus=\"opened1=true\" show-button-bar=\"false\" close-on-date-selection=\"false\"></li><li class=\"col-xs-6\"><input type=\"text\" class=\"form-control\" uib-datepicker-popup=\"\" ng-model=\"params.filter()[\'end.\'+name]\" min-date=\"params.filter()[\'start.\'+name]\" datepicker-mode=\"\'year\'\" show-weeks=\"false\" is-open=\"opened2\" placeholder=\"到\" ng-focus=\"opened2=true\" show-button-bar=\"false\" close-on-date-selection=\"false\"></li></ul></div>");
$templateCache.put("app/theme/components/table/filters/num_range.html","<div class=\"btn-group filter-num-range\" style=\"width:100%\" dropdown=\"\" auto-close=\"outsideClick\"><button type=\"button\" data-toggle=\"dropdown\" style=\"text-align: left !important;\" class=\"btn btn-default dropdown-toggle btn-block\"><span ng-show=\"(params.filter()[\'start.\'+name] != \'\' && params.filter()[\'start.\'+name] != null) && (params.filter()[\'end.\'+name] != \'\' && params.filter()[\'end.\'+name] != null)\"><strong>{{params.filter()[\'start.\'+name]}}</strong>到<strong>{{params.filter()[\'end.\'+name]}}</strong></span> <span ng-show=\"(params.filter()[\'start.\'+name] != \'\' && params.filter()[\'start.\'+name] != null) && (params.filter()[\'end.\'+name] == \'\' || params.filter()[\'end.\'+name] == null)\">不小于<strong>{{params.filter()[\'start.\'+name]}}</strong></span> <span ng-show=\"(params.filter()[\'start.\'+name] == \'\' || params.filter()[\'start.\'+name] == null) && (params.filter()[\'end.\'+name] != \'\' && params.filter()[\'end.\'+name] != null)\">不大于<strong>{{params.filter()[\'end.\'+name]}}</strong></span> <span ng-show=\"(params.filter()[\'start.\'+name] == \'\' || params.filter()[\'start.\'+name] == null) && (params.filter()[\'end.\'+name] == \'\' || params.filter()[\'end.\'+name] == null)\">{{placeHolder?placeHolder:\'填写范围\'}}</span></button><ul class=\"dropdown-menu list-inline\"><li class=\"col-xs-6\"><input type=\"text\" input-number=\"\" class=\"form-control\" placeholder=\"从\" ng-model=\"params.filter()[\'start.\'+name]\"></li><li class=\"col-xs-6\"><input type=\"text\" input-number=\"\" class=\"form-control\" placeholder=\"到\" ng-model=\"params.filter()[\'end.\'+name]\"></li></ul></div>");
$templateCache.put("app/theme/components/table/filters/select.html","<select ng-options=\"data.id as data.title for data in col.data\" ng-model=\"params.filter()[name]\" class=\"filter filter-select form-control\" name=\"{{name}}\"></select>");
$templateCache.put("app/theme/components/table/filters/text.html","<input type=\"text\" name=\"{{name}}\" ng-model=\"params.filter()[name]\" class=\"input-filter form-control\">");
$templateCache.put("app/theme/components/table/filters/tree.html","<script type=\"text/ng-template\" id=\"tree_items.html\"><div ui-tree-handle class=\"tree-node\" ng-click=\"params.filter()[name]={id:item.id,name:item.name};x.isOpen=false\" style=\"cursor:pointer\"> <a class=\"btn btn-success btn-xs\" ng-if=\"item.children&&item.children.length>0\" data-nodrag ng-click=\"$event.stopPropagation();toggle(this)\"> <i class=\"glyphicon\" ng-class=\"{\'glyphicon-chevron-right\':collapsed, \'glyphicon-chevron-down\':!collapsed}\"> </i> </a> <span ng-bind=\"item.name\"></span> </div> <ol ui-tree-nodes ng-model=\"item.children\" ng-class=\"{hidden:collapsed}\"> <li ng-repeat=\"item in item.children\" ui-tree-node ng-include=\"\'tree_items.html\'\"> </li> </ol></script><div uib-dropdown=\"\" auto-close=\"outsideClick\" is-open=\"x.isOpen\" ng-init=\"x={}\"><button type=\"button\" class=\"btn btn-default btn-block dropdown-toggle noHover\" uib-dropdown-toggle=\"\"><span class=\"pull-left\" ng-bind=\"params.filter()[name].name\"></span> <span class=\"caret pull-right\" style=\"margin:9px 0 9px 0\"></span></button><div class=\"dropdown-menu\" uib-dropdown-menu=\"\" role=\"menu\" style=\"white-space:normal\"><div oc-lazy-load=\"[\'/ocLazyLoad/uiTree/angular-ui-tree.min.css\', \'/ocLazyLoad/uiTree/angular-ui-tree.min.js\']\"><div ui-tree=\"\" id=\"tree-root\" style=\"margin:8px\" data-drag-enabled=\"false\"><div style=\"min-height:150px;max-height:280px;overflow-y:auto\"><ol ui-tree-nodes=\"\" ng-model=\"col.data[1].children\"><li ng-repeat=\"item in col.data[1].children\" ui-tree-node=\"\" ng-include=\"\'tree_items.html\'\" data-collapsed=\"true\"></li></ol></div></div></div></div></div>");
$templateCache.put("app/theme/components/table/tableOptionTab/tableOptionTab.html","<div class=\"option-tab-nav\"><div class=\"nav-tag\">{{::tagTitle}}</div><uib-tabset type=\"pills\" active=\"curOptionId\"><uib-tab index=\"option.id\" ng-repeat=\"option in options track by option.id\" select=\"optionSelected(option)\"><uib-tab-heading><i class=\"fa fa-tags\"></i> {{::option.name}}</uib-tab-heading></uib-tab></uib-tabset><hr class=\"mt-5 mb-5\"></div>");
$templateCache.put("app/pages/csmbs/batches/batch/edit/edit.html","<div ba-panel=\"\" ba-panel-class=\"profile-page\" ba-panel-title=\"<span ncy-breadcrumb-last></span>\"><div class=\"panel-content\"><div class=\"alert alert-warning\"><strong class=\"text-danger\">添加批次后会自动生成主动发货申请单，若需要撤销发货可在【供货申请】|【已处理】标签下撤销，撤销后可在待处理中重新发货或者移除订单</strong></div><form name=\"Form\" class=\"form-horizontal\" novalidate=\"\"><div class=\"form-group\"><label class=\"col-md-2 control-label\">接收库房</label><div class=\"col-md-10\"><div class=\"input-group\"><ui-select name=\"room\" ng-class=\"{\'submitted\':Form.$submitted}\" ng-model=\"vm.m.room\" search-enabled=\"false\" title=\"选择库房\" required=\"\" on-select=\"vm.roomSelectedFn($item,vm.m)\"><ui-select-match placeholder=\"选择库房...\">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat=\"room in vm.rooms | filter: $select.search\"><div ng-bind-html=\"room.name | highlight: $select.search\"></div></ui-select-choices></ui-select><span class=\"input-group-addon\"><label class=\"checkbox-label\"><input type=\"checkbox\" ng-model=\"vm.m.with_sms\"> <small>短信通知库房</small></label></span></div><div ng-show=\"Form.$submitted||Form.room.$touched\"><span ng-show=\"Form.room.$error.required\" class=\"validation-invalid\">必填项!!</span></div></div></div><div class=\"form-group\" ng-show=\"vm.m.room.id\"><label class=\"col-md-2 control-label\">耗材名称</label><div class=\"col-md-10\"><csmb-select ng-model=\"vm.m.consumable\" room-id=\"vm.m.room.id\" name=\"consumable\" on-select=\"vm.csmbSelectedFn(vm.m)\"></csmb-select><div ng-show=\"Form.$submitted||Form.consumable.$touched\"><span ng-show=\"!vm.m.consumable\" class=\"validation-invalid control-label\">必填项!!(更换库房需重新选择耗材)</span></div></div></div><div class=\"form-group\" ng-show=\"vm.m.consumable\"><label class=\"col-md-2 control-label\">注册证号</label><div class=\"col-md-10\"><p class=\"form-control-static\">{{vm.m.consumable.r_num}}</p></div></div><div class=\"form-group\" ng-show=\"vm.m.consumable\"><label class=\"col-md-2 control-label\">编号</label><div class=\"col-md-10\"><p class=\"form-control-static\">{{vm.m.consumable.code}}</p></div></div><div class=\"form-group\" ng-if=\"vm.m.consumable.has_life==\'1\'\"><label class=\"col-md-2 control-label\">保质期</label><div class=\"col-md-10\"><p class=\"form-control-static\">{{vm.m.consumable[\'year_shelf_life\']>0?vm.m.consumable[\'year_shelf_life\']+\'年\':\'\'}} {{vm.m.consumable[\'month_shelf_life\']>0?vm.m.consumable[\'month_shelf_life\']+\'月\':\'\'}} {{vm.m.consumable[\'shelf_life\']>0?vm.m.consumable[\'shelf_life\']+\'天\':\'\'}}</p></div></div><div class=\"form-group\" ng-if=\"vm.m.consumable.purchase_unit!=vm.m.consumable.storage_unit||vm.m.consumable.use_unit!=vm.m.consumable.storage_unit\"><label class=\"col-md-2 control-label\">单位换算</label><div class=\"col-md-10\"><p class=\"form-control-static\"><span ng-if=\"vm.m.consumable.purchase_unit!=vm.m.consumable.storage_unit\">每 <span class=\"text-red\" ng-bind=\"vm.m.consumable.purchase_unit\"></span> <span class=\"text-red\" ng-bind=\"vm.m.consumable.storage_num\"></span> <span class=\"text-red\" ng-bind=\"vm.m.consumable.storage_unit\"></span></span> <span ng-if=\"vm.m.consumable.use_unit!=vm.m.consumable.storage_unit\">每 <span class=\"text-red\" ng-bind=\"vm.m.consumable.storage_unit\"></span> <span class=\"text-red\" ng-bind=\"vm.m.consumable.use_num\"></span> <span class=\"text-red\" ng-bind=\"vm.m.consumable.use_unit\"></span></span></p></div></div><div class=\"form-group\" ng-if=\"vm.m.consumable\"><div class=\"col-md-10 col-md-offset-2 mb-10\"><table class=\"table table-hover table-bordered table-condensed\" style=\"margin-bottom:0\"><thead style=\"background:azure\"><tr><th colspan=\"6\">发货详情</th></tr></thead><tbody><tr><td>批次</td><td>生产日期</td><td>失效日期</td><td width=\"180\">发货量</td><td>操作</td></tr><tr ng-repeat=\"batch in vm.m.batches\"><td><input class=\"form-control input-sm\" type=\"text\" name=\"no{{batch.index}}\" style=\"margin-top: 3px\" ng-change=\"vm.noSelected(vm.m,batch)\" ng-model=\"batch.no\" validator=\"required\"></td><td><input type=\"text\" class=\"form-control\" uib-datepicker-popup=\"yyyy-MM-dd\" datepicker-options=\"vm.dateOptions\" ng-change=\"vm.dateSelected(vm.m,batch,1)\" name=\"production_date{{batch.index}}\" ng-model=\"batch.production_date\" datepicker-mode=\"\'day\'\" is-open=\"opened1\" ng-required=\"true\" ng-click=\"opened1=true\"><div ng-show=\"Form.$submitted||Form[\'production_date\'+batch.index].$touched\"><span ng-show=\"Form[\'production_date\'+batch.index].$error.required\" class=\"validation-invalid\">必填项!!</span></div><div ng-if=\"batch.production_date2\">{{batch.production_date2}}<a class=\"btn btn-xs\" ng-click=\"vm.dateInput(batch)\">填充生产日期</a></div></td><td ng-if=\"vm.m.consumable.has_life == \'1\'\"><input type=\"text\" class=\"form-control\" uib-datepicker-popup=\"yyyy-MM-dd\" ng-change=\"vm.dateSelected(vm.m,batch,2)\" name=\"deadline{{batch.index}}\" ng-model=\"batch.deadline\" datepicker-mode=\"\'day\'\" is-open=\"opened2\" ng-required=\"true\" ng-click=\"opened2=true\"><div ng-show=\"Form.$submitted||Form[\'deadline\'+batch.index].$touched\"><span ng-show=\"Form[\'deadline\'+batch.index].$error.required\" class=\"validation-invalid\">必填项!!</span></div></td><td ng-if=\"vm.m.consumable.has_life == \'0\'\">长期有效</td><td><span ng-if=\"vm.m.consumable.purchase_unit!=vm.m.consumable.storage_unit\"><input class=\"form-control form-control-36 input-sm\" type=\"text\" name=\"l_num{{batch.index}}\" ng-model=\"batch.l_num\" input-number=\"\" validator=\"required\"> {{vm.m.consumable.purchase_unit}}</span> <input class=\"form-control form-control-36 input-sm\" type=\"text\" name=\"s_num{{batch.index}}\" ng-model=\"batch.s_num\" input-number=\"\" validator=\"required\"> {{vm.m.consumable.storage_unit}}</td><td><button type=\"button\" class=\"btn btn-danger btn-xs\" ng-disabled=\"$index==0\" ng-click=\"vm.remove(vm.m,$index)\">删除</button></td></tr></tbody><tfoot><tr><td colspan=\"4\" class=\"text-info text-right\">批次无货时直接删除,同一经销商批次建议不要分开录入，否则系统会产生多个批次</td><td><button type=\"button\" class=\"btn btn-success btn-xs\" ng-click=\"vm.add(vm.m)\">添加批次</button></td></tr></tfoot></table></div></div><div class=\"form-group\"><div class=\"col-md-10 col-md-offset-2\"><label class=\"cb-label-wrapper\"><checkbox ng-model=\"vm.m.gift\" ng-change=\"vm.checkPrice(vm.m)\"></checkbox><strong>是否赠品</strong></label></div></div><div class=\"form-group\"><label class=\"col-md-2 control-label\">出厂价格/元</label><div class=\"col-md-10\"><div class=\"input-group\"><input class=\"form-control\" type=\"text\" name=\"price\" ng-model=\"vm.m.price\" ng-disabled=\"(!vm.m.canEditPrice&&!vm.m.canIncreasePrice)||vm.m.gift\" input-float=\"2\" validator=\"maxnum={{vm.m.canIncreasePrice?\'9999999\':vm.m.consumable.purchase_price}},required\"> <span class=\"input-group-addon\"><label class=\"checkbox-label\">{{vm.m.consumable.use_unit}}</label></span></div></div></div><div class=\"form-group\"><div class=\"col-md-10 col-md-offset-2\"><label class=\"cb-label-wrapper mr-5\"><checkbox ng-model=\"vm.m.disinfect\"></checkbox><strong>是否消毒</strong></label> <label class=\"cb-label-wrapper\"><checkbox ng-model=\"vm.m.temporary\"></checkbox><strong>是否暂存至库房</strong></label></div></div><div class=\"form-group\"><label class=\"col-md-2 control-label\">备注</label><div class=\"col-md-10\"><textarea class=\"form-control\" rows=\"5\" name=\"note\" ng-model=\"vm.m.note\" placeholder=\"200字内...\" maxlength=\"200\"></textarea></div></div><div class=\"form-group\"><div class=\"col-md-offset-3 col-md-9\"><div class=\"pull-right\"><button ng-click=\"vm.reset(Form)\" class=\"btn btn-default\"><i class=\"fa fa-refresh\"></i>&nbsp;重置</button><submit-button btn-class=\"btn-primary\" btn-click=\"vm.submit(Form,vm.m)\"><i class=\"ion-android-checkmark-circle\"></i>&nbsp;提交</submit-button></div></div></div></form></div></div>");
$templateCache.put("app/pages/csmbs/batches/dialogs/batchDetail/history.html","<div class=\"modal-header dialog-header-confirm\"><button type=\"button\" class=\"close\" ng-click=\"vm.cancel()\">&times;</button> <span><i class=\"fa fa-history modal-icon\"></i>&nbsp;批次历史</span></div><div class=\"modal-body\"><div class=\"panel panel-default\"><div class=\"panel-heading\"><strong>历史列表</strong><div class=\"btn-group pull-right\" style=\"margin-top: -8px\"><button ng-click=\"vm.tableReload()\" class=\"btn btn-default btn-circle\"><i class=\"fa fa-refresh\"></i></button></div></div><div class=\"panel-body single-panel\" loading-container=\"vm.tableParams.settings().$loading\"><table class=\"table table-hover table-row-clicked\" ng-table=\"vm.tableParams\" template-header=\"app/theme/components/table/header.html\"><tr ng-repeat=\"row in $data track by row.id\"><td ng-repeat=\"col in vm.cols\" ng-switch=\"col.field\" ng-if=\"col.show\"><div ng-switch-when=\"num\">{{row.num}}</div><div ng-switch-when=\"receive_time\">{{row.receive_time.substr(0,16)}}</div><div ng-switch-default=\"\">{{row[col.field].name}}</div></td></tr><tr ng-if=\"!vm.tableParams.settings().$loading&&($data==null||$data.length==0)\" class=\"table-no-data\"><td colspan=\"99\" align=\"center\"><span>暂无数据</span></td></tr></table></div></div></div><div class=\"modal-footer\"><button class=\"btn btn-default\" ng-click=\"vm.cancel()\">取消</button></div>");
$templateCache.put("app/pages/csmbs/batches/dialogs/directDetail/history.html","<div class=\"modal-header dialog-header-confirm\"><button type=\"button\" class=\"close\" ng-click=\"vm.cancel()\">&times;</button> <span><i class=\"fa fa-history modal-icon\"></i>&nbsp;批次历史</span></div><div class=\"modal-body\"><div class=\"panel panel-default\"><div class=\"panel-heading\"><strong>历史列表</strong><div class=\"btn-group pull-right\" style=\"margin-top: -8px\"><button ng-click=\"vm.tableReload()\" class=\"btn btn-default btn-circle\"><i class=\"fa fa-refresh\"></i></button></div></div><div class=\"panel-body single-panel\" loading-container=\"vm.tableParams.settings().$loading\"><table class=\"table table-hover table-row-clicked\" ng-table=\"vm.tableParams\" template-header=\"app/theme/components/table/header.html\"><tr ng-repeat=\"row in $data track by row.id\"><td ng-repeat=\"col in vm.cols\" ng-switch=\"col.field\" ng-if=\"col.show\"><div ng-switch-when=\"num\">{{row.num}}</div><div ng-switch-when=\"receive_time\">{{row.receive_time.substr(0,16)}}</div><div ng-switch-default=\"\">{{row[col.field].name}}</div></td></tr><tr ng-if=\"!vm.tableParams.settings().$loading&&($data==null||$data.length==0)\" class=\"table-no-data\"><td colspan=\"99\" align=\"center\"><span>暂无数据</span></td></tr></table></div></div></div><div class=\"modal-footer\"><button class=\"btn btn-default\" ng-click=\"vm.cancel()\">取消</button></div>");
$templateCache.put("app/pages/csmbs/batches/dialogs/invoice/csmbBatch.html","<style>\n    @media print {\n        @page {\n            size: 68mm 48mm;\n            margin: 1mm 1mm;\n        }\n\n        html, body {\n            width: 70mm;\n            margin: 0;\n            padding: 0;\n        }\n\n        .title {\n            margin-top: 5px;\n            font-weight: bold;\n            text-align: center;\n        }\n\n        .title-small {\n            margin-top: 5px;\n            font-weight: bold;\n            text-align: center;\n            font-size: 10px;\n        }\n\n        .info {\n            font-size: 10px;\n            margin-top: 5px;\n        }\n\n        .img {\n            float: left;\n        }\n\n        .note {\n            margin-left: 110px;\n        }\n\n        .paging {\n            font-family: \'黑体\';\n            /*font-size: 15px;*/\n            margin-left: 10px;\n            page-break-after: always;\n        }\n    }\n</style>");
$templateCache.put("app/pages/csmbs/batches/dialogs/invoice/invoice.html","<div class=\"modal-header dialog-header-confirm\"><button type=\"button\" class=\"close\" ng-click=\"vm.cancel()\">&times;</button><h4 class=\"modal-title\"><i class=\"fa fa-file-text\">批次发货单</i></h4></div><div class=\"modal-body\"><div class=\"text-center\"><label>{{vm.room.name}}发货详情</label></div><div id=\"invoice-table\" class=\"table-responsive\"><table class=\"table\"><tr><th>出库时间</th><th>名称</th><th>规格型号</th><th>编号</th><th>注册证号</th><th>生产经销商</th><th>批号/有效期</th><th>流水号</th><th>单位</th><th>单价</th><th>数量</th><th>金额</th></tr><tr class=\"form-table-input-text\" ng-repeat=\"m in vm.items\"><td>{{m.created_at}}</td><td>{{m.consumable.name!=\'\'?m.consumable.name:m.consumable.c_name}}</td><td>{{m.consumable.spec}}</td><td>{{m.consumable.code}}</td><td>{{m.consumable.r_num}}</td><td>{{m.consumable.producer?m.consumable.producer.name:\'\'}}</td><td>{{m.no+\'/\'+(m.deadline?m.deadline:\'长期有效\')}}</td><td>{{m.consumable.sunshine_num}}</td><td><span ng-if=\"m.consumable.purchase_unit!=m.consumable.storage_unit\">每{{m.consumable.purchase_unit}}{{m.consumable.storage_num}}{{m.consumable.storage_unit}}</span> <span ng-if=\"m.consumable.storage_unit!=m.consumable.use_unit\">每{{m.consumable.storage_unit}}{{m.consumable.use_num}}{{m.consumable.use_unit}}</span> <span ng-if=\"(m.consumable.purchase_unit==m.consumable.storage_unit)&&(m.consumable.storage_unit==m.consumable.use_unit)\">{{m.consumable.storage_unit}}</span></td><td>{{m.purchase_price}}</td><td>{{m.c_num}}</td><td>{{m.money}}</td></tr><tr bgcolor=\"#f5f5dc\"><td colspan=\"11\">合计</td><td>{{vm.items.TotalMoney}}</td></tr></table></div><div class=\"text-center attachments\"><h5>发货单二维码</h5><qrcode id=\"QrCode\" size=\"128\" data=\"{{vm.m}}\"></qrcode></div><qrcode id=\"QrCode{{qrCode.id}}\" version=\"5\" error-correction-level=\"M\" size=\"128\" hidden=\"\" ng-repeat=\"qrCode in vm.items\" data=\"{{qrCode.qrUrl}}\"></qrcode></div><div class=\"modal-footer\"><button class=\"btn btn-success\" ng-click=\"vm.printBatch()\"><i class=\"fa fa-print fa-fw\"></i>打印耗材批次</button> <button class=\"btn btn-primary\" ng-click=\"vm.print()\"><i class=\"fa fa-print fa-fw\"></i>打印</button> <button class=\"btn btn-default\" ng-click=\"vm.cancel()\">取消</button></div>");
$templateCache.put("app/pages/csmbs/batches/dialogs/invoice/print.html","<style>\n    @media print {\n        h3 {\n            font-size: 28px;\n            font-weight: normal;\n            text-align: center;\n            margin-bottom: 3px;\n        }\n\n        h5 {\n            color: grey;\n            font-size: 16px;\n            font-weight: normal;\n\n            padding-bottom: 20px;\n            margin-top: 25px;\n            margin-bottom: -10px;\n\n            text-align: center;\n            border-bottom: solid 1px grey;\n        }\n\n        h5 > span {\n            margin: 3px 30px 3px 30px;\n        }\n\n        .qrcode {\n            float: left;\n        }\n\n        h4 {\n            text-align: center;\n            margin: 16px 3px 6px 3px;\n        }\n\n        table {\n            width: 100%;\n            border: solid 1px grey;\n        }\n\n        table {\n            border-collapse: collapse;\n        }\n\n        table, th, td {\n            border: solid 1px grey;\n        }\n\n        th, td {\n            padding: 2px;\n            text-align: left;\n        }\n    }\n</style>");
$templateCache.put("app/pages/csmbs/direct/dialogs/csmbOut/batch.html","<script type=\"text/ng-template\" id=\"CsmbLargeImgDlg.html\"><div fullscreen=\"isFullscreen\"> <div class=\"modal-header dialog-header-confirm\"> <button type=\"button\" class=\"close\" ng-click=\"vm.cancel()\">&times;</button> <button type=\"button\" class=\"close\" ng-click=\"isFullscreen=!isFullscreen\" style=\"padding-right:6px\"> <i class=\"fa fa-square-o\"></i></button> <h4 class=\"modal-title\"> <i class=\"fa fa-photo\"></i>&nbsp;耗材图片 </h4> </div> <div class=\"modal-body\"> <img class=\"img-responsive poster\" ng-src=\"{{vm.m.path}}\"><br> </div> <div class=\"modal-footer\"> <button class=\"btn btn-default\" ng-click=\"vm.cancel()\">返回</button> </div> </div></script><div class=\"modal-header dialog-header-confirm\"><button type=\"button\" class=\"close\" ng-click=\"vm.cancel()\">&times;</button> <span><i class=\"fa fa-stack-overflow modal-icon\"></i>发货批次</span></div><div class=\"modal-body\"><div class=\"panel panel-default\"><div class=\"panel-heading\"><strong>发货耗材列表</strong> <small class=\"text-red\">实际金额总计：{{vm.totalPrice|currency:\'￥\'}}</small><div class=\"btn-group pull-right\" style=\"margin-top: -8px\"><button ng-click=\"vm.tableReload()\" class=\"btn btn-default btn-circle\"><i class=\"fa fa-refresh\"></i></button></div></div><div class=\"panel-body single-panel min-h418\" loading-container=\"vm.tableParams.settings().$loading\"><div class=\"table-responsive\"><table class=\"table table-hover table-row-clicked\" ng-table=\"vm.tableParams\" template-header=\"app/theme/components/table/header.html\"><tr ng-repeat-start=\"row in $data track by row.id\" ng-click=\"row.showDetail=!row.showDetail\"><td ng-click=\"$event.stopPropagation()\"><button type=\"button\" class=\"btn btn-default btn-xs\" ng-click=\"row.showDetail=!row.showDetail\"><i class=\"glyphicon glyphicon-chevron-down\" ng-hide=\"row.showDetail\"></i> <i class=\"glyphicon glyphicon-chevron-up\" ng-show=\"row.showDetail\"></i></button> <button class=\"btn btn-info btn-xs\" ng-if=\"row.items.length>0\" ng-click=\"vm.show(row)\"><span class=\"fa fa-search\"></span></button> <button class=\"btn btn-default btn-xs\" uib-tooltip=\"二维码\" tooltip-class=\"tooltipInfo\" ng-click=\"vm.qrcode(row)\"><span class=\"fa fa-qrcode\"></span></button><qrcode id=\"QrCode{{row.id}}\" version=\"5\" error-correction-level=\"M\" size=\"128\" hidden=\"\" data=\"{{row.qrUrl}}\"></qrcode></td><td ng-repeat=\"col in vm.cols\" ng-switch=\"col.field\" ng-if=\"col.show\"><div ng-switch-when=\"consumable\">{{row[col.field].name}}</div><div ng-switch-when=\"c_name\">{{row.consumable.c_name}}</div><div ng-switch-when=\"spec\">{{row.consumable.spec}}</div><div ng-switch-when=\"state\">{{row[col.field].name}}</div><div ng-switch-when=\"type\">{{row.consumable.type}}</div><div ng-switch-when=\"code\">{{row.consumable.code}}</div><div ng-switch-when=\"c_r_num\"><span ng-bind=\"row.r_num?row.c_r_num:\'暂未确认\'\"></span></div><div ng-switch-default=\"\">{{row[col.field]}}</div></td></tr><tr ng-repeat-end=\"\" ng-if=\"row.showDetail\" class=\"bg-gray-light\"><td colspan=\"99\"><table class=\"table table-hover\"><tbody><tr><td rowspan=\"8\" width=\"256\"><div style=\"position:relative\"><div style=\"position:absolute;right:0;top:0;z-index:1001\"><button type=\"button\" class=\"btn btn-success btn-xs\" ng-if=\"row.consumable.images.length>0\" ng-click=\"vm.zoomIn(row)\"><i class=\"fa fa-search-plus fa-fw\"></i></button></div><div style=\"height:180px\"><div uib-carousel=\"\" interval=\"5000\" no-wrap=\"false\" active=\"row.active\"><div uib-slide=\"\" ng-repeat=\"image in row.consumable.images track by image.id\" index=\"$index\"><img ng-src=\"{{image.path}}\" style=\"margin:auto;height:180px\"></div></div></div></div></td><td height=\"36\">生产商：{{row.consumable.producer.name}}</td><td height=\"36\">经销商：{{row.consumable.dealer.name}}</td></tr><tr ng-if=\"row.consumable.s_dealer\"><td height=\"36\">二级经销商：{{row.consumable.s_dealer.name}}</td><td height=\"36\">二级经销商进价：{{row.sd_purchase_price!=null?(row.sd_purchase_price +\'元/\'+row.consumable.use_unit):\'暂无\'}}</td></tr><tr><td height=\"36\">注册证号：{{row.consumable.r_num}}</td><td height=\"36\">原产地：{{row.consumable.is_import==\'1\'?row.consumable.country.cn+ \'&lt;\'+row.consumable.country.en+\'&gt;\':(row.consumable.country.cn+(row.consumable.province?\'&lt;\'+row.consumable.province.name+\'&gt;\':\'\'))}}</td></tr><tr><td height=\"36\">创建人：{{row.creator.name}}</td><td height=\"36\">确认人：<span ng-bind=\"row.handler_id?row.handler.name:\'暂未确认\'\"></span></td></tr><tr><td height=\"36\">出厂价格：{{row[\'purchase_price\']}}元/{{row.consumable.use_unit}}</td><td height=\"36\">出厂批次：<span ng-bind=\"row.no?row.no:\'暂无\'\"></span></td></tr><tr><td height=\"36\">生产日期：{{row[\'production_date\']}}</td><td height=\"36\">失效日期：{{row[\'deadline\']?row[\'deadline\']:\'长期有效\'}}</td></tr><tr><td height=\"36\">高值耗材： <span ng-class=\"{true:\'text-red\',false:\'text-default\'}[row.consumable.is_high_value==\'1\']\" ng-bind=\"row.consumable.is_high_value==\'1\'?\'是\':\'否\'\"></span></td><td height=\"36\">正常到货周期：{{row.consumable.lead_time?(row.consumable.lead_time+\'天\'):\'未设置\'}}</td></tr><tr><td height=\"36\" colspan=\"2\">按 <span class=\"text-red\" ng-bind=\"row.consumable[\'storage_unit\']\"></span> 领用, <span ng-if=\"row.consumable[\'purchase_unit\']!=row.consumable[\'storage_unit\']\">每 <span class=\"text-red\" ng-bind=\"row.consumable[\'purchase_unit\']\"></span> <span class=\"text-red\" ng-bind=\"row.consumable[\'storage_num\']\"></span> <span class=\"text-red\" ng-bind=\"row.consumable[\'storage_unit\']\"></span></span> <span ng-if=\"row.consumable[\'storage_unit\']!=row.consumable[\'use_unit\']\">每 <span class=\"text-red\" ng-bind=\"row.consumable[\'storage_unit\']\"></span> <span class=\"text-red\" ng-bind=\"row.consumable[\'use_num\']\"></span> <span class=\"text-red\" ng-bind=\"row.consumable[\'use_unit\']\"></span> ,</span> <span ng-switch=\"row.consumable.level\" class=\"text-info\"><span ng-switch-when=\"1\">可直接领用</span> <span ng-switch-when=\"2\">需科主任审批</span> <span ng-switch-when=\"3\">需分管院领导审批</span> <span ng-switch-when=\"4\">需主管院领导审批</span></span>.</td></tr><tr><td colspan=\"2\">备注：<span ng-bind=\"row.note?row.note:\'暂无\'\"></span></td></tr></tbody></table></td></tr><tr ng-if=\"!vm.tableParams.settings().$loading&&($data==null||$data.length==0)\" class=\"table-no-data\"><td colspan=\"99\" align=\"center\"><span>暂无数据</span></td></tr></table></div></div></div></div><div class=\"modal-footer\"><button class=\"btn btn-primary\" ng-click=\"vm.invoice()\">发货单</button> <button class=\"btn btn-default\" ng-click=\"vm.cancel()\">取消</button></div>");
$templateCache.put("app/pages/csmbs/direct/dialogs/csmbOut/out.html","<div class=\"modal-header dialog-header-confirm\"><button type=\"button\" class=\"close\" ng-click=\"vm.cancel()\">&times;</button> <span><i class=\"fa fa-edit modal-icon\"></i>科室申请耗材确认</span></div><div class=\"modal-body\"><form name=\"Form\" class=\"form-horizontal\" novalidate=\"\"><div class=\"text-red\" style=\"margin-top:-18px\"><label class=\"cb-label-wrapper\"><span class=\"text-default\">需要消毒处理</span> <input type=\"checkbox\" ng-model=\"vm.disinfect\" class=\"title-cb\"></label></div><div class=\"text-center\"><h3>申请耗材列表</h3></div><div class=\"text-center\"><label class=\"text-info\">发货金额总计：{{vm.csmbs.totalAll| currency:\'￥\'}}</label></div><table class=\"table\"><tr><th>名称</th><th>型号</th><th>注册证号</th><th>编号</th><th>申请量</th><th>差额数量</th><th>发货详情</th></tr><tr class=\"form-table-input-text\" ng-repeat-start=\"m in vm.csmbs\"><td>{{m.name!=\'\'?m.name:m.c_name}}</td><td>{{m.spec}}</td><td>{{m.reNum}}</td><td>{{m.code}}</td><td>{{m.l_num>0?(m.l_num+m.purchase_unit):\'\'}}{{m.s_num>0?(m.s_num+m.storage_unit):\'\'}}</td><td>{{m.diff_num+m.storage_unit}}</td><td><button type=\"button\" class=\"btn btn-default btn-xs\" ng-click=\"row.showDetail=!row.showDetail\"><i class=\"glyphicon glyphicon-chevron-down\" ng-hide=\"row.showDetail\"></i> <i class=\"glyphicon glyphicon-chevron-up\" ng-show=\"row.showDetail\"></i></button></td></tr><tr ng-repeat-end=\"\" ng-if=\"!row.showDetail\" class=\"bg-gray-light\"><td colspan=\"99\"><table class=\"table\"><tr ng-if=\"m.purchase_unit!=m.storage_unit\"><td style=\"text-align: left\">备注: <span>每 <span class=\"text-red\" ng-bind=\"m.purchase_unit\"></span> <span class=\"text-red\" ng-bind=\"m.storage_num\"></span> <span class=\"text-red\" ng-bind=\"m.storage_unit\"></span></span> <span ng-if=\"m.use_unit!=m.storage_unit\">每 <span class=\"text-red\" ng-bind=\"m.storage_unit\"></span> <span class=\"text-red\" ng-bind=\"m.use_num\"></span> <span class=\"text-red\" ng-bind=\"m.use_unit\"></span></span></td></tr><tr ng-if=\"m.s_dealer\"><td>二级经销商:{{m.s_dealer.name}}</td><td>价格:{{m.sd_purchase_price!=null?(m.sd_purchase_price+\'/\'+m.use_unit):\'暂无\'}}</td></tr><tr><td style=\"text-align: left\">出厂价格: <input type=\"text\" class=\"form-control input-xs\" input-float=\"2\" style=\"display:inline-block;width: 88px\" ng-model=\"m.purchase_price\" ng-change=\"vm.priceChange(m)\" ng-disabled=\"!m.canEditPrice&&!m.canIncreasePrice\" validator=\"maxnum={{m.canIncreasePrice?\'9999999\':m.price}},required\">/{{m.use_unit}}</td><td>发货总数量： {{m.n_l_num>0?(m.n_l_num+m.purchase_unit):\'\'}}{{m.n_s_num>0?(m.n_s_num+m.storage_unit):\'\'}} {{(m.n_l_num==0&&m.n_s_num==0)?0:\'\'}}</td><td ng-if=\"m.has_life==\'1\'\">保质期： {{m[\'year_shelf_life\']>0?m[\'year_shelf_life\']+\'年\':\'\'}} {{m[\'month_shelf_life\']>0?m[\'month_shelf_life\']+\'月\':\'\'}} {{m[\'shelf_life\']>0?m[\'shelf_life\']+\'天\':\'\'}}</td></tr><tr><td colspan=\"99\"><table class=\"table table-hover table-bordered table-condensed\" style=\"margin-bottom:0\"><thead style=\"background:azure\"><tr><th colspan=\"6\">发货详情</th></tr></thead><tbody><tr><td>批次</td><td>生产日期</td><td>失效日期</td><td width=\"180\">发货量</td><td>操作</td></tr><tr ng-repeat=\"batch in m.batches\"><td><input class=\"form-control input-sm\" type=\"text\" name=\"no{{batch.index}}\" style=\"margin-top: 3px\" ng-change=\"vm.noSelected(m,batch)\" ng-model=\"batch.no\" validator=\"required\"></td><td><input type=\"text\" class=\"form-control\" uib-datepicker-popup=\"yyyy-MM-dd\" datepicker-options=\"vm.dateOptions\" ng-change=\"vm.dateSelected(m,batch,1)\" name=\"production_date{{batch.index}}\" ng-model=\"batch.production_date\" datepicker-mode=\"\'day\'\" is-open=\"opened1\" ng-required=\"true\" ng-click=\"opened1=true\"><div ng-show=\"Form.$submitted||Form[\'production_date\'+batch.index].$touched\"><span ng-show=\"Form[\'production_date\'+batch.index].$error.required\" class=\"validation-invalid\">必填项!!</span></div><div ng-if=\"batch.production_date2\">{{batch.production_date2}}<a class=\"btn btn-xs\" ng-click=\"vm.dateInput(batch)\">填充生产日期</a></div></td><td ng-if=\"m.has_life == \'1\'\"><input type=\"text\" class=\"form-control\" uib-datepicker-popup=\"yyyy-MM-dd\" name=\"deadline{{batch.index}}\" ng-model=\"batch.deadline\" ng-change=\"vm.dateSelected(m,batch,2)\" datepicker-mode=\"\'day\'\" is-open=\"opened2\" ng-required=\"true\" ng-click=\"opened2=true\"><div ng-show=\"Form.$submitted||Form[\'deadline\'+batch.index].$touched\"><span ng-show=\"Form[\'deadline\'+batch.index].$error.required\" class=\"validation-invalid\">必填项!!</span></div></td><td ng-if=\"m.has_life == \'0\'\">长期有效</td><td><span ng-if=\"m.l_num>0\"><input class=\"form-control form-control-36 input-sm\" type=\"text\" name=\"l_num{{batch.index}}\" ng-change=\"vm.numChange(m)\" ng-model=\"batch.n_l_num\" input-number=\"\" validator=\"required\"> {{m.purchase_unit}}</span> <span ng-if=\"m.purchase_unit!=m.storage_unit||m.s_num>0\"><input class=\"form-control form-control-36 input-sm\" type=\"text\" name=\"s_num{{batch.index}}\" ng-change=\"vm.numChange(m)\" ng-model=\"batch.n_s_num\" input-number=\"\" validator=\"required\"> {{m.storage_unit}}</span></td><td><button type=\"button\" class=\"btn btn-danger btn-xs\" ng-click=\"vm.remove(m,$index)\">删除</button></td></tr></tbody><tfoot><tr><td colspan=\"4\" class=\"text-info text-right\">批次无货时直接删除,同一经销商批次建议不要分开录入，否则系统会产生多个批次</td><td><button type=\"button\" class=\"btn btn-success btn-xs\" ng-click=\"vm.add(m)\">添加批次</button></td></tr></tfoot></table></td></tr><tr><td style=\"text-align: left\" colspan=\"4\"><span class=\"text-info\">发货金额合计:{{m.total| currency:\'￥\'}}</span></td></tr><tr><td style=\"text-align: left\" colspan=\"4\">备注:<textarea class=\"form-control\" rows=\"1\" msd-elastic=\"\" name=\"note\" ng-model=\"m.note\" style=\"height: 48px;margin-bottom: 10px\" placeholder=\"200字内...\" maxlength=\"200\"></textarea></td></tr></table></td></tr></table></form></div><div class=\"modal-footer\"><button class=\"btn btn-primary\" ng-click=\"vm.submit(Form,vm.csmbs)\" promise-btn=\"\">确认</button> <button class=\"btn btn-default\" ng-click=\"vm.cancel()\">取消</button></div>");
$templateCache.put("app/pages/csmbs/direct/dialogs/csmbOut/reissues.html","");
$templateCache.put("app/pages/csmbs/direct/return/list/list.html","<div ba-panel=\"\" ba-panel-class=\"light-text tab-content-panel\" ba-panel-header=\"\" hide-add-btn=\"true\" ba-panel-title=\"<span ncy-breadcrumb-last></span>列表\"><table-option-tab ng-model=\"vm.roomId\" options=\"vm.rooms\" tag-title=\"退货库房\" filter-name=\"room_id\"></table-option-tab><label class=\"cb-label-wrapper\" ng-if=\"vm.tableParams.filter()[\'item\']\"><checkbox ng-model=\"vm.hideSub\" ng-change=\"vm.changeHide(vm.items,vm.tableParams.filter()[\'item\'])\"></checkbox><strong>隐藏其余筛选子项</strong></label><div class=\"table-responsive\" loading-container=\"vm.tableParams.settings().$loading\"><table class=\"table table-hover table-row-clicked\" ng-table=\"vm.tableParams\" template-header=\"app/theme/components/table/header.html\"><tr ng-repeat-start=\"row in $data track by row.id\"><td><button type=\"button\" class=\"btn btn-default btn-xs\" ng-click=\"row.showDetail=!row.showDetail\"><i class=\"glyphicon glyphicon-chevron-down\" ng-hide=\"row.showDetail\"></i> <i class=\"glyphicon glyphicon-chevron-up\" ng-show=\"row.showDetail\"></i></button> <button class=\"btn btn-primary btn-xs\" ui-sref=\"^.handle({id:row.id})\"><i class=\"fa fa-edit\"></i></button></td><td ng-repeat=\"col in vm.cols\" ng-switch=\"col.field\" ng-if=\"col.show\"><div ng-switch-when=\"created_at\">{{row[col.field]}}</div><div ng-switch-when=\"itemDesc\"><table class=\"table table-bordered table-condensed\"><tbody><tr ng-repeat=\"i in row[col.field]\" ng-hide=\"i.hide\" ng-if=\"row.expand||$index<4\"><td>{{i.consumable.name!=\'\'?i.consumable.name:i.consumable.c_name}} <span class=\"badge bulletin-subject-col\">{{i.consumable.spec}}</span> <span class=\"text-danger\" ng-bind=\"i.num+(row.for_purchase==\'1\'?i.consumable.purchase_unit:i.consumable.storage_unit)\"></span></td><td>{{i.consumable.producer?i.consumable.producer.name:\'暂无生产商\'}}</td></tr></tbody></table><a class=\"pull-right\" ng-if=\"row[col.field].length>4\" ng-click=\"row.expand=!row.expand\"><span ng-if=\"row.expand\" class=\"fa fa-chevron-up\">收起</span> <span ng-if=\"!row.expand\" class=\"fa fa-chevron-down\">展开剩余{{row[col.field].length-4}}项...</span></a></div><div ng-switch-default=\"\">{{row[col.field].name}}</div></td></tr><tr ng-repeat-end=\"\" ng-if=\"row.showDetail\" class=\"bg-gray-light\"><td colspan=\"5\"><table class=\"table table-hover\"><tbody><tr><td>库房审批意见：<span ng-bind=\"row.storeroom_opinion?row.storeroom_opinion:\'暂无\'\"></span></td></tr><tr><td>库房确认时间：<span ng-bind=\"row.storeroom_confirmed_time?row.storeroom_confirmed_time:\'库房未确认\'\"></span></td></tr><tr><td>备注：<span ng-bind=\"row.note?row.note:\'暂无\'\"></span></td></tr><tr><td><table class=\"table table-bordered table-condensed\"><thead><tr><th>耗材</th><th>规格型号</th><th>单位</th><th>批次</th><th>经销商批次</th><th>进价</th><th>数量</th><th>合计</th></tr></thead><tbody><tr ng-repeat=\"item in row.application_items track by item.id\"><td>{{item.consumable.name!=\'\'?item.consumable.name:item.consumable.c_name}}</td><td>{{item.consumable.spec}}</td><td><span ng-if=\"item.consumable.purchase_unit!=item.consumable.storage_unit\">每{{item.consumable.purchase_unit}}{{item.consumable.storage_num}}{{item.consumable.storage_unit}}</span> <span ng-if=\"item.consumable.storage_unit!=item.consumable.use_unit\">每{{item.consumable.storage_unit}}{{item.consumable.use_num}}{{item.consumable.use_unit}}</span> <span ng-if=\"(item.consumable.purchase_unit==item.consumable.storage_unit)&&(item.consumable.storage_unit==item.consumable.use_unit)\">{{item.consumable.storage_unit}}</span></td><td>{{item.batch.sn}}</td><td>{{item.batch.no}}</td><td>{{item.batch.purchase_price}}/{{item.consumable.use_unit}}</td><td>{{item.num}}{{item.consumable.storage_unit}}</td><td>{{item.total}}</td></tr><tr><td colspan=\"7\">总计</td><td ng-bind=\"row.total\"></td></tr></tbody></table></td></tr><tr ng-if=\"!tableParams.settings().$loading&&($data==null||$data.length==0)\" height=\"160px\"><td colspan=\"11\" align=\"center\" style=\"vertical-align:middle\"><span class=\"table-no-data\">暂无数据</span></td></tr></tbody></table></td></tr><tr ng-if=\"!vm.tableParams.settings().$loading&&($data==null||$data.length==0)\" class=\"table-no-data\"><td colspan=\"99\" align=\"center\"><span>暂无数据</span></td></tr></table></div></div>");
$templateCache.put("app/pages/csmbs/direct/return/handle/handle.html","<div ba-panel=\"\" ba-panel-class=\"light-text tab-content-panel\" ba-panel-title=\"<span ncy-breadcrumb-last></span>\"><form name=\"Form\" class=\"form-horizontal\" novalidate=\"\"><div class=\"table-responsive\" style=\"min-height: 100px\"><table class=\"table table-bordered table-condensed\" style=\"margin-bottom:20px\"><thead><tr><th>耗材</th><th>规格型号</th><th>单位</th><th>批次</th><th>经销商批次</th><th>进价</th><th>数量</th><th>合计</th></tr></thead><tbody><tr ng-repeat=\"item in vm.m.application_items track by item.id\"><td>{{item.consumable.name!=\'\'?item.consumable.name:item.consumable.c_name}}</td><td>{{item.consumable.spec}}</td><td><span ng-if=\"item.consumable.purchase_unit!=item.consumable.storage_unit\">每{{item.consumable.purchase_unit}}{{item.consumable.storage_num}}{{item.consumable.storage_unit}}</span> <span ng-if=\"item.consumable.storage_unit!=item.consumable.use_unit\">每{{item.consumable.storage_unit}}{{item.consumable.use_num}}{{item.consumable.use_unit}}</span> <span ng-if=\"(item.consumable.purchase_unit==item.consumable.storage_unit)&&(item.consumable.storage_unit==item.consumable.use_unit)\">{{item.consumable.storage_unit}}</span></td><td>{{item.batch.sn}}</td><td>{{item.batch.no}}</td><td>{{item.batch.purchase_price}}/{{item.consumable.use_unit}}</td><td>{{item.num}}{{item.consumable.storage_unit}}</td><td>{{item.total}}</td></tr><tr><td colspan=\"7\">总计</td><td ng-bind=\"vm.m.total\"></td></tr></tbody></table></div><div class=\"form-group\"><label class=\"col-md-4 control-label\">审批意见</label><div class=\"col-md-6\"><textarea maxlength=\"300\" class=\"form-control\" rows=\"4\" name=\"opinion\" placeholder=\"300字内...\" ng-model=\"vm.m.opinion\"></textarea></div></div><div class=\"form-group\"><label class=\"col-md-4 control-label\">短信通知申请人</label><div class=\"col-md-6\"><switch id=\"sms\" name=\"with_sms\" ng-model=\"vm.m.sms\" on=\"是\" off=\"否\" class=\"green\"></switch></div></div><div class=\"form-group\"><div class=\"col-md-offset-3 col-md-9\"><div class=\"pull-right\"><submit-button btn-class=\"btn-primary\" btn-click=\"vm.handle(Form,vm.m,1)\">同意</submit-button><submit-button btn-class=\"btn-danger\" btn-click=\"vm.handle(Form,vm.m,2)\">拒绝</submit-button><button class=\"btn btn-default\" ui-sref=\"^.list\">取消</button></div></div></div></form></div>");
$templateCache.put("app/pages/csmbs/batches/batch/list/list.html","<script type=\"text/ng-template\" id=\"CsmbLargeImgDlg.html\"><div fullscreen=\"isFullscreen\"> <div class=\"modal-header dialog-header-confirm\"> <button type=\"button\" class=\"close\" ng-click=\"vm.cancel()\">&times;</button> <button type=\"button\" class=\"close\" ng-click=\"isFullscreen=!isFullscreen\" style=\"padding-right:6px\"> <i class=\"fa fa-square-o\"></i></button> <h4 class=\"modal-title\"> <i class=\"fa fa-photo\"></i>&nbsp;耗材图片 </h4> </div> <div class=\"modal-body\"> <img class=\"img-responsive poster\" ng-src=\"{{vm.m.path}}\"><br> </div> <div class=\"modal-footer\"> <button class=\"btn btn-default\" ng-click=\"vm.cancel()\">返回</button> </div> </div></script><div ba-panel=\"\" ba-panel-class=\"light-text tab-content-panel\" ba-panel-header=\"\" ba-panel-title=\"<span ncy-breadcrumb-last></span>列表\"><table-option-tab ng-model=\"vm.roomId\" options=\"vm.rooms\" filter-name=\"room_id\" tag-title=\"接收库房\"></table-option-tab><div class=\"table-responsive\" loading-container=\"vm.tableParams.settings().$loading\"><table class=\"table table-hover table-row-clicked\" ng-table=\"vm.tableParams\" template-header=\"app/theme/components/table/header.html\"><tr ng-repeat-start=\"row in $data track by row.id\"><td ng-click=\"$event.stopPropagation()\"><button type=\"button\" class=\"btn btn-default btn-xs\" ng-click=\"row.showDetail=!row.showDetail\"><i class=\"glyphicon glyphicon-chevron-down\" ng-hide=\"row.showDetail\"></i> <i class=\"glyphicon glyphicon-chevron-up\" ng-show=\"row.showDetail\"></i></button> <button class=\"btn btn-info btn-xs\" ng-if=\"row.store_items.length>0\" uib-tooltip=\"库房寄销历史\" tooltip-class=\"tooltipInfo\" ng-click=\"vm.show(row,true)\"><span class=\"fa fa-search\"></span></button> <button class=\"btn btn-info btn-xs\" ng-if=\"row.items.length>0\" uib-tooltip=\"科室寄销历史\" tooltip-class=\"tooltipInfo\" ng-click=\"vm.show(row,false)\"><span class=\"fa fa-search\"></span></button> <button class=\"btn btn-default btn-xs\" uib-tooltip=\"二维码\" tooltip-class=\"tooltipInfo\" ng-click=\"vm.qrcode(row)\"><span class=\"fa fa-qrcode\"></span></button><qrcode id=\"QrCode{{row.id}}\" version=\"5\" error-correction-level=\"M\" size=\"128\" hidden=\"\" data=\"{{row.qrUrl}}\"></qrcode></td><td ng-repeat=\"col in vm.cols\" ng-switch=\"col.field\" ng-if=\"col.show\"><div ng-switch-when=\"consumable\">{{row[col.field].name}}</div><div ng-switch-when=\"c_name\">{{row.consumable.c_name}}</div><div ng-switch-when=\"spec\">{{row.consumable.spec}}</div><div ng-switch-when=\"state\">{{row[col.field].name}}</div><div ng-switch-when=\"type\">{{row.consumable.type}}</div><div ng-switch-when=\"c_r_num\"><span ng-bind=\"row.r_num?row.c_r_num:\'暂未确认\'\"></span></div><div ng-switch-when=\"code\">{{row.consumable.code}}</div><div ng-switch-default=\"\">{{row[col.field]}}</div></td></tr><tr ng-repeat-end=\"\" ng-if=\"row.showDetail\" class=\"bg-gray-light\"><td colspan=\"99\"><table class=\"table table-hover\"><tbody><tr><td rowspan=\"8\" width=\"256\"><div style=\"position:relative\"><div style=\"position:absolute;right:0;top:0;z-index:1001\"><button type=\"button\" class=\"btn btn-success btn-xs\" ng-if=\"row.consumable.images.length>0\" ng-click=\"vm.zoomIn(row)\"><i class=\"fa fa-search-plus fa-fw\"></i></button></div><div style=\"height:180px\"><div uib-carousel=\"\" interval=\"5000\" no-wrap=\"false\" active=\"row.active\"><div uib-slide=\"\" ng-repeat=\"image in row.consumable.images track by image.id\" index=\"$index\"><img ng-src=\"{{image.path}}\" style=\"margin:auto;height:180px\"></div></div></div></div></td><td height=\"36\">生产商：{{row.consumable.producer.name}}</td><td height=\"36\">经销商：{{row.consumable.dealer.name}}</td></tr><tr ng-if=\"row.consumable.s_dealer\"><td height=\"36\">二级经销商：{{row.consumable.s_dealer.name}}</td><td height=\"36\">二级经销商进价：{{row.sd_purchase_price!=null?(row.sd_purchase_price +\'元/\'+row.consumable.use_unit):\'暂无\'}}</td></tr><tr><td height=\"36\">注册证号：{{row.consumable.r_num}}</td><td height=\"36\">原产地：{{row.consumable.is_import==\'1\'?row.consumable.country.cn+ \'&lt;\'+row.consumable.country.en+\'&gt;\':(row.consumable.country.cn+(row.consumable.province?\'&lt;\'+row.consumable.province.name+\'&gt;\':\'\'))}}</td></tr><tr><td height=\"36\">创建人：{{row.creator.name}}</td><td height=\"36\">确认人：<span ng-bind=\"row.handler_id?row.handler.name:\'暂未确认\'\"></span></td></tr><tr><td height=\"36\">出厂价格：{{row[\'purchase_price\']}}元/{{row.consumable.use_unit}}</td><td height=\"36\">出厂批次：<span ng-bind=\"row.no?row.no:\'暂无\'\"></span></td></tr><tr><td height=\"36\">生产日期：{{row[\'production_date\']}}</td><td height=\"36\">失效日期：{{row[\'deadline\']?row[\'deadline\']:\'长期有效\'}}</td></tr><tr><td height=\"36\">高值耗材： <span ng-class=\"{true:\'text-red\',false:\'text-default\'}[row.consumable.is_high_value==\'1\']\" ng-bind=\"row.consumable.is_high_value==\'1\'?\'是\':\'否\'\"></span></td><td height=\"36\">正常到货周期：{{row.consumable.lead_time?(row.consumable.lead_time+\'天\'):\'未设置\'}}</td></tr><tr><td height=\"36\" colspan=\"2\">按 <span class=\"text-red\" ng-bind=\"row.consumable[\'storage_unit\']\"></span> 领用, <span ng-if=\"row.consumable[\'purchase_unit\']!=row.consumable[\'storage_unit\']\">每 <span class=\"text-red\" ng-bind=\"row.consumable[\'purchase_unit\']\"></span> <span class=\"text-red\" ng-bind=\"row.consumable[\'storage_num\']\"></span> <span class=\"text-red\" ng-bind=\"row.consumable[\'storage_unit\']\"></span></span> <span ng-if=\"row.consumable[\'storage_unit\']!=row.consumable[\'use_unit\']\">每 <span class=\"text-red\" ng-bind=\"row.consumable[\'storage_unit\']\"></span> <span class=\"text-red\" ng-bind=\"row.consumable[\'use_num\']\"></span> <span class=\"text-red\" ng-bind=\"row.consumable[\'use_unit\']\"></span> ,</span> <span ng-switch=\"row.consumable.level\" class=\"text-info\"><span ng-switch-when=\"1\">可直接领用</span> <span ng-switch-when=\"2\">需科主任审批</span> <span ng-switch-when=\"3\">需分管院领导审批</span> <span ng-switch-when=\"4\">需主管院领导审批</span></span>.</td></tr><tr><td colspan=\"2\">备注：<span ng-bind=\"row.note?row.note:\'暂无\'\"></span></td></tr></tbody></table></td></tr><tr ng-if=\"!vm.tableParams.settings().$loading&&($data==null||$data.length==0)\" class=\"table-no-data\"><td colspan=\"99\" align=\"center\"><span>暂无数据</span></td></tr></table></div></div>");
$templateCache.put("app/pages/csmbs/categories/cStop/list/list.html","<script type=\"text/ng-template\" id=\"CsmbLargeImgDlg.html\"><div fullscreen=\"isFullscreen\"> <div class=\"modal-header dialog-header-confirm\"> <button type=\"button\" class=\"close\" ng-click=\"vm.cancel()\">&times;</button> <button type=\"button\" class=\"close\" ng-click=\"isFullscreen=!isFullscreen\" style=\"padding-right:6px\"> <i class=\"fa fa-square-o\"></i></button> <h4 class=\"modal-title\"> <i class=\"fa fa-photo\"></i>&nbsp;耗材图片 </h4> </div> <div class=\"modal-body\"> <img class=\"img-responsive poster\" ng-src=\"{{vm.m.path}}\"><br> </div> <div class=\"modal-footer\"> <button class=\"btn btn-default\" ng-click=\"vm.cancel()\">返回</button> </div> </div></script><div ba-panel=\"\" ba-panel-class=\"light-text tab-content-panel\" ba-panel-header=\"\" ba-panel-title=\"<span ncy-breadcrumb-last></span>\"><div class=\"table-responsive\" loading-container=\"vm.tableParams.settings().$loading\"><table class=\"table table-hover table-row-clicked\" ng-table=\"vm.tableParams\" template-header=\"app/theme/components/table/header.html\"><tr ng-repeat-start=\"row in $data track by row.id\" ng-click=\"row.showDetail=!row.showDetail\"><td ng-click=\"$event.stopPropagation()\"><button type=\"button\" class=\"btn btn-default btn-xs\" ng-click=\"row.showDetail=!row.showDetail\"><i class=\"glyphicon glyphicon-chevron-down\" ng-hide=\"row.showDetail\"></i> <i class=\"glyphicon glyphicon-chevron-up\" ng-show=\"row.showDetail\"></i></button> <button class=\"btn btn-warning btn-xs\" ui-sref=\"^.edit({id:row.id})\" ng-if=\"row.state.id==3\" uib-tooltip=\"重新申请\" tooltip-class=\"tooltipInfo\"><span class=\"glyphicon glyphicon-pencil\"></span></button> <button class=\"btn btn-info btn-xs\" ui-sref=\"^.edit({id:row.id})\" ng-if=\"row.state.id==1\" uib-tooltip=\"修改\" tooltip-class=\"tooltipInfo\"><span class=\"glyphicon glyphicon-pencil\"></span></button> <button class=\"btn btn-danger btn-xs\" ng-if=\"row.state.id==3\" ng-click=\"vm.remove(row)\"><span class=\"glyphicon glyphicon-trash\"></span></button></td><td ng-repeat=\"col in vm.cols\" ng-switch=\"col.field\" ng-if=\"col.show\"><div ng-switch-when=\"items\"><table class=\"table table-bordered table-condensed\"><tbody><tr ng-repeat=\"i in row[col.field]\" ng-if=\"row.expand||$index<4\"><td>{{i.consumable.name!=\'\'?i.consumable.name:i.consumable.c_name}} <span class=\"badge bulletin-subject-col\">{{i.consumable.spec}}</span></td><td>{{i.consumable.producer?i.consumable.producer.name:\'暂无生产商\'}}</td></tr></tbody></table><div ng-click=\"$event.stopPropagation()\"><a class=\"pull-right\" ng-if=\"row[col.field].length>4\" ng-click=\"row.expand=!row.expand\"><span ng-if=\"row.expand\" class=\"fa fa-chevron-up\">收起</span> <span ng-if=\"!row.expand\" class=\"fa fa-chevron-down\">展开剩余{{row[col.field].length-4}}项...</span></a></div></div><span ng-switch-when=\"created_at\">{{row[col.field].substr(0,16)}}</span> <span ng-switch-when=\"note\">{{row[col.field]}}</span> <span ng-switch-default=\"\">{{row[col.field].name}}</span></td></tr><tr ng-repeat-end=\"\" ng-if=\"row.showDetail\" class=\"bg-gray-light\"><td colspan=\"99\"><table class=\"table table-hover\"><tbody><tr ng-if=\"row.state.id==2\"><td colspan=\"3\" align=\"left\">退回原因：<span class=\"text-red\" ng-bind=\"row.reason\"></span></td></tr><tr><th>注册证名称</th><th>通用名</th><th width=\"168\">类型</th><th>规格型号</th><th>编号</th><th>阳光流水号</th><th width=\"108\">所属库房</th><th width=\"36\">更多</th></tr><tr ng-repeat-start=\"item in row.items track by item.id\"><td>{{item.consumable.name}}</td><td>{{item.consumable.c_name}}</td><td>{{item.consumable.type}}</td><td>{{item.consumable.spec}}</td><td>{{item.consumable.code}}</td><td>{{item.consumable.sunshine_num}}</td><td>{{item.consumable.storeroom.name}}</td><td><button type=\"button\" class=\"btn btn-default btn-xs\" ng-click=\"item.showDetail=!item.showDetail\"><i class=\"glyphicon glyphicon-chevron-down\" ng-hide=\"item.showDetail\"></i> <i class=\"glyphicon glyphicon-chevron-up\" ng-show=\"item.showDetail\"></i></button></td></tr><tr ng-repeat-end=\"\" ng-if=\"item.showDetail\" class=\"bg-gray-light\"><td colspan=\"99\"><table class=\"table table-hover\"><tbody><tr><td rowspan=\"8\" width=\"256\"><div style=\"position:relative\"><div style=\"height:180px\"><div uib-carousel=\"\" interval=\"5000\" no-wrap=\"false\" active=\"item.consumable.active\"><div uib-slide=\"\" ng-repeat=\"image in item.consumable.images track by image.id\" index=\"$index\"><img ng-src=\"{{image.path}}\" style=\"margin:auto;height:180px\"></div></div></div></div></td><td height=\"36\">生产商：{{item.consumable[\'producer\'].name}}</td><td height=\"36\">经销商：{{item.consumable[\'dealer\'].name}}</td></tr><tr ng-if=\"item.consumable.s_dealer\"><td height=\"36\">二级经销商：{{item.consumable.s_dealer.name}}</td><td height=\"36\">二级经销商进价：{{item.consumable.sd_purchase_price!=null?(item.consumable.sd_purchase_price +\'元/\'+item.consumable.use_unit):\'暂无\'}}</td></tr><tr><td height=\"36\">注册证号：{{item.consumable[\'r_num\']}}</td><td height=\"36\">原产地：{{item.consumable.is_import==\'1\'?item.consumable.country.cn+\'lt;\'+item.consumable.country.en+\'&gt;\':(item.consumable.country.cn+(item.consumable.province?\'&lt;\'+item.consumable.province.name+\'&gt;\':\'\'))}}</td></tr><tr><td height=\"36\">价格：{{item.consumable[\'purchase_price\']}}元/{{item.consumable[\'use_unit\']}}</td><td height=\"36\">正常到货周期：{{item.consumable.lead_time?(item.consumable.lead_time+\'天\'):\'未设置\'}}</td></tr><tr ng-if=\"item.consumable.has_life==\'1\'\"><td height=\"36\">保质期： {{item.consumable[\'year_shelf_life\']>0?item.consumable[\'year_shelf_life\']+\'年\':\'\'}} {{item.consumable[\'month_shelf_life\']>0?item.consumable[\'month_shelf_life\']+\'月\':\'\'}} {{item.consumable[\'shelf_life\']>0?item.consumable[\'shelf_life\']+\'天\':\'\'}}</td><td height=\"36\">到期提醒：{{item.consumable[\'remind_day\']}}天</td></tr><tr><td height=\"36\" colspan=\"2\">按 <span class=\"text-red\" ng-bind=\"item.consumable[\'storage_unit\']\"></span> 领用, <span ng-if=\"item.consumable[\'purchase_unit\']!=item.consumable[\'storage_unit\']\">每 <span class=\"text-red\" ng-bind=\"item.consumable[\'purchase_unit\']\"></span> <span class=\"text-red\" ng-bind=\"item.consumable[\'storage_num\']\"></span> <span class=\"text-red\" ng-bind=\"item.consumable[\'storage_unit\']\"></span></span> <span ng-if=\"item.consumable[\'storage_unit\']!=item.consumable[\'use_unit\']\">每 <span class=\"text-red\" ng-bind=\"item.consumable[\'storage_unit\']\"></span> <span class=\"text-red\" ng-bind=\"item.consumable[\'use_num\']\"></span> <span class=\"text-red\" ng-bind=\"item.consumable[\'use_unit\']\"></span> ,</span> <span ng-switch=\"item.consumable.level\" class=\"text-info\"><span ng-switch-when=\"1\">可直接领用</span> <span ng-switch-when=\"2\">需科主任审批</span> <span ng-switch-when=\"3\">需分管院领导审批</span> <span ng-switch-when=\"4\">需主管院领导审批</span></span>.</td></tr><tr><td colspan=\"2\">备注：<span ng-bind=\"item.consumable.note?item.consumable.note:\'暂无备注\'\"></span></td></tr></tbody></table></td></tr></tbody></table></td></tr><tr ng-if=\"!vm.tableParams.settings().$loading&&($data==null||$data.length==0)\" class=\"table-no-data\"><td colspan=\"99\" align=\"center\"><span>暂无数据</span></td></tr></table></div></div>");
$templateCache.put("app/pages/csmbs/categories/cStop/add/add.html","<div ba-panel=\"\" ba-panel-class=\"profile-page\" ba-panel-title=\"<span ncy-breadcrumb-last></span>\"><div class=\"panel-content\"><form name=\"Form\" class=\"form-horizontal\" scroll-form=\"\" novalidate=\"\"><div class=\"form-group\"><label class=\"col-md-2 control-label\">耗材名称</label><div class=\"col-md-9\"><csmbs-select ng-model=\"vm.m.csmbs\" name=\"csmbs\" disabled=\"vm.m.id\" on-select=\"vm.csmbSelected(vm.m)\" on-remove=\"vm.csmbSelected(vm.m)\"></csmbs-select><div ng-show=\"Form.$submitted||Form.csmbs.$touched\"><span ng-show=\"vm.m.csmbs.length==0\" class=\"validation-invalid control-label\">必填项!!</span></div></div></div><div class=\"form-group\"><label class=\"col-md-2 control-label\">耗材明细</label><div class=\"col-md-9\"><div class=\"table-responsive\" style=\"min-height: 150px\"><table class=\"table table-bordered table-condensed\"><thead><tr><th>注册证名称</th><th>通用名</th><th width=\"168\">类型</th><th>规格型号</th><th>编号</th><th>阳光流水号</th><th width=\"108\">所属库房</th><th width=\"36\">更多</th></tr></thead><tbody><tr ng-repeat-start=\"row in vm.m.consumables track by row.id\"><td>{{row.name}}</td><td>{{row.c_name}}</td><td>{{row.type}}</td><td>{{row.spec}}</td><td>{{row.code}}</td><td>{{row.sunshine_num}}</td><td>{{row.storeroom.name}}</td><td><button type=\"button\" class=\"btn btn-default btn-xs\" ng-click=\"row.showDetail=!row.showDetail\"><i class=\"glyphicon glyphicon-chevron-down\" ng-hide=\"row.showDetail\"></i> <i class=\"glyphicon glyphicon-chevron-up\" ng-show=\"row.showDetail\"></i></button></td></tr><tr ng-repeat-end=\"\" ng-if=\"row.showDetail\" class=\"bg-gray-light\"><td colspan=\"99\"><table class=\"table table-hover\"><tbody><tr><td rowspan=\"8\" width=\"256\"><div style=\"position:relative\"><div style=\"height:180px\"><div uib-carousel=\"\" interval=\"5000\" no-wrap=\"false\" active=\"row.active\"><div uib-slide=\"\" ng-repeat=\"image in row.images track by image.id\" index=\"$index\"><img ng-src=\"{{image.path}}\" style=\"margin:auto;height:180px\"></div></div></div></div></td><td height=\"36\">生产商：{{row[\'producer\'].name}}</td><td height=\"36\">经销商：{{row[\'dealer\'].name}}</td></tr><tr ng-if=\"row.s_dealer\"><td height=\"36\">二级经销商：{{row.s_dealer.name}}</td><td height=\"36\">二级经销商进价：{{row.sd_purchase_price!=null?(row.sd_purchase_price +\'元/\'+row.use_unit):\'暂无\'}}</td></tr><tr><td height=\"36\">注册证号：{{row[\'r_num\']}}</td><td height=\"36\">原产地：{{row.is_import==\'1\'?row.country.cn+\'lt;\'+row.country.en+\'&gt;\':(row.country.cn+(row.province?\'&lt;\'+row.province.name+\'&gt;\':\'\'))}}</td></tr><tr><td height=\"36\">价格：{{row[\'purchase_price\']}}元/{{row[\'use_unit\']}}</td><td height=\"36\">正常到货周期：{{row.lead_time?(row.lead_time+\'天\'):\'未设置\'}}</td></tr><tr ng-if=\"row.has_life==\'1\'\"><td height=\"36\">保质期： {{row[\'year_shelf_life\']>0?row[\'year_shelf_life\']+\'年\':\'\'}} {{row[\'month_shelf_life\']>0?row[\'month_shelf_life\']+\'月\':\'\'}} {{row[\'shelf_life\']>0?row[\'shelf_life\']+\'天\':\'\'}}</td><td height=\"36\">到期提醒：{{row[\'remind_day\']}}天</td></tr><tr><td height=\"36\" colspan=\"2\">按 <span class=\"text-red\" ng-bind=\"row[\'storage_unit\']\"></span> 领用, <span ng-if=\"row[\'purchase_unit\']!=row[\'storage_unit\']\">每 <span class=\"text-red\" ng-bind=\"row[\'purchase_unit\']\"></span> <span class=\"text-red\" ng-bind=\"row[\'storage_num\']\"></span> <span class=\"text-red\" ng-bind=\"row[\'storage_unit\']\"></span></span> <span ng-if=\"row[\'storage_unit\']!=row[\'use_unit\']\">每 <span class=\"text-red\" ng-bind=\"row[\'storage_unit\']\"></span> <span class=\"text-red\" ng-bind=\"row[\'use_num\']\"></span> <span class=\"text-red\" ng-bind=\"row[\'use_unit\']\"></span> ,</span> <span ng-switch=\"row.level\" class=\"text-info\"><span ng-switch-when=\"1\">可直接领用</span> <span ng-switch-when=\"2\">需科主任审批</span> <span ng-switch-when=\"3\">需分管院领导审批</span> <span ng-switch-when=\"4\">需主管院领导审批</span></span>.</td></tr><tr><td colspan=\"2\">备注：<span ng-bind=\"row.note?row.note:\'暂无备注\'\"></span></td></tr></tbody></table></td></tr><tr ng-if=\"vm.m.consumables==null||vm.m.consumables.length==0\" height=\"160px\"><td colspan=\"11\" align=\"center\" style=\"vertical-align:middle\"><span class=\"table-no-data\">暂无数据</span></td></tr></tbody></table></div></div></div><div class=\"form-group\"><label class=\"col-md-2 control-label\">停用原因</label><div class=\"col-md-9\"><textarea maxlength=\"255\" class=\"form-control\" rows=\"4\" name=\"note\" validator=\"required\" ng-model=\"vm.m.note\"></textarea><div ng-if=\"Form.$submitted||Form.note.$touched\"><span ng-show=\"Form.note.$error.required\" class=\"validation-invalid\">必填项!!</span></div></div></div><div class=\"form-group\"><div class=\"col-md-offset-2 col-md-9\"><div class=\"pull-right\"><button ui-sref=\"^.list\" class=\"btn btn-default\">取消</button> <button class=\"btn btn-primary\" ng-click=\"vm.submit(vm.m,Form)\" promise-btn=\"\">提交</button></div></div></div></form></div></div>");
$templateCache.put("app/pages/csmbs/categories/category/add/add.html","<script type=\"text/ng-template\" id=\"CsmbLargeImgDlg.html\"><div fullscreen=\"isFullscreen\"> <div class=\"modal-header dialog-header-confirm\"> <button type=\"button\" class=\"close\" ng-click=\"vm.cancel()\">&times;</button> <button type=\"button\" class=\"close\" ng-click=\"isFullscreen=!isFullscreen\" style=\"padding-right:6px\"> <i class=\"fa fa-square-o\"></i></button> <h4 class=\"modal-title\"> <i class=\"fa fa-photo\"></i>&nbsp;耗材图片 </h4> </div> <div class=\"modal-body\"> <img class=\"img-responsive poster\" ng-src=\"{{vm.m.path}}\"><br> </div> <div class=\"modal-footer\"> <button class=\"btn btn-default\" ng-click=\"vm.cancel()\">返回</button> </div> </div></script><div ba-panel=\"\" ba-panel-class=\"profile-page\" ba-panel-title=\"<span ncy-breadcrumb-last></span>\"><div class=\"panel-content col-md-10\"><form name=\"Form\" class=\"form-horizontal\" scroll-form=\"\" novalidate=\"\"><div class=\"form-group\" ng-if=\"!vm.m.id\"><label class=\"col-md-2 control-label\">耗材品种<span class=\"text-red\">&nbsp;*</span></label><div class=\"col-md-6\"><cv-select ng-model=\"vm.m.variety\" name=\"variety\" on-select=\"vm.varietySelectFn(vm.m)\"></cv-select><div ng-show=\"Form.$submitted||Form.variety.$touched\"><span ng-show=\"Form.variety.$error.required\" class=\"validation-invalid\">必填项!!</span></div></div></div><div class=\"form-group\"><label class=\"col-md-2 control-label\">图片<span class=\"text-red\">&nbsp;*</span></label><div class=\"col-md-6\"><button type=\"button\" class=\"btn btn-info btn-raised\" ng-click=\"vm.setImg(vm.m)\"><span ng-if=\"vm.m.images.length==0\" style=\"color: #fff\">添加</span> <span ng-if=\"vm.m.images.length>0\" style=\"color: #fff\">继续添加</span></button><div ng-repeat=\"image in vm.m.images\" style=\"margin-bottom: 5px\"><img class=\"img-responsive poster\" ng-src=\"{{image.path}}\"><br><button type=\"button\" class=\"btn btn-primary btn-raised\" ng-click=\"vm.zoomIn(image)\">放大</button> <button type=\"button\" class=\"btn btn-info btn-raised\" ng-click=\"vm.editImg(image)\">更改</button> <button type=\"button\" class=\"btn btn-danger btn-raised\" ng-click=\"vm.delImg(vm.m,$index)\">删除</button></div></div></div>[<div class=\"form-group\" ng-if=\"!vm.m.is_admin\"><label class=\"col-md-2 control-label\">阳光流水号</label><div class=\"col-md-6\"><input type=\"text\" class=\"form-control\" name=\"sunshine_num\" ng-model=\"vm.m.sunshine_num\"></div></div><div class=\"form-group\" ng-if=\"vm.m.id\"><label class=\"col-md-2 control-label\">规格型号<span class=\"text-red\">&nbsp;*</span></label><div class=\"col-md-6\"><input type=\"text\" class=\"form-control\" name=\"spec\" validator=\"required\" ng-model=\"vm.m.spec\"></div></div><div class=\"form-group\" ng-if=\"!vm.m.id\"><label class=\"col-md-2 control-label\">规格型号<span class=\"text-red\">&nbsp;*</span></label><div class=\"col-md-6\"><ui-select multiple=\"\" tagging=\"vm.tagTransform\" ng-model=\"vm.m.specs\"><ui-select-match><span ng-bind=\"$item.name\" title=\"{{$item.name}}\"></span></ui-select-match><ui-select-choices repeat=\"spec in vm.specs | filter: $select.search\"><div ng-if=\"spec.isTag\" ng-bind-html=\"(spec.name | highlight: $select.search) +\' (新建)\'\"></div><div ng-if=\"!spec.isTag\" ng-bind-html=\"spec.name | highlight: $select.search\"></div></ui-select-choices></ui-select></div></div><div class=\"form-group\"><label class=\"col-md-2 control-label\">价格/元<span class=\"text-red\">&nbsp;*</span> <i uib-tooltip=\"使用单位价格\" tooltip-append-to-body=\"true\" tooltip-class=\"tooltipInfo\" style=\"display: inline\" class=\"fa fa-info-circle text-info\"></i></label><div class=\"col-md-6\"><input type=\"text\" input-float=\"2\" class=\"form-control\" name=\"purchase_price\" validator=\"required\" ng-model=\"vm.m.purchase_price\"></div></div><div class=\"form-group\"><label class=\"col-md-2 control-label\">二级经销商价格/元 <i uib-tooltip=\"使用单位价格\" tooltip-append-to-body=\"true\" tooltip-class=\"tooltipInfo\" style=\"display: inline\" class=\"fa fa-info-circle text-info\"></i></label><div class=\"col-md-6\"><input type=\"text\" input-float=\"2\" class=\"form-control\" name=\"sd_purchase_price\" ng-model=\"vm.m.sd_purchase_price\"></div></div><div class=\"form-group\"><label class=\"col-md-2 control-label\">国家医保材料代码<span class=\"text-red\">&nbsp;*</span></label><div class=\"col-md-6\"><input type=\"text\" class=\"form-control\" name=\"m_code\" ng-model=\"vm.m.m_code\" validator=\"required\"></div></div><div class=\"form-group\"><label class=\"col-md-2 control-label\">成都市编码<span class=\"text-red\">&nbsp;*</span></label><div class=\"col-md-6\"><input type=\"text\" class=\"form-control\" name=\"c_code\" ng-model=\"vm.m.c_code\" validator=\"required\"></div></div><div class=\"form-group\"><label class=\"col-md-2 control-label\">his计费类型<span class=\"text-red\">&nbsp;*</span></label><div class=\"col-md-6\"><ui-select name=\"his_fee_type\" ng-model=\"vm.m.his_fee_type\"><ui-select-match placeholder=\"请选择计费类型...\">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat=\"type in vm.hisFeeTypes | filter: $select.search\"><div ng-bind-html=\"type.name | highlight: $select.search\"></div></ui-select-choices></ui-select></div></div><div class=\"form-group\"><label class=\"col-md-2 control-label\">备注</label><div class=\"col-md-6\"><textarea class=\"form-control\" rows=\"5\" name=\"note\" ng-model=\"vm.m.note\" maxlength=\"200\"></textarea></div></div><div class=\"form-group\"><div class=\"col-md-offset-3 col-md-9\"><div class=\"pull-right\"><button class=\"btn btn-info\" ng-click=\"vm.ok(vm.m,Form,5)\" promise-btn=\"\" ng-if=\"vm.m.state==5||!vm.m.state\">保存草稿</button> <button class=\"btn btn-primary\" ng-click=\"vm.ok(vm.m,Form,1)\" promise-btn=\"\">发送申请</button> <button ui-sref=\"^.list\" class=\"btn btn-default\">取消</button></div></div></div></form></div></div>");
$templateCache.put("app/pages/csmbs/categories/category/price/list.html","<div ba-panel=\"\" ba-panel-class=\"light-text tab-content-panel\" ba-panel-header=\"\" hide-add-btn=\"true\" ba-panel-title=\"<span ncy-breadcrumb-last></span>\"><div class=\"table-responsive\" loading-container=\"vm.tableParams.settings().$loading\"><table class=\"table table-hover table-row-clicked\" ng-table=\"vm.tableParams\" template-header=\"app/theme/components/table/header.html\"><tr ng-repeat=\"row in $data track by row.id\" ng-click=\"row.showDetail=!row.showDetail\"><td ng-repeat=\"col in vm.cols\" ng-switch=\"col.field\"><div ng-switch-default=\"\" class=\"text-center\">{{row[col.field]}}</div></td></tr><tr ng-if=\"!vm.tableParams.settings().$loading&&($data==null||$data.length==0)\" class=\"table-no-data\"><td colspan=\"99\" align=\"center\"><span>暂无数据</span></td></tr></table></div><div class=\"col-md-offset-3 col-md-9 ng-scope\"><div class=\"pull-right\"><button class=\"btn btn-default\" ui-sref=\"^.list\">返回</button></div></div></div>");
$templateCache.put("app/pages/csmbs/categories/update/list/list.html","<script type=\"text/ng-template\" id=\"CsmbLargeImgDlg.html\"><div fullscreen=\"isFullscreen\"> <div class=\"modal-header dialog-header-confirm\"> <button type=\"button\" class=\"close\" ng-click=\"vm.cancel()\">&times;</button> <button type=\"button\" class=\"close\" ng-click=\"isFullscreen=!isFullscreen\" style=\"padding-right:6px\"> <i class=\"fa fa-square-o\"></i></button> <h4 class=\"modal-title\"> <i class=\"fa fa-photo\"></i>&nbsp;耗材图片 </h4> </div> <div class=\"modal-body\"> <img class=\"img-responsive poster\" ng-src=\"{{vm.m.path}}\"><br> </div> <div class=\"modal-footer\"> <button class=\"btn btn-default\" ng-click=\"vm.cancel()\">返回</button> </div> </div></script><div ba-panel=\"\" ba-panel-class=\"light-text tab-content-panel\" ba-panel-header=\"\" ba-panel-title=\"<span ncy-breadcrumb-last></span>\"><div class=\"table-responsive\" loading-container=\"vm.tableParams.settings().$loading\"><table class=\"table table-hover table-row-clicked\" ng-table=\"vm.tableParams\" template-header=\"app/theme/components/table/header.html\"><tr ng-repeat-start=\"row in $data track by row.id\" ng-click=\"row.showDetail=!row.showDetail\"><td ng-click=\"$event.stopPropagation()\"><button type=\"button\" class=\"btn btn-default btn-xs\" ng-click=\"row.showDetail=!row.showDetail\"><i class=\"glyphicon glyphicon-chevron-down\" ng-hide=\"row.showDetail\"></i> <i class=\"glyphicon glyphicon-chevron-up\" ng-show=\"row.showDetail\"></i></button> <button class=\"btn btn-warning btn-xs\" ui-sref=\"^.edit({id:row.id})\" ng-if=\"row.state.id==3\" uib-tooltip=\"重新申请\" tooltip-class=\"tooltipInfo\"><span class=\"glyphicon glyphicon-pencil\"></span></button> <button class=\"btn btn-info btn-xs\" ui-sref=\"^.edit({id:row.id})\" ng-if=\"row.state.id==1\" uib-tooltip=\"修改\" tooltip-class=\"tooltipInfo\"><span class=\"glyphicon glyphicon-pencil\"></span></button> <button class=\"btn btn-danger btn-xs\" ng-if=\"row.state.id==3\" ng-click=\"vm.remove(row)\"><span class=\"glyphicon glyphicon-trash\"></span></button></td><td ng-repeat=\"col in vm.cols\" ng-switch=\"col.field\" ng-if=\"col.show\"><div ng-switch-when=\"items\"><table class=\"table table-bordered table-condensed\"><tbody><tr ng-repeat=\"i in row[col.field]\" ng-if=\"row.expand||$index<4\"><td>{{i.consumable.name!=\'\'?i.consumable.name:i.consumable.c_name}} <span class=\"badge bulletin-subject-col\">{{i.consumable.spec}}</span></td><td>{{i.consumable.producer?i.consumable.producer.name:\'暂无生产商\'}}</td></tr></tbody></table><a class=\"pull-right\" ng-if=\"row[col.field].length>4\" ng-click=\"row.expand=!row.expand\"><span ng-if=\"row.expand\" class=\"fa fa-chevron-up\">收起</span> <span ng-if=\"!row.expand\" class=\"fa fa-chevron-down\">展开剩余{{row[col.field].length-4}}项...</span></a></div><span ng-switch-when=\"created_at\">{{row[col.field].substr(0,16)}}</span> <span ng-switch-default=\"\">{{row[col.field].name}}</span></td></tr><tr ng-repeat-end=\"\" ng-if=\"row.showDetail\" class=\"bg-gray-light\"><td colspan=\"7\"><table class=\"table table-bordered table-condensed\"><tbody><tr ng-if=\"row.state.id==3\"><td colspan=\"4\" align=\"left\">退回原因：<span class=\"text-red\" ng-bind=\"row.reason\"></span>，退回人：<span ng-bind=\"row.handler.name\"></span></td></tr><tr><th width=\"108\">耗材名称</th><th width=\"72\">流水号</th><th width=\"72\">规格型号</th><th width=\"72\">备注</th></tr><tr ng-repeat-start=\"item in row.items track by item.id\"><td>{{item.consumable.name!=\'\'?item.consumable.name:item.consumable.c_name}}</td><td>{{item.sunshine_num}}</td><td>{{item.spec}}</td><td>{{item.note}}</td></tr><tr ng-repeat-end=\"\" class=\"bg-gray-light\"><td colspan=\"4\"><table class=\"table table-hover\"><tbody><tr><td><span class=\"text-blue\" ng-if=\"row.state.id!=2\">原图</span><div style=\"position:relative\"><div style=\"position:absolute;left:220px;top:0;z-index:1001\"><button type=\"button\" class=\"btn btn-success btn-xs\" ng-if=\"item.consumable.images.length>0\" ng-click=\"vm.zoomIn(item,true)\"><i class=\"fa fa-search-plus fa-fw\"></i></button></div><div style=\"height:180px;width:256px\"><div uib-carousel=\"\" interval=\"5000\" no-wrap=\"false\" active=\"item.active\"><div uib-slide=\"\" ng-repeat=\"image in item.consumable.images track by image.id\" index=\"$index\"><img ng-src=\"{{image.path}}\" style=\"margin:auto;height:180px\"></div></div></div></div></td><td ng-if=\"row.state.id!=2\"><span class=\"text-blue\">修改</span><div style=\"position:relative\"><div style=\"position:absolute;left:220px;top:0;z-index:1001\"><button type=\"button\" class=\"btn btn-success btn-xs\" ng-if=\"item.images.length>0\" ng-click=\"vm.zoomIn(item,false)\"><i class=\"fa fa-search-plus fa-fw\"></i></button></div><div style=\"height:180px;width:256px\"><div uib-carousel=\"\" interval=\"5000\" no-wrap=\"false\" active=\"item.active1\"><div uib-slide=\"\" ng-repeat=\"image in item.images track by $index\" index=\"$index\"><img ng-src=\"{{image.path}}\" style=\"margin:auto;height:180px\"></div></div></div></div></td></tr></tbody></table></td></tr></tbody></table></td></tr><tr ng-if=\"!vm.tableParams.settings().$loading&&($data==null||$data.length==0)\" class=\"table-no-data\"><td colspan=\"99\" align=\"center\"><span>暂无数据</span></td></tr></table></div></div>");
$templateCache.put("app/pages/csmbs/categories/update/add/add.html","<script type=\"text/ng-template\" id=\"ConsumableImgDlg.html\"><div class=\"modal-header dialog-header-confirm\"> <button type=\"button\" class=\"close\" ng-click=\"vm.cancel()\">&times;</button> <h4 class=\"modal-title\"> <i class=\"fa fa-plus\" ng-hide=\"vm.m.id\">添加</i> <i class=\"fa fa-edit\" ng-show=\"vm.m.id\">编辑</i>耗材图片 </h4> </div> <div class=\"modal-body\"> <form name=\"Form\" class=\"form-horizontal\" scroll-form novalidate> <div class=\"form-group\"> <label class=\"col-md-4 control-label\">图片</label> <div class=\"col-md-6\"> <button type=\"button\" class=\"btn btn-info btn-raised\" ng-click=\"vm.setImg(vm.m)\"> <span ng-if=\"!vm.m.path\">添加</span> <span ng-if=\"vm.m.path\">更改</span> </button> <img class=\"img-responsive poster\" ng-src=\"{{vm.m.path}}\"><br> </div> </div> </form> </div> <div class=\"modal-footer\"> <button class=\"btn btn-primary\" ng-click=\"vm.ok(vm.m,Form)\" promise-btn>确认</button> <button class=\"btn btn-default\" ng-click=\"vm.cancel()\">取消</button> </div></script><script type=\"text/ng-template\" id=\"CsmbLargeImgDlg.html\"><div fullscreen=\"isFullscreen\"> <div class=\"modal-header dialog-header-confirm\"> <button type=\"button\" class=\"close\" ng-click=\"vm.cancel()\">&times;</button> <button type=\"button\" class=\"close\" ng-click=\"isFullscreen=!isFullscreen\" style=\"padding-right:6px\"> <i class=\"fa fa-square-o\"></i></button> <h4 class=\"modal-title\"> <i class=\"fa fa-photo\"></i>&nbsp;耗材图片 </h4> </div> <div class=\"modal-body\"> <img class=\"img-responsive poster\" ng-src=\"{{vm.m.path}}\"><br> </div> <div class=\"modal-footer\"> <button class=\"btn btn-default\" ng-click=\"vm.cancel()\">返回</button> </div> </div></script><div ba-panel=\"\" ba-panel-class=\"profile-page\" ba-panel-title=\"<span ncy-breadcrumb-last></span>\"><div class=\"panel-content\"><form name=\"Form\" class=\"form-horizontal\" scroll-form=\"\" novalidate=\"\"><div class=\"form-group\"><label class=\"col-md-2 control-label\">耗材名称</label><div class=\"col-md-9\"><csmbs-select ng-model=\"vm.m.csmbs\" name=\"csmbs\" disabled=\"vm.m.id\" on-select=\"vm.csmbSelected(vm.m)\" on-remove=\"vm.csmbSelected(vm.m)\"></csmbs-select><div ng-show=\"Form.$submitted||Form.csmbs.$touched\"><span ng-show=\"vm.m.csmbs.length==0\" class=\"validation-invalid control-label\">必填项!!</span></div></div></div><div class=\"form-group\"><label class=\"col-md-2 control-label\">耗材明细</label><div class=\"col-md-9\"><table class=\"table table-bordered table-condensed\"><thead><tr><th width=\"108\">耗材名称</th><th width=\"72\">流水号</th><th width=\"72\">规格型号</th><th width=\"72\">备注</th></tr></thead><tbody><tr ng-repeat-start=\"row in vm.m.consumables track by row.id\"><td>{{row.name!=\'\'?row.name:row.c_name}}</td><td><input type=\"text\" class=\"form-control input-xs\" style=\"display:inline-block\" ng-model=\"row.sunshine_num\"></td><td><input type=\"text\" class=\"form-control input-xs\" style=\"display:inline-block\" id=\"spec\" ng-model=\"row.spec\" validator=\"required\"></td><td><input type=\"text\" class=\"form-control input-xs\" style=\"display:inline-block\" ng-model=\"row.note\"></td></tr><tr ng-repeat-end=\"\" class=\"bg-gray-light\"><td colspan=\"4\"><table class=\"table table-hover\"><tbody><tr><td><span class=\"text-blue\">原图</span><div style=\"position:relative\"><div style=\"position:absolute;left:220px;top:0;z-index:1001\"><button type=\"button\" class=\"btn btn-success btn-xs\" ng-if=\"row.images.length>0\" ng-click=\"vm.zoomIn(row,true)\"><i class=\"fa fa-search-plus fa-fw\"></i></button></div><div style=\"height:180px;width:256px\"><div uib-carousel=\"\" interval=\"5000\" no-wrap=\"false\" active=\"row.active\"><div uib-slide=\"\" ng-repeat=\"image in row.images track by image.id\" index=\"$index\"><img ng-src=\"{{image.path}}\" style=\"margin:auto;height:180px\"></div></div></div></div></td><td><span class=\"text-blue\">修改</span> <button class=\"btn btn-info btn-xs\" ng-if=\"row.newImages.length==0\" ng-click=\"vm.setImg(row)\"><i class=\"fa fa-plus fa-fw\"></i></button> <button class=\"btn btn-info btn-xs\" ng-if=\"row.newImages.length==0\" ng-click=\"vm.keepImg(row)\">使用原图</button><div style=\"position:relative\"><div style=\"position:absolute;left:130px;top:0;z-index:1001\"><button class=\"btn btn-info btn-xs\" ng-if=\"row.newImages.length>0\" ng-click=\"vm.setImg(row)\"><i class=\"fa fa-plus fa-fw\"></i></button> <button type=\"button\" class=\"btn btn-success btn-xs\" ng-if=\"row.newImages.length>0\" ng-click=\"vm.zoomIn(row,false)\"><i class=\"fa fa-search-plus fa-fw\"></i></button> <button class=\"btn btn-primary btn-xs\" ng-if=\"row.newImages.length>0\" ng-click=\"vm.editImg(row)\"><i class=\"fa fa-pencil fa-fw\"></i></button> <button type=\"button\" class=\"btn btn-danger btn-xs\" ng-if=\"row.newImages.length>0\" ng-click=\"vm.delImg(row)\"><i class=\"fa fa-times fa-fw\"></i></button></div><div style=\"height:180px;width:256px\"><div uib-carousel=\"\" interval=\"5000\" no-wrap=\"false\" active=\"row.active1\"><div uib-slide=\"\" ng-repeat=\"image in row.newImages track by $index\" index=\"$index\"><img ng-src=\"{{image.path}}\" style=\"margin:auto;height:180px\"></div></div></div></div></td></tr></tbody></table></td></tr><tr ng-if=\"vm.m.consumables==null||vm.m.consumables.length==0\" height=\"160px\"><td colspan=\"11\" align=\"center\" style=\"vertical-align:middle\"><span class=\"table-no-data\">暂无数据</span></td></tr></tbody></table></div></div><div class=\"form-group\"><div class=\"col-md-offset-2 col-md-9\"><div class=\"pull-right\"><button ui-sref=\"^.list\" class=\"btn btn-default\">取消</button> <button class=\"btn btn-primary\" ng-click=\"vm.submit(vm.m,Form)\" promise-btn=\"\">提交</button></div></div></div></form></div></div>");
$templateCache.put("app/pages/csmbs/categories/vStop/add/add.html","<div ba-panel=\"\" ba-panel-class=\"profile-page\" ba-panel-title=\"<span ncy-breadcrumb-last></span>\"><div class=\"panel-content\"><form name=\"Form\" class=\"form-horizontal\" scroll-form=\"\" novalidate=\"\"><div class=\"alert bg-danger\"><strong>注意：停用品种将会同时停用品种下的所有耗材型号！</strong></div><div class=\"form-group\"><label class=\"col-md-2 control-label\">耗材名称</label><div class=\"col-md-9\"><cvs-select ng-model=\"vm.m.csmbs\" name=\"csmbs\" disabled=\"vm.m.id\" on-select=\"vm.csmbSelected(vm.m)\" on-remove=\"vm.csmbSelected(vm.m)\"></cvs-select><div ng-show=\"Form.$submitted||Form.csmbs.$touched\"><span ng-show=\"vm.m.csmbs.length==0\" class=\"validation-invalid control-label\">必填项!!</span></div></div></div><div class=\"form-group\"><label class=\"col-md-2 control-label\">耗材明细</label><div class=\"col-md-9\"><div class=\"table-responsive\" style=\"min-height: 150px\"><table class=\"table table-bordered table-condensed\"><thead><tr><th>注册证名称</th><th>通用名</th><th width=\"168\">类型</th><th width=\"108\">所属库房</th><th width=\"36\">更多</th></tr></thead><tbody><tr ng-repeat-start=\"row in vm.m.consumables track by row.id\"><td>{{row.name}}</td><td>{{row.c_name}}</td><td>{{row.type}}</td><td>{{row.storeroom.name}}</td><td><button type=\"button\" class=\"btn btn-default btn-xs\" ng-click=\"row.showDetail=!row.showDetail\"><i class=\"glyphicon glyphicon-chevron-down\" ng-hide=\"row.showDetail\"></i> <i class=\"glyphicon glyphicon-chevron-up\" ng-show=\"row.showDetail\"></i></button></td></tr><tr ng-repeat-end=\"\" ng-if=\"row.showDetail\" class=\"bg-gray-light\"><td colspan=\"9\"><table class=\"table table-hover\"><tbody><tr><td height=\"36\">生产商：{{row[\'producer\'].name}}</td><td height=\"36\">经销商：{{row[\'dealer\'].name}}</td></tr><tr ng-if=\"row.s_dealer\"><td height=\"36\" colspan=\"2\">二级经销商：{{row.s_dealer.name}}</td></tr><tr><td height=\"36\">注册证号：{{row[\'r_num\']}}</td><td height=\"36\">原产地：{{row.is_import==\'1\'?row.country.cn+\'lt;\'+row.country.en+\'&gt;\':(row.country.cn+(row.province?\'&lt;\'+row.province.name+\'&gt;\':\'\'))}}</td></tr><tr ng-if=\"row.has_life==\'1\'\"><td height=\"36\">保质期： {{row[\'year_shelf_life\']>0?row[\'year_shelf_life\']+\'年\':\'\'}} {{row[\'month_shelf_life\']>0?row[\'month_shelf_life\']+\'月\':\'\'}} {{row[\'shelf_life\']>0?row[\'shelf_life\']+\'天\':\'\'}}</td><td height=\"36\">到期提醒：{{row[\'remind_day\']}}天</td></tr><tr><td height=\"36\">高值耗材： <span ng-class=\"{true:\'text-red\',false:\'text-default\'}[row.is_high_value==\'1\']\" ng-bind=\"row.is_high_value==\'1\'?\'是\':\'否\'\"></span></td><td height=\"36\">正常到货周期：{{row.lead_time?(row.lead_time+\'天\'):\'未设置\'}}</td></tr><tr><td height=\"36\" colspan=\"2\">按 <span class=\"text-red\" ng-bind=\"row[\'storage_unit\']\"></span> 领用 <span ng-if=\"row[\'purchase_unit\']!=row[\'storage_unit\']\">, 每 <span class=\"text-red\" ng-bind=\"row[\'purchase_unit\']\"></span> <span class=\"text-red\" ng-bind=\"row[\'storage_num\']\"></span> <span class=\"text-red\" ng-bind=\"row[\'storage_unit\']\"></span></span> <span ng-if=\"row[\'storage_unit\']!=row[\'use_unit\']\">每 <span class=\"text-red\" ng-bind=\"row[\'storage_unit\']\"></span> <span class=\"text-red\" ng-bind=\"row[\'use_num\']\"></span> <span class=\"text-red\" ng-bind=\"row[\'use_unit\']\"></span></span><div ng-if=\"row.level>0\" style=\"display: inline\"><span ng-switch=\"row.level\" class=\"text-info\"><span ng-switch-when=\"1\">可直接领用</span> <span ng-switch-when=\"2\">需科主任审批</span> <span ng-switch-when=\"3\">需分管院领导审批</span> <span ng-switch-when=\"4\">需主管院领导审批</span></span></div>.</td></tr><tr><td colspan=\"2\">备注：<span ng-bind=\"row.note?row.note:\'暂无备注\'\"></span></td></tr></tbody></table></td></tr><tr ng-if=\"vm.m.consumables==null||vm.m.consumables.length==0\" height=\"160px\"><td colspan=\"11\" align=\"center\" style=\"vertical-align:middle\"><span class=\"table-no-data\">暂无数据</span></td></tr></tbody></table></div></div></div><div class=\"form-group\"><label class=\"col-md-2 control-label\">停用原因</label><div class=\"col-md-9\"><textarea maxlength=\"255\" class=\"form-control\" rows=\"4\" name=\"note\" validator=\"required\" ng-model=\"vm.m.note\"></textarea><div ng-if=\"Form.$submitted||Form.note.$touched\"><span ng-show=\"Form.note.$error.required\" class=\"validation-invalid\">必填项!!</span></div></div></div><div class=\"form-group\"><div class=\"col-md-offset-2 col-md-9\"><div class=\"pull-right\"><button ui-sref=\"^.list\" class=\"btn btn-default\">取消</button> <button class=\"btn btn-primary\" ng-click=\"vm.submit(vm.m,Form)\" promise-btn=\"\">提交</button></div></div></div></form></div></div>");
$templateCache.put("app/pages/csmbs/categories/vStop/list/list.html","<div ba-panel=\"\" ba-panel-class=\"light-text tab-content-panel\" ba-panel-header=\"\" ba-panel-title=\"<span ncy-breadcrumb-last></span>\"><div class=\"table-responsive\" loading-container=\"vm.tableParams.settings().$loading\"><table class=\"table table-hover table-row-clicked\" ng-table=\"vm.tableParams\" template-header=\"app/theme/components/table/header.html\"><tr ng-repeat-start=\"row in $data track by row.id\" ng-click=\"row.showDetail=!row.showDetail\"><td ng-click=\"$event.stopPropagation()\"><button type=\"button\" class=\"btn btn-default btn-xs\" ng-click=\"row.showDetail=!row.showDetail\"><i class=\"glyphicon glyphicon-chevron-down\" ng-hide=\"row.showDetail\"></i> <i class=\"glyphicon glyphicon-chevron-up\" ng-show=\"row.showDetail\"></i></button> <button class=\"btn btn-warning btn-xs\" ui-sref=\"^.edit({id:row.id})\" ng-if=\"row.state.id==3\" uib-tooltip=\"重新申请\" tooltip-class=\"tooltipInfo\"><span class=\"glyphicon glyphicon-pencil\"></span></button> <button class=\"btn btn-info btn-xs\" ui-sref=\"^.edit({id:row.id})\" ng-if=\"row.state.id==1\" uib-tooltip=\"修改\" tooltip-class=\"tooltipInfo\"><span class=\"glyphicon glyphicon-pencil\"></span></button> <button class=\"btn btn-danger btn-xs\" ng-if=\"row.state.id==3\" ng-click=\"vm.remove(row)\"><span class=\"glyphicon glyphicon-trash\"></span></button></td><td ng-repeat=\"col in vm.cols\" ng-switch=\"col.field\" ng-if=\"col.show\"><div ng-switch-when=\"items\"><table class=\"table table-bordered table-condensed\"><tbody><tr ng-repeat=\"i in row[col.field]\" ng-if=\"row.expand||$index<4\"><td>{{i.variety.name+(i.variety.c_name?\'(\'+i.variety.c_name+\')\':\'\')}}</td><td>{{i.variety.producer?i.variety.producer.name:\'暂无生产商\'}}</td></tr></tbody></table><div ng-click=\"$event.stopPropagation()\"><a class=\"pull-right\" ng-if=\"row[col.field].length>4\" ng-click=\"row.expand=!row.expand\"><span ng-if=\"row.expand\" class=\"fa fa-chevron-up\">收起</span> <span ng-if=\"!row.expand\" class=\"fa fa-chevron-down\">展开剩余{{row[col.field].length-4}}项...</span></a></div></div><span ng-switch-when=\"created_at\">{{row[col.field].substr(0,16)}}</span> <span ng-switch-when=\"note\">{{row[col.field]}}</span> <span ng-switch-default=\"\">{{row[col.field].name}}</span></td></tr><tr ng-repeat-end=\"\" ng-if=\"row.showDetail\" class=\"bg-gray-light\"><td colspan=\"99\"><table class=\"table table-bordered table-condensed\"><tbody><tr ng-if=\"row.state.id==3\"><td colspan=\"5\" align=\"left\">退回原因：<span class=\"text-red\" ng-bind=\"row.reason\"></span>，退回人：<span ng-bind=\"row.handler.name\"></span></td></tr><tr><th>注册证名称</th><th>通用名</th><th width=\"168\">类型</th><th width=\"108\">所属库房</th><th width=\"36\">更多</th></tr><tr ng-repeat-start=\"item in row.items track by item.id\"><td>{{item.variety.name}}</td><td>{{item.variety.c_name}}</td><td>{{item.variety.type}}</td><td>{{item.variety.storeroom.name}}</td><td><button type=\"button\" class=\"btn btn-default btn-xs\" ng-click=\"item.showDetail=!item.showDetail\"><i class=\"glyphicon glyphicon-chevron-down\" ng-hide=\"item.showDetail\"></i> <i class=\"glyphicon glyphicon-chevron-up\" ng-show=\"item.showDetail\"></i></button></td></tr><tr ng-repeat-end=\"\" ng-if=\"item.showDetail\" class=\"bg-gray-light\"><td colspan=\"9\"><table class=\"table table-hover\"><tbody><tr><td height=\"36\">生产商：{{item.variety[\'producer\'].name}}</td><td height=\"36\">经销商：{{item.variety[\'dealer\'].name}}</td></tr><tr ng-if=\"item.variety.s_dealer\"><td height=\"36\" colspan=\"2\">二级经销商：{{item.variety.s_dealer.name}}</td></tr><tr><td height=\"36\">注册证号：{{item.variety[\'r_num\']}}</td><td height=\"36\">原产地：{{item.variety.is_import==\'1\'?item.variety.country.cn+\'lt;\'+item.variety.country.en+\'&gt;\':(item.variety.country.cn+(item.variety.province?\'&lt;\'+item.variety.province.name+\'&gt;\':\'\'))}}</td></tr><tr ng-if=\"item.variety.has_life==\'1\'\"><td height=\"36\">保质期： {{item.variety[\'year_shelf_life\']>0?item.variety[\'year_shelf_life\']+\'年\':\'\'}} {{item.variety[\'month_shelf_life\']>0?item.variety[\'month_shelf_life\']+\'月\':\'\'}} {{item.variety[\'shelf_life\']>0?item.variety[\'shelf_life\']+\'天\':\'\'}}</td><td height=\"36\">到期提醒：{{item.variety[\'remind_day\']}}天</td></tr><tr><td height=\"36\">高值耗材： <span ng-class=\"{true:\'text-red\',false:\'text-default\'}[item.variety.is_high_value==\'1\']\" ng-bind=\"item.variety.is_high_value==\'1\'?\'是\':\'否\'\"></span></td><td height=\"36\">正常到货周期：{{item.variety.lead_time?(item.variety.lead_time+\'天\'):\'未设置\'}}</td></tr><tr><td height=\"36\" colspan=\"2\">按 <span class=\"text-red\" ng-bind=\"item.variety[\'storage_unit\']\"></span> 领用 <span ng-if=\"item.variety[\'purchase_unit\']!=item.variety[\'storage_unit\']\">, 每 <span class=\"text-red\" ng-bind=\"item.variety[\'purchase_unit\']\"></span> <span class=\"text-red\" ng-bind=\"item.variety[\'storage_num\']\"></span> <span class=\"text-red\" ng-bind=\"item.variety[\'storage_unit\']\"></span></span> <span ng-if=\"item.variety[\'storage_unit\']!=item.variety[\'use_unit\']\">每 <span class=\"text-red\" ng-bind=\"item.variety[\'storage_unit\']\"></span> <span class=\"text-red\" ng-bind=\"item.variety[\'use_num\']\"></span> <span class=\"text-red\" ng-bind=\"item.variety[\'use_unit\']\"></span></span><div ng-if=\"item.variety.level>0\" style=\"display: inline\"><span ng-switch=\"item.variety.level\" class=\"text-info\"><span ng-switch-when=\"1\">可直接领用</span> <span ng-switch-when=\"2\">需科主任审批</span> <span ng-switch-when=\"3\">需分管院领导审批</span> <span ng-switch-when=\"4\">需主管院领导审批</span></span></div>.</td></tr><tr><td colspan=\"2\">备注：<span ng-bind=\"item.variety.note?item.variety.note:\'暂无备注\'\"></span></td></tr></tbody></table></td></tr></tbody></table></td></tr><tr ng-if=\"!vm.tableParams.settings().$loading&&($data==null||$data.length==0)\" class=\"table-no-data\"><td colspan=\"99\" align=\"center\"><span>暂无数据</span></td></tr></table></div></div>");
$templateCache.put("app/pages/csmbs/categories/category/list/list.html","<script type=\"text/ng-template\" id=\"CsmbCodeDlg.html\"><div class=\"modal-header dialog-header-confirm\"> <button type=\"button\" class=\"close\" ng-click=\"vm.cancel()\">&times;</button> <h4 class=\"modal-title\"> <i class=\"fa fa-edit\">设置编码及计费类型</i> </h4> </div> <div class=\"modal-body\"> <form name=\"Form\" class=\"form-horizontal\" scroll-form novalidate> <div class=\"form-group\"> <label class=\"col-md-4 control-label\">国家医保材料代码<span class=\"text-red\">&nbsp;*</span></label> <div class=\"col-md-6\"> <input type=\"text\" class=\"form-control\" name=\"m_code\" ng-model=\"vm.m.m_code\" validator=\"required\"> </div> </div> <div class=\"form-group\"> <label class=\"col-md-4 control-label\">成都市编码<span class=\"text-red\">&nbsp;*</span></label> <div class=\"col-md-6\"> <input type=\"text\" class=\"form-control\" name=\"c_code\" ng-model=\"vm.m.c_code\" validator=\"required\"> </div> </div> <div class=\"form-group\"> <label class=\"col-md-4 control-label\">his计费类型<span class=\"text-red\">&nbsp;*</span></label> <div class=\"col-md-6\"> <ui-select name=\"his_fee_type\" ng-model=\"vm.m.his_fee_type\"> <ui-select-match placeholder=\"请选择计费类型...\">{{$select.selected.name}} </ui-select-match> <ui-select-choices repeat=\"type in vm.hisFeeTypes | filter: $select.search\"> <div ng-bind-html=\"type.name | highlight: $select.search\"></div> </ui-select-choices> </ui-select> </div> </div> </form> </div> <div class=\"modal-footer\"> <button class=\"btn btn-primary\" ng-click=\"vm.ok(vm.m,Form)\" promise-btn>确认</button> <button class=\"btn btn-default\" ng-click=\"vm.cancel()\">取消</button> </div></script><script type=\"text/ng-template\" id=\"CsmbStopDlg.html\"><div class=\"modal-header dialog-header-confirm\"> <button type=\"button\" class=\"close\" ng-click=\"vm.cancel()\">&times;</button> <h4 class=\"modal-title\"> <i class=\"fa fa-edit\">申请停用型号</i> </h4> </div> <div class=\"modal-body\"> <form name=\"Form\" class=\"form-horizontal\" scroll-form novalidate> <div class=\"form-group\"> <label class=\"col-md-4 control-label\">停用原因</label> <div class=\"col-md-6\"> <textarea maxlength=\"255\" class=\"form-control\" rows=\"4\" name=\"note\" validator=\"required\" ng-model=\"vm.m.note\"></textarea> <div ng-if=\"Form.$submitted||Form.note.$touched\"> <span ng-show=\"Form.note.$error.required\" class=\"validation-invalid\">必填项!!</span> </div> </div> </div> </form> </div> <div class=\"modal-footer\"> <button class=\"btn btn-primary\" ng-click=\"vm.ok(vm.m,Form)\">确认</button> <button class=\"btn btn-default\" ng-click=\"vm.cancel()\">取消</button> </div></script><script type=\"text/ng-template\" id=\"CsmbDealerPriceHistoryDlg.html\"><div class=\"modal-header dialog-header-confirm\"> <button type=\"button\" class=\"close\" ng-click=\"vm.cancel()\">&times;</button> <h4 class=\"modal-title\"> <i class=\"fa fa-money\">二级经销商价格变动记录</i> </h4> </div> <div class=\"modal-body\"> <div class=\"panel panel-default\"> <div class=\"panel-heading\"> <strong>价格变动列表</strong> <div class=\"btn-group pull-right\" style=\"margin-top: -8px\"> <button ng-click=\"vm.tableReload()\" class=\"btn btn-default btn-circle\"> <i class=\"fa fa-refresh\"></i> </button> </div> </div> <div class=\"panel-body single-panel min-h418\" loading-container=\"vm.tableParams.settings().$loading\"> <table class=\"table table-hover table-row-clicked\" ng-table=\"vm.tableParams\" template-header=\"app/theme/components/table/header.html\"> <tr ng-repeat=\"row in $data track by row.id\" class=\"text-center\"> <td ng-repeat=\"col in vm.cols\" ng-switch=\"col.field\" ng-show=\"col.show\"> <div ng-switch-when=\"updated_at\">{{row[col.field].substr(0,16)}}</div> <div ng-switch-when=\"old_purchase_price\"> {{row[col.field]?(row[col.field]|currency:\'￥\'):\'暂无\'}} </div> <div ng-switch-when=\"purchase_price\">{{row[col.field]?(row[col.field]|currency:\'￥\'):\'暂无\'}} </div> </td> </tr> <tr ng-if=\"!vm.tableParams.settings().$loading&&($data==null||$data.length==0)\" class=\"table-no-data\"> <td colspan=\"99\" align=\"center\"><span>暂无数据</span> </td> </tr> </table> </div> </div> </div> <div class=\"modal-footer\"> <button class=\"btn btn-default\" ng-click=\"vm.cancel()\">返回</button> </div></script><script type=\"text/ng-template\" id=\"CsmbDealerPriceDlg.html\"><div class=\"modal-header dialog-header-confirm\"> <button type=\"button\" class=\"close\" ng-click=\"vm.cancel()\">&times;</button> <h4 class=\"modal-title\"> <i class=\"fa fa-edit\">设置二级经销商价格</i> </h4> </div> <div class=\"modal-body\"> <form name=\"Form\" class=\"form-horizontal\" scroll-form novalidate> <div class=\"form-group\"> <label class=\"col-md-4 control-label\">二级经销商价格/元 <i uib-tooltip=\"使用单位价格\" tooltip-append-to-body=\"true\" tooltip-class=\"tooltipInfo\" style=\"display: inline\" class=\"fa fa-info-circle text-info\"></i></label> <div class=\"col-md-6\"> <input type=\"text\" input-float=\"2\" class=\"form-control\" name=\"sd_purchase_price\" ng-model=\"vm.m.sd_purchase_price\" validator=\"required\"> </div> </div> </form> </div> <div class=\"modal-footer\"> <button class=\"btn btn-primary\" ng-click=\"vm.ok(vm.m,Form)\" promise-btn>确认</button> <button class=\"btn btn-default\" ng-click=\"vm.cancel()\">取消</button> </div></script><script type=\"text/ng-template\" id=\"ConsumableImgDlg.html\"><div class=\"modal-header dialog-header-confirm\"> <button type=\"button\" class=\"close\" ng-click=\"vm.cancel()\">&times;</button> <h4 class=\"modal-title\"> <i class=\"fa fa-plus\" ng-hide=\"vm.m.id\">添加</i> <i class=\"fa fa-edit\" ng-show=\"vm.m.id\">编辑</i>耗材图片 </h4> </div> <div class=\"modal-body\"> <form name=\"Form\" class=\"form-horizontal\" scroll-form novalidate> <div class=\"form-group\"> <label class=\"col-md-4 control-label\">图片</label> <div class=\"col-md-6\"> <button type=\"button\" class=\"btn btn-info btn-raised\" ng-click=\"vm.setImg(vm.m)\"> <span ng-if=\"!vm.m.path\">添加</span> <span ng-if=\"vm.m.path\">更改</span> </button> <img class=\"img-responsive poster\" ng-src=\"{{vm.m.path}}\"><br> </div> </div> </form> </div> <div class=\"modal-footer\"> <button class=\"btn btn-primary\" ng-click=\"vm.ok(vm.m,Form)\" promise-btn>确认</button> <button class=\"btn btn-default\" ng-click=\"vm.cancel()\">取消</button> </div></script><script type=\"text/ng-template\" id=\"CsmbLargeImgDlg.html\"><div fullscreen=\"isFullscreen\"> <div class=\"modal-header dialog-header-confirm\"> <button type=\"button\" class=\"close\" ng-click=\"vm.cancel()\">&times;</button> <button type=\"button\" class=\"close\" ng-click=\"isFullscreen=!isFullscreen\" style=\"padding-right:6px\"> <i class=\"fa fa-square-o\"></i></button> <h4 class=\"modal-title\"> <i class=\"fa fa-photo\"></i>&nbsp;耗材图片 </h4> </div> <div class=\"modal-body\"> <img class=\"img-responsive poster\" ng-src=\"{{vm.m.path}}\"><br> </div> <div class=\"modal-footer\"> <button class=\"btn btn-default\" ng-click=\"vm.cancel()\">返回</button> </div> </div></script><div ba-panel=\"\" ba-panel-class=\"light-text tab-content-panel\" ba-panel-header=\"\" download-btn=\"\" ba-panel-title=\"<span ncy-breadcrumb-last></span>\"><div class=\"table-responsive\" loading-container=\"vm.tableParams.settings().$loading\"><table class=\"table table-hover table-row-clicked\" ng-table=\"vm.tableParams\" template-header=\"app/theme/components/table/header.html\"><tr ng-repeat-start=\"row in $data track by row.id\" ng-click=\"row.showDetail=!row.showDetail\"><td ng-click=\"$event.stopPropagation()\"><button type=\"button\" class=\"btn btn-default btn-xs\" ng-click=\"row.showDetail=!row.showDetail\"><i class=\"glyphicon glyphicon-chevron-down\" ng-hide=\"row.showDetail\"></i> <i class=\"glyphicon glyphicon-chevron-up\" ng-show=\"row.showDetail\"></i></button> <button class=\"btn btn-primary btn-xs\" ng-if=\"row.state.id==5||row.state.id==1\" uib-tooltip=\"修改\" ui-sref=\"^.edit({id:row.id})\"><span class=\"fa fa-edit fa-fw\"></span></button> <button class=\"btn btn-warning btn-xs\" ng-if=\"row.state.id==2\" uib-tooltip=\"重新申请\" ui-sref=\"^.edit({id:row.id})\"><span class=\"fa fa-edit fa-fw\"></span></button> <button class=\"btn btn-success btn-xs\" ng-if=\"row.state.id==4||row.state.id==3\" uib-tooltip=\"价格变动\" ui-sref=\"^.price({id:row.id})\"><span class=\"fa fa-money fa-fw\"></span></button> <button class=\"btn btn-danger btn-xs\" ng-if=\"row.state.id==1||row.state.id==2||row.state.id==5\" uib-tooltip=\"删除\" ng-click=\"vm.remove(row)\"><span class=\"fa fa-trash fa-fw\"></span></button> <button class=\"btn btn-info btn-xs\" tooltip-append-to-body=\"true\" uib-tooltip=\"二级经销商价格变动\" ng-click=\"vm.sPrice(row)\"><span class=\"fa fa-money fa-fw\"></span></button> <button class=\"btn btn-primary btn-xs\" tooltip-append-to-body=\"true\" ng-if=\"row.state.id!=1&&row.state.id!=5\" uib-tooltip=\"设置二级经销商价格\" ng-click=\"vm.setPrice(row)\"><span class=\"fa fa-cog fa-fw\"></span></button> <button class=\"btn btn-danger btn-xs\" ng-if=\"(row.state.id==3||row.state.id==4)&&row.is_stop==0\" uib-tooltip=\"申请停用\" ng-click=\"vm.stop(row)\"><span class=\"fa fa-ban fa-fw\"></span></button> <button class=\"btn btn-warning btn-xs\" tooltip-append-to-body=\"true\" uib-tooltip=\"设置编码及计费类型\" ng-click=\"vm.setCode(row)\"><span class=\"fa fa-tag fa-fw\"></span></button></td><td ng-repeat=\"col in vm.cols\" ng-switch=\"col.field\" ng-if=\"col.show\"><div ng-switch-when=\"name\">{{row[col.field]}} <span ng-if=\"row.is_stop==\'1\'\" class=\"tag tag-danger\">停</span></div><div ng-switch-when=\"state\">{{row[col.field].name}}</div><div ng-switch-when=\"storeroom\">{{row.storeroom?row[col.field].name:\'暂无\'}}</div><div ng-switch-when=\"s_dealer\">{{row.s_dealer?row[col.field].name:\'暂无\'}}</div><div ng-switch-when=\"group\">{{row.group?row.group.name:\'\'}}</div><div ng-switch-when=\"manage_type\">{{row.manage_type?row.manage_type.name:\'\'}}</div><div ng-switch-default=\"\">{{row[col.field]}}</div></td></tr><tr ng-repeat-end=\"\" ng-if=\"row.showDetail\" class=\"bg-gray-light\"><td colspan=\"99\"><table class=\"table table-hover\"><tbody><tr ng-if=\"row.state.id==2\"><td colspan=\"3\" align=\"left\">退回原因：<span class=\"text-red\" ng-bind=\"row.reason\"></span></td></tr><tr><td rowspan=\"8\" width=\"256\"><div style=\"position:relative\"><div style=\"position:absolute;right:0;top:0;z-index:1001\"><button class=\"btn btn-info btn-xs\" ng-if=\"row.state.id==2||row.state.id==5\" ng-click=\"vm.addEditImg(row)\"><i class=\"fa fa-plus fa-fw\"></i></button> <button type=\"button\" class=\"btn btn-success btn-xs\" ng-if=\"row.images.length>0\" ng-click=\"vm.zoomIn(row)\"><i class=\"fa fa-search-plus fa-fw\"></i></button> <button class=\"btn btn-primary btn-xs\" ng-if=\"row.images.length>0&&(row.state.id==2||row.state.id==5)\" ng-click=\"vm.addEditImg(row,true)\"><i class=\"fa fa-pencil fa-fw\"></i></button> <button type=\"button\" class=\"btn btn-danger btn-xs\" ng-if=\"row.images.length>0&&(row.state.id==2||row.state.id==5)\" ng-click=\"vm.rmImg(row)\"><i class=\"fa fa-times fa-fw\"></i></button></div><div style=\"height:180px\"><div uib-carousel=\"\" interval=\"5000\" no-wrap=\"false\" active=\"row.active\"><div uib-slide=\"\" ng-repeat=\"image in row.images track by image.id\" index=\"$index\"><img ng-src=\"{{image.path}}\" style=\"margin:auto;height:180px\"></div></div></div></div></td><td height=\"36\">生产商：{{row[\'producer\'].name}}</td><td height=\"36\">经销商：{{row[\'dealer\'].name}}</td></tr><tr ng-if=\"row.s_dealer\"><td height=\"36\">二级经销商：{{row.s_dealer.name}}</td><td height=\"36\">二级经销商进价：{{row.sd_purchase_price!=null?(row.sd_purchase_price +\'元/\'+row.use_unit):\'暂无\'}}</td></tr><tr><td height=\"36\">注册证号：{{row[\'r_num\']}}</td><td height=\"36\">原产地：{{row.is_import==\'1\'?row.country.cn+\'lt;\'+row.country.en+\'&gt;\':(row.country.cn+(row.province?\'&lt;\'+row.province.name+\'&gt;\':\'\'))}}</td></tr><tr><td height=\"36\">价格：{{row[\'purchase_price\']}}元/{{row[\'use_unit\']}}</td><td height=\"36\">正常到货周期：{{row.lead_time?(row.lead_time+\'天\'):\'未设置\'}}</td></tr><tr ng-if=\"row.has_life==\'1\'\"><td height=\"36\">保质期： {{row[\'year_shelf_life\']>0?row[\'year_shelf_life\']+\'年\':\'\'}} {{row[\'month_shelf_life\']>0?row[\'month_shelf_life\']+\'月\':\'\'}} {{row[\'shelf_life\']>0?row[\'shelf_life\']+\'天\':\'\'}}</td><td height=\"36\">到期提醒：{{row[\'remind_day\']}}天</td></tr><tr><td height=\"36\" colspan=\"2\">按 <span class=\"text-red\" ng-bind=\"row[\'storage_unit\']\"></span> 领用, <span ng-if=\"row[\'purchase_unit\']!=row[\'storage_unit\']\">每 <span class=\"text-red\" ng-bind=\"row[\'purchase_unit\']\"></span> <span class=\"text-red\" ng-bind=\"row[\'storage_num\']\"></span> <span class=\"text-red\" ng-bind=\"row[\'storage_unit\']\"></span></span> <span ng-if=\"row[\'storage_unit\']!=row[\'use_unit\']\">每 <span class=\"text-red\" ng-bind=\"row[\'storage_unit\']\"></span> <span class=\"text-red\" ng-bind=\"row[\'use_num\']\"></span> <span class=\"text-red\" ng-bind=\"row[\'use_unit\']\"></span> ,</span> <span ng-switch=\"row.level\" class=\"text-info\"><span ng-switch-when=\"1\">可直接领用</span> <span ng-switch-when=\"2\">需科主任审批</span> <span ng-switch-when=\"3\">需分管院领导审批</span> <span ng-switch-when=\"4\">需主管院领导审批</span></span>.</td></tr><tr><td colspan=\"2\">备注：<span ng-bind=\"row.note?row.note:\'暂无备注\'\"></span></td></tr><tr><td ng-if=\"row.fee\" colspan=\"2\">his计费类型：{{row.fee.name}}</td></tr></tbody></table></td></tr><tr ng-if=\"!vm.tableParams.settings().$loading&&($data==null||$data.length==0)\" class=\"table-no-data\"><td colspan=\"99\" align=\"center\"><span>暂无数据</span></td></tr></table></div></div>");
$templateCache.put("app/pages/csmbs/categories/variety/add/add.html","<script type=\"text/ng-template\" id=\"items_renderer.html\"><div ui-tree-handle class=\"tree-node\" ng-click=\"vm.m.type=item;vm.opt.isOpen=false\" style=\"cursor:pointer\"> <a class=\"btn btn-success btn-xs\" ng-if=\"item.children&&item.children.length>0\" data-nodrag ng-click=\"$event.stopPropagation();toggle(this)\"> <span class=\"glyphicon\" ng-class=\"{\'glyphicon-chevron-right\':collapsed, \'glyphicon-chevron-down\':!collapsed}\"> </span> </a> <span ng-bind=\"item.name\"></span> </div> <ol ui-tree-nodes ng-model=\"item.children\" ng-class=\"{hidden:collapsed}\"> <li ng-repeat=\"item in item.children\" ui-tree-node ng-include=\"\'items_renderer.html\'\"> </li> </ol></script><script type=\"text/ng-template\" id=\"CsmbLargeImgDlg.html\"><div fullscreen=\"isFullscreen\"> <div class=\"modal-header dialog-header-confirm\"> <button type=\"button\" class=\"close\" ng-click=\"vm.cancel()\">&times;</button> <button type=\"button\" class=\"close\" ng-click=\"isFullscreen=!isFullscreen\" style=\"padding-right:6px\"> <i class=\"fa fa-square-o\"></i></button> <h4 class=\"modal-title\"> <i class=\"fa fa-photo\"></i>&nbsp;耗材图片 </h4> </div> <div class=\"modal-body\"> <img class=\"img-responsive poster\" ng-src=\"{{vm.m.path}}\"><br> </div> <div class=\"modal-footer\"> <button class=\"btn btn-default\" ng-click=\"vm.cancel()\">返回</button> </div> </div></script><script type=\"text/ng-template\" id=\"CsmbCategoryDlg.html\"><div class=\"modal-header dialog-header-confirm\"> <button type=\"button\" class=\"close\" ng-click=\"vm.cancel()\">&times;</button> <h4 class=\"modal-title\"> <i class=\"fa fa-plus\" ng-hide=\"vm.m.id\">添加</i> <i class=\"fa fa-edit\" ng-show=\"vm.m.id\">编辑</i>耗材型号 </h4> </div> <div class=\"modal-body\"> <form name=\"Form\" class=\"form-horizontal\" scroll-form novalidate> <div class=\"form-group\"> <label class=\"col-md-4 control-label\">图片<span class=\"text-red\">&nbsp;*</span></label> <div class=\"col-md-6\"> <button type=\"button\" class=\"btn btn-info btn-raised\" ng-click=\"vm.setImg(vm.m)\"> <span ng-if=\"vm.m.images.length==0\" style=\"color: #fff\">添加</span> <span ng-if=\"vm.m.images.length>0\" style=\"color: #fff\">继续添加</span> </button> <div ng-repeat=\"image in vm.m.images\" style=\"margin-bottom: 5px\"> <img class=\"img-responsive poster\" ng-src=\"{{image.path}}\"><br> <button type=\"button\" class=\"btn btn-primary btn-raised\" ng-click=\"vm.zoomIn(image)\">放大</button> <button type=\"button\" class=\"btn btn-info btn-raised\" ng-click=\"vm.editImg(image)\">更改</button> <button type=\"button\" class=\"btn btn-danger btn-raised\" ng-click=\"vm.delImg(vm.m,$index)\">删除 </button> </div> </div> </div> <div class=\"form-group\" ng-if=\"!vm.is_admin\"> <label class=\"col-md-4 control-label\">阳光流水号</label> <div class=\"col-md-6\"> <input type=\"text\" class=\"form-control\" name=\"sunshine_num\" ng-model=\"vm.m.sunshine_num\"> </div> </div> <div class=\"form-group\" ng-if=\"vm.index!=0\"> <label class=\"col-md-4 control-label\">规格型号<span class=\"text-red\">&nbsp;*</span></label> <div class=\"col-md-6\"> <input type=\"text\" class=\"form-control\" name=\"spec\" validator=\"required\" ng-model=\"vm.m.spec\"> </div> </div> <div class=\"form-group\" ng-if=\"vm.index==0\"> <label class=\"col-md-4 control-label\">规格型号<span class=\"text-red\">&nbsp;*</span></label> <div class=\"col-md-6\"> <ui-select multiple tagging=\"vm.tagTransform\" ng-model=\"vm.m.specs\"> <ui-select-match><span ng-bind=\"$item.name\" title={{$item.name}}></span></ui-select-match> <ui-select-choices repeat=\"spec in vm.specs | filter: $select.search\"> <div ng-if=\"spec.isTag\" ng-bind-html=\"(spec.name | highlight: $select.search) +\' (新建)\'\"></div> <div ng-if=\"!spec.isTag\" ng-bind-html=\"spec.name | highlight: $select.search\"></div> </ui-select-choices> </ui-select> </div> </div> <div class=\"form-group\"> <label class=\"col-md-4 control-label\">价格/元<span class=\"text-red\">&nbsp;*</span> <i uib-tooltip=\"使用单位价格\" tooltip-append-to-body=\"true\" tooltip-class=\"tooltipInfo\" style=\"display: inline\" class=\"fa fa-info-circle text-info\"></i></label> <div class=\"col-md-6\"> <input type=\"text\" input-float=\"2\" class=\"form-control\" name=\"purchase_price\" validator=\"required\" ng-model=\"vm.m.purchase_price\"> </div> </div> <div class=\"form-group\"> <label class=\"col-md-4 control-label\">二级经销商价格/元 <i uib-tooltip=\"使用单位价格\" tooltip-append-to-body=\"true\" tooltip-class=\"tooltipInfo\" style=\"display: inline\" class=\"fa fa-info-circle text-info\"></i></label> <div class=\"col-md-6\"> <input type=\"text\" input-float=\"2\" class=\"form-control\" name=\"sd_purchase_price\" ng-model=\"vm.m.sd_purchase_price\"> </div> </div> <div class=\"form-group\"> <label class=\"col-md-2 control-label\">国家医保材料代码<span class=\"text-red\">&nbsp;*</span></label> <div class=\"col-md-6\"> <input type=\"text\" class=\"form-control\" name=\"m_code\" ng-model=\"vm.m.m_code\" validator=\"required\"> </div> </div> <div class=\"form-group\"> <label class=\"col-md-4 control-label\">成都市编码<span class=\"text-red\">&nbsp;*</span></label> <div class=\"col-md-6\"> <input type=\"text\" class=\"form-control\" name=\"c_code\" ng-model=\"vm.m.c_code\" validator=\"required\"> </div> </div> <div class=\"form-group\"> <label class=\"col-md-4 control-label\">his计费类型<span class=\"text-red\">&nbsp;*</span></label> <div class=\"col-md-6\"> <ui-select name=\"his_fee_type\" ng-model=\"vm.m.his_fee_type\"> <ui-select-match placeholder=\"请选择计费类型...\">{{$select.selected.name}} </ui-select-match> <ui-select-choices repeat=\"type in vm.hisFeeTypes | filter: $select.search\"> <div ng-bind-html=\"type.name | highlight: $select.search\"></div> </ui-select-choices> </ui-select> </div> </div> <div class=\"form-group\"> <label class=\"col-md-4 control-label\">备注</label> <div class=\"col-md-6\"> <textarea class=\"form-control\" rows=\"5\" name=\"note\" ng-model=\"vm.m.note\" maxlength=\"200\"></textarea> </div> </div> </form> </div> <div class=\"modal-footer\"> <button class=\"btn btn-primary\" ng-click=\"vm.ok(vm.m,Form)\" promise-btn>确认</button> <button class=\"btn btn-default\" ng-click=\"vm.cancel()\">取消</button> </div></script><div ba-panel=\"\" ba-panel-class=\"profile-page\" ba-panel-title=\"<span ncy-breadcrumb-last></span>\"><div class=\"panel-content col-md-10\"><form name=\"Form\" class=\"form-horizontal\" scroll-form=\"\" novalidate=\"\"><div class=\"form-group\"><label class=\"col-md-2 control-label\">类型<span class=\"text-red\">&nbsp;*</span></label><div class=\"col-md-8\"><div uib-dropdown=\"\" auto-close=\"outsideClick\" is-open=\"vm.opt.isOpen\"><button type=\"button\" class=\"btn btn-default btn-block dropdown-toggle noHover\" uib-dropdown-toggle=\"\"><span class=\"pull-left\" title=\"{{(vm.m.type.parent&&vm.m.type.parent_id!=1)?(vm.m.type.parent.name+\'-\'+vm.m.type.name):vm.m.type.name}}\" ng-bind=\"(vm.m.type.parent&&vm.m.type.parent_id!=1)?(vm.m.type.parent.name+\'-\'+vm.m.type.name):vm.m.type.name\"></span> <span class=\"caret pull-right\" style=\"margin:9px 0 9px 0\"></span></button><div class=\"dropdown-menu\" uib-dropdown-menu=\"\" role=\"menu\"><div oc-lazy-load=\"[\'/ocLazyLoad/uiTree/angular-ui-tree.min.css\', \'/ocLazyLoad/uiTree/angular-ui-tree.min.js\']\"><div ui-tree=\"\" id=\"tree-root\" style=\"margin:8px\" data-drag-enabled=\"false\"><div class=\"consumable-type-selector-box\"><ol ui-tree-nodes=\"\" ng-model=\"vm.types[1].children\"><li ng-repeat=\"item in vm.types[1].children\" ui-tree-node=\"\" ng-include=\"\'items_renderer.html\'\" data-collapsed=\"true\"></li></ol></div></div></div></div></div></div></div><div class=\"form-group\"><label class=\"col-md-2 control-label\">注册证名称<span class=\"text-red\" ng-if=\"!vm.m.is_admin\">&nbsp;*</span></label><div class=\"col-md-8\"><input ng-if=\"!vm.m.is_admin\" type=\"text\" class=\"form-control\" name=\"name\" validator=\"required\" ng-model=\"vm.m.name\"> <input ng-if=\"vm.m.is_admin\" type=\"text\" class=\"form-control\" name=\"name\" ng-model=\"vm.m.name\"></div></div><div class=\"form-group\"><label class=\"col-md-2 control-label\">通用名<span class=\"text-red\" ng-if=\"vm.m.is_admin\">&nbsp;*</span></label><div class=\"col-md-8\"><input ng-if=\"vm.m.is_admin\" type=\"text\" class=\"form-control\" name=\"c_name\" ng-model=\"vm.m.c_name\" validator=\"required\"> <input ng-if=\"!vm.m.is_admin\" type=\"text\" class=\"form-control\" name=\"c_name\" ng-model=\"vm.m.c_name\"></div></div><div class=\"form-group\"><label class=\"col-md-2 control-label\">英文简写</label><div class=\"col-md-8\"><input type=\"text\" class=\"form-control\" name=\"en\" ng-model=\"vm.m.en\"></div></div><div class=\"form-group\"><label class=\"col-md-2 control-label\">注册证号<span class=\"text-red\" ng-if=\"!vm.m.is_admin\">&nbsp;*</span></label><div class=\"col-md-8\"><input ng-if=\"!vm.m.is_admin\" type=\"text\" class=\"form-control\" name=\"r_num\" validator=\"required\" ng-model=\"vm.m.r_num\"> <input ng-if=\"vm.m.is_admin\" type=\"text\" class=\"form-control\" name=\"r_num\" ng-model=\"vm.m.r_num\"></div></div><div class=\"form-group\"><div class=\"col-md-8 col-md-offset-2\"><label class=\"cb-label-wrapper\"><checkbox ng-model=\"vm.m.is_import\" ng-change=\"vm.importChangeFn(vm.m)\"></checkbox><strong>是否进口</strong></label></div></div><div class=\"form-group\"><label class=\"col-md-2 control-label\">原产地<span class=\"text-red\" ng-if=\"!vm.m.is_admin\">&nbsp;*</span></label><div class=\"col-md-8\"><ui-select ng-model=\"vm.m.country\" name=\"country\" title=\"选择原产地\" id=\"country\" ng-disabled=\"!vm.m.is_import\"><ui-select-match placeholder=\"选择或搜索原产地\">{{$select.selected.cn}} &lt;{{$select.selected.en}}&gt;</ui-select-match><ui-select-choices repeat=\"country in vm.countries | filter: $select.search\" ui-disable-choice=\"vm.m.is_import&&country.id==37\"><span ng-bind-html=\"country.cn | highlight: $select.search\"></span> <span class=\"text-muted\">&lt;{{country.en}}&gt;</span></ui-select-choices></ui-select></div></div><div class=\"form-group\" ng-if=\"!vm.m.is_import\"><label class=\"col-md-2 control-label\">省/市<span class=\"text-red\" ng-if=\"!vm.m.is_admin\">&nbsp;*</span></label><div class=\"col-md-8\"><ui-select ng-model=\"vm.m.province\" name=\"province\" title=\"选择省/市\" id=\"province\"><ui-select-match placeholder=\"选择或搜索省/市\">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat=\"province in vm.provinces | filter: $select.search\"><span ng-bind-html=\"province.name | highlight: $select.search\"></span></ui-select-choices></ui-select></div></div><div class=\"form-group\"><label class=\"col-md-2 control-label\">生产商<span class=\"text-red\" ng-if=\"!vm.m.is_admin\">&nbsp;*</span></label><div class=\"col-md-8\"><ui-select multiple=\"\" limit=\"1\" tagging=\"vm.tagTransform\" ng-model=\"vm.m.producers\" title=\"选择或新建生产商\"><ui-select-match placeholder=\"选择或新建生产商...\"><span ng-bind=\"$item.name\" title=\"{{$item.name}}\"></span></ui-select-match><ui-select-choices repeat=\"producer in vm.producers | filter: $select.search | limitTo:100\"><div ng-if=\"producer.isTag\" ng-bind-html=\"(producer.name | highlight: $select.search) +\' (新建)\'\"></div><div ng-if=\"!producer.isTag\" ng-bind-html=\"producer.name | highlight: $select.search\"></div></ui-select-choices></ui-select></div></div><div class=\"form-group\"><label class=\"col-md-2 control-label\">供应商送货单位<span class=\"text-red\">&nbsp;*</span></label><div class=\"col-md-8\"><ui-select name=\"purchase_unit\" ng-model=\"vm.m.purchase_unit\"><ui-select-match placeholder=\"请选择送货单位...\">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat=\"value in vm.units | filter: $select.search\"><div ng-bind-html=\"value.name | highlight: $select.search\"></div></ui-select-choices></ui-select></div></div><div class=\"form-group\"><label class=\"col-md-2 control-label\">数量<span class=\"text-red\">&nbsp;*</span> <i uib-tooltip=\"送货单位内存储单位的数量\" tooltip-append-to-body=\"true\" tooltip-class=\"tooltipInfo\" style=\"display: inline\" class=\"fa fa-info-circle text-info\"></i></label><div class=\"col-md-8\"><input type=\"text\" input-number=\"\" class=\"form-control\" name=\"storage_num\" ng-model=\"vm.m.storage_num\" validator=\"required\"></div></div><div class=\"form-group\"><label class=\"col-md-2 control-label\">库房存储单位<span class=\"text-red\">&nbsp;*</span></label><div class=\"col-md-8\"><ui-select name=\"storage_unit\" ng-model=\"vm.m.storage_unit\"><ui-select-match placeholder=\"请选择存储单位...\">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat=\"value in vm.units | filter: $select.search\"><div ng-bind-html=\"value.name | highlight: $select.search\"></div></ui-select-choices></ui-select></div></div><div class=\"form-group\"><label class=\"col-md-2 control-label\">数量<span class=\"text-red\">&nbsp;*</span> <i uib-tooltip=\"存储单位内使用单位的数量\" tooltip-append-to-body=\"true\" tooltip-class=\"tooltipInfo\" style=\"display: inline\" class=\"fa fa-info-circle text-info\"></i></label><div class=\"col-md-8\"><input type=\"text\" input-number=\"\" class=\"form-control\" name=\"use_num\" ng-model=\"vm.m.use_num\" validator=\"required\"></div></div><div class=\"form-group\"><label class=\"col-md-2 control-label\">科室使用单位<span class=\"text-red\">&nbsp;*</span></label><div class=\"col-md-8\"><ui-select name=\"use_unit\" ng-model=\"vm.m.use_unit\"><ui-select-match placeholder=\"请选择使用单位...\">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat=\"value in vm.units | filter: $select.search\"><div ng-bind-html=\"value.name | highlight: $select.search\"></div></ui-select-choices></ui-select></div></div><div class=\"form-group\" ng-if=\"!vm.m.is_admin\"><div class=\"col-md-8 col-md-offset-2\"><label class=\"cb-label-wrapper\"><checkbox ng-model=\"vm.m.is_high_value\"></checkbox><strong>高值耗材</strong></label></div></div><div class=\"form-group\" ng-if=\"!vm.m.is_admin\"><div class=\"col-md-8 col-md-offset-2\"><label class=\"cb-label-wrapper\"><checkbox ng-model=\"vm.m.has_life\"></checkbox><strong>进行保质期管理</strong></label></div></div><div class=\"form-group\" ng-if=\"vm.m.has_life\"><label class=\"col-md-2 control-label\">保质期</label><div class=\"col-md-8\"><label class=\"btn btn-default\" ng-model=\"vm.m.lifeType\" uib-btn-radio=\"\'1\'\">年</label> <label class=\"btn btn-default\" ng-model=\"vm.m.lifeType\" uib-btn-radio=\"\'2\'\">月</label> <label class=\"btn btn-default\" ng-model=\"vm.m.lifeType\" uib-btn-radio=\"\'3\'\">日</label></div></div><div ng-if=\"vm.m.has_life\"><div class=\"form-group\" ng-if=\"vm.m.lifeType==\'1\'\"><label class=\"col-md-2 control-label\">保质期/年<span class=\"text-red\">&nbsp;*</span></label><div class=\"col-md-8\"><input type=\"text\" input-number=\"\" class=\"form-control\" name=\"year_shelf_life\" validator=\"required,minnum=1\" ng-model=\"vm.m.year_shelf_life\"></div></div><div class=\"form-group\" ng-if=\"vm.m.lifeType==\'2\'\"><label class=\"col-md-2 control-label\">保质期/月<span class=\"text-red\">&nbsp;*</span></label><div class=\"col-md-8\"><input type=\"text\" input-number=\"\" class=\"form-control\" name=\"month_shelf_life\" validator=\"required,minnum=1\" ng-model=\"vm.m.month_shelf_life\"></div></div><div class=\"form-group\" ng-if=\"vm.m.lifeType==\'3\'\"><label class=\"col-md-2 control-label\">保质期/日<span class=\"text-red\">&nbsp;*</span></label><div class=\"col-md-8\"><input type=\"text\" input-number=\"\" class=\"form-control\" name=\"shelf_life\" validator=\"required,minnum=1\" ng-model=\"vm.m.shelf_life\"></div></div><div class=\"form-group\"><label class=\"col-md-2 control-label\">到期提醒/天<span class=\"text-red\">&nbsp;*</span></label><div class=\"col-md-8\"><input type=\"text\" input-number=\"\" class=\"form-control\" name=\"remind_day\" validator=\"required\" ng-model=\"vm.m.remind_day\"></div></div></div><div class=\"form-group\"><label class=\"col-md-2 control-label\">到货周期/天<span class=\"text-red\">&nbsp;*</span></label><div class=\"col-md-8\"><input type=\"text\" input-number=\"\" class=\"form-control\" name=\"lead_time\" validator=\"required\" ng-model=\"vm.m.lead_time\"></div></div><div class=\"form-group\"><label class=\"col-md-2 control-label\">所属库房<span class=\"text-red\">&nbsp;*</span></label><div class=\"col-md-8\"><ui-select name=\"storeroom\" ng-model=\"vm.m.storeroom\" on-select=\"vm.roomSelectFn(vm.m)\"><ui-select-match placeholder=\"请选择库房...\">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat=\"room in vm.rooms | filter: $select.search\"><div ng-bind-html=\"room.name | highlight: $select.search\"></div></ui-select-choices></ui-select></div></div><div class=\"form-group\"><label class=\"col-md-2 control-label\">所属组别</label><div class=\"col-md-8\"><ui-select name=\"group\" ng-model=\"vm.m.group\"><ui-select-match placeholder=\"请选择组别...\">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat=\"group in vm.groups | filter: $select.search\"><div ng-bind-html=\"group.name | highlight: $select.search\"></div></ui-select-choices></ui-select></div></div><div class=\"form-group\"><label class=\"col-md-2 control-label\">管理类别</label><div class=\"col-md-8\"><ui-select name=\"manage_type\" ng-model=\"vm.m.manage_type\"><ui-select-match placeholder=\"请选择管理类别...\" allow-clear=\"true\">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat=\"t in vm.manageTypes | filter: $select.search\"><div ng-bind-html=\"t.name | highlight: $select.search\"></div></ui-select-choices></ui-select></div></div><div class=\"form-group\" ng-if=\"vm.names.length>0\"><div class=\"col-md-8 col-md-offset-2\">原关联资质 <span ng-repeat=\"name in vm.names\" class=\"text-danger\">{{name}} <span ng-show=\"!$last\">,</span></span> 已停用,请注意!</div></div><div class=\"form-group\"><label class=\"col-md-2 control-label\">关联资质<span class=\"text-red\" ng-if=\"!vm.m.is_admin\">&nbsp;*</span></label><div class=\"col-md-8\"><ui-select ng-model=\"vm.m.qualifications\" multiple=\"\" close-on-select=\"false\"><ui-select-match placeholder=\"选择资质...\"><span ng-bind=\"$item.name\" title=\"{{$item.name}}\"></span></ui-select-match><ui-select-choices repeat=\"qualification in vm.qualifications | filter: $select.search\"><span ng-bind-html=\"qualification.name | highlight: $select.search\" title=\"{{qualification.name}}\"></span></ui-select-choices></ui-select></div></div><div class=\"form-group\"><label class=\"col-md-2 control-label\">备注</label><div class=\"col-md-8\"><textarea class=\"form-control\" rows=\"5\" name=\"note\" ng-model=\"vm.m.note\" maxlength=\"200\"></textarea></div></div><div class=\"form-group\"><label class=\"col-md-2 control-label\"></label><div class=\"col-md-8\"><div><button class=\"btn btn-success\" ng-click=\"vm.addEditCategory(vm.m,0)\">添加</button> 有<span ng-class=\"{\'text-danger\':vm.m.categories.length==0}\" ng-bind-html=\"vm.m.categories.length\"></span>个耗材型号</div></div></div><div class=\"form-group\"><div class=\"col-md-8 col-md-offset-2\"><span class=\"text-info\"><i class=\"fa fa-exclamation-circle\"></i> 价格指耗材的科室使用单位价格</span></div></div><div class=\"form-group\"><div class=\"table-responsive col-md-8 col-md-offset-2\" style=\"overflow:visible;min-height: 200px\"><table class=\"table table-dropdown\"><thead><tr><th width=\"200\"><strong>规格型号</strong></th><th ng-if=\"!vm.m.is_admin\"><strong>阳光流水号</strong></th><th><strong>价格/元</strong></th><th width=\"100\"><strong>操作</strong></th></tr></thead><tbody><tr ng-show=\"vm.m.categories.length==0\"><td colspan=\"4\"><span class=\"list-group-item text-muted\" style=\"margin-top: 20px\">请添加耗材型号</span></td></tr><tr ng-repeat=\"category in vm.m.categories\"><td>{{category.spec}}</td><td ng-if=\"!vm.m.is_admin\">{{category.sunshine_num}}</td><td>{{category.purchase_price}}</td><td><a class=\"btn btn-default btn-xs\" ng-click=\"vm.addEditCategory(vm.m,$index+1)\"><i class=\"fa fa-pencil\"></i></a> <a class=\"btn btn-danger btn-xs\" ng-click=\"vm.delCategory(vm.m,$index,category)\"><i class=\"fa fa-trash\"></i></a></td></tr></tbody></table></div></div><div class=\"form-group\"><div class=\"col-md-offset-3 col-md-9\"><div class=\"pull-right\"><button class=\"btn btn-info\" ng-click=\"vm.ok(vm.m,Form,5)\" promise-btn=\"\" ng-if=\"vm.m.state==5||!vm.m.state\">保存草稿</button> <button class=\"btn btn-primary\" ng-click=\"vm.ok(vm.m,Form,1)\" promise-btn=\"\">发送申请</button> <button ui-sref=\"^.list\" class=\"btn btn-default\">取消</button></div></div></div></form></div></div>");
$templateCache.put("app/pages/csmbs/categories/variety/list/list.html","<script type=\"text/ng-template\" id=\"CsmbTypeDlg.html\"><div class=\"modal-header dialog-header-confirm\"> <button type=\"button\" class=\"close\" ng-click=\"vm.cancel()\">&times;</button> <h4 class=\"modal-title\"> <i class=\"fa fa-edit\">设置管理类别</i> </h4> </div> <div class=\"modal-body\"> <form name=\"Form\" class=\"form-horizontal\" scroll-form novalidate> <div class=\"form-group\"> <label class=\"col-md-4 control-label\">管理类别</label> <div class=\"col-md-6\"> <ui-select name=\"manage_type\" ng-model=\"vm.m.manage_type\"> <ui-select-match placeholder=\"请选择管理类别...\" allow-clear=\"true\">{{$select.selected.name}} </ui-select-match> <ui-select-choices repeat=\"type in vm.manageTypes | filter: $select.search\"> <div ng-bind-html=\"type.name | highlight: $select.search\"></div> </ui-select-choices> </ui-select> </div> </div> </form> </div> <div class=\"modal-footer\"> <button class=\"btn btn-primary\" ng-click=\"vm.ok(vm.m,Form)\" promise-btn>确认</button> <button class=\"btn btn-default\" ng-click=\"vm.cancel()\">取消</button> </div></script><script type=\"text/ng-template\" id=\"VarietyStopDlg.html\"><div class=\"modal-header dialog-header-confirm\"> <button type=\"button\" class=\"close\" ng-click=\"vm.cancel()\">&times;</button> <h4 class=\"modal-title\"> <i class=\"fa fa-edit\">申请停用品种</i> </h4> </div> <div class=\"modal-body\"> <form name=\"Form\" class=\"form-horizontal\" scroll-form novalidate> <div class=\"alert bg-danger\"> <strong>注意：停用品种将会同时停用品种下的所有耗材型号！</strong> </div> <div class=\"form-group\"> <label class=\"col-md-4 control-label\">停用原因</label> <div class=\"col-md-6\"> <textarea maxlength=\"255\" class=\"form-control\" rows=\"4\" name=\"note\" validator=\"required\" ng-model=\"vm.m.note\"></textarea> <div ng-if=\"Form.$submitted||Form.note.$touched\"> <span ng-show=\"Form.note.$error.required\" class=\"validation-invalid\">必填项!!</span> </div> </div> </div> </form> </div> <div class=\"modal-footer\"> <button class=\"btn btn-primary\" ng-click=\"vm.ok(vm.m,Form)\">确认</button> <button class=\"btn btn-default\" ng-click=\"vm.cancel()\">取消</button> </div></script><script type=\"text/ng-template\" id=\"ConsumableQualification.html\"><div class=\"modal-header dialog-header-confirm\"> <button type=\"button\" class=\"close\" ng-click=\"vm.cancel()\">&times;</button> <h4 class=\"modal-title\"> <i class=\"fa fa-files-o\">&nbsp;耗材资质列表</i> </h4> </div> <div class=\"modal-body\"> <div class=\"panel panel-default\"> <div class=\"panel-heading\"> <strong>耗材资质列表</strong> <div class=\"btn-group pull-right\" style=\"margin-top: -8px\"> <button ng-click=\"vm.tableReload()\" class=\"btn btn-default btn-circle\"> <i class=\"fa fa-refresh\"></i> </button> </div> </div> <div class=\"panel-body single-panel min-h418\" loading-container=\"vm.tableParams.settings().$loading\"> <table class=\"table table-hover table-row-clicked\" ng-table=\"vm.tableParams\" template-header=\"app/theme/components/table/header.html\"> <tr ng-repeat-start=\"row in $data track by row.id\" ng-click=\"row.showDetail=!row.showDetail\"> <td ng-click=\"$event.stopPropagation()\"> <button type=\"button\" class=\"btn btn-default btn-xs\" ng-click=\"row.showDetail=!row.showDetail\"> <i class=\"glyphicon glyphicon-chevron-down\" ng-hide=\"row.showDetail\"></i> <i class=\"glyphicon glyphicon-chevron-up\" ng-show=\"row.showDetail\"></i> </button> </td> <td ng-repeat=\"col in vm.cols\" ng-switch=\"col.field\" ng-show=\"col.show\" class=\"text-center\"> <div ng-switch-when=\"name\">{{row[col.field]}} <span ng-if=\"row.is_stop==\'1\'\" class=\"tag tag-danger\" title=\"停用\">停</span> <span ng-if=\"row.is_invalid==\'1\'\" class=\"tag tag-danger\" title=\"禁用\">禁用</span> </div> <div ng-switch-when=\"limit\"> {{row.start_time}}~{{row.end_time?row.end_time:\'永久\'}} </div> <div ng-switch-default>{{row[col.field].name}}</div> </td> </tr> <tr ng-repeat-end ng-if=\"row.showDetail\" class=\"bg-gray-light\"> <td colspan=\"6\"> <table class=\"table table-hover\"> <tbody> <tr> <td>提醒时间：{{row.remind_time?row.remind_time:\'暂无\'}}</td> </tr> <tr ng-if=\"row.attachments!=null&&row.attachments.length>0\" ng-repeat=\"attachment in row.attachments\"> <td colspan=\"2\"> <div class=\"att-item\"> <div class=\"att-ico\"> <i class=\"fa fa-{{attachment.ico}} fa-2x text-info\"></i> </div> <div class=\"att-name\"> <span ng-bind=\"attachment.name\"></span> <span class=\"text-muted\">({{attachment.size|bytes}})</span> <a ng-click=\"vm.download(attachment)\">下载</a>&nbsp; <span ng-show=\"attachment.downloading\" class=\"fa fa-circle-o-notch fa-spin text-muted\"></span> </div> </div> </td> </tr> <tr ng-if=\"row.note!=null\"> <td colspan=\"2\">备注：{{row.note}}</td> </tr> <tr ng-if=\"row.reason!=null\"> <td colspan=\"2\">停用原因：{{row.reason}}</td> </tr> </tbody> </table> </td> </tr> <tr ng-if=\"!vm.tableParams.settings().$loading&&($data==null||$data.length==0)\" class=\"table-no-data\"> <td colspan=\"99\" align=\"center\"><span>暂无数据</span> </td> </tr> </table> </div> </div> </div> <div class=\"modal-footer\"> <button class=\"btn btn-default\" ng-click=\"vm.cancel()\">返回</button> </div></script><script type=\"text/ng-template\" id=\"ConsumableCategoryDlg.html\"><div class=\"modal-header dialog-header-confirm\"> <button type=\"button\" class=\"close\" ng-click=\"vm.cancel()\">&times;</button> <h4 class=\"modal-title\"> <i class=\"fa fa-medkit\">&nbsp;耗材型号管理</i> </h4> </div> <div class=\"modal-body\"> <div class=\"panel panel-default\"> <div class=\"panel-heading\"> <strong>耗材型号列表</strong> <div class=\"btn-group pull-right\" style=\"margin-top: -8px\"> <button ng-click=\"vm.addEdit()\" ng-if=\"(vm.state==3||vm.state==4)&&!vm.is_stop\" class=\"btn btn-primary btn-circle\"> 添加 </button> <button ng-click=\"vm.tableReload()\" class=\"btn btn-default btn-circle\"> <i class=\"fa fa-refresh\"></i> </button> </div> </div> <div class=\"panel-body single-panel min-h418\" loading-container=\"vm.tableParams.settings().$loading\"> <table class=\"table table-hover table-row-clicked\" ng-table=\"vm.tableParams\" template-header=\"app/theme/components/table/header.html\"> <tr ng-repeat-start=\"row in $data track by row.id\" ng-click=\"row.showDetail=!row.showDetail\"> <td ng-click=\"$event.stopPropagation()\"> <button type=\"button\" class=\"btn btn-default btn-xs\" ng-click=\"row.showDetail=!row.showDetail\"> <i class=\"glyphicon glyphicon-chevron-down\" ng-hide=\"row.showDetail\"></i> <i class=\"glyphicon glyphicon-chevron-up\" ng-show=\"row.showDetail\"></i> </button> <button class=\"btn btn-primary btn-xs\" ng-if=\"row.state.id==5&&(vm.state==3||vm.state==4)\" uib-tooltip=\"修改\" ng-click=\"vm.addEdit(row)\"> <i class=\"fa fa-edit fa-fw\"></i></button> <button class=\"btn btn-warning btn-xs\" ng-if=\"row.state.id==2&&(vm.state==3||vm.state==4)\" uib-tooltip=\"重新申请\" ng-click=\"vm.addEdit(row)\"> <i class=\"fa fa-edit fa-fw\"></i></button> </td> <td ng-repeat=\"col in vm.cols\" ng-switch=\"col.field\"> <div ng-switch-when=\"spec\"> {{row[col.field]}} <span ng-if=\"row.is_stop==\'1\'\" class=\"tag tag-danger\">停</span> </div> <div ng-switch-when=\"storeroom\"> {{row.storeroom?row[col.field].name:\'暂无\'}} </div> <div ng-switch-when=\"state\"> {{row[col.field].name}} </div> <div ng-switch-default>{{row[col.field]}}</div> </td> </tr> <tr ng-repeat-end ng-if=\"row.showDetail\" class=\"bg-gray-light\"> <td colspan=\"9\"> <table class=\"table table-hover\"> <tbody> <tr ng-if=\"row.state.id==2\"> <td colspan=\"3\" align=\"left\">退回原因：<span class=\"text-red\" ng-bind=\"row.reason\"></span></td> </tr> <tr> <td rowspan=\"8\" width=\"256\"> <div style=\"position:relative\"> <div style=\"position:absolute;right:0;top:0;z-index:1001\"> <button class=\"btn btn-info btn-xs\" ng-if=\"(row.state.id==2||row.state.id==5)&&(vm.state==3||vm.state==4)\" ng-click=\"vm.addEditImg(row)\"> <i class=\"fa fa-plus fa-fw\"></i> </button> <button type=\"button\" class=\"btn btn-success btn-xs\" ng-if=\"row.images.length>0\" ng-click=\"vm.zoomIn(row)\"> <i class=\"fa fa-search-plus fa-fw\"></i> </button> <button class=\"btn btn-primary btn-xs\" ng-if=\"row.images.length>0&&(row.state.id==2||row.state.id==5)&&(vm.state==3||vm.state==4)\" ng-click=\"vm.addEditImg(row,true)\"> <i class=\"fa fa-pencil fa-fw\"></i> </button> <button type=\"button\" class=\"btn btn-danger btn-xs\" ng-if=\"row.images.length>0&&(row.state.id==2||row.state.id==5)&&(vm.state==3||vm.state==4)\" ng-click=\"vm.rmImg(row)\"> <i class=\"fa fa-times fa-fw\"></i> </button> </div> <div style=\"height:180px\"> <div uib-carousel interval=\"5000\" no-wrap=\"false\" active=\"row.active\"> <div uib-slide ng-repeat=\"image in row.images track by image.id\" index=\"$index\"> <img ng-src=\"{{image.path}}\" style=\"margin:auto;height:180px\"> </div> </div> </div> </div> </td> <td height=\"36\">生产商：{{row[\'producer\'].name}}</td> <td height=\"36\">经销商：{{row[\'dealer\'].name}}</td> </tr> <tr ng-if=\"row.s_dealer\"> <td height=\"36\">二级经销商：{{row.s_dealer.name}}</td> <td height=\"36\">二级经销商进价：{{row.sd_purchase_price!=null?(row.sd_purchase_price +\'元/\'+row.use_unit):\'暂无\'}} </td> </tr> <tr> <td height=\"36\">注册证号：{{row[\'r_num\']}}</td> <td height=\"36\"> 原产地：{{row.is_import==\'1\'?row.country.cn+\'lt;\'+row.country.en+\'&gt;\':(row.country.cn+(row.province?\'&lt;\'+row.province.name+\'&gt;\':\'\'))}} </td> </tr> <tr> <td height=\"36\">价格：{{row[\'purchase_price\']}}元/{{row[\'use_unit\']}} </td> <td height=\"36\">正常到货周期：{{row.lead_time?(row.lead_time+\'天\'):\'未设置\'}}</td> </tr> <tr ng-if=\"row.has_life==\'1\'\"> <td height=\"36\">保质期： {{row[\'year_shelf_life\']>0?row[\'year_shelf_life\']+\'年\':\'\'}} {{row[\'month_shelf_life\']>0?row[\'month_shelf_life\']+\'月\':\'\'}} {{row[\'shelf_life\']>0?row[\'shelf_life\']+\'天\':\'\'}} </td> <td height=\"36\">到期提醒：{{row[\'remind_day\']}}天</td> </tr> <tr> <td height=\"36\" colspan=\"2\"> 按 <span class=\"text-red\" ng-bind=\"row[\'storage_unit\']\"></span> 领用, <span ng-if=\"row[\'purchase_unit\']!=row[\'storage_unit\']\"> 每 <span class=\"text-red\" ng-bind=\"row[\'purchase_unit\']\"></span> <span class=\"text-red\" ng-bind=\"row[\'storage_num\']\"></span> <span class=\"text-red\" ng-bind=\"row[\'storage_unit\']\"></span> </span> <span ng-if=\"row[\'storage_unit\']!=row[\'use_unit\']\"> 每 <span class=\"text-red\" ng-bind=\"row[\'storage_unit\']\"></span> <span class=\"text-red\" ng-bind=\"row[\'use_num\']\"></span> <span class=\"text-red\" ng-bind=\"row[\'use_unit\']\"></span> </span> <span ng-switch=\"row.level\" class=\"text-info\"> <span ng-switch-when=\"1\">可直接领用</span> <span ng-switch-when=\"2\">需科主任审批</span> <span ng-switch-when=\"3\">需分管院领导审批</span> <span ng-switch-when=\"4\">需主管院领导审批</span> </span>. </td> </tr> <tr> <td colspan=\"2\">备注：<span ng-bind=\"row.note?row.note:\'暂无备注\'\"></span></td> </tr> </tbody> </table> </td> </tr> <tr ng-if=\"!vm.tableParams.settings().$loading&&($data==null||$data.length==0)\" class=\"table-no-data\"> <td colspan=\"99\" align=\"center\"><span>暂无数据</span> </td> </tr> </table> </div> </div> </div> <div class=\"modal-footer\"> <button class=\"btn btn-default\" ng-click=\"vm.cancel()\">返回</button> </div></script><script type=\"text/ng-template\" id=\"ConsumableDlg.html\"><div class=\"modal-header dialog-header-confirm\"> <button type=\"button\" class=\"close\" ng-click=\"vm.cancel()\">&times;</button> <h4 class=\"modal-title\"> <i class=\"fa fa-plus\" ng-hide=\"vm.m.id\">添加</i> <i class=\"fa fa-edit\" ng-show=\"vm.m.id\">编辑</i>耗材型号 </h4> </div> <div class=\"modal-body\"> <form name=\"Form\" class=\"form-horizontal\" scroll-form novalidate> <div class=\"form-group\"> <label class=\"col-md-4 control-label\">图片<span class=\"text-red\">&nbsp;*</span></label> <div class=\"col-md-6\"> <button type=\"button\" class=\"btn btn-info btn-raised\" ng-click=\"vm.setImg(vm.m)\"> <span ng-if=\"vm.m.images.length==0\" style=\"color: #fff\">添加</span> <span ng-if=\"vm.m.images.length>0\" style=\"color: #fff\">继续添加</span> </button> <div ng-repeat=\"image in vm.m.images\" style=\"margin-bottom: 5px\"> <img class=\"img-responsive poster\" ng-src=\"{{image.path}}\"><br> <button type=\"button\" class=\"btn btn-info btn-raised\" ng-click=\"vm.editImg(image)\">更改</button> <button type=\"button\" class=\"btn btn-danger btn-raised\" ng-click=\"vm.delImg(vm.m,$index)\">删除 </button> </div> </div> </div> <div class=\"form-group\" ng-if=\"!vm.is_admin\"> <label class=\"col-md-4 control-label\">阳光流水号</label> <div class=\"col-md-6\"> <input type=\"text\" class=\"form-control\" name=\"sunshine_num\" ng-model=\"vm.m.sunshine_num\"> </div> </div> <div class=\"form-group\" ng-if=\"vm.m.id\"> <label class=\"col-md-4 control-label\">规格型号<span class=\"text-red\">&nbsp;*</span></label> <div class=\"col-md-6\"> <input type=\"text\" class=\"form-control\" name=\"spec\" validator=\"required\" ng-model=\"vm.m.spec\"> </div> </div> <div class=\"form-group\" ng-if=\"!vm.m.id\"> <label class=\"col-md-4 control-label\">规格型号<span class=\"text-red\">&nbsp;*</span></label> <div class=\"col-md-6\"> <ui-select multiple tagging=\"vm.tagTransform\" ng-model=\"vm.m.specs\"> <ui-select-match><span ng-bind=\"$item.name\" title={{$item.name}}></span></ui-select-match> <ui-select-choices repeat=\"spec in vm.specs | filter: $select.search\"> <div ng-if=\"spec.isTag\" ng-bind-html=\"(spec.name | highlight: $select.search) +\' (新建)\'\"></div> <div ng-if=\"!spec.isTag\" ng-bind-html=\"spec.name | highlight: $select.search\"></div> </ui-select-choices> </ui-select> </div> </div> <div class=\"form-group\"> <label class=\"col-md-4 control-label\">价格/元<span class=\"text-red\">&nbsp;*</span> <i uib-tooltip=\"使用单位价格\" tooltip-append-to-body=\"true\" tooltip-class=\"tooltipInfo\" style=\"display: inline\" class=\"fa fa-info-circle text-info\"></i></label> <div class=\"col-md-6\"> <input type=\"text\" input-float=\"2\" class=\"form-control\" name=\"purchase_price\" validator=\"required\" ng-model=\"vm.m.purchase_price\"> </div> </div> <div class=\"form-group\"> <label class=\"col-md-4 control-label\">二级经销商价格/元 <i uib-tooltip=\"使用单位价格\" tooltip-append-to-body=\"true\" tooltip-class=\"tooltipInfo\" style=\"display: inline\" class=\"fa fa-info-circle text-info\"></i></label> <div class=\"col-md-6\"> <input type=\"text\" input-float=\"2\" class=\"form-control\" name=\"sd_purchase_price\" ng-model=\"vm.m.sd_purchase_price\"> </div> </div> <div class=\"form-group\"> <label class=\"col-md-2 control-label\">国家医保材料代码<span class=\"text-red\">&nbsp;*</span></label> <div class=\"col-md-6\"> <input type=\"text\" class=\"form-control\" name=\"m_code\" ng-model=\"vm.m.m_code\" validator=\"required\"> </div> </div> <div class=\"form-group\"> <label class=\"col-md-4 control-label\">成都市编码<span class=\"text-red\">&nbsp;*</span></label> <div class=\"col-md-6\"> <input type=\"text\" class=\"form-control\" name=\"c_code\" ng-model=\"vm.m.c_code\" validator=\"required\"> </div> </div> <div class=\"form-group\"> <label class=\"col-md-4 control-label\">his计费类型<span class=\"text-red\">&nbsp;*</span></label> <div class=\"col-md-6\"> <ui-select name=\"his_fee_type\" ng-model=\"vm.m.his_fee_type\"> <ui-select-match placeholder=\"请选择计费类型...\">{{$select.selected.name}} </ui-select-match> <ui-select-choices repeat=\"type in vm.hisFeeTypes | filter: $select.search\"> <div ng-bind-html=\"type.name | highlight: $select.search\"></div> </ui-select-choices> </ui-select> </div> </div> <div class=\"form-group\"> <label class=\"col-md-4 control-label\">备注</label> <div class=\"col-md-6\"> <textarea class=\"form-control\" rows=\"5\" name=\"note\" ng-model=\"vm.m.note\" maxlength=\"200\"></textarea> </div> </div> </form> </div> <div class=\"modal-footer\"> <button class=\"btn btn-info\" ng-click=\"vm.ok(vm.m,Form,5)\" promise-btn>保存草稿</button> <button class=\"btn btn-primary\" ng-click=\"vm.ok(vm.m,Form,1)\" promise-btn>发送申请</button> <button class=\"btn btn-default\" ng-click=\"vm.cancel()\">取消</button> </div></script><script type=\"text/ng-template\" id=\"ConsumableImgDlg.html\"><div class=\"modal-header dialog-header-confirm\"> <button type=\"button\" class=\"close\" ng-click=\"vm.cancel()\">&times;</button> <h4 class=\"modal-title\"> <i class=\"fa fa-plus\" ng-hide=\"vm.m.id\">添加</i> <i class=\"fa fa-edit\" ng-show=\"vm.m.id\">编辑</i>耗材图片 </h4> </div> <div class=\"modal-body\"> <form name=\"Form\" class=\"form-horizontal\" scroll-form novalidate> <div class=\"form-group\"> <label class=\"col-md-4 control-label\">图片</label> <div class=\"col-md-6\"> <button type=\"button\" class=\"btn btn-info btn-raised\" ng-click=\"vm.setImg(vm.m)\"> <span ng-if=\"!vm.m.path\">添加</span> <span ng-if=\"vm.m.path\">更改</span> </button> <img class=\"img-responsive poster\" ng-src=\"{{vm.m.path}}\"><br> </div> </div> </form> </div> <div class=\"modal-footer\"> <button class=\"btn btn-primary\" ng-click=\"vm.ok(vm.m,Form)\" promise-btn>确认</button> <button class=\"btn btn-default\" ng-click=\"vm.cancel()\">取消</button> </div></script><script type=\"text/ng-template\" id=\"CsmbLargeImgDlg.html\"><div fullscreen=\"isFullscreen\"> <div class=\"modal-header dialog-header-confirm\"> <button type=\"button\" class=\"close\" ng-click=\"vm.cancel()\">&times;</button> <button type=\"button\" class=\"close\" ng-click=\"isFullscreen=!isFullscreen\" style=\"padding-right:6px\"> <i class=\"fa fa-square-o\"></i></button> <h4 class=\"modal-title\"> <i class=\"fa fa-photo\"></i>&nbsp;耗材图片 </h4> </div> <div class=\"modal-body\"> <img class=\"img-responsive poster\" ng-src=\"{{vm.m.path}}\"><br> </div> <div class=\"modal-footer\"> <button class=\"btn btn-default\" ng-click=\"vm.cancel()\">返回</button> </div> </div></script><div ba-panel=\"\" ba-panel-class=\"light-text tab-content-panel\" ba-panel-header=\"\" ba-panel-title=\"<span ncy-breadcrumb-last></span>\"><div class=\"table-responsive\" loading-container=\"vm.tableParams.settings().$loading\"><table class=\"table table-hover table-row-clicked\" ng-table=\"vm.tableParams\" template-header=\"app/theme/components/table/header.html\"><tr ng-repeat-start=\"row in $data track by row.id\" ng-click=\"row.showDetail=!row.showDetail\"><td ng-click=\"$event.stopPropagation()\"><button type=\"button\" class=\"btn btn-default btn-xs\" ng-click=\"row.showDetail=!row.showDetail\"><i class=\"glyphicon glyphicon-chevron-down\" ng-hide=\"row.showDetail\"></i> <i class=\"glyphicon glyphicon-chevron-up\" ng-show=\"row.showDetail\"></i></button> <button class=\"btn btn-info btn-xs\" ng-click=\"vm.showQualification(row)\" uib-tooltip=\"耗材资质\" tooltip-class=\"tooltipInfo\"><span class=\"fa fa-files-o fa-fw\"></span></button> <button class=\"btn btn-success btn-xs\" ng-click=\"vm.showCategory(row)\" uib-tooltip=\"耗材型号\" tooltip-class=\"tooltipInfo\"><span class=\"fa fa-medkit fa-fw\"></span></button> <button class=\"btn btn-primary btn-xs\" ng-if=\"row.state.id==5||row.state.id==1\" uib-tooltip=\"修改\" ui-sref=\"^.edit({id:row.id})\"><span class=\"fa fa-edit fa-fw\"></span></button> <button class=\"btn btn-warning btn-xs\" ng-if=\"row.state.id==2\" uib-tooltip=\"重新修改\" ui-sref=\"^.edit({id:row.id})\"><span class=\"fa fa-edit fa-fw\"></span></button> <button class=\"btn btn-warning btn-xs\" ng-if=\"row.state.id!=1&&row.state.id!=2&&row.state.id!=5\" uib-tooltip=\"重新申请\" ui-sref=\"^.edit({id:row.id})\"><span class=\"fa fa-copy fa-fw\"></span></button> <button class=\"btn btn-danger btn-xs\" ng-if=\"row.state.id==1||row.state.id==2||row.state.id==5\" uib-tooltip=\"删除\" ng-click=\"vm.remove(row)\"><span class=\"fa fa-trash fa-fw\"></span></button> <button class=\"btn btn-danger btn-xs\" ng-if=\"(row.state.id==3||row.state.id==4)&&row.is_stop==0\" uib-tooltip=\"申请停用\" ng-click=\"vm.stop(row)\"><span class=\"fa fa-ban fa-fw\"></span></button> <button class=\"btn btn-info btn-xs\" uib-tooltip=\"设置管理类别\" ng-click=\"vm.setType(row)\"><span class=\"fa fa-tag fa-fw\"></span></button></td><td ng-repeat=\"col in vm.cols\" ng-switch=\"col.field\" ng-if=\"col.show\"><div ng-switch-when=\"name\">{{row[col.field]}} <span ng-if=\"row.is_stop==\'1\'\" class=\"tag tag-danger\">停</span> <span ng-if=\"row.expired\" class=\"tag tag-danger\">资质过期，请解绑或更新</span></div><div ng-switch-when=\"state\">{{row[col.field].name}}</div><div ng-switch-when=\"storeroom\">{{row.storeroom?row[col.field].name:\'暂无\'}}</div><div ng-switch-when=\"s_dealer\">{{row.s_dealer?row[col.field].name:\'暂无\'}}</div><div ng-switch-when=\"group\">{{row.group?row.group.name:\'\'}}</div><div ng-switch-when=\"manage_type\">{{row.manage_type?row.manage_type.name:\'\'}}</div><div ng-switch-default=\"\">{{row[col.field]}}</div></td></tr><tr ng-repeat-end=\"\" ng-if=\"row.showDetail\" class=\"bg-gray-light\"><td colspan=\"9\"><table class=\"table table-hover\"><tbody><tr ng-if=\"row.state.id==2\"><td colspan=\"2\">退回原因：<span class=\"text-danger\" ng-bind=\"row.reason\"></span></td></tr><tr><td height=\"36\">生产商：{{row[\'producer\'].name}}</td><td height=\"36\">经销商：{{row[\'dealer\'].name}}</td></tr><tr ng-if=\"row.s_dealer\"><td height=\"36\" colspan=\"2\">二级经销商：{{row.s_dealer.name}}</td></tr><tr><td height=\"36\">注册证号：{{row[\'r_num\']}}</td><td height=\"36\">原产地：{{row.is_import==\'1\'?row.country.cn+\'lt;\'+row.country.en+\'&gt;\':(row.country.cn+(row.province?\'&lt;\'+row.province.name+\'&gt;\':\'\'))}}</td></tr><tr ng-if=\"row.has_life==\'1\'\"><td height=\"36\">保质期： {{row[\'year_shelf_life\']>0?row[\'year_shelf_life\']+\'年\':\'\'}} {{row[\'month_shelf_life\']>0?row[\'month_shelf_life\']+\'月\':\'\'}} {{row[\'shelf_life\']>0?row[\'shelf_life\']+\'天\':\'\'}}</td><td height=\"36\">到期提醒：{{row[\'remind_day\']}}天</td></tr><tr><td height=\"36\">高值耗材： <span ng-class=\"{true:\'text-red\',false:\'text-default\'}[row.is_high_value==\'1\']\" ng-bind=\"row.is_high_value==\'1\'?\'是\':\'否\'\"></span></td><td height=\"36\">正常到货周期：{{row.lead_time?(row.lead_time+\'天\'):\'未设置\'}}</td></tr><tr><td height=\"36\" colspan=\"2\">按 <span class=\"text-red\" ng-bind=\"row[\'storage_unit\']\"></span> 领用 <span ng-if=\"row[\'purchase_unit\']!=row[\'storage_unit\']\">, 每 <span class=\"text-red\" ng-bind=\"row[\'purchase_unit\']\"></span> <span class=\"text-red\" ng-bind=\"row[\'storage_num\']\"></span> <span class=\"text-red\" ng-bind=\"row[\'storage_unit\']\"></span></span> <span ng-if=\"row[\'storage_unit\']!=row[\'use_unit\']\">每 <span class=\"text-red\" ng-bind=\"row[\'storage_unit\']\"></span> <span class=\"text-red\" ng-bind=\"row[\'use_num\']\"></span> <span class=\"text-red\" ng-bind=\"row[\'use_unit\']\"></span></span><div ng-if=\"row.level>0\" style=\"display: inline\"><span ng-switch=\"row.level\" class=\"text-info\"><span ng-switch-when=\"1\">可直接领用</span> <span ng-switch-when=\"2\">需科主任审批</span> <span ng-switch-when=\"3\">需分管院领导审批</span> <span ng-switch-when=\"4\">需主管院领导审批</span></span></div>.</td></tr><tr><td colspan=\"2\">备注：<span ng-bind=\"row.note?row.note:\'暂无备注\'\"></span></td></tr></tbody></table></td></tr><tr ng-if=\"!vm.tableParams.settings().$loading&&($data==null||$data.length==0)\" class=\"table-no-data\"><td colspan=\"99\" align=\"center\"><span>暂无数据</span></td></tr></table></div></div>");
$templateCache.put("app/pages/csmbs/purchase/dialogs/appMsn/msn.html","<div class=\"modal-header dialog-header-confirm\"><button type=\"button\" class=\"close\" ng-click=\"vm.cancel()\">&times;</button> <span><i class=\"fa fa-commenting modal-icon\"></i>库房申请经销商补充信息</span></div><div class=\"modal-body\"><form name=\"Form\" class=\"form-horizontal\" novalidate=\"\"><div class=\"table-responsive\" style=\"min-height: 100px\"><table class=\"table table-bordered table-condensed\" style=\"margin-bottom:20px\"><thead><tr><th>经销商</th><th>耗材</th><th>规格型号</th><th>数量</th></tr></thead><tbody><tr ng-repeat=\"item in vm.m.application_items track by item.id\"><td>{{item.consumable.producer?item.consumable.producer.name:\'暂无生产商\'}}</td><td>{{item.consumable.name!=\'\'?item.consumable.name:item.consumable.c_name}}</td><td>{{item.consumable.spec}}</td><td>{{item.num+(vm.m.for_purchase==\'1\'?item.consumable.purchase_unit:item.consumable.storage_unit)}}</td></tr></tbody></table></div><div class=\"form-group\"><label class=\"col-md-2 control-label\">内容</label><div class=\"col-md-8\"><textarea class=\"form-control\" rows=\"5\" name=\"msn\" ng-model=\"vm.m.msn\" maxlength=\"200\"></textarea></div></div></form></div><div class=\"modal-footer\"><button class=\"btn btn-primary\" ng-click=\"vm.submit(Form,vm.m)\" promise-btn=\"\">确认</button> <button class=\"btn btn-default\" ng-click=\"vm.cancel()\">取消</button></div>");
$templateCache.put("app/pages/csmbs/purchase/dialogs/csmbOut/batch.html","<script type=\"text/ng-template\" id=\"CsmbLargeImgDlg.html\"><div fullscreen=\"isFullscreen\"> <div class=\"modal-header dialog-header-confirm\"> <button type=\"button\" class=\"close\" ng-click=\"vm.cancel()\">&times;</button> <button type=\"button\" class=\"close\" ng-click=\"isFullscreen=!isFullscreen\" style=\"padding-right:6px\"> <i class=\"fa fa-square-o\"></i></button> <h4 class=\"modal-title\"> <i class=\"fa fa-photo\"></i>&nbsp;耗材图片 </h4> </div> <div class=\"modal-body\"> <img class=\"img-responsive poster\" ng-src=\"{{vm.m.path}}\"><br> </div> <div class=\"modal-footer\"> <button class=\"btn btn-default\" ng-click=\"vm.cancel()\">返回</button> </div> </div></script><div class=\"modal-header dialog-header-confirm\"><button type=\"button\" class=\"close\" ng-click=\"vm.cancel()\">&times;</button> <span><i class=\"fa fa-stack-overflow modal-icon\"></i>发货批次</span></div><div class=\"modal-body\"><div class=\"panel panel-default\"><div class=\"panel-heading\"><strong>发货耗材列表</strong> <small class=\"text-red\">实际金额总计：{{vm.totalPrice|currency:\'￥\'}}</small><div class=\"btn-group pull-right\" style=\"margin-top: -8px\"><button ng-click=\"vm.tableReload()\" class=\"btn btn-default btn-circle\"><i class=\"fa fa-refresh\"></i></button></div></div><div class=\"panel-body single-panel min-h418\" loading-container=\"vm.tableParams.settings().$loading\"><div class=\"table-responsive\"><table class=\"table table-hover table-row-clicked\" ng-table=\"vm.tableParams\" template-header=\"app/theme/components/table/header.html\"><tr ng-repeat-start=\"row in $data track by row.id\" ng-click=\"row.showDetail=!row.showDetail\"><td ng-click=\"$event.stopPropagation()\"><button type=\"button\" class=\"btn btn-default btn-xs\" ng-click=\"row.showDetail=!row.showDetail\"><i class=\"glyphicon glyphicon-chevron-down\" ng-hide=\"row.showDetail\"></i> <i class=\"glyphicon glyphicon-chevron-up\" ng-show=\"row.showDetail\"></i></button> <button class=\"btn btn-info btn-xs\" ng-if=\"row.store_items.length>0\" ng-click=\"vm.show(row)\"><span class=\"fa fa-search\"></span></button> <button class=\"btn btn-default btn-xs\" uib-tooltip=\"二维码\" tooltip-class=\"tooltipInfo\" ng-click=\"vm.qrcode(row)\"><span class=\"fa fa-qrcode\"></span></button><qrcode id=\"QrCode{{row.id}}\" version=\"5\" error-correction-level=\"M\" size=\"128\" hidden=\"\" data=\"{{row.qrUrl}}\"></qrcode></td><td ng-repeat=\"col in vm.cols\" ng-switch=\"col.field\" ng-if=\"col.show\"><div ng-switch-when=\"consumable\">{{row[col.field].name}}</div><div ng-switch-when=\"c_name\">{{row.consumable.c_name}}</div><div ng-switch-when=\"spec\">{{row.consumable.spec}}</div><div ng-switch-when=\"state\">{{row[col.field].name}}</div><div ng-switch-when=\"type\">{{row.consumable.type}}</div><div ng-switch-when=\"code\">{{row.consumable.code}}</div><div ng-switch-when=\"c_r_num\"><span ng-bind=\"row.r_num?row.c_r_num:\'暂未确认\'\"></span></div><div ng-switch-default=\"\">{{row[col.field]}}</div></td></tr><tr ng-repeat-end=\"\" ng-if=\"row.showDetail\" class=\"bg-gray-light\"><td colspan=\"99\"><table class=\"table table-hover\"><tbody><tr><td rowspan=\"8\" width=\"256\"><div style=\"position:relative\"><div style=\"position:absolute;right:0;top:0;z-index:1001\"><button type=\"button\" class=\"btn btn-success btn-xs\" ng-if=\"row.consumable.images.length>0\" ng-click=\"vm.zoomIn(row)\"><i class=\"fa fa-search-plus fa-fw\"></i></button></div><div style=\"height:180px\"><div uib-carousel=\"\" interval=\"5000\" no-wrap=\"false\" active=\"row.active\"><div uib-slide=\"\" ng-repeat=\"image in row.consumable.images track by image.id\" index=\"$index\"><img ng-src=\"{{image.path}}\" style=\"margin:auto;height:180px\"></div></div></div></div></td><td height=\"36\">生产商：{{row.consumable.producer.name}}</td><td height=\"36\">经销商：{{row.consumable.dealer.name}} <small ng-if=\"row.consumable.s_dealer\"><{{row.consumable.s_dealer.name}}></{{row.consumable.s_dealer.name}}></small></td></tr><tr ng-if=\"row.consumable.s_dealer\"><td height=\"36\">二级经销商：{{row.consumable.s_dealer.name}}</td><td height=\"36\">二级经销商进价：{{row.sd_purchase_price!=null?(row.sd_purchase_price +\'元/\'+row.consumable.use_unit):\'暂无\'}}</td></tr><tr><td height=\"36\">注册证号：{{row.consumable.r_num}}</td><td height=\"36\">原产地：{{row.consumable.is_import==\'1\'?row.consumable.country.cn+ \'&lt;\'+row.consumable.country.en+\'&gt;\':(row.consumable.country.cn+(row.consumable.province?\'&lt;\'+row.consumable.province.name+\'&gt;\':\'\'))}}</td></tr><tr><td height=\"36\">创建人：{{row.creator.name}}</td><td height=\"36\">确认人：<span ng-bind=\"row.handler_id?row.handler.name:\'暂未确认\'\"></span></td></tr><tr><td height=\"36\">出厂价格：{{row[\'purchase_price\']}}元/{{row.consumable.use_unit}}</td><td height=\"36\">出厂批次：<span ng-bind=\"row.no?row.no:\'暂无\'\"></span></td></tr><tr><td height=\"36\">生产日期：{{row[\'production_date\']}}</td><td height=\"36\">失效日期：{{row[\'deadline\']?row[\'deadline\']:\'长期有效\'}}</td></tr><tr><td height=\"36\">高值耗材： <span ng-class=\"{true:\'text-red\',false:\'text-default\'}[row.consumable.is_high_value==\'1\']\" ng-bind=\"row.consumable.is_high_value==\'1\'?\'是\':\'否\'\"></span></td><td height=\"36\">正常到货周期：{{row.consumable.lead_time?(row.consumable.lead_time+\'天\'):\'未设置\'}}</td></tr><tr><td height=\"36\" colspan=\"2\">按 <span class=\"text-red\" ng-bind=\"row.consumable[\'storage_unit\']\"></span> 领用, <span ng-if=\"row.consumable[\'purchase_unit\']!=row.consumable[\'storage_unit\']\">每 <span class=\"text-red\" ng-bind=\"row.consumable[\'purchase_unit\']\"></span> <span class=\"text-red\" ng-bind=\"row.consumable[\'storage_num\']\"></span> <span class=\"text-red\" ng-bind=\"row.consumable[\'storage_unit\']\"></span></span> <span ng-if=\"row.consumable[\'storage_unit\']!=row.consumable[\'use_unit\']\">每 <span class=\"text-red\" ng-bind=\"row.consumable[\'storage_unit\']\"></span> <span class=\"text-red\" ng-bind=\"row.consumable[\'use_num\']\"></span> <span class=\"text-red\" ng-bind=\"row.consumable[\'use_unit\']\"></span> ,</span> <span ng-switch=\"row.consumable.level\" class=\"text-info\"><span ng-switch-when=\"1\">可直接领用</span> <span ng-switch-when=\"2\">需科主任审批</span> <span ng-switch-when=\"3\">需分管院领导审批</span> <span ng-switch-when=\"4\">需主管院领导审批</span></span>.</td></tr><tr><td colspan=\"2\">备注：<span ng-bind=\"row.note?row.note:\'暂无\'\"></span></td></tr></tbody></table></td></tr><tr ng-if=\"!vm.tableParams.settings().$loading&&($data==null||$data.length==0)\" class=\"table-no-data\"><td colspan=\"99\" align=\"center\"><span>暂无数据</span></td></tr></table></div></div></div></div><div class=\"modal-footer\"><button class=\"btn btn-primary\" ng-click=\"vm.invoice()\">发货单</button> <button class=\"btn btn-default\" ng-click=\"vm.cancel()\">取消</button></div>");
$templateCache.put("app/pages/csmbs/purchase/dialogs/csmbOut/out.html","<div class=\"modal-header dialog-header-confirm\"><button type=\"button\" class=\"close\" ng-click=\"vm.cancel()\">&times;</button> <span><i class=\"fa fa-ambulance modal-icon\"></i>库房申请耗材发货</span></div><div class=\"modal-body\"><form name=\"Form\" class=\"form-horizontal\" novalidate=\"\"><div class=\"text-red\" style=\"margin-top:-18px\"><label class=\"cb-label-wrapper\"><span class=\"text-default\">需要消毒处理</span> <input type=\"checkbox\" ng-model=\"vm.disinfect\" class=\"title-cb\"></label></div><div class=\"text-center\"><h3>申请耗材列表</h3></div><div class=\"text-center\"><label class=\"text-info\">发货金额总计：{{vm.csmbs.totalAll| currency:\'￥\'}}</label></div><table class=\"table\"><tr><th>名称</th><th>型号</th><th>注册证号</th><th>编号</th><th>差额数量</th><th>发货详情</th></tr><tr class=\"form-table-input-text\" ng-repeat-start=\"m in vm.csmbs\"><td>{{m.name!=\'\'?m.name:m.c_name}}</td><td>{{m.spec}}</td><td>{{m.reNum}}</td><td>{{m.code}}</td><td>{{m.l_num>0?(m.l_num+m.purchase_unit):\'\'}}{{m.s_num>0?(m.s_num+m.storage_unit):\'\'}}</td><td><button type=\"button\" class=\"btn btn-default btn-xs\" ng-click=\"row.showDetail=!row.showDetail\"><i class=\"glyphicon glyphicon-chevron-down\" ng-hide=\"row.showDetail\"></i> <i class=\"glyphicon glyphicon-chevron-up\" ng-show=\"row.showDetail\"></i></button></td></tr><tr ng-repeat-end=\"\" ng-if=\"!row.showDetail\" class=\"bg-gray-light\"><td colspan=\"6\"><table class=\"table\"><tr ng-if=\"m.purchase_unit!=m.storage_unit\"><td style=\"text-align: left\">备注: <span>每 <span class=\"text-red\" ng-bind=\"m.purchase_unit\"></span> <span class=\"text-red\" ng-bind=\"m.storage_num\"></span> <span class=\"text-red\" ng-bind=\"m.storage_unit\"></span></span> <span ng-if=\"m.use_unit!=m.storage_unit\">每 <span class=\"text-red\" ng-bind=\"m.storage_unit\"></span> <span class=\"text-red\" ng-bind=\"m.use_num\"></span> <span class=\"text-red\" ng-bind=\"m.use_unit\"></span></span></td></tr><tr ng-if=\"m.s_dealer\"><td>二级经销商:{{m.s_dealer.name}}</td><td>价格:{{m.sd_purchase_price!=null?(m.sd_purchase_price+\'/\'+m.use_unit):\'暂无\'}}</td></tr><tr><td style=\"text-align: left\">出厂价格: <input type=\"text\" class=\"form-control input-xs\" input-float=\"2\" style=\"display:inline-block;width: 88px\" ng-model=\"m.purchase_price\" ng-change=\"vm.priceChange(m)\" ng-disabled=\"!m.canEditPrice&&!m.canIncreasePrice\" validator=\"maxnum={{m.canIncreasePrice?\'9999999\':m.price}},required\">/{{m.use_unit}}</td><td>发货总数量： {{m.n_l_num>0?(m.n_l_num+m.purchase_unit):\'\'}}{{m.n_s_num>0?(m.n_s_num+m.storage_unit):\'\'}} {{(m.n_l_num==0&&m.n_s_num==0)?0:\'\'}}</td><td ng-if=\"m.has_life==\'1\'\">保质期： {{m[\'year_shelf_life\']>0?m[\'year_shelf_life\']+\'年\':\'\'}} {{m[\'month_shelf_life\']>0?m[\'month_shelf_life\']+\'月\':\'\'}} {{m[\'shelf_life\']>0?m[\'shelf_life\']+\'天\':\'\'}}</td></tr><tr><td colspan=\"4\"><table class=\"table table-hover table-bordered table-condensed\" style=\"margin-bottom:0\"><thead style=\"background:azure\"><tr><th colspan=\"6\">发货详情</th></tr></thead><tbody><tr><td>批次</td><td>生产日期</td><td>失效日期</td><td width=\"180\">发货量</td><td>操作</td></tr><tr ng-repeat=\"batch in m.batches\"><td><input class=\"form-control input-sm\" type=\"text\" name=\"no{{batch.index}}\" style=\"margin-top: 3px\" ng-change=\"vm.noSelected(m,batch)\" ng-model=\"batch.no\" validator=\"required\"></td><td><input type=\"text\" class=\"form-control\" uib-datepicker-popup=\"yyyy-MM-dd\" datepicker-options=\"vm.dateOptions\" ng-change=\"vm.dateSelected(m,batch,1)\" name=\"production_date{{batch.index}}\" ng-model=\"batch.production_date\" datepicker-mode=\"\'day\'\" is-open=\"opened1\" ng-required=\"true\" ng-click=\"opened1=true\"><div ng-show=\"Form.$submitted||Form[\'production_date\'+batch.index].$touched\"><span ng-show=\"Form[\'production_date\'+batch.index].$error.required\" class=\"validation-invalid\">必填项!!</span></div><div ng-if=\"batch.production_date2\">{{batch.production_date2}}<a class=\"btn btn-xs\" ng-click=\"vm.dateInput(batch)\">填充生产日期</a></div></td><td ng-if=\"m.has_life == \'1\'\"><input type=\"text\" class=\"form-control\" uib-datepicker-popup=\"yyyy-MM-dd\" name=\"deadline{{batch.index}}\" ng-model=\"batch.deadline\" ng-change=\"vm.dateSelected(m,batch,2)\" datepicker-mode=\"\'day\'\" is-open=\"opened2\" ng-required=\"true\" ng-click=\"opened2=true\"><div ng-show=\"Form.$submitted||Form[\'deadline\'+batch.index].$touched\"><span ng-show=\"Form[\'deadline\'+batch.index].$error.required\" class=\"validation-invalid\">必填项!!</span></div></td><td ng-if=\"m.has_life == \'0\'\">长期有效</td><td><span ng-if=\"m.l_num>0\"><input class=\"form-control form-control-36 input-sm\" type=\"text\" name=\"l_num{{batch.index}}\" ng-change=\"vm.numChange(m)\" ng-model=\"batch.n_l_num\" input-number=\"\" validator=\"required\"> {{m.purchase_unit}}</span> <span ng-if=\"m.s_num>0\"><input class=\"form-control form-control-36 input-sm\" type=\"text\" name=\"s_num{{batch.index}}\" ng-change=\"vm.numChange(m)\" ng-model=\"batch.n_s_num\" input-number=\"\" validator=\"required\"> {{m.storage_unit}}</span></td><td><button type=\"button\" class=\"btn btn-danger btn-xs\" ng-click=\"vm.remove(m,$index)\">删除</button></td></tr></tbody><tfoot><tr><td colspan=\"4\" class=\"text-info text-right\">批次无货时直接删除,同一经销商批次建议不要分开录入，否则系统会产生多个批次</td><td><button type=\"button\" class=\"btn btn-success btn-xs\" ng-click=\"vm.add(m)\">添加批次</button></td></tr></tfoot></table></td></tr><tr><td style=\"text-align: left\" colspan=\"4\"><span class=\"text-info\">金额合计:{{m.total| currency:\'￥\'}}</span></td></tr><tr><td style=\"text-align: left\" colspan=\"4\">备注:<textarea class=\"form-control\" rows=\"1\" msd-elastic=\"\" name=\"note\" ng-model=\"m.note\" style=\"height: 48px;margin-bottom: 10px\" placeholder=\"200字内...\" maxlength=\"200\"></textarea></td></tr></table></td></tr></table></form></div><div class=\"modal-footer\"><button class=\"btn btn-primary\" ng-click=\"vm.submit(Form,vm.csmbs)\" promise-btn=\"\">确认</button> <button class=\"btn btn-default\" ng-click=\"vm.cancel()\">取消</button></div>");
$templateCache.put("app/pages/csmbs/prices/query/list/list.html","<div ba-panel=\"\" ba-panel-class=\"light-text tab-content-panel\" ba-panel-header=\"\" hide-add-btn=\"true\" ba-panel-title=\"<span ncy-breadcrumb-last></span>列表\"><label class=\"cb-label-wrapper\" ng-if=\"vm.tableParams.filter()[\'item\']\"><checkbox ng-model=\"vm.hideSub\" ng-change=\"vm.changeHide(vm.items,vm.tableParams.filter()[\'item\'])\"></checkbox><strong>隐藏其余筛选子项</strong></label><div class=\"table-responsive\" loading-container=\"vm.tableParams.settings().$loading\"><table class=\"table table-hover table-row-clicked\" ng-table=\"vm.tableParams\" template-header=\"app/theme/components/table/header.html\"><tr ng-repeat-start=\"row in $data track by row.id\" ng-click=\"row.showDetail=!row.showDetail\"><td ng-click=\"$event.stopPropagation()\"><button type=\"button\" class=\"btn btn-default btn-xs\" ng-click=\"row.showDetail=!row.showDetail\"><i class=\"glyphicon glyphicon-chevron-down\" ng-hide=\"row.showDetail\"></i> <i class=\"glyphicon glyphicon-chevron-up\" ng-show=\"row.showDetail\"></i></button> <button class=\"btn btn-xs btn-info\" ui-sref=\"^.edit({id:row.id})\" ng-if=\"row.state.id==5\" uib-tooltip=\"重新申请\" tooltip-class=\"tooltipInfo\" tooltip-append-to-body=\"true\"><i class=\"fa fa-pencil-square-o\"></i></button> <button class=\"btn btn-info btn-xs\" ui-sref=\"^.edit({id:row.id})\" ng-if=\"row.state.id==1\" uib-tooltip=\"修改\" tooltip-class=\"tooltipInfo\"><span class=\"glyphicon glyphicon-pencil\"></span></button> <button class=\"btn btn-danger btn-xs\" ng-if=\"row.state.id==5\" ng-click=\"vm.remove(row)\"><span class=\"glyphicon glyphicon-trash\"></span></button></td><td ng-repeat=\"col in vm.cols\" ng-switch=\"col.field\" ng-if=\"col.show\"><div ng-switch-when=\"items\"><table class=\"table table-bordered table-condensed\"><tbody><tr ng-repeat=\"i in row[col.field]\" ng-hide=\"i.hide\" ng-if=\"row.expand||$index<4\"><td>{{i.consumable.name!=\'\'?i.consumable.name:i.consumable.c_name}} <span class=\"badge bulletin-subject-col\">{{i.consumable.spec}}</span> <span class=\"badge bg-aqua-active\">{{i.consumable.id}}</span></td><td>{{i.consumable.producer?i.consumable.producer.name:\'暂无生产商\'}}</td></tr></tbody></table><a class=\"pull-right\" ng-if=\"row[col.field].length>4\" ng-click=\"row.expand=!row.expand\"><span ng-if=\"row.expand\" class=\"fa fa-chevron-up\">收起</span> <span ng-if=\"!row.expand\" class=\"fa fa-chevron-down\">展开剩余{{row[col.field].length-4}}项...</span></a></div><span ng-switch-when=\"created_at\">{{row[col.field]}}</span> <span ng-switch-default=\"\">{{row[col.field].name}}</span></td></tr><tr ng-repeat-end=\"\" ng-if=\"row.showDetail\" class=\"bg-gray-light\"><td colspan=\"7\"><table class=\"table table-hover\"><tbody><tr ng-if=\"row.state.id==5\"><td width=\"100\">退回原因</td><td><span class=\"text-red\" ng-bind=\"row.reason\"></span></td></tr><tr ng-if=\"row.state.id==5\"><td width=\"100\">退回人</td><td><span ng-bind=\"row.handler.name\"></span></td></tr><tr><td width=\"100\">变价原因</td><td><span ng-bind-html=\"row.content\"></span></td></tr><tr><td colspan=\"2\"><table class=\"table table-condensed\" style=\"margin-bottom:0\"><thead><tr><th>耗材</th><th>规格型号</th><th>单位</th><th>原价</th><th>改价</th></tr></thead><tbody><tr ng-repeat=\"item in row.items track by item.id\"><td>{{item.consumable.name!=\'\'?item.consumable.name:item.consumable.c_name}}</td><td>{{item.consumable.spec}}</td><td><span ng-if=\"item.consumable.storage_unit!=item.consumable.use_unit\">每{{item.consumable.storage_unit}}{{item.consumable.use_num}}{{item.consumable.use_unit}}</span> <span ng-if=\"item.consumable.storage_unit==item.consumable.use_unit\">{{item.consumable.storage_unit}}</span></td><td>{{item.old_purchase_price+\'/\'+item.consumable.use_unit}}</td><td>{{item.purchase_price+\'/\'+item.consumable.use_unit}}</td></tr></tbody></table></td></tr></tbody></table></td></tr><tr ng-if=\"!vm.tableParams.settings().$loading&&($data==null||$data.length==0)\" class=\"table-no-data\"><td colspan=\"99\" align=\"center\"><span>暂无数据</span></td></tr></table></div></div>");
$templateCache.put("app/pages/csmbs/prices/query/edit/edit.html","<div class=\"row\"><div class=\"col-md-10\"><div ba-panel=\"\" ba-panel-class=\"light-text tab-content-panel\" ba-panel-title=\"<span ncy-breadcrumb-last></span>\"><form name=\"Form\" class=\"form-horizontal\" scroll-form=\"\" novalidate=\"\"><div class=\"form-group\"><label class=\"col-md-2 control-label\">变价耗材</label><div class=\"col-md-8\"><csmbs-select ng-model=\"vm.m.csmbs\" name=\"csmbs\" only-use=\"true\" disabled=\"vm.m.id\" on-select=\"vm.csmbSelected(vm.m)\" on-remove=\"vm.csmbSelected(vm.m)\"></csmbs-select><div ng-show=\"Form.$submitted||Form.csmbs.$touched\"><span ng-show=\"vm.m.csmbs.length==0\" class=\"validation-invalid control-label\">必填项!!</span></div></div></div><div class=\"form-group\"><label class=\"col-md-2 control-label\">耗材明细</label><div class=\"col-md-8\"><table class=\"table table-bordered table-condensed\"><thead><tr><th width=\"108\">耗材名称</th><th width=\"72\">规格型号</th><th width=\"72\">单位</th><th width=\"72\">原价</th><th width=\"120\">现价</th></tr></thead><tbody><tr ng-repeat=\"row in vm.m.consumables track by row.id\"><td>{{row.name!=\'\'?row.name:row.c_name}}</td><td>{{row.spec}}</td><td><span ng-if=\"row.storage_unit!=row.use_unit\">每{{row.storage_unit}}{{row.use_num}}{{row.use_unit}}</span> <span ng-if=\"row.storage_unit==row.use_unit\">{{row.storage_unit}}</span></td><td>{{row.purchase_price}}/{{row.use_unit}}</td><td><input type=\"text\" input-float=\"2\" class=\"form-control input-xs\" style=\"display:inline-block;width:80px\" ng-model=\"row.new_price\" validator=\"required\"> /{{row.use_unit}}<div class=\"btn-group\"><button class=\"btn btn-xs btn-success\" ng-click=\"vm.increase(row)\"><i class=\"fa fa-plus\"></i></button> <button class=\"btn btn-xs btn-danger\" ng-click=\"vm.decrease(row)\"><i class=\"fa fa-minus\"></i></button></div></td></tr><tr ng-if=\"vm.m.consumables==null||vm.m.consumables.length==0\" height=\"160px\"><td colspan=\"11\" align=\"center\" style=\"vertical-align:middle\"><span class=\"table-no-data\">暂无数据</span></td></tr></tbody></table></div></div><div class=\"form-group\"><label class=\"col-md-2 control-label\">变价原因</label><div class=\"col-md-8\"><div ckeditor=\"\" ng-model=\"vm.m.content\" ready=\"vm.onCKReady(\'editor1\')\" id=\"editor1\" name=\"content\" required=\"\"></div><div ng-if=\"Form.$submitted||Form.content.$touched\"><span ng-show=\"Form.content.$error.required\" class=\"validation-invalid\">必填项!!</span></div></div></div><div class=\"form-group\"><div class=\"col-md-offset-3 col-md-9\"><div class=\"pull-right\"><submit-button btn-class=\"btn-primary\" btn-click=\"vm.submit(Form,vm.m)\">提交</submit-button><button class=\"btn btn-default\" ui-sref=\"^.list\">取消</button></div></div></div></form></div></div></div>");
$templateCache.put("app/pages/csmbs/qualifications/query/list/list.html","<div ba-panel=\"\" ba-panel-class=\"light-text tab-content-panel\" ba-panel-header=\"\" hide-add-btn=\"true\" ba-panel-title=\"<span ncy-breadcrumb-last></span>\"><label class=\"cb-label-wrapper\" ng-if=\"vm.tableParams.filter()[\'item\']\"><checkbox ng-model=\"vm.hideSub\" ng-change=\"vm.changeHide(vm.items,vm.tableParams.filter()[\'item\'])\"></checkbox><strong>隐藏其余筛选子项</strong></label><div class=\"table-responsive\" loading-container=\"vm.tableParams.settings().$loading\"><table class=\"table table-hover table-row-clicked\" ng-table=\"vm.tableParams\" template-header=\"app/theme/components/table/header.html\"><tr ng-repeat=\"row in $data track by row.id\" ng-click=\"row.showDetail=!row.showDetail\"><td ng-click=\"$event.stopPropagation()\"><button class=\"btn btn-info btn-xs\" ui-sref=\"^.edit({id:row.id})\" uib-tooltip=\"修改\" tooltip-class=\"tooltipInfo\" ng-if=\"row.state.id==1\"><span class=\"fa fa-edit\"></span></button> <button class=\"btn btn-warning btn-xs\" ui-sref=\"^.edit({id:row.id})\" uib-tooltip=\"再次申请\" tooltip-class=\"tooltipInfo\" tooltip-append-to-body=\"true\" ng-if=\"row.state.id==2\"><span class=\"fa fa-edit\"></span></button> <button class=\"btn btn-danger btn-xs\" ng-click=\"vm.remove(row)\" ng-if=\"row.state.id!=3\"><span class=\"glyphicon glyphicon-trash\"></span></button></td><td ng-repeat=\"col in vm.cols\" ng-switch=\"col.field\" ng-if=\"col.show\"><span ng-switch-when=\"items\"><table class=\"table table-bordered table-condensed\"><thead><tr><th>耗材</th><th>资质</th><th>附件</th></tr></thead><tbody><tr ng-repeat=\"i in row[col.field]\" ng-hide=\"i.hide\"><td>{{i.consumable.name+(i.consumable.c_name?(\'<\'+i.consumable.c_name+\'>\'):\'\')}}</\'+i.consumable.c_name+\'></td><td>{{i.qualification.name}}<span class=\"tag\" ng-class=\"{true:\'tag-danger\',false:\'tag-info\'}[i.type.id==2]\">{{i.type.name}}</span></td><td><div class=\"att-item\" ng-repeat=\"attachment in i.qualification.attachments\"><div class=\"att-name\"><span ng-bind=\"attachment.name\"></span> <span class=\"text-muted\">({{attachment.size|bytes}})</span> <a ng-click=\"vm.download(attachment)\">下载</a>&nbsp; <span ng-show=\"attachment.downloading\" class=\"fa fa-circle-o-notch fa-spin text-muted\"></span><attachment-preview ng-model=\"attachment\"></attachment-preview></div></div></td></tr><tr><td colspan=\"3\">备注:{{row.note?row.note:\'暂无\'}}</td></tr><tr ng-if=\"row.state.id==2\"><td colspan=\"3\">退回人:<span ng-bind=\"row.handler.name\"></span></td></tr><tr ng-if=\"row.state.id==2\"><td colspan=\"3\">退回原因: <span class=\"text-red\" ng-bind=\"row.reason\"></span></td></tr></tbody></table></span> <span ng-switch-when=\"state\">{{row.state.name}}</span> <span ng-switch-default=\"\">{{row[col.field]}}</span></td></tr><tr ng-if=\"!vm.tableParams.settings().$loading&&($data==null||$data.length==0)\" class=\"table-no-data\"><td colspan=\"99\" align=\"center\"><span>暂无数据</span></td></tr></table></div></div>");
$templateCache.put("app/pages/csmbs/qualifications/query/edit/edit.html","<script type=\"text/ng-template\" id=\"csmbQAAdd.html\"><div class=\"modal-header dialog-header-confirm\"> <button type=\"button\" class=\"close\" ng-click=\"vm.cancel()\">&times;</button> <h4 class=\"modal-title\"> <i class=\"fa fa-plus\">选择耗材资质</i> </h4> </div> <div class=\"modal-body\"> <form name=\"Form\" class=\"form-horizontal\" novalidate> <div class=\"alert bg-danger\" ng-if=\"vm.qualifications.length==0\"><strong>没有可添加的资质!</strong></div> <div class=\"form-group\" ng-if=\"vm.qualifications.length>0\"> <label class=\"col-md-3 control-label\">选择资质</label> <div class=\"col-md-7\"> <ui-select ng-model=\"vm.m.qualifications\" multiple close-on-select=\"false\"> <ui-select-match placeholder=\"选择资质...\"><span ng-bind=\"$item.name\" title={{$item.name}}></span> </ui-select-match> <ui-select-choices repeat=\"qualification in vm.qualifications | filter: $select.search\"> <span ng-bind-html=\"qualification.name | highlight: $select.search\" title={{qualification.name}}></span> </ui-select-choices> </ui-select> </div> </div> </form> </div> <div class=\"modal-footer\"> <button class=\"btn btn-primary\" ng-click=\"vm.ok(vm.m)\" promise-btn ng-if=\"vm.qualifications.length>0\">确认 </button> <button class=\"btn btn-default\" ng-click=\"vm.cancel()\">取消</button> </div></script><div ba-panel=\"\" ba-panel-class=\"profile-page\" ba-panel-title=\"<span ncy-breadcrumb-last></span>\"><div class=\"panel-content\"><form name=\"Form\" class=\"form-horizontal\" scroll-form=\"\" novalidate=\"\"><div class=\"form-group\"><label class=\"col-md-1 control-label\">变更耗材</label><div class=\"col-md-10\"><cvs-select ng-model=\"vm.m.csmbs\" name=\"csmbs\" required=\"\" disabled=\"vm.m.id\" on-select=\"vm.csmbSelected(vm.m)\" on-remove=\"vm.csmbSelected(vm.m)\"></cvs-select><div ng-show=\"Form.$submitted||Form.csmbs.$touched\"><span ng-show=\"vm.m.csmbs.length==0\" class=\"validation-invalid control-label\">必填项!!</span></div></div></div><div class=\"form-group\" ng-if=\"vm.m.consumables.length>0\"><div class=\"col-md-10 col-md-offset-1 mb-10\" ng-repeat=\"csmb in vm.m.consumables track by csmb.id\"><table class=\"table table-hover table-bordered table-condensed\" style=\"margin-bottom:0\"><thead style=\"background:azure\"><tr><th colspan=\"6\">{{csmb.name+(csmb.c_name?(\'<\'+csmb.c_name+\'>\'):\'\')}}资质详情</\'+csmb.c_name+\'></th></tr></thead><tbody><tr><td>名称</td><td>证件号</td><td>类型</td><td>资质期限</td><td width=\"260\">附件</td><td width=\"80\">操作</td></tr><tr ng-repeat=\"item in csmb.qualifications\"><td>{{item.name}} <span class=\"tag tag-danger\" title=\"停用\" ng-if=\"item.pivot.is_stop==1\">停</span> <span class=\"tag tag-danger\" title=\"禁用\" ng-if=\"item.pivot.is_invalid==1\">禁</span> <span class=\"tag tag-info\" title=\"新资质\" ng-if=\"item.isNew\">新</span></td><td>{{item.code}}</td><td>{{item.type.name}}</td><td>{{item.start_time}}~{{item.end_time?item.end_time:\'永久\'}}</td><td><div class=\"att-item\" ng-repeat=\"attachment in item.attachments\"><div class=\"att-name\"><span ng-bind=\"attachment.name\"></span> <span class=\"text-muted\">({{attachment.size|bytes}})</span> <a ng-click=\"vm.download(attachment)\">下载</a>&nbsp; <span ng-show=\"attachment.downloading\" class=\"fa fa-circle-o-notch fa-spin text-muted\"></span><attachment-preview ng-model=\"attachment\"></attachment-preview></div></div></td><td align=\"center\"><label class=\"cb-label-wrapper\" ng-if=\"!item.isNew\"><checkbox ng-model=\"item.remove\"></checkbox><strong>解绑</strong></label> <label class=\"cb-label-wrapper\" ng-if=\"item.isNew&&item.type_id==18\"><checkbox ng-model=\"item.change\" ng-change=\"vm.changeFn(item,csmb)\"></checkbox><strong>更换注册证号</strong></label> <button type=\"button\" ng-if=\"item.isNew\" class=\"btn btn-danger btn-xs\" ng-click=\"vm.remove(csmb.qualifications, $index)\"><i class=\"fa fa-trash\"></i></button></td></tr></tbody><tfoot><tr><td colspan=\"5\"></td><td><button type=\"button\" class=\"btn btn-success btn-xs\" ng-click=\"vm.add(csmb,csmb.qualifications)\">添加资质</button></td></tr></tfoot></table></div></div><div class=\"form-group\"><label class=\"col-md-1 control-label\">备注</label><div class=\"col-md-10\"><textarea class=\"form-control\" id=\"inputNote\" placeholder=\"200字内...\" maxlength=\"200\" name=\"note\" ng-model=\"vm.m.note\"></textarea></div></div><div class=\"form-group\"><div class=\"col-md-offset-3 col-md-9\"><div class=\"pull-right\"><submit-button btn-class=\"btn-primary\" btn-click=\"vm.submit(Form,vm.m)\">提交</submit-button><button class=\"btn btn-default\" ui-sref=\"^.list\">取消</button></div></div></div></form></div></div>");
$templateCache.put("app/pages/csmbs/return/approval/handle/handle.html","<div ba-panel=\"\" ba-panel-class=\"light-text tab-content-panel\" ba-panel-title=\"<span ncy-breadcrumb-last></span>\"><form name=\"Form\" class=\"form-horizontal\" novalidate=\"\"><div class=\"table-responsive\" style=\"min-height: 100px\"><table class=\"table table-bordered table-condensed\" style=\"margin-bottom:20px\"><thead><tr><th>耗材</th><th>规格型号</th><th>单位</th><th>批次</th><th>经销商批次</th><th>进价</th><th>数量</th><th>合计</th></tr></thead><tbody><tr ng-repeat=\"item in vm.m.application_items track by item.id\"><td>{{item.consumable.name!=\'\'?item.consumable.name:item.consumable.c_name}}</td><td>{{item.consumable.spec}}</td><td><span ng-if=\"item.consumable.purchase_unit!=item.consumable.storage_unit\">每{{item.consumable.purchase_unit}}{{item.consumable.storage_num}}{{item.consumable.storage_unit}}</span> <span ng-if=\"item.consumable.storage_unit!=item.consumable.use_unit\">每{{item.consumable.storage_unit}}{{item.consumable.use_num}}{{item.consumable.use_unit}}</span> <span ng-if=\"(item.consumable.purchase_unit==item.consumable.storage_unit)&&(item.consumable.storage_unit==item.consumable.use_unit)\">{{item.consumable.storage_unit}}</span></td><td>{{item.batch.sn}}</td><td>{{item.batch.no}}</td><td>{{item.batch.purchase_price}}/{{item.consumable.use_unit}}</td><td>{{item.num}}{{item.consumable.storage_unit}}</td><td>{{item.total}}</td></tr><tr><td colspan=\"7\">总计</td><td ng-bind=\"vm.m.total\"></td></tr></tbody></table></div><div class=\"form-group\"><label class=\"col-md-4 control-label\">审批意见</label><div class=\"col-md-6\"><textarea maxlength=\"300\" class=\"form-control\" rows=\"4\" name=\"opinion\" placeholder=\"300字内...\" ng-model=\"vm.m.opinion\"></textarea></div></div><div class=\"form-group\"><label class=\"col-md-4 control-label\">短信通知申请人</label><div class=\"col-md-6\"><switch id=\"sms\" name=\"with_sms\" ng-model=\"vm.m.sms\" on=\"是\" off=\"否\" class=\"green\"></switch></div></div><div class=\"form-group\"><div class=\"col-md-offset-3 col-md-9\"><div class=\"pull-right\"><submit-button btn-class=\"btn-primary\" btn-click=\"vm.handle(Form,vm.m,3)\">同意</submit-button><submit-button btn-class=\"btn-danger\" btn-click=\"vm.handle(Form,vm.m,4)\">拒绝</submit-button><button class=\"btn btn-default\" ui-sref=\"^.list\">取消</button></div></div></div></form></div>");
$templateCache.put("app/pages/csmbs/return/approval/list/list.html","<div ba-panel=\"\" ba-panel-class=\"light-text tab-content-panel\" ba-panel-header=\"\" hide-add-btn=\"true\" ba-panel-title=\"<span ncy-breadcrumb-last></span>列表\"><table-option-tab ng-model=\"vm.roomId\" options=\"vm.rooms\" tag-title=\"退货库房\" filter-name=\"room_id\"></table-option-tab><label class=\"cb-label-wrapper\" ng-if=\"vm.tableParams.filter()[\'item\']\"><checkbox ng-model=\"vm.hideSub\" ng-change=\"vm.changeHide(vm.items,vm.tableParams.filter()[\'item\'])\"></checkbox><strong>隐藏其余筛选子项</strong></label><div class=\"table-responsive\" loading-container=\"vm.tableParams.settings().$loading\"><table class=\"table table-hover table-row-clicked\" ng-table=\"vm.tableParams\" template-header=\"app/theme/components/table/header.html\"><tr ng-repeat-start=\"row in $data track by row.id\"><td><button type=\"button\" class=\"btn btn-default btn-xs\" ng-click=\"row.showDetail=!row.showDetail\"><i class=\"glyphicon glyphicon-chevron-down\" ng-hide=\"row.showDetail\"></i> <i class=\"glyphicon glyphicon-chevron-up\" ng-show=\"row.showDetail\"></i></button> <button class=\"btn btn-primary btn-xs\" ui-sref=\"^.handle({id:row.id})\"><i class=\"fa fa-edit\"></i></button></td><td ng-repeat=\"col in vm.cols\" ng-switch=\"col.field\" ng-if=\"col.show\"><div ng-switch-when=\"created_at\">{{row[col.field]}}</div><div ng-switch-when=\"itemDesc\"><table class=\"table table-bordered table-condensed\"><tbody><tr ng-repeat=\"i in row[col.field]\" ng-hide=\"i.hide\" ng-if=\"row.expand||$index<4\"><td>{{i.consumable.name!=\'\'?i.consumable.name:i.consumable.c_name}} <span class=\"badge bulletin-subject-col\">{{i.consumable.spec}}</span> <span class=\"text-danger\" ng-bind=\"i.num+(row.for_purchase==\'1\'?i.consumable.purchase_unit:i.consumable.storage_unit)\"></span></td><td>{{i.consumable.producer?i.consumable.producer.name:\'暂无生产商\'}}</td></tr></tbody></table><a class=\"pull-right\" ng-if=\"row[col.field].length>4\" ng-click=\"row.expand=!row.expand\"><span ng-if=\"row.expand\" class=\"fa fa-chevron-up\">收起</span> <span ng-if=\"!row.expand\" class=\"fa fa-chevron-down\">展开剩余{{row[col.field].length-4}}项...</span></a></div><div ng-switch-default=\"\">{{row[col.field].name}}</div></td></tr><tr ng-repeat-end=\"\" ng-if=\"row.showDetail\" class=\"bg-gray-light\"><td colspan=\"5\"><table class=\"table table-hover\"><tbody><tr><td>备注：<span ng-bind=\"row.note?row.note:\'暂无\'\"></span></td></tr><tr><td><table class=\"table table-bordered table-condensed\"><thead><tr><th>耗材</th><th>规格型号</th><th>单位</th><th>批次</th><th>经销商批次</th><th>进价</th><th>数量</th><th>合计</th></tr></thead><tbody><tr ng-repeat=\"item in row.application_items track by item.id\"><td>{{item.consumable.name!=\'\'?item.consumable.name:item.consumable.c_name}}</td><td>{{item.consumable.spec}}</td><td><span ng-if=\"item.consumable.purchase_unit!=item.consumable.storage_unit\">每{{item.consumable.purchase_unit}}{{item.consumable.storage_num}}{{item.consumable.storage_unit}}</span> <span ng-if=\"item.consumable.storage_unit!=item.consumable.use_unit\">每{{item.consumable.storage_unit}}{{item.consumable.use_num}}{{item.consumable.use_unit}}</span> <span ng-if=\"(item.consumable.purchase_unit==item.consumable.storage_unit)&&(item.consumable.storage_unit==item.consumable.use_unit)\">{{item.consumable.storage_unit}}</span></td><td>{{item.batch.sn}}</td><td>{{item.batch.no}}</td><td>{{item.batch.purchase_price}}/{{item.consumable.use_unit}}</td><td>{{item.num}}{{item.consumable.storage_unit}}</td><td>{{item.total}}</td></tr><tr><td colspan=\"7\">总计</td><td ng-bind=\"row.total\"></td></tr></tbody></table></td></tr><tr ng-if=\"!tableParams.settings().$loading&&($data==null||$data.length==0)\" height=\"160px\"><td colspan=\"11\" align=\"center\" style=\"vertical-align:middle\"><span class=\"table-no-data\">暂无数据</span></td></tr></tbody></table></td></tr><tr ng-if=\"!vm.tableParams.settings().$loading&&($data==null||$data.length==0)\" class=\"table-no-data\"><td colspan=\"99\" align=\"center\"><span>暂无数据</span></td></tr></table></div></div>");}]);